var H4 = Object.defineProperty;
var V4 = (r, a, n) => a in r ? H4(r, a, { enumerable: !0, configurable: !0, writable: !0, value: n }) : r[a] = n;
var Ye = (r, a, n) => V4(r, typeof a != "symbol" ? a + "" : a, n);
var Te = /* @__PURE__ */ ((r) => (r.BOOKING_NAME = "booking-name", r.VIEWER_DATE = "viewer-date", r.VIEWER_FULL = "viewer-full", r.VIEWER_NAME = "viewer-name", r.VIEWER_STAGING = "viewer-staging", r))(Te || {}), _n = /* @__PURE__ */ ((r) => (r.CONTAIN = "contain", r.COVER = "cover", r))(_n || {}), tt = /* @__PURE__ */ ((r) => (r.RED = "Red", r.BLUE = "Blue", r.GREEN = "Green", r.YELLOW = "Yellow", r.ORANGE = "Orange", r.PINK = "Pink", r.WHITE = "White", r.BLACK = "Black", r.PURPLE = "Purple", r.RED_FLUO = "Fluored", r.BLUE_FLUO = "Fluoblue", r.GREEN_FLUO = "Fluogreen", r.YELLOW_FLUO = "Fluoyellow", r.PINK_FLUO = "Fluopink", r.WHITE_FLUO = "Fluowhite", r.PURPLE_FLUO = "Fluopurple", r.BLACK_WHITE = "Black-White", r.BLACK_BLUE = "Black-Blue", r.BLACK_YELLOW = "Black-Yellow", r.BLACK_GREY = "Black-Grey", r.BLACK_RED = "Black-Red", r.BLACK_GREEN = "Black-Green", r.BLACK_PURPLE = "Black-Purple", r.GREY = "Grey", r.CYAN = "Cyan", r.BROWN = "Brown", r.LIME = "Lime", r))(tt || {});
tt.RED, tt.BLUE, tt.GREEN, tt.YELLOW, tt.ORANGE, tt.PINK, tt.WHITE, tt.BLACK, tt.PURPLE, tt.RED_FLUO, tt.BLUE_FLUO, tt.GREEN_FLUO, tt.YELLOW_FLUO, tt.PINK_FLUO, tt.WHITE_FLUO, tt.PURPLE_FLUO, tt.BLACK_WHITE, tt.BLACK_BLUE, tt.BLACK_YELLOW, tt.BLACK_GREY, tt.BLACK_RED, tt.BLACK_GREEN, // Color.BLACK_PINK,
tt.BLACK_PURPLE;
tt.RED, tt.BLUE, tt.GREEN, tt.YELLOW, tt.ORANGE, tt.PINK, tt.WHITE, tt.BLACK, tt.PURPLE;
tt.RED, tt.BLUE, tt.GREEN, tt.YELLOW, tt.ORANGE, tt.PINK;
// Color.WHITE,
tt.RED, tt.BLUE, tt.GREEN, tt.YELLOW, tt.ORANGE, tt.PINK;
tt.RED, tt.BLUE, tt.GREEN, tt.YELLOW, tt.ORANGE, tt.PINK, tt.GREY, tt.CYAN, tt.BROWN, tt.LIME;
tt.RED, tt.BLUE, tt.GREEN, tt.YELLOW, tt.ORANGE, tt.PINK, tt.GREY, tt.CYAN, tt.BROWN, tt.LIME, tt.WHITE, tt.BLACK, tt.PURPLE, tt.WHITE_FLUO, tt.RED_FLUO, tt.BLUE_FLUO, tt.GREEN_FLUO, tt.YELLOW_FLUO, tt.PURPLE_FLUO, tt.BLACK_WHITE, tt.BLACK_RED, tt.BLACK_BLUE, tt.BLACK_GREEN, tt.BLACK_YELLOW, tt.BLACK_PURPLE, tt.BLACK_GREY;
var ge = /* @__PURE__ */ ((r) => (r.FOOTBOARD = "footboard", r.LINE = "line", r.LABEL = "label", r.CUSTOM = "custom", r.BENCH = "bench", r.CAR = "car", r.CHIRINGUITO = "chiringuito", r.RECEPTION = "reception", r.DESK = "desk", r.BEACH_VOLLEY = "beach-volley", r.BASKET_FIELD = "basket-field", r.COURT = "court", r.SOCCER_FIELD = "soccer-field", r.LIFEBELT = "lifebelt", r.GYM_BARBELL = "gym-barbell", r.GYM_EXERCISE = "gym-exercise", r.GYM_TREADMILL = "gym-treadmill", r.PALM = "palm", r.PLAYGROUND = "playground", r.POOL = "pool", r.POOL_ROUNDED = "pool-rounded", r.SHOWER = "shower", r.ROWBOAT = "rowboat", r.TENT = "tent", r.TENT_BIG = "tent-big", r.TREE = "tree", r.TREE1 = "tree1", r))(ge || {}), Er = /* @__PURE__ */ ((r) => (r.UMBRELLA = "umbrella", r.GAZEBO = "gazebo", r.PARKING = "parking", r.BED = "bed", r.BEDS = "beds", r.CABIN = "cabins", r.BOAT = "boat", r.PLAYFIELD = "playfield", r))(Er || {});
function Dr(r, a) {
  throw new Error(
    `Unhandled discriminated union member: ${JSON.stringify(r)}`
  );
}
var wi = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {}, fa = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
fa.exports;
(function(r, a) {
  (function() {
    var n, o = "4.17.21", c = 200, s = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", h = "Expected a function", l = "Invalid `variable` option passed into `_.template`", g = "__lodash_hash_undefined__", p = 500, b = "__lodash_placeholder__", w = 1, x = 2, v = 4, _ = 1, S = 2, C = 1, O = 2, d = 4, f = 8, m = 16, E = 32, T = 64, D = 128, I = 256, L = 512, F = 30, N = "...", H = 800, y = 16, P = 1, A = 2, G = 3, U = 1 / 0, K = 9007199254740991, $ = 17976931348623157e292, X = NaN, Q = 4294967295, st = Q - 1, Z = Q >>> 1, at = [
      ["ary", D],
      ["bind", C],
      ["bindKey", O],
      ["curry", f],
      ["curryRight", m],
      ["flip", L],
      ["partial", E],
      ["partialRight", T],
      ["rearg", I]
    ], ht = "[object Arguments]", ct = "[object Array]", V = "[object AsyncFunction]", j = "[object Boolean]", et = "[object Date]", ut = "[object DOMException]", ft = "[object Error]", gt = "[object Function]", Lt = "[object GeneratorFunction]", Et = "[object Map]", mt = "[object Number]", ee = "[object Null]", Pt = "[object Object]", Vt = "[object Promise]", gr = "[object Proxy]", re = "[object RegExp]", Zt = "[object Set]", Jt = "[object String]", Ut = "[object Symbol]", qe = "[object Undefined]", ie = "[object WeakMap]", He = "[object WeakSet]", zt = "[object ArrayBuffer]", ne = "[object DataView]", Pe = "[object Float32Array]", pe = "[object Float64Array]", $e = "[object Int8Array]", Aa = "[object Int16Array]", Ve = "[object Int32Array]", Oe = "[object Uint8Array]", Ze = "[object Uint8ClampedArray]", ai = "[object Uint16Array]", Ra = "[object Uint32Array]", l1 = /\b__p \+= '';/g, u1 = /\b(__p \+=) '' \+/g, c1 = /(__e\(.*?\)|\b__t\)) \+\n'';/g, tl = /&(?:amp|lt|gt|quot|#39);/g, el = /[&<>"']/g, d1 = RegExp(tl.source), f1 = RegExp(el.source), g1 = /<%-([\s\S]+?)%>/g, p1 = /<%([\s\S]+?)%>/g, rl = /<%=([\s\S]+?)%>/g, _1 = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, v1 = /^\w*$/, y1 = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, Ta = /[\\^$.*+?()[\]{}|]/g, m1 = RegExp(Ta.source), Pa = /^\s+/, b1 = /\s/, w1 = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, S1 = /\{\n\/\* \[wrapped with (.+)\] \*/, C1 = /,? & /, x1 = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, E1 = /[()=,{}\[\]\/\s]/, A1 = /\\(\\)?/g, R1 = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, il = /\w*$/, T1 = /^[-+]0x[0-9a-f]+$/i, P1 = /^0b[01]+$/i, O1 = /^\[object .+?Constructor\]$/, F1 = /^0o[0-7]+$/i, k1 = /^(?:0|[1-9]\d*)$/, I1 = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, wn = /($^)/, L1 = /['\n\r\u2028\u2029\\]/g, Sn = "\\ud800-\\udfff", M1 = "\\u0300-\\u036f", N1 = "\\ufe20-\\ufe2f", G1 = "\\u20d0-\\u20ff", nl = M1 + N1 + G1, al = "\\u2700-\\u27bf", sl = "a-z\\xdf-\\xf6\\xf8-\\xff", D1 = "\\xac\\xb1\\xd7\\xf7", B1 = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", U1 = "\\u2000-\\u206f", q1 = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", ol = "A-Z\\xc0-\\xd6\\xd8-\\xde", hl = "\\ufe0e\\ufe0f", ll = D1 + B1 + U1 + q1, Oa = "['’]", H1 = "[" + Sn + "]", ul = "[" + ll + "]", Cn = "[" + nl + "]", cl = "\\d+", V1 = "[" + al + "]", dl = "[" + sl + "]", fl = "[^" + Sn + ll + cl + al + sl + ol + "]", Fa = "\\ud83c[\\udffb-\\udfff]", W1 = "(?:" + Cn + "|" + Fa + ")", gl = "[^" + Sn + "]", ka = "(?:\\ud83c[\\udde6-\\uddff]){2}", Ia = "[\\ud800-\\udbff][\\udc00-\\udfff]", Br = "[" + ol + "]", pl = "\\u200d", _l = "(?:" + dl + "|" + fl + ")", z1 = "(?:" + Br + "|" + fl + ")", vl = "(?:" + Oa + "(?:d|ll|m|re|s|t|ve))?", yl = "(?:" + Oa + "(?:D|LL|M|RE|S|T|VE))?", ml = W1 + "?", bl = "[" + hl + "]?", j1 = "(?:" + pl + "(?:" + [gl, ka, Ia].join("|") + ")" + bl + ml + ")*", K1 = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", Y1 = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", wl = bl + ml + j1, X1 = "(?:" + [V1, ka, Ia].join("|") + ")" + wl, $1 = "(?:" + [gl + Cn + "?", Cn, ka, Ia, H1].join("|") + ")", Z1 = RegExp(Oa, "g"), J1 = RegExp(Cn, "g"), La = RegExp(Fa + "(?=" + Fa + ")|" + $1 + wl, "g"), Q1 = RegExp([
      Br + "?" + dl + "+" + vl + "(?=" + [ul, Br, "$"].join("|") + ")",
      z1 + "+" + yl + "(?=" + [ul, Br + _l, "$"].join("|") + ")",
      Br + "?" + _l + "+" + vl,
      Br + "+" + yl,
      Y1,
      K1,
      cl,
      X1
    ].join("|"), "g"), tg = RegExp("[" + pl + Sn + nl + hl + "]"), eg = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, rg = [
      "Array",
      "Buffer",
      "DataView",
      "Date",
      "Error",
      "Float32Array",
      "Float64Array",
      "Function",
      "Int8Array",
      "Int16Array",
      "Int32Array",
      "Map",
      "Math",
      "Object",
      "Promise",
      "RegExp",
      "Set",
      "String",
      "Symbol",
      "TypeError",
      "Uint8Array",
      "Uint8ClampedArray",
      "Uint16Array",
      "Uint32Array",
      "WeakMap",
      "_",
      "clearTimeout",
      "isFinite",
      "parseInt",
      "setTimeout"
    ], ig = -1, qt = {};
    qt[Pe] = qt[pe] = qt[$e] = qt[Aa] = qt[Ve] = qt[Oe] = qt[Ze] = qt[ai] = qt[Ra] = !0, qt[ht] = qt[ct] = qt[zt] = qt[j] = qt[ne] = qt[et] = qt[ft] = qt[gt] = qt[Et] = qt[mt] = qt[Pt] = qt[re] = qt[Zt] = qt[Jt] = qt[ie] = !1;
    var Bt = {};
    Bt[ht] = Bt[ct] = Bt[zt] = Bt[ne] = Bt[j] = Bt[et] = Bt[Pe] = Bt[pe] = Bt[$e] = Bt[Aa] = Bt[Ve] = Bt[Et] = Bt[mt] = Bt[Pt] = Bt[re] = Bt[Zt] = Bt[Jt] = Bt[Ut] = Bt[Oe] = Bt[Ze] = Bt[ai] = Bt[Ra] = !0, Bt[ft] = Bt[gt] = Bt[ie] = !1;
    var ng = {
      // Latin-1 Supplement block.
      À: "A",
      Á: "A",
      Â: "A",
      Ã: "A",
      Ä: "A",
      Å: "A",
      à: "a",
      á: "a",
      â: "a",
      ã: "a",
      ä: "a",
      å: "a",
      Ç: "C",
      ç: "c",
      Ð: "D",
      ð: "d",
      È: "E",
      É: "E",
      Ê: "E",
      Ë: "E",
      è: "e",
      é: "e",
      ê: "e",
      ë: "e",
      Ì: "I",
      Í: "I",
      Î: "I",
      Ï: "I",
      ì: "i",
      í: "i",
      î: "i",
      ï: "i",
      Ñ: "N",
      ñ: "n",
      Ò: "O",
      Ó: "O",
      Ô: "O",
      Õ: "O",
      Ö: "O",
      Ø: "O",
      ò: "o",
      ó: "o",
      ô: "o",
      õ: "o",
      ö: "o",
      ø: "o",
      Ù: "U",
      Ú: "U",
      Û: "U",
      Ü: "U",
      ù: "u",
      ú: "u",
      û: "u",
      ü: "u",
      Ý: "Y",
      ý: "y",
      ÿ: "y",
      Æ: "Ae",
      æ: "ae",
      Þ: "Th",
      þ: "th",
      ß: "ss",
      // Latin Extended-A block.
      Ā: "A",
      Ă: "A",
      Ą: "A",
      ā: "a",
      ă: "a",
      ą: "a",
      Ć: "C",
      Ĉ: "C",
      Ċ: "C",
      Č: "C",
      ć: "c",
      ĉ: "c",
      ċ: "c",
      č: "c",
      Ď: "D",
      Đ: "D",
      ď: "d",
      đ: "d",
      Ē: "E",
      Ĕ: "E",
      Ė: "E",
      Ę: "E",
      Ě: "E",
      ē: "e",
      ĕ: "e",
      ė: "e",
      ę: "e",
      ě: "e",
      Ĝ: "G",
      Ğ: "G",
      Ġ: "G",
      Ģ: "G",
      ĝ: "g",
      ğ: "g",
      ġ: "g",
      ģ: "g",
      Ĥ: "H",
      Ħ: "H",
      ĥ: "h",
      ħ: "h",
      Ĩ: "I",
      Ī: "I",
      Ĭ: "I",
      Į: "I",
      İ: "I",
      ĩ: "i",
      ī: "i",
      ĭ: "i",
      į: "i",
      ı: "i",
      Ĵ: "J",
      ĵ: "j",
      Ķ: "K",
      ķ: "k",
      ĸ: "k",
      Ĺ: "L",
      Ļ: "L",
      Ľ: "L",
      Ŀ: "L",
      Ł: "L",
      ĺ: "l",
      ļ: "l",
      ľ: "l",
      ŀ: "l",
      ł: "l",
      Ń: "N",
      Ņ: "N",
      Ň: "N",
      Ŋ: "N",
      ń: "n",
      ņ: "n",
      ň: "n",
      ŋ: "n",
      Ō: "O",
      Ŏ: "O",
      Ő: "O",
      ō: "o",
      ŏ: "o",
      ő: "o",
      Ŕ: "R",
      Ŗ: "R",
      Ř: "R",
      ŕ: "r",
      ŗ: "r",
      ř: "r",
      Ś: "S",
      Ŝ: "S",
      Ş: "S",
      Š: "S",
      ś: "s",
      ŝ: "s",
      ş: "s",
      š: "s",
      Ţ: "T",
      Ť: "T",
      Ŧ: "T",
      ţ: "t",
      ť: "t",
      ŧ: "t",
      Ũ: "U",
      Ū: "U",
      Ŭ: "U",
      Ů: "U",
      Ű: "U",
      Ų: "U",
      ũ: "u",
      ū: "u",
      ŭ: "u",
      ů: "u",
      ű: "u",
      ų: "u",
      Ŵ: "W",
      ŵ: "w",
      Ŷ: "Y",
      ŷ: "y",
      Ÿ: "Y",
      Ź: "Z",
      Ż: "Z",
      Ž: "Z",
      ź: "z",
      ż: "z",
      ž: "z",
      Ĳ: "IJ",
      ĳ: "ij",
      Œ: "Oe",
      œ: "oe",
      ŉ: "'n",
      ſ: "s"
    }, ag = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;"
    }, sg = {
      "&amp;": "&",
      "&lt;": "<",
      "&gt;": ">",
      "&quot;": '"',
      "&#39;": "'"
    }, og = {
      "\\": "\\",
      "'": "'",
      "\n": "n",
      "\r": "r",
      "\u2028": "u2028",
      "\u2029": "u2029"
    }, hg = parseFloat, lg = parseInt, Sl = typeof wi == "object" && wi && wi.Object === Object && wi, ug = typeof self == "object" && self && self.Object === Object && self, oe = Sl || ug || Function("return this")(), Ma = a && !a.nodeType && a, Ar = Ma && !0 && r && !r.nodeType && r, Cl = Ar && Ar.exports === Ma, Na = Cl && Sl.process, Fe = function() {
      try {
        var W = Ar && Ar.require && Ar.require("util").types;
        return W || Na && Na.binding && Na.binding("util");
      } catch {
      }
    }(), xl = Fe && Fe.isArrayBuffer, El = Fe && Fe.isDate, Al = Fe && Fe.isMap, Rl = Fe && Fe.isRegExp, Tl = Fe && Fe.isSet, Pl = Fe && Fe.isTypedArray;
    function Se(W, J, Y) {
      switch (Y.length) {
        case 0:
          return W.call(J);
        case 1:
          return W.call(J, Y[0]);
        case 2:
          return W.call(J, Y[0], Y[1]);
        case 3:
          return W.call(J, Y[0], Y[1], Y[2]);
      }
      return W.apply(J, Y);
    }
    function cg(W, J, Y, lt) {
      for (var bt = -1, Mt = W == null ? 0 : W.length; ++bt < Mt; ) {
        var Qt = W[bt];
        J(lt, Qt, Y(Qt), W);
      }
      return lt;
    }
    function ke(W, J) {
      for (var Y = -1, lt = W == null ? 0 : W.length; ++Y < lt && J(W[Y], Y, W) !== !1; )
        ;
      return W;
    }
    function dg(W, J) {
      for (var Y = W == null ? 0 : W.length; Y-- && J(W[Y], Y, W) !== !1; )
        ;
      return W;
    }
    function Ol(W, J) {
      for (var Y = -1, lt = W == null ? 0 : W.length; ++Y < lt; )
        if (!J(W[Y], Y, W))
          return !1;
      return !0;
    }
    function pr(W, J) {
      for (var Y = -1, lt = W == null ? 0 : W.length, bt = 0, Mt = []; ++Y < lt; ) {
        var Qt = W[Y];
        J(Qt, Y, W) && (Mt[bt++] = Qt);
      }
      return Mt;
    }
    function xn(W, J) {
      var Y = W == null ? 0 : W.length;
      return !!Y && Ur(W, J, 0) > -1;
    }
    function Ga(W, J, Y) {
      for (var lt = -1, bt = W == null ? 0 : W.length; ++lt < bt; )
        if (Y(J, W[lt]))
          return !0;
      return !1;
    }
    function Ht(W, J) {
      for (var Y = -1, lt = W == null ? 0 : W.length, bt = Array(lt); ++Y < lt; )
        bt[Y] = J(W[Y], Y, W);
      return bt;
    }
    function _r(W, J) {
      for (var Y = -1, lt = J.length, bt = W.length; ++Y < lt; )
        W[bt + Y] = J[Y];
      return W;
    }
    function Da(W, J, Y, lt) {
      var bt = -1, Mt = W == null ? 0 : W.length;
      for (lt && Mt && (Y = W[++bt]); ++bt < Mt; )
        Y = J(Y, W[bt], bt, W);
      return Y;
    }
    function fg(W, J, Y, lt) {
      var bt = W == null ? 0 : W.length;
      for (lt && bt && (Y = W[--bt]); bt--; )
        Y = J(Y, W[bt], bt, W);
      return Y;
    }
    function Ba(W, J) {
      for (var Y = -1, lt = W == null ? 0 : W.length; ++Y < lt; )
        if (J(W[Y], Y, W))
          return !0;
      return !1;
    }
    var gg = Ua("length");
    function pg(W) {
      return W.split("");
    }
    function _g(W) {
      return W.match(x1) || [];
    }
    function Fl(W, J, Y) {
      var lt;
      return Y(W, function(bt, Mt, Qt) {
        if (J(bt, Mt, Qt))
          return lt = Mt, !1;
      }), lt;
    }
    function En(W, J, Y, lt) {
      for (var bt = W.length, Mt = Y + (lt ? 1 : -1); lt ? Mt-- : ++Mt < bt; )
        if (J(W[Mt], Mt, W))
          return Mt;
      return -1;
    }
    function Ur(W, J, Y) {
      return J === J ? Tg(W, J, Y) : En(W, kl, Y);
    }
    function vg(W, J, Y, lt) {
      for (var bt = Y - 1, Mt = W.length; ++bt < Mt; )
        if (lt(W[bt], J))
          return bt;
      return -1;
    }
    function kl(W) {
      return W !== W;
    }
    function Il(W, J) {
      var Y = W == null ? 0 : W.length;
      return Y ? Ha(W, J) / Y : X;
    }
    function Ua(W) {
      return function(J) {
        return J == null ? n : J[W];
      };
    }
    function qa(W) {
      return function(J) {
        return W == null ? n : W[J];
      };
    }
    function Ll(W, J, Y, lt, bt) {
      return bt(W, function(Mt, Qt, Dt) {
        Y = lt ? (lt = !1, Mt) : J(Y, Mt, Qt, Dt);
      }), Y;
    }
    function yg(W, J) {
      var Y = W.length;
      for (W.sort(J); Y--; )
        W[Y] = W[Y].value;
      return W;
    }
    function Ha(W, J) {
      for (var Y, lt = -1, bt = W.length; ++lt < bt; ) {
        var Mt = J(W[lt]);
        Mt !== n && (Y = Y === n ? Mt : Y + Mt);
      }
      return Y;
    }
    function Va(W, J) {
      for (var Y = -1, lt = Array(W); ++Y < W; )
        lt[Y] = J(Y);
      return lt;
    }
    function mg(W, J) {
      return Ht(J, function(Y) {
        return [Y, W[Y]];
      });
    }
    function Ml(W) {
      return W && W.slice(0, Bl(W) + 1).replace(Pa, "");
    }
    function Ce(W) {
      return function(J) {
        return W(J);
      };
    }
    function Wa(W, J) {
      return Ht(J, function(Y) {
        return W[Y];
      });
    }
    function si(W, J) {
      return W.has(J);
    }
    function Nl(W, J) {
      for (var Y = -1, lt = W.length; ++Y < lt && Ur(J, W[Y], 0) > -1; )
        ;
      return Y;
    }
    function Gl(W, J) {
      for (var Y = W.length; Y-- && Ur(J, W[Y], 0) > -1; )
        ;
      return Y;
    }
    function bg(W, J) {
      for (var Y = W.length, lt = 0; Y--; )
        W[Y] === J && ++lt;
      return lt;
    }
    var wg = qa(ng), Sg = qa(ag);
    function Cg(W) {
      return "\\" + og[W];
    }
    function xg(W, J) {
      return W == null ? n : W[J];
    }
    function qr(W) {
      return tg.test(W);
    }
    function Eg(W) {
      return eg.test(W);
    }
    function Ag(W) {
      for (var J, Y = []; !(J = W.next()).done; )
        Y.push(J.value);
      return Y;
    }
    function za(W) {
      var J = -1, Y = Array(W.size);
      return W.forEach(function(lt, bt) {
        Y[++J] = [bt, lt];
      }), Y;
    }
    function Dl(W, J) {
      return function(Y) {
        return W(J(Y));
      };
    }
    function vr(W, J) {
      for (var Y = -1, lt = W.length, bt = 0, Mt = []; ++Y < lt; ) {
        var Qt = W[Y];
        (Qt === J || Qt === b) && (W[Y] = b, Mt[bt++] = Y);
      }
      return Mt;
    }
    function An(W) {
      var J = -1, Y = Array(W.size);
      return W.forEach(function(lt) {
        Y[++J] = lt;
      }), Y;
    }
    function Rg(W) {
      var J = -1, Y = Array(W.size);
      return W.forEach(function(lt) {
        Y[++J] = [lt, lt];
      }), Y;
    }
    function Tg(W, J, Y) {
      for (var lt = Y - 1, bt = W.length; ++lt < bt; )
        if (W[lt] === J)
          return lt;
      return -1;
    }
    function Pg(W, J, Y) {
      for (var lt = Y + 1; lt--; )
        if (W[lt] === J)
          return lt;
      return lt;
    }
    function Hr(W) {
      return qr(W) ? Fg(W) : gg(W);
    }
    function We(W) {
      return qr(W) ? kg(W) : pg(W);
    }
    function Bl(W) {
      for (var J = W.length; J-- && b1.test(W.charAt(J)); )
        ;
      return J;
    }
    var Og = qa(sg);
    function Fg(W) {
      for (var J = La.lastIndex = 0; La.test(W); )
        ++J;
      return J;
    }
    function kg(W) {
      return W.match(La) || [];
    }
    function Ig(W) {
      return W.match(Q1) || [];
    }
    var Lg = function W(J) {
      J = J == null ? oe : Vr.defaults(oe.Object(), J, Vr.pick(oe, rg));
      var Y = J.Array, lt = J.Date, bt = J.Error, Mt = J.Function, Qt = J.Math, Dt = J.Object, ja = J.RegExp, Mg = J.String, Ie = J.TypeError, Rn = Y.prototype, Ng = Mt.prototype, Wr = Dt.prototype, Tn = J["__core-js_shared__"], Pn = Ng.toString, Gt = Wr.hasOwnProperty, Gg = 0, Ul = function() {
        var t = /[^.]+$/.exec(Tn && Tn.keys && Tn.keys.IE_PROTO || "");
        return t ? "Symbol(src)_1." + t : "";
      }(), On = Wr.toString, Dg = Pn.call(Dt), Bg = oe._, Ug = ja(
        "^" + Pn.call(Gt).replace(Ta, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
      ), Fn = Cl ? J.Buffer : n, yr = J.Symbol, kn = J.Uint8Array, ql = Fn ? Fn.allocUnsafe : n, In = Dl(Dt.getPrototypeOf, Dt), Hl = Dt.create, Vl = Wr.propertyIsEnumerable, Ln = Rn.splice, Wl = yr ? yr.isConcatSpreadable : n, oi = yr ? yr.iterator : n, Rr = yr ? yr.toStringTag : n, Mn = function() {
        try {
          var t = kr(Dt, "defineProperty");
          return t({}, "", {}), t;
        } catch {
        }
      }(), qg = J.clearTimeout !== oe.clearTimeout && J.clearTimeout, Hg = lt && lt.now !== oe.Date.now && lt.now, Vg = J.setTimeout !== oe.setTimeout && J.setTimeout, Nn = Qt.ceil, Gn = Qt.floor, Ka = Dt.getOwnPropertySymbols, Wg = Fn ? Fn.isBuffer : n, zl = J.isFinite, zg = Rn.join, jg = Dl(Dt.keys, Dt), te = Qt.max, le = Qt.min, Kg = lt.now, Yg = J.parseInt, jl = Qt.random, Xg = Rn.reverse, Ya = kr(J, "DataView"), hi = kr(J, "Map"), Xa = kr(J, "Promise"), zr = kr(J, "Set"), li = kr(J, "WeakMap"), ui = kr(Dt, "create"), Dn = li && new li(), jr = {}, $g = Ir(Ya), Zg = Ir(hi), Jg = Ir(Xa), Qg = Ir(zr), t2 = Ir(li), Bn = yr ? yr.prototype : n, ci = Bn ? Bn.valueOf : n, Kl = Bn ? Bn.toString : n;
      function k(t) {
        if (jt(t) && !wt(t) && !(t instanceof kt)) {
          if (t instanceof Le)
            return t;
          if (Gt.call(t, "__wrapped__"))
            return Yu(t);
        }
        return new Le(t);
      }
      var Kr = /* @__PURE__ */ function() {
        function t() {
        }
        return function(e) {
          if (!Wt(e))
            return {};
          if (Hl)
            return Hl(e);
          t.prototype = e;
          var i = new t();
          return t.prototype = n, i;
        };
      }();
      function Un() {
      }
      function Le(t, e) {
        this.__wrapped__ = t, this.__actions__ = [], this.__chain__ = !!e, this.__index__ = 0, this.__values__ = n;
      }
      k.templateSettings = {
        /**
         * Used to detect `data` property values to be HTML-escaped.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        escape: g1,
        /**
         * Used to detect code to be evaluated.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        evaluate: p1,
        /**
         * Used to detect `data` property values to inject.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        interpolate: rl,
        /**
         * Used to reference the data object in the template text.
         *
         * @memberOf _.templateSettings
         * @type {string}
         */
        variable: "",
        /**
         * Used to import variables into the compiled template.
         *
         * @memberOf _.templateSettings
         * @type {Object}
         */
        imports: {
          /**
           * A reference to the `lodash` function.
           *
           * @memberOf _.templateSettings.imports
           * @type {Function}
           */
          _: k
        }
      }, k.prototype = Un.prototype, k.prototype.constructor = k, Le.prototype = Kr(Un.prototype), Le.prototype.constructor = Le;
      function kt(t) {
        this.__wrapped__ = t, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = Q, this.__views__ = [];
      }
      function e2() {
        var t = new kt(this.__wrapped__);
        return t.__actions__ = _e(this.__actions__), t.__dir__ = this.__dir__, t.__filtered__ = this.__filtered__, t.__iteratees__ = _e(this.__iteratees__), t.__takeCount__ = this.__takeCount__, t.__views__ = _e(this.__views__), t;
      }
      function r2() {
        if (this.__filtered__) {
          var t = new kt(this);
          t.__dir__ = -1, t.__filtered__ = !0;
        } else
          t = this.clone(), t.__dir__ *= -1;
        return t;
      }
      function i2() {
        var t = this.__wrapped__.value(), e = this.__dir__, i = wt(t), u = e < 0, R = i ? t.length : 0, M = pp(0, R, this.__views__), B = M.start, q = M.end, z = q - B, rt = u ? q : B - 1, it = this.__iteratees__, nt = it.length, ot = 0, dt = le(z, this.__takeCount__);
        if (!i || !u && R == z && dt == z)
          return vu(t, this.__actions__);
        var _t = [];
        t:
          for (; z-- && ot < dt; ) {
            rt += e;
            for (var Ct = -1, vt = t[rt]; ++Ct < nt; ) {
              var Ot = it[Ct], It = Ot.iteratee, Ae = Ot.type, fe = It(vt);
              if (Ae == A)
                vt = fe;
              else if (!fe) {
                if (Ae == P)
                  continue t;
                break t;
              }
            }
            _t[ot++] = vt;
          }
        return _t;
      }
      kt.prototype = Kr(Un.prototype), kt.prototype.constructor = kt;
      function Tr(t) {
        var e = -1, i = t == null ? 0 : t.length;
        for (this.clear(); ++e < i; ) {
          var u = t[e];
          this.set(u[0], u[1]);
        }
      }
      function n2() {
        this.__data__ = ui ? ui(null) : {}, this.size = 0;
      }
      function a2(t) {
        var e = this.has(t) && delete this.__data__[t];
        return this.size -= e ? 1 : 0, e;
      }
      function s2(t) {
        var e = this.__data__;
        if (ui) {
          var i = e[t];
          return i === g ? n : i;
        }
        return Gt.call(e, t) ? e[t] : n;
      }
      function o2(t) {
        var e = this.__data__;
        return ui ? e[t] !== n : Gt.call(e, t);
      }
      function h2(t, e) {
        var i = this.__data__;
        return this.size += this.has(t) ? 0 : 1, i[t] = ui && e === n ? g : e, this;
      }
      Tr.prototype.clear = n2, Tr.prototype.delete = a2, Tr.prototype.get = s2, Tr.prototype.has = o2, Tr.prototype.set = h2;
      function rr(t) {
        var e = -1, i = t == null ? 0 : t.length;
        for (this.clear(); ++e < i; ) {
          var u = t[e];
          this.set(u[0], u[1]);
        }
      }
      function l2() {
        this.__data__ = [], this.size = 0;
      }
      function u2(t) {
        var e = this.__data__, i = qn(e, t);
        if (i < 0)
          return !1;
        var u = e.length - 1;
        return i == u ? e.pop() : Ln.call(e, i, 1), --this.size, !0;
      }
      function c2(t) {
        var e = this.__data__, i = qn(e, t);
        return i < 0 ? n : e[i][1];
      }
      function d2(t) {
        return qn(this.__data__, t) > -1;
      }
      function f2(t, e) {
        var i = this.__data__, u = qn(i, t);
        return u < 0 ? (++this.size, i.push([t, e])) : i[u][1] = e, this;
      }
      rr.prototype.clear = l2, rr.prototype.delete = u2, rr.prototype.get = c2, rr.prototype.has = d2, rr.prototype.set = f2;
      function ir(t) {
        var e = -1, i = t == null ? 0 : t.length;
        for (this.clear(); ++e < i; ) {
          var u = t[e];
          this.set(u[0], u[1]);
        }
      }
      function g2() {
        this.size = 0, this.__data__ = {
          hash: new Tr(),
          map: new (hi || rr)(),
          string: new Tr()
        };
      }
      function p2(t) {
        var e = Qn(this, t).delete(t);
        return this.size -= e ? 1 : 0, e;
      }
      function _2(t) {
        return Qn(this, t).get(t);
      }
      function v2(t) {
        return Qn(this, t).has(t);
      }
      function y2(t, e) {
        var i = Qn(this, t), u = i.size;
        return i.set(t, e), this.size += i.size == u ? 0 : 1, this;
      }
      ir.prototype.clear = g2, ir.prototype.delete = p2, ir.prototype.get = _2, ir.prototype.has = v2, ir.prototype.set = y2;
      function Pr(t) {
        var e = -1, i = t == null ? 0 : t.length;
        for (this.__data__ = new ir(); ++e < i; )
          this.add(t[e]);
      }
      function m2(t) {
        return this.__data__.set(t, g), this;
      }
      function b2(t) {
        return this.__data__.has(t);
      }
      Pr.prototype.add = Pr.prototype.push = m2, Pr.prototype.has = b2;
      function ze(t) {
        var e = this.__data__ = new rr(t);
        this.size = e.size;
      }
      function w2() {
        this.__data__ = new rr(), this.size = 0;
      }
      function S2(t) {
        var e = this.__data__, i = e.delete(t);
        return this.size = e.size, i;
      }
      function C2(t) {
        return this.__data__.get(t);
      }
      function x2(t) {
        return this.__data__.has(t);
      }
      function E2(t, e) {
        var i = this.__data__;
        if (i instanceof rr) {
          var u = i.__data__;
          if (!hi || u.length < c - 1)
            return u.push([t, e]), this.size = ++i.size, this;
          i = this.__data__ = new ir(u);
        }
        return i.set(t, e), this.size = i.size, this;
      }
      ze.prototype.clear = w2, ze.prototype.delete = S2, ze.prototype.get = C2, ze.prototype.has = x2, ze.prototype.set = E2;
      function Yl(t, e) {
        var i = wt(t), u = !i && Lr(t), R = !i && !u && Cr(t), M = !i && !u && !R && Zr(t), B = i || u || R || M, q = B ? Va(t.length, Mg) : [], z = q.length;
        for (var rt in t)
          (e || Gt.call(t, rt)) && !(B && // Safari 9 has enumerable `arguments.length` in strict mode.
          (rt == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
          R && (rt == "offset" || rt == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
          M && (rt == "buffer" || rt == "byteLength" || rt == "byteOffset") || // Skip index properties.
          or(rt, z))) && q.push(rt);
        return q;
      }
      function Xl(t) {
        var e = t.length;
        return e ? t[ss(0, e - 1)] : n;
      }
      function A2(t, e) {
        return ta(_e(t), Or(e, 0, t.length));
      }
      function R2(t) {
        return ta(_e(t));
      }
      function $a(t, e, i) {
        (i !== n && !je(t[e], i) || i === n && !(e in t)) && nr(t, e, i);
      }
      function di(t, e, i) {
        var u = t[e];
        (!(Gt.call(t, e) && je(u, i)) || i === n && !(e in t)) && nr(t, e, i);
      }
      function qn(t, e) {
        for (var i = t.length; i--; )
          if (je(t[i][0], e))
            return i;
        return -1;
      }
      function T2(t, e, i, u) {
        return mr(t, function(R, M, B) {
          e(u, R, i(R), B);
        }), u;
      }
      function $l(t, e) {
        return t && Qe(e, ae(e), t);
      }
      function P2(t, e) {
        return t && Qe(e, ye(e), t);
      }
      function nr(t, e, i) {
        e == "__proto__" && Mn ? Mn(t, e, {
          configurable: !0,
          enumerable: !0,
          value: i,
          writable: !0
        }) : t[e] = i;
      }
      function Za(t, e) {
        for (var i = -1, u = e.length, R = Y(u), M = t == null; ++i < u; )
          R[i] = M ? n : Fs(t, e[i]);
        return R;
      }
      function Or(t, e, i) {
        return t === t && (i !== n && (t = t <= i ? t : i), e !== n && (t = t >= e ? t : e)), t;
      }
      function Me(t, e, i, u, R, M) {
        var B, q = e & w, z = e & x, rt = e & v;
        if (i && (B = R ? i(t, u, R, M) : i(t)), B !== n)
          return B;
        if (!Wt(t))
          return t;
        var it = wt(t);
        if (it) {
          if (B = vp(t), !q)
            return _e(t, B);
        } else {
          var nt = ue(t), ot = nt == gt || nt == Lt;
          if (Cr(t))
            return bu(t, q);
          if (nt == Pt || nt == ht || ot && !R) {
            if (B = z || ot ? {} : Bu(t), !q)
              return z ? sp(t, P2(B, t)) : ap(t, $l(B, t));
          } else {
            if (!Bt[nt])
              return R ? t : {};
            B = yp(t, nt, q);
          }
        }
        M || (M = new ze());
        var dt = M.get(t);
        if (dt)
          return dt;
        M.set(t, B), gc(t) ? t.forEach(function(vt) {
          B.add(Me(vt, e, i, vt, t, M));
        }) : dc(t) && t.forEach(function(vt, Ot) {
          B.set(Ot, Me(vt, e, i, Ot, t, M));
        });
        var _t = rt ? z ? vs : _s : z ? ye : ae, Ct = it ? n : _t(t);
        return ke(Ct || t, function(vt, Ot) {
          Ct && (Ot = vt, vt = t[Ot]), di(B, Ot, Me(vt, e, i, Ot, t, M));
        }), B;
      }
      function O2(t) {
        var e = ae(t);
        return function(i) {
          return Zl(i, t, e);
        };
      }
      function Zl(t, e, i) {
        var u = i.length;
        if (t == null)
          return !u;
        for (t = Dt(t); u--; ) {
          var R = i[u], M = e[R], B = t[R];
          if (B === n && !(R in t) || !M(B))
            return !1;
        }
        return !0;
      }
      function Jl(t, e, i) {
        if (typeof t != "function")
          throw new Ie(h);
        return mi(function() {
          t.apply(n, i);
        }, e);
      }
      function fi(t, e, i, u) {
        var R = -1, M = xn, B = !0, q = t.length, z = [], rt = e.length;
        if (!q)
          return z;
        i && (e = Ht(e, Ce(i))), u ? (M = Ga, B = !1) : e.length >= c && (M = si, B = !1, e = new Pr(e));
        t:
          for (; ++R < q; ) {
            var it = t[R], nt = i == null ? it : i(it);
            if (it = u || it !== 0 ? it : 0, B && nt === nt) {
              for (var ot = rt; ot--; )
                if (e[ot] === nt)
                  continue t;
              z.push(it);
            } else
              M(e, nt, u) || z.push(it);
          }
        return z;
      }
      var mr = Eu(Je), Ql = Eu(Qa, !0);
      function F2(t, e) {
        var i = !0;
        return mr(t, function(u, R, M) {
          return i = !!e(u, R, M), i;
        }), i;
      }
      function Hn(t, e, i) {
        for (var u = -1, R = t.length; ++u < R; ) {
          var M = t[u], B = e(M);
          if (B != null && (q === n ? B === B && !Ee(B) : i(B, q)))
            var q = B, z = M;
        }
        return z;
      }
      function k2(t, e, i, u) {
        var R = t.length;
        for (i = St(i), i < 0 && (i = -i > R ? 0 : R + i), u = u === n || u > R ? R : St(u), u < 0 && (u += R), u = i > u ? 0 : _c(u); i < u; )
          t[i++] = e;
        return t;
      }
      function tu(t, e) {
        var i = [];
        return mr(t, function(u, R, M) {
          e(u, R, M) && i.push(u);
        }), i;
      }
      function he(t, e, i, u, R) {
        var M = -1, B = t.length;
        for (i || (i = bp), R || (R = []); ++M < B; ) {
          var q = t[M];
          e > 0 && i(q) ? e > 1 ? he(q, e - 1, i, u, R) : _r(R, q) : u || (R[R.length] = q);
        }
        return R;
      }
      var Ja = Au(), eu = Au(!0);
      function Je(t, e) {
        return t && Ja(t, e, ae);
      }
      function Qa(t, e) {
        return t && eu(t, e, ae);
      }
      function Vn(t, e) {
        return pr(e, function(i) {
          return hr(t[i]);
        });
      }
      function Fr(t, e) {
        e = wr(e, t);
        for (var i = 0, u = e.length; t != null && i < u; )
          t = t[tr(e[i++])];
        return i && i == u ? t : n;
      }
      function ru(t, e, i) {
        var u = e(t);
        return wt(t) ? u : _r(u, i(t));
      }
      function ce(t) {
        return t == null ? t === n ? qe : ee : Rr && Rr in Dt(t) ? gp(t) : Rp(t);
      }
      function ts(t, e) {
        return t > e;
      }
      function I2(t, e) {
        return t != null && Gt.call(t, e);
      }
      function L2(t, e) {
        return t != null && e in Dt(t);
      }
      function M2(t, e, i) {
        return t >= le(e, i) && t < te(e, i);
      }
      function es(t, e, i) {
        for (var u = i ? Ga : xn, R = t[0].length, M = t.length, B = M, q = Y(M), z = 1 / 0, rt = []; B--; ) {
          var it = t[B];
          B && e && (it = Ht(it, Ce(e))), z = le(it.length, z), q[B] = !i && (e || R >= 120 && it.length >= 120) ? new Pr(B && it) : n;
        }
        it = t[0];
        var nt = -1, ot = q[0];
        t:
          for (; ++nt < R && rt.length < z; ) {
            var dt = it[nt], _t = e ? e(dt) : dt;
            if (dt = i || dt !== 0 ? dt : 0, !(ot ? si(ot, _t) : u(rt, _t, i))) {
              for (B = M; --B; ) {
                var Ct = q[B];
                if (!(Ct ? si(Ct, _t) : u(t[B], _t, i)))
                  continue t;
              }
              ot && ot.push(_t), rt.push(dt);
            }
          }
        return rt;
      }
      function N2(t, e, i, u) {
        return Je(t, function(R, M, B) {
          e(u, i(R), M, B);
        }), u;
      }
      function gi(t, e, i) {
        e = wr(e, t), t = Vu(t, e);
        var u = t == null ? t : t[tr(Ge(e))];
        return u == null ? n : Se(u, t, i);
      }
      function iu(t) {
        return jt(t) && ce(t) == ht;
      }
      function G2(t) {
        return jt(t) && ce(t) == zt;
      }
      function D2(t) {
        return jt(t) && ce(t) == et;
      }
      function pi(t, e, i, u, R) {
        return t === e ? !0 : t == null || e == null || !jt(t) && !jt(e) ? t !== t && e !== e : B2(t, e, i, u, pi, R);
      }
      function B2(t, e, i, u, R, M) {
        var B = wt(t), q = wt(e), z = B ? ct : ue(t), rt = q ? ct : ue(e);
        z = z == ht ? Pt : z, rt = rt == ht ? Pt : rt;
        var it = z == Pt, nt = rt == Pt, ot = z == rt;
        if (ot && Cr(t)) {
          if (!Cr(e))
            return !1;
          B = !0, it = !1;
        }
        if (ot && !it)
          return M || (M = new ze()), B || Zr(t) ? Nu(t, e, i, u, R, M) : dp(t, e, z, i, u, R, M);
        if (!(i & _)) {
          var dt = it && Gt.call(t, "__wrapped__"), _t = nt && Gt.call(e, "__wrapped__");
          if (dt || _t) {
            var Ct = dt ? t.value() : t, vt = _t ? e.value() : e;
            return M || (M = new ze()), R(Ct, vt, i, u, M);
          }
        }
        return ot ? (M || (M = new ze()), fp(t, e, i, u, R, M)) : !1;
      }
      function U2(t) {
        return jt(t) && ue(t) == Et;
      }
      function rs(t, e, i, u) {
        var R = i.length, M = R, B = !u;
        if (t == null)
          return !M;
        for (t = Dt(t); R--; ) {
          var q = i[R];
          if (B && q[2] ? q[1] !== t[q[0]] : !(q[0] in t))
            return !1;
        }
        for (; ++R < M; ) {
          q = i[R];
          var z = q[0], rt = t[z], it = q[1];
          if (B && q[2]) {
            if (rt === n && !(z in t))
              return !1;
          } else {
            var nt = new ze();
            if (u)
              var ot = u(rt, it, z, t, e, nt);
            if (!(ot === n ? pi(it, rt, _ | S, u, nt) : ot))
              return !1;
          }
        }
        return !0;
      }
      function nu(t) {
        if (!Wt(t) || Sp(t))
          return !1;
        var e = hr(t) ? Ug : O1;
        return e.test(Ir(t));
      }
      function q2(t) {
        return jt(t) && ce(t) == re;
      }
      function H2(t) {
        return jt(t) && ue(t) == Zt;
      }
      function V2(t) {
        return jt(t) && sa(t.length) && !!qt[ce(t)];
      }
      function au(t) {
        return typeof t == "function" ? t : t == null ? me : typeof t == "object" ? wt(t) ? hu(t[0], t[1]) : ou(t) : Rc(t);
      }
      function is(t) {
        if (!yi(t))
          return jg(t);
        var e = [];
        for (var i in Dt(t))
          Gt.call(t, i) && i != "constructor" && e.push(i);
        return e;
      }
      function W2(t) {
        if (!Wt(t))
          return Ap(t);
        var e = yi(t), i = [];
        for (var u in t)
          u == "constructor" && (e || !Gt.call(t, u)) || i.push(u);
        return i;
      }
      function ns(t, e) {
        return t < e;
      }
      function su(t, e) {
        var i = -1, u = ve(t) ? Y(t.length) : [];
        return mr(t, function(R, M, B) {
          u[++i] = e(R, M, B);
        }), u;
      }
      function ou(t) {
        var e = ms(t);
        return e.length == 1 && e[0][2] ? qu(e[0][0], e[0][1]) : function(i) {
          return i === t || rs(i, t, e);
        };
      }
      function hu(t, e) {
        return ws(t) && Uu(e) ? qu(tr(t), e) : function(i) {
          var u = Fs(i, t);
          return u === n && u === e ? ks(i, t) : pi(e, u, _ | S);
        };
      }
      function Wn(t, e, i, u, R) {
        t !== e && Ja(e, function(M, B) {
          if (R || (R = new ze()), Wt(M))
            z2(t, e, B, i, Wn, u, R);
          else {
            var q = u ? u(Cs(t, B), M, B + "", t, e, R) : n;
            q === n && (q = M), $a(t, B, q);
          }
        }, ye);
      }
      function z2(t, e, i, u, R, M, B) {
        var q = Cs(t, i), z = Cs(e, i), rt = B.get(z);
        if (rt) {
          $a(t, i, rt);
          return;
        }
        var it = M ? M(q, z, i + "", t, e, B) : n, nt = it === n;
        if (nt) {
          var ot = wt(z), dt = !ot && Cr(z), _t = !ot && !dt && Zr(z);
          it = z, ot || dt || _t ? wt(q) ? it = q : Yt(q) ? it = _e(q) : dt ? (nt = !1, it = bu(z, !0)) : _t ? (nt = !1, it = wu(z, !0)) : it = [] : bi(z) || Lr(z) ? (it = q, Lr(q) ? it = vc(q) : (!Wt(q) || hr(q)) && (it = Bu(z))) : nt = !1;
        }
        nt && (B.set(z, it), R(it, z, u, M, B), B.delete(z)), $a(t, i, it);
      }
      function lu(t, e) {
        var i = t.length;
        if (i)
          return e += e < 0 ? i : 0, or(e, i) ? t[e] : n;
      }
      function uu(t, e, i) {
        e.length ? e = Ht(e, function(M) {
          return wt(M) ? function(B) {
            return Fr(B, M.length === 1 ? M[0] : M);
          } : M;
        }) : e = [me];
        var u = -1;
        e = Ht(e, Ce(pt()));
        var R = su(t, function(M, B, q) {
          var z = Ht(e, function(rt) {
            return rt(M);
          });
          return { criteria: z, index: ++u, value: M };
        });
        return yg(R, function(M, B) {
          return np(M, B, i);
        });
      }
      function j2(t, e) {
        return cu(t, e, function(i, u) {
          return ks(t, u);
        });
      }
      function cu(t, e, i) {
        for (var u = -1, R = e.length, M = {}; ++u < R; ) {
          var B = e[u], q = Fr(t, B);
          i(q, B) && _i(M, wr(B, t), q);
        }
        return M;
      }
      function K2(t) {
        return function(e) {
          return Fr(e, t);
        };
      }
      function as(t, e, i, u) {
        var R = u ? vg : Ur, M = -1, B = e.length, q = t;
        for (t === e && (e = _e(e)), i && (q = Ht(t, Ce(i))); ++M < B; )
          for (var z = 0, rt = e[M], it = i ? i(rt) : rt; (z = R(q, it, z, u)) > -1; )
            q !== t && Ln.call(q, z, 1), Ln.call(t, z, 1);
        return t;
      }
      function du(t, e) {
        for (var i = t ? e.length : 0, u = i - 1; i--; ) {
          var R = e[i];
          if (i == u || R !== M) {
            var M = R;
            or(R) ? Ln.call(t, R, 1) : ls(t, R);
          }
        }
        return t;
      }
      function ss(t, e) {
        return t + Gn(jl() * (e - t + 1));
      }
      function Y2(t, e, i, u) {
        for (var R = -1, M = te(Nn((e - t) / (i || 1)), 0), B = Y(M); M--; )
          B[u ? M : ++R] = t, t += i;
        return B;
      }
      function os(t, e) {
        var i = "";
        if (!t || e < 1 || e > K)
          return i;
        do
          e % 2 && (i += t), e = Gn(e / 2), e && (t += t);
        while (e);
        return i;
      }
      function At(t, e) {
        return xs(Hu(t, e, me), t + "");
      }
      function X2(t) {
        return Xl(Jr(t));
      }
      function $2(t, e) {
        var i = Jr(t);
        return ta(i, Or(e, 0, i.length));
      }
      function _i(t, e, i, u) {
        if (!Wt(t))
          return t;
        e = wr(e, t);
        for (var R = -1, M = e.length, B = M - 1, q = t; q != null && ++R < M; ) {
          var z = tr(e[R]), rt = i;
          if (z === "__proto__" || z === "constructor" || z === "prototype")
            return t;
          if (R != B) {
            var it = q[z];
            rt = u ? u(it, z, q) : n, rt === n && (rt = Wt(it) ? it : or(e[R + 1]) ? [] : {});
          }
          di(q, z, rt), q = q[z];
        }
        return t;
      }
      var fu = Dn ? function(t, e) {
        return Dn.set(t, e), t;
      } : me, Z2 = Mn ? function(t, e) {
        return Mn(t, "toString", {
          configurable: !0,
          enumerable: !1,
          value: Ls(e),
          writable: !0
        });
      } : me;
      function J2(t) {
        return ta(Jr(t));
      }
      function Ne(t, e, i) {
        var u = -1, R = t.length;
        e < 0 && (e = -e > R ? 0 : R + e), i = i > R ? R : i, i < 0 && (i += R), R = e > i ? 0 : i - e >>> 0, e >>>= 0;
        for (var M = Y(R); ++u < R; )
          M[u] = t[u + e];
        return M;
      }
      function Q2(t, e) {
        var i;
        return mr(t, function(u, R, M) {
          return i = e(u, R, M), !i;
        }), !!i;
      }
      function zn(t, e, i) {
        var u = 0, R = t == null ? u : t.length;
        if (typeof e == "number" && e === e && R <= Z) {
          for (; u < R; ) {
            var M = u + R >>> 1, B = t[M];
            B !== null && !Ee(B) && (i ? B <= e : B < e) ? u = M + 1 : R = M;
          }
          return R;
        }
        return hs(t, e, me, i);
      }
      function hs(t, e, i, u) {
        var R = 0, M = t == null ? 0 : t.length;
        if (M === 0)
          return 0;
        e = i(e);
        for (var B = e !== e, q = e === null, z = Ee(e), rt = e === n; R < M; ) {
          var it = Gn((R + M) / 2), nt = i(t[it]), ot = nt !== n, dt = nt === null, _t = nt === nt, Ct = Ee(nt);
          if (B)
            var vt = u || _t;
          else
            rt ? vt = _t && (u || ot) : q ? vt = _t && ot && (u || !dt) : z ? vt = _t && ot && !dt && (u || !Ct) : dt || Ct ? vt = !1 : vt = u ? nt <= e : nt < e;
          vt ? R = it + 1 : M = it;
        }
        return le(M, st);
      }
      function gu(t, e) {
        for (var i = -1, u = t.length, R = 0, M = []; ++i < u; ) {
          var B = t[i], q = e ? e(B) : B;
          if (!i || !je(q, z)) {
            var z = q;
            M[R++] = B === 0 ? 0 : B;
          }
        }
        return M;
      }
      function pu(t) {
        return typeof t == "number" ? t : Ee(t) ? X : +t;
      }
      function xe(t) {
        if (typeof t == "string")
          return t;
        if (wt(t))
          return Ht(t, xe) + "";
        if (Ee(t))
          return Kl ? Kl.call(t) : "";
        var e = t + "";
        return e == "0" && 1 / t == -1 / 0 ? "-0" : e;
      }
      function br(t, e, i) {
        var u = -1, R = xn, M = t.length, B = !0, q = [], z = q;
        if (i)
          B = !1, R = Ga;
        else if (M >= c) {
          var rt = e ? null : up(t);
          if (rt)
            return An(rt);
          B = !1, R = si, z = new Pr();
        } else
          z = e ? [] : q;
        t:
          for (; ++u < M; ) {
            var it = t[u], nt = e ? e(it) : it;
            if (it = i || it !== 0 ? it : 0, B && nt === nt) {
              for (var ot = z.length; ot--; )
                if (z[ot] === nt)
                  continue t;
              e && z.push(nt), q.push(it);
            } else
              R(z, nt, i) || (z !== q && z.push(nt), q.push(it));
          }
        return q;
      }
      function ls(t, e) {
        return e = wr(e, t), t = Vu(t, e), t == null || delete t[tr(Ge(e))];
      }
      function _u(t, e, i, u) {
        return _i(t, e, i(Fr(t, e)), u);
      }
      function jn(t, e, i, u) {
        for (var R = t.length, M = u ? R : -1; (u ? M-- : ++M < R) && e(t[M], M, t); )
          ;
        return i ? Ne(t, u ? 0 : M, u ? M + 1 : R) : Ne(t, u ? M + 1 : 0, u ? R : M);
      }
      function vu(t, e) {
        var i = t;
        return i instanceof kt && (i = i.value()), Da(e, function(u, R) {
          return R.func.apply(R.thisArg, _r([u], R.args));
        }, i);
      }
      function us(t, e, i) {
        var u = t.length;
        if (u < 2)
          return u ? br(t[0]) : [];
        for (var R = -1, M = Y(u); ++R < u; )
          for (var B = t[R], q = -1; ++q < u; )
            q != R && (M[R] = fi(M[R] || B, t[q], e, i));
        return br(he(M, 1), e, i);
      }
      function yu(t, e, i) {
        for (var u = -1, R = t.length, M = e.length, B = {}; ++u < R; ) {
          var q = u < M ? e[u] : n;
          i(B, t[u], q);
        }
        return B;
      }
      function cs(t) {
        return Yt(t) ? t : [];
      }
      function ds(t) {
        return typeof t == "function" ? t : me;
      }
      function wr(t, e) {
        return wt(t) ? t : ws(t, e) ? [t] : Ku(Nt(t));
      }
      var tp = At;
      function Sr(t, e, i) {
        var u = t.length;
        return i = i === n ? u : i, !e && i >= u ? t : Ne(t, e, i);
      }
      var mu = qg || function(t) {
        return oe.clearTimeout(t);
      };
      function bu(t, e) {
        if (e)
          return t.slice();
        var i = t.length, u = ql ? ql(i) : new t.constructor(i);
        return t.copy(u), u;
      }
      function fs(t) {
        var e = new t.constructor(t.byteLength);
        return new kn(e).set(new kn(t)), e;
      }
      function ep(t, e) {
        var i = e ? fs(t.buffer) : t.buffer;
        return new t.constructor(i, t.byteOffset, t.byteLength);
      }
      function rp(t) {
        var e = new t.constructor(t.source, il.exec(t));
        return e.lastIndex = t.lastIndex, e;
      }
      function ip(t) {
        return ci ? Dt(ci.call(t)) : {};
      }
      function wu(t, e) {
        var i = e ? fs(t.buffer) : t.buffer;
        return new t.constructor(i, t.byteOffset, t.length);
      }
      function Su(t, e) {
        if (t !== e) {
          var i = t !== n, u = t === null, R = t === t, M = Ee(t), B = e !== n, q = e === null, z = e === e, rt = Ee(e);
          if (!q && !rt && !M && t > e || M && B && z && !q && !rt || u && B && z || !i && z || !R)
            return 1;
          if (!u && !M && !rt && t < e || rt && i && R && !u && !M || q && i && R || !B && R || !z)
            return -1;
        }
        return 0;
      }
      function np(t, e, i) {
        for (var u = -1, R = t.criteria, M = e.criteria, B = R.length, q = i.length; ++u < B; ) {
          var z = Su(R[u], M[u]);
          if (z) {
            if (u >= q)
              return z;
            var rt = i[u];
            return z * (rt == "desc" ? -1 : 1);
          }
        }
        return t.index - e.index;
      }
      function Cu(t, e, i, u) {
        for (var R = -1, M = t.length, B = i.length, q = -1, z = e.length, rt = te(M - B, 0), it = Y(z + rt), nt = !u; ++q < z; )
          it[q] = e[q];
        for (; ++R < B; )
          (nt || R < M) && (it[i[R]] = t[R]);
        for (; rt--; )
          it[q++] = t[R++];
        return it;
      }
      function xu(t, e, i, u) {
        for (var R = -1, M = t.length, B = -1, q = i.length, z = -1, rt = e.length, it = te(M - q, 0), nt = Y(it + rt), ot = !u; ++R < it; )
          nt[R] = t[R];
        for (var dt = R; ++z < rt; )
          nt[dt + z] = e[z];
        for (; ++B < q; )
          (ot || R < M) && (nt[dt + i[B]] = t[R++]);
        return nt;
      }
      function _e(t, e) {
        var i = -1, u = t.length;
        for (e || (e = Y(u)); ++i < u; )
          e[i] = t[i];
        return e;
      }
      function Qe(t, e, i, u) {
        var R = !i;
        i || (i = {});
        for (var M = -1, B = e.length; ++M < B; ) {
          var q = e[M], z = u ? u(i[q], t[q], q, i, t) : n;
          z === n && (z = t[q]), R ? nr(i, q, z) : di(i, q, z);
        }
        return i;
      }
      function ap(t, e) {
        return Qe(t, bs(t), e);
      }
      function sp(t, e) {
        return Qe(t, Gu(t), e);
      }
      function Kn(t, e) {
        return function(i, u) {
          var R = wt(i) ? cg : T2, M = e ? e() : {};
          return R(i, t, pt(u, 2), M);
        };
      }
      function Yr(t) {
        return At(function(e, i) {
          var u = -1, R = i.length, M = R > 1 ? i[R - 1] : n, B = R > 2 ? i[2] : n;
          for (M = t.length > 3 && typeof M == "function" ? (R--, M) : n, B && de(i[0], i[1], B) && (M = R < 3 ? n : M, R = 1), e = Dt(e); ++u < R; ) {
            var q = i[u];
            q && t(e, q, u, M);
          }
          return e;
        });
      }
      function Eu(t, e) {
        return function(i, u) {
          if (i == null)
            return i;
          if (!ve(i))
            return t(i, u);
          for (var R = i.length, M = e ? R : -1, B = Dt(i); (e ? M-- : ++M < R) && u(B[M], M, B) !== !1; )
            ;
          return i;
        };
      }
      function Au(t) {
        return function(e, i, u) {
          for (var R = -1, M = Dt(e), B = u(e), q = B.length; q--; ) {
            var z = B[t ? q : ++R];
            if (i(M[z], z, M) === !1)
              break;
          }
          return e;
        };
      }
      function op(t, e, i) {
        var u = e & C, R = vi(t);
        function M() {
          var B = this && this !== oe && this instanceof M ? R : t;
          return B.apply(u ? i : this, arguments);
        }
        return M;
      }
      function Ru(t) {
        return function(e) {
          e = Nt(e);
          var i = qr(e) ? We(e) : n, u = i ? i[0] : e.charAt(0), R = i ? Sr(i, 1).join("") : e.slice(1);
          return u[t]() + R;
        };
      }
      function Xr(t) {
        return function(e) {
          return Da(Ec(xc(e).replace(Z1, "")), t, "");
        };
      }
      function vi(t) {
        return function() {
          var e = arguments;
          switch (e.length) {
            case 0:
              return new t();
            case 1:
              return new t(e[0]);
            case 2:
              return new t(e[0], e[1]);
            case 3:
              return new t(e[0], e[1], e[2]);
            case 4:
              return new t(e[0], e[1], e[2], e[3]);
            case 5:
              return new t(e[0], e[1], e[2], e[3], e[4]);
            case 6:
              return new t(e[0], e[1], e[2], e[3], e[4], e[5]);
            case 7:
              return new t(e[0], e[1], e[2], e[3], e[4], e[5], e[6]);
          }
          var i = Kr(t.prototype), u = t.apply(i, e);
          return Wt(u) ? u : i;
        };
      }
      function hp(t, e, i) {
        var u = vi(t);
        function R() {
          for (var M = arguments.length, B = Y(M), q = M, z = $r(R); q--; )
            B[q] = arguments[q];
          var rt = M < 3 && B[0] !== z && B[M - 1] !== z ? [] : vr(B, z);
          if (M -= rt.length, M < i)
            return ku(
              t,
              e,
              Yn,
              R.placeholder,
              n,
              B,
              rt,
              n,
              n,
              i - M
            );
          var it = this && this !== oe && this instanceof R ? u : t;
          return Se(it, this, B);
        }
        return R;
      }
      function Tu(t) {
        return function(e, i, u) {
          var R = Dt(e);
          if (!ve(e)) {
            var M = pt(i, 3);
            e = ae(e), i = function(q) {
              return M(R[q], q, R);
            };
          }
          var B = t(e, i, u);
          return B > -1 ? R[M ? e[B] : B] : n;
        };
      }
      function Pu(t) {
        return sr(function(e) {
          var i = e.length, u = i, R = Le.prototype.thru;
          for (t && e.reverse(); u--; ) {
            var M = e[u];
            if (typeof M != "function")
              throw new Ie(h);
            if (R && !B && Jn(M) == "wrapper")
              var B = new Le([], !0);
          }
          for (u = B ? u : i; ++u < i; ) {
            M = e[u];
            var q = Jn(M), z = q == "wrapper" ? ys(M) : n;
            z && Ss(z[0]) && z[1] == (D | f | E | I) && !z[4].length && z[9] == 1 ? B = B[Jn(z[0])].apply(B, z[3]) : B = M.length == 1 && Ss(M) ? B[q]() : B.thru(M);
          }
          return function() {
            var rt = arguments, it = rt[0];
            if (B && rt.length == 1 && wt(it))
              return B.plant(it).value();
            for (var nt = 0, ot = i ? e[nt].apply(this, rt) : it; ++nt < i; )
              ot = e[nt].call(this, ot);
            return ot;
          };
        });
      }
      function Yn(t, e, i, u, R, M, B, q, z, rt) {
        var it = e & D, nt = e & C, ot = e & O, dt = e & (f | m), _t = e & L, Ct = ot ? n : vi(t);
        function vt() {
          for (var Ot = arguments.length, It = Y(Ot), Ae = Ot; Ae--; )
            It[Ae] = arguments[Ae];
          if (dt)
            var fe = $r(vt), Re = bg(It, fe);
          if (u && (It = Cu(It, u, R, dt)), M && (It = xu(It, M, B, dt)), Ot -= Re, dt && Ot < rt) {
            var Xt = vr(It, fe);
            return ku(
              t,
              e,
              Yn,
              vt.placeholder,
              i,
              It,
              Xt,
              q,
              z,
              rt - Ot
            );
          }
          var Ke = nt ? i : this, ur = ot ? Ke[t] : t;
          return Ot = It.length, q ? It = Tp(It, q) : _t && Ot > 1 && It.reverse(), it && z < Ot && (It.length = z), this && this !== oe && this instanceof vt && (ur = Ct || vi(ur)), ur.apply(Ke, It);
        }
        return vt;
      }
      function Ou(t, e) {
        return function(i, u) {
          return N2(i, t, e(u), {});
        };
      }
      function Xn(t, e) {
        return function(i, u) {
          var R;
          if (i === n && u === n)
            return e;
          if (i !== n && (R = i), u !== n) {
            if (R === n)
              return u;
            typeof i == "string" || typeof u == "string" ? (i = xe(i), u = xe(u)) : (i = pu(i), u = pu(u)), R = t(i, u);
          }
          return R;
        };
      }
      function gs(t) {
        return sr(function(e) {
          return e = Ht(e, Ce(pt())), At(function(i) {
            var u = this;
            return t(e, function(R) {
              return Se(R, u, i);
            });
          });
        });
      }
      function $n(t, e) {
        e = e === n ? " " : xe(e);
        var i = e.length;
        if (i < 2)
          return i ? os(e, t) : e;
        var u = os(e, Nn(t / Hr(e)));
        return qr(e) ? Sr(We(u), 0, t).join("") : u.slice(0, t);
      }
      function lp(t, e, i, u) {
        var R = e & C, M = vi(t);
        function B() {
          for (var q = -1, z = arguments.length, rt = -1, it = u.length, nt = Y(it + z), ot = this && this !== oe && this instanceof B ? M : t; ++rt < it; )
            nt[rt] = u[rt];
          for (; z--; )
            nt[rt++] = arguments[++q];
          return Se(ot, R ? i : this, nt);
        }
        return B;
      }
      function Fu(t) {
        return function(e, i, u) {
          return u && typeof u != "number" && de(e, i, u) && (i = u = n), e = lr(e), i === n ? (i = e, e = 0) : i = lr(i), u = u === n ? e < i ? 1 : -1 : lr(u), Y2(e, i, u, t);
        };
      }
      function Zn(t) {
        return function(e, i) {
          return typeof e == "string" && typeof i == "string" || (e = De(e), i = De(i)), t(e, i);
        };
      }
      function ku(t, e, i, u, R, M, B, q, z, rt) {
        var it = e & f, nt = it ? B : n, ot = it ? n : B, dt = it ? M : n, _t = it ? n : M;
        e |= it ? E : T, e &= ~(it ? T : E), e & d || (e &= -4);
        var Ct = [
          t,
          e,
          R,
          dt,
          nt,
          _t,
          ot,
          q,
          z,
          rt
        ], vt = i.apply(n, Ct);
        return Ss(t) && Wu(vt, Ct), vt.placeholder = u, zu(vt, t, e);
      }
      function ps(t) {
        var e = Qt[t];
        return function(i, u) {
          if (i = De(i), u = u == null ? 0 : le(St(u), 292), u && zl(i)) {
            var R = (Nt(i) + "e").split("e"), M = e(R[0] + "e" + (+R[1] + u));
            return R = (Nt(M) + "e").split("e"), +(R[0] + "e" + (+R[1] - u));
          }
          return e(i);
        };
      }
      var up = zr && 1 / An(new zr([, -0]))[1] == U ? function(t) {
        return new zr(t);
      } : Gs;
      function Iu(t) {
        return function(e) {
          var i = ue(e);
          return i == Et ? za(e) : i == Zt ? Rg(e) : mg(e, t(e));
        };
      }
      function ar(t, e, i, u, R, M, B, q) {
        var z = e & O;
        if (!z && typeof t != "function")
          throw new Ie(h);
        var rt = u ? u.length : 0;
        if (rt || (e &= -97, u = R = n), B = B === n ? B : te(St(B), 0), q = q === n ? q : St(q), rt -= R ? R.length : 0, e & T) {
          var it = u, nt = R;
          u = R = n;
        }
        var ot = z ? n : ys(t), dt = [
          t,
          e,
          i,
          u,
          R,
          it,
          nt,
          M,
          B,
          q
        ];
        if (ot && Ep(dt, ot), t = dt[0], e = dt[1], i = dt[2], u = dt[3], R = dt[4], q = dt[9] = dt[9] === n ? z ? 0 : t.length : te(dt[9] - rt, 0), !q && e & (f | m) && (e &= -25), !e || e == C)
          var _t = op(t, e, i);
        else
          e == f || e == m ? _t = hp(t, e, q) : (e == E || e == (C | E)) && !R.length ? _t = lp(t, e, i, u) : _t = Yn.apply(n, dt);
        var Ct = ot ? fu : Wu;
        return zu(Ct(_t, dt), t, e);
      }
      function Lu(t, e, i, u) {
        return t === n || je(t, Wr[i]) && !Gt.call(u, i) ? e : t;
      }
      function Mu(t, e, i, u, R, M) {
        return Wt(t) && Wt(e) && (M.set(e, t), Wn(t, e, n, Mu, M), M.delete(e)), t;
      }
      function cp(t) {
        return bi(t) ? n : t;
      }
      function Nu(t, e, i, u, R, M) {
        var B = i & _, q = t.length, z = e.length;
        if (q != z && !(B && z > q))
          return !1;
        var rt = M.get(t), it = M.get(e);
        if (rt && it)
          return rt == e && it == t;
        var nt = -1, ot = !0, dt = i & S ? new Pr() : n;
        for (M.set(t, e), M.set(e, t); ++nt < q; ) {
          var _t = t[nt], Ct = e[nt];
          if (u)
            var vt = B ? u(Ct, _t, nt, e, t, M) : u(_t, Ct, nt, t, e, M);
          if (vt !== n) {
            if (vt)
              continue;
            ot = !1;
            break;
          }
          if (dt) {
            if (!Ba(e, function(Ot, It) {
              if (!si(dt, It) && (_t === Ot || R(_t, Ot, i, u, M)))
                return dt.push(It);
            })) {
              ot = !1;
              break;
            }
          } else if (!(_t === Ct || R(_t, Ct, i, u, M))) {
            ot = !1;
            break;
          }
        }
        return M.delete(t), M.delete(e), ot;
      }
      function dp(t, e, i, u, R, M, B) {
        switch (i) {
          case ne:
            if (t.byteLength != e.byteLength || t.byteOffset != e.byteOffset)
              return !1;
            t = t.buffer, e = e.buffer;
          case zt:
            return !(t.byteLength != e.byteLength || !M(new kn(t), new kn(e)));
          case j:
          case et:
          case mt:
            return je(+t, +e);
          case ft:
            return t.name == e.name && t.message == e.message;
          case re:
          case Jt:
            return t == e + "";
          case Et:
            var q = za;
          case Zt:
            var z = u & _;
            if (q || (q = An), t.size != e.size && !z)
              return !1;
            var rt = B.get(t);
            if (rt)
              return rt == e;
            u |= S, B.set(t, e);
            var it = Nu(q(t), q(e), u, R, M, B);
            return B.delete(t), it;
          case Ut:
            if (ci)
              return ci.call(t) == ci.call(e);
        }
        return !1;
      }
      function fp(t, e, i, u, R, M) {
        var B = i & _, q = _s(t), z = q.length, rt = _s(e), it = rt.length;
        if (z != it && !B)
          return !1;
        for (var nt = z; nt--; ) {
          var ot = q[nt];
          if (!(B ? ot in e : Gt.call(e, ot)))
            return !1;
        }
        var dt = M.get(t), _t = M.get(e);
        if (dt && _t)
          return dt == e && _t == t;
        var Ct = !0;
        M.set(t, e), M.set(e, t);
        for (var vt = B; ++nt < z; ) {
          ot = q[nt];
          var Ot = t[ot], It = e[ot];
          if (u)
            var Ae = B ? u(It, Ot, ot, e, t, M) : u(Ot, It, ot, t, e, M);
          if (!(Ae === n ? Ot === It || R(Ot, It, i, u, M) : Ae)) {
            Ct = !1;
            break;
          }
          vt || (vt = ot == "constructor");
        }
        if (Ct && !vt) {
          var fe = t.constructor, Re = e.constructor;
          fe != Re && "constructor" in t && "constructor" in e && !(typeof fe == "function" && fe instanceof fe && typeof Re == "function" && Re instanceof Re) && (Ct = !1);
        }
        return M.delete(t), M.delete(e), Ct;
      }
      function sr(t) {
        return xs(Hu(t, n, Zu), t + "");
      }
      function _s(t) {
        return ru(t, ae, bs);
      }
      function vs(t) {
        return ru(t, ye, Gu);
      }
      var ys = Dn ? function(t) {
        return Dn.get(t);
      } : Gs;
      function Jn(t) {
        for (var e = t.name + "", i = jr[e], u = Gt.call(jr, e) ? i.length : 0; u--; ) {
          var R = i[u], M = R.func;
          if (M == null || M == t)
            return R.name;
        }
        return e;
      }
      function $r(t) {
        var e = Gt.call(k, "placeholder") ? k : t;
        return e.placeholder;
      }
      function pt() {
        var t = k.iteratee || Ms;
        return t = t === Ms ? au : t, arguments.length ? t(arguments[0], arguments[1]) : t;
      }
      function Qn(t, e) {
        var i = t.__data__;
        return wp(e) ? i[typeof e == "string" ? "string" : "hash"] : i.map;
      }
      function ms(t) {
        for (var e = ae(t), i = e.length; i--; ) {
          var u = e[i], R = t[u];
          e[i] = [u, R, Uu(R)];
        }
        return e;
      }
      function kr(t, e) {
        var i = xg(t, e);
        return nu(i) ? i : n;
      }
      function gp(t) {
        var e = Gt.call(t, Rr), i = t[Rr];
        try {
          t[Rr] = n;
          var u = !0;
        } catch {
        }
        var R = On.call(t);
        return u && (e ? t[Rr] = i : delete t[Rr]), R;
      }
      var bs = Ka ? function(t) {
        return t == null ? [] : (t = Dt(t), pr(Ka(t), function(e) {
          return Vl.call(t, e);
        }));
      } : Ds, Gu = Ka ? function(t) {
        for (var e = []; t; )
          _r(e, bs(t)), t = In(t);
        return e;
      } : Ds, ue = ce;
      (Ya && ue(new Ya(new ArrayBuffer(1))) != ne || hi && ue(new hi()) != Et || Xa && ue(Xa.resolve()) != Vt || zr && ue(new zr()) != Zt || li && ue(new li()) != ie) && (ue = function(t) {
        var e = ce(t), i = e == Pt ? t.constructor : n, u = i ? Ir(i) : "";
        if (u)
          switch (u) {
            case $g:
              return ne;
            case Zg:
              return Et;
            case Jg:
              return Vt;
            case Qg:
              return Zt;
            case t2:
              return ie;
          }
        return e;
      });
      function pp(t, e, i) {
        for (var u = -1, R = i.length; ++u < R; ) {
          var M = i[u], B = M.size;
          switch (M.type) {
            case "drop":
              t += B;
              break;
            case "dropRight":
              e -= B;
              break;
            case "take":
              e = le(e, t + B);
              break;
            case "takeRight":
              t = te(t, e - B);
              break;
          }
        }
        return { start: t, end: e };
      }
      function _p(t) {
        var e = t.match(S1);
        return e ? e[1].split(C1) : [];
      }
      function Du(t, e, i) {
        e = wr(e, t);
        for (var u = -1, R = e.length, M = !1; ++u < R; ) {
          var B = tr(e[u]);
          if (!(M = t != null && i(t, B)))
            break;
          t = t[B];
        }
        return M || ++u != R ? M : (R = t == null ? 0 : t.length, !!R && sa(R) && or(B, R) && (wt(t) || Lr(t)));
      }
      function vp(t) {
        var e = t.length, i = new t.constructor(e);
        return e && typeof t[0] == "string" && Gt.call(t, "index") && (i.index = t.index, i.input = t.input), i;
      }
      function Bu(t) {
        return typeof t.constructor == "function" && !yi(t) ? Kr(In(t)) : {};
      }
      function yp(t, e, i) {
        var u = t.constructor;
        switch (e) {
          case zt:
            return fs(t);
          case j:
          case et:
            return new u(+t);
          case ne:
            return ep(t, i);
          case Pe:
          case pe:
          case $e:
          case Aa:
          case Ve:
          case Oe:
          case Ze:
          case ai:
          case Ra:
            return wu(t, i);
          case Et:
            return new u();
          case mt:
          case Jt:
            return new u(t);
          case re:
            return rp(t);
          case Zt:
            return new u();
          case Ut:
            return ip(t);
        }
      }
      function mp(t, e) {
        var i = e.length;
        if (!i)
          return t;
        var u = i - 1;
        return e[u] = (i > 1 ? "& " : "") + e[u], e = e.join(i > 2 ? ", " : " "), t.replace(w1, `{
/* [wrapped with ` + e + `] */
`);
      }
      function bp(t) {
        return wt(t) || Lr(t) || !!(Wl && t && t[Wl]);
      }
      function or(t, e) {
        var i = typeof t;
        return e = e == null ? K : e, !!e && (i == "number" || i != "symbol" && k1.test(t)) && t > -1 && t % 1 == 0 && t < e;
      }
      function de(t, e, i) {
        if (!Wt(i))
          return !1;
        var u = typeof e;
        return (u == "number" ? ve(i) && or(e, i.length) : u == "string" && e in i) ? je(i[e], t) : !1;
      }
      function ws(t, e) {
        if (wt(t))
          return !1;
        var i = typeof t;
        return i == "number" || i == "symbol" || i == "boolean" || t == null || Ee(t) ? !0 : v1.test(t) || !_1.test(t) || e != null && t in Dt(e);
      }
      function wp(t) {
        var e = typeof t;
        return e == "string" || e == "number" || e == "symbol" || e == "boolean" ? t !== "__proto__" : t === null;
      }
      function Ss(t) {
        var e = Jn(t), i = k[e];
        if (typeof i != "function" || !(e in kt.prototype))
          return !1;
        if (t === i)
          return !0;
        var u = ys(i);
        return !!u && t === u[0];
      }
      function Sp(t) {
        return !!Ul && Ul in t;
      }
      var Cp = Tn ? hr : Bs;
      function yi(t) {
        var e = t && t.constructor, i = typeof e == "function" && e.prototype || Wr;
        return t === i;
      }
      function Uu(t) {
        return t === t && !Wt(t);
      }
      function qu(t, e) {
        return function(i) {
          return i == null ? !1 : i[t] === e && (e !== n || t in Dt(i));
        };
      }
      function xp(t) {
        var e = na(t, function(u) {
          return i.size === p && i.clear(), u;
        }), i = e.cache;
        return e;
      }
      function Ep(t, e) {
        var i = t[1], u = e[1], R = i | u, M = R < (C | O | D), B = u == D && i == f || u == D && i == I && t[7].length <= e[8] || u == (D | I) && e[7].length <= e[8] && i == f;
        if (!(M || B))
          return t;
        u & C && (t[2] = e[2], R |= i & C ? 0 : d);
        var q = e[3];
        if (q) {
          var z = t[3];
          t[3] = z ? Cu(z, q, e[4]) : q, t[4] = z ? vr(t[3], b) : e[4];
        }
        return q = e[5], q && (z = t[5], t[5] = z ? xu(z, q, e[6]) : q, t[6] = z ? vr(t[5], b) : e[6]), q = e[7], q && (t[7] = q), u & D && (t[8] = t[8] == null ? e[8] : le(t[8], e[8])), t[9] == null && (t[9] = e[9]), t[0] = e[0], t[1] = R, t;
      }
      function Ap(t) {
        var e = [];
        if (t != null)
          for (var i in Dt(t))
            e.push(i);
        return e;
      }
      function Rp(t) {
        return On.call(t);
      }
      function Hu(t, e, i) {
        return e = te(e === n ? t.length - 1 : e, 0), function() {
          for (var u = arguments, R = -1, M = te(u.length - e, 0), B = Y(M); ++R < M; )
            B[R] = u[e + R];
          R = -1;
          for (var q = Y(e + 1); ++R < e; )
            q[R] = u[R];
          return q[e] = i(B), Se(t, this, q);
        };
      }
      function Vu(t, e) {
        return e.length < 2 ? t : Fr(t, Ne(e, 0, -1));
      }
      function Tp(t, e) {
        for (var i = t.length, u = le(e.length, i), R = _e(t); u--; ) {
          var M = e[u];
          t[u] = or(M, i) ? R[M] : n;
        }
        return t;
      }
      function Cs(t, e) {
        if (!(e === "constructor" && typeof t[e] == "function") && e != "__proto__")
          return t[e];
      }
      var Wu = ju(fu), mi = Vg || function(t, e) {
        return oe.setTimeout(t, e);
      }, xs = ju(Z2);
      function zu(t, e, i) {
        var u = e + "";
        return xs(t, mp(u, Pp(_p(u), i)));
      }
      function ju(t) {
        var e = 0, i = 0;
        return function() {
          var u = Kg(), R = y - (u - i);
          if (i = u, R > 0) {
            if (++e >= H)
              return arguments[0];
          } else
            e = 0;
          return t.apply(n, arguments);
        };
      }
      function ta(t, e) {
        var i = -1, u = t.length, R = u - 1;
        for (e = e === n ? u : e; ++i < e; ) {
          var M = ss(i, R), B = t[M];
          t[M] = t[i], t[i] = B;
        }
        return t.length = e, t;
      }
      var Ku = xp(function(t) {
        var e = [];
        return t.charCodeAt(0) === 46 && e.push(""), t.replace(y1, function(i, u, R, M) {
          e.push(R ? M.replace(A1, "$1") : u || i);
        }), e;
      });
      function tr(t) {
        if (typeof t == "string" || Ee(t))
          return t;
        var e = t + "";
        return e == "0" && 1 / t == -1 / 0 ? "-0" : e;
      }
      function Ir(t) {
        if (t != null) {
          try {
            return Pn.call(t);
          } catch {
          }
          try {
            return t + "";
          } catch {
          }
        }
        return "";
      }
      function Pp(t, e) {
        return ke(at, function(i) {
          var u = "_." + i[0];
          e & i[1] && !xn(t, u) && t.push(u);
        }), t.sort();
      }
      function Yu(t) {
        if (t instanceof kt)
          return t.clone();
        var e = new Le(t.__wrapped__, t.__chain__);
        return e.__actions__ = _e(t.__actions__), e.__index__ = t.__index__, e.__values__ = t.__values__, e;
      }
      function Op(t, e, i) {
        (i ? de(t, e, i) : e === n) ? e = 1 : e = te(St(e), 0);
        var u = t == null ? 0 : t.length;
        if (!u || e < 1)
          return [];
        for (var R = 0, M = 0, B = Y(Nn(u / e)); R < u; )
          B[M++] = Ne(t, R, R += e);
        return B;
      }
      function Fp(t) {
        for (var e = -1, i = t == null ? 0 : t.length, u = 0, R = []; ++e < i; ) {
          var M = t[e];
          M && (R[u++] = M);
        }
        return R;
      }
      function kp() {
        var t = arguments.length;
        if (!t)
          return [];
        for (var e = Y(t - 1), i = arguments[0], u = t; u--; )
          e[u - 1] = arguments[u];
        return _r(wt(i) ? _e(i) : [i], he(e, 1));
      }
      var Ip = At(function(t, e) {
        return Yt(t) ? fi(t, he(e, 1, Yt, !0)) : [];
      }), Lp = At(function(t, e) {
        var i = Ge(e);
        return Yt(i) && (i = n), Yt(t) ? fi(t, he(e, 1, Yt, !0), pt(i, 2)) : [];
      }), Mp = At(function(t, e) {
        var i = Ge(e);
        return Yt(i) && (i = n), Yt(t) ? fi(t, he(e, 1, Yt, !0), n, i) : [];
      });
      function Np(t, e, i) {
        var u = t == null ? 0 : t.length;
        return u ? (e = i || e === n ? 1 : St(e), Ne(t, e < 0 ? 0 : e, u)) : [];
      }
      function Gp(t, e, i) {
        var u = t == null ? 0 : t.length;
        return u ? (e = i || e === n ? 1 : St(e), e = u - e, Ne(t, 0, e < 0 ? 0 : e)) : [];
      }
      function Dp(t, e) {
        return t && t.length ? jn(t, pt(e, 3), !0, !0) : [];
      }
      function Bp(t, e) {
        return t && t.length ? jn(t, pt(e, 3), !0) : [];
      }
      function Up(t, e, i, u) {
        var R = t == null ? 0 : t.length;
        return R ? (i && typeof i != "number" && de(t, e, i) && (i = 0, u = R), k2(t, e, i, u)) : [];
      }
      function Xu(t, e, i) {
        var u = t == null ? 0 : t.length;
        if (!u)
          return -1;
        var R = i == null ? 0 : St(i);
        return R < 0 && (R = te(u + R, 0)), En(t, pt(e, 3), R);
      }
      function $u(t, e, i) {
        var u = t == null ? 0 : t.length;
        if (!u)
          return -1;
        var R = u - 1;
        return i !== n && (R = St(i), R = i < 0 ? te(u + R, 0) : le(R, u - 1)), En(t, pt(e, 3), R, !0);
      }
      function Zu(t) {
        var e = t == null ? 0 : t.length;
        return e ? he(t, 1) : [];
      }
      function qp(t) {
        var e = t == null ? 0 : t.length;
        return e ? he(t, U) : [];
      }
      function Hp(t, e) {
        var i = t == null ? 0 : t.length;
        return i ? (e = e === n ? 1 : St(e), he(t, e)) : [];
      }
      function Vp(t) {
        for (var e = -1, i = t == null ? 0 : t.length, u = {}; ++e < i; ) {
          var R = t[e];
          u[R[0]] = R[1];
        }
        return u;
      }
      function Ju(t) {
        return t && t.length ? t[0] : n;
      }
      function Wp(t, e, i) {
        var u = t == null ? 0 : t.length;
        if (!u)
          return -1;
        var R = i == null ? 0 : St(i);
        return R < 0 && (R = te(u + R, 0)), Ur(t, e, R);
      }
      function zp(t) {
        var e = t == null ? 0 : t.length;
        return e ? Ne(t, 0, -1) : [];
      }
      var jp = At(function(t) {
        var e = Ht(t, cs);
        return e.length && e[0] === t[0] ? es(e) : [];
      }), Kp = At(function(t) {
        var e = Ge(t), i = Ht(t, cs);
        return e === Ge(i) ? e = n : i.pop(), i.length && i[0] === t[0] ? es(i, pt(e, 2)) : [];
      }), Yp = At(function(t) {
        var e = Ge(t), i = Ht(t, cs);
        return e = typeof e == "function" ? e : n, e && i.pop(), i.length && i[0] === t[0] ? es(i, n, e) : [];
      });
      function Xp(t, e) {
        return t == null ? "" : zg.call(t, e);
      }
      function Ge(t) {
        var e = t == null ? 0 : t.length;
        return e ? t[e - 1] : n;
      }
      function $p(t, e, i) {
        var u = t == null ? 0 : t.length;
        if (!u)
          return -1;
        var R = u;
        return i !== n && (R = St(i), R = R < 0 ? te(u + R, 0) : le(R, u - 1)), e === e ? Pg(t, e, R) : En(t, kl, R, !0);
      }
      function Zp(t, e) {
        return t && t.length ? lu(t, St(e)) : n;
      }
      var Jp = At(Qu);
      function Qu(t, e) {
        return t && t.length && e && e.length ? as(t, e) : t;
      }
      function Qp(t, e, i) {
        return t && t.length && e && e.length ? as(t, e, pt(i, 2)) : t;
      }
      function t_(t, e, i) {
        return t && t.length && e && e.length ? as(t, e, n, i) : t;
      }
      var e_ = sr(function(t, e) {
        var i = t == null ? 0 : t.length, u = Za(t, e);
        return du(t, Ht(e, function(R) {
          return or(R, i) ? +R : R;
        }).sort(Su)), u;
      });
      function r_(t, e) {
        var i = [];
        if (!(t && t.length))
          return i;
        var u = -1, R = [], M = t.length;
        for (e = pt(e, 3); ++u < M; ) {
          var B = t[u];
          e(B, u, t) && (i.push(B), R.push(u));
        }
        return du(t, R), i;
      }
      function Es(t) {
        return t == null ? t : Xg.call(t);
      }
      function i_(t, e, i) {
        var u = t == null ? 0 : t.length;
        return u ? (i && typeof i != "number" && de(t, e, i) ? (e = 0, i = u) : (e = e == null ? 0 : St(e), i = i === n ? u : St(i)), Ne(t, e, i)) : [];
      }
      function n_(t, e) {
        return zn(t, e);
      }
      function a_(t, e, i) {
        return hs(t, e, pt(i, 2));
      }
      function s_(t, e) {
        var i = t == null ? 0 : t.length;
        if (i) {
          var u = zn(t, e);
          if (u < i && je(t[u], e))
            return u;
        }
        return -1;
      }
      function o_(t, e) {
        return zn(t, e, !0);
      }
      function h_(t, e, i) {
        return hs(t, e, pt(i, 2), !0);
      }
      function l_(t, e) {
        var i = t == null ? 0 : t.length;
        if (i) {
          var u = zn(t, e, !0) - 1;
          if (je(t[u], e))
            return u;
        }
        return -1;
      }
      function u_(t) {
        return t && t.length ? gu(t) : [];
      }
      function c_(t, e) {
        return t && t.length ? gu(t, pt(e, 2)) : [];
      }
      function d_(t) {
        var e = t == null ? 0 : t.length;
        return e ? Ne(t, 1, e) : [];
      }
      function f_(t, e, i) {
        return t && t.length ? (e = i || e === n ? 1 : St(e), Ne(t, 0, e < 0 ? 0 : e)) : [];
      }
      function g_(t, e, i) {
        var u = t == null ? 0 : t.length;
        return u ? (e = i || e === n ? 1 : St(e), e = u - e, Ne(t, e < 0 ? 0 : e, u)) : [];
      }
      function p_(t, e) {
        return t && t.length ? jn(t, pt(e, 3), !1, !0) : [];
      }
      function __(t, e) {
        return t && t.length ? jn(t, pt(e, 3)) : [];
      }
      var v_ = At(function(t) {
        return br(he(t, 1, Yt, !0));
      }), y_ = At(function(t) {
        var e = Ge(t);
        return Yt(e) && (e = n), br(he(t, 1, Yt, !0), pt(e, 2));
      }), m_ = At(function(t) {
        var e = Ge(t);
        return e = typeof e == "function" ? e : n, br(he(t, 1, Yt, !0), n, e);
      });
      function b_(t) {
        return t && t.length ? br(t) : [];
      }
      function w_(t, e) {
        return t && t.length ? br(t, pt(e, 2)) : [];
      }
      function S_(t, e) {
        return e = typeof e == "function" ? e : n, t && t.length ? br(t, n, e) : [];
      }
      function As(t) {
        if (!(t && t.length))
          return [];
        var e = 0;
        return t = pr(t, function(i) {
          if (Yt(i))
            return e = te(i.length, e), !0;
        }), Va(e, function(i) {
          return Ht(t, Ua(i));
        });
      }
      function tc(t, e) {
        if (!(t && t.length))
          return [];
        var i = As(t);
        return e == null ? i : Ht(i, function(u) {
          return Se(e, n, u);
        });
      }
      var C_ = At(function(t, e) {
        return Yt(t) ? fi(t, e) : [];
      }), x_ = At(function(t) {
        return us(pr(t, Yt));
      }), E_ = At(function(t) {
        var e = Ge(t);
        return Yt(e) && (e = n), us(pr(t, Yt), pt(e, 2));
      }), A_ = At(function(t) {
        var e = Ge(t);
        return e = typeof e == "function" ? e : n, us(pr(t, Yt), n, e);
      }), R_ = At(As);
      function T_(t, e) {
        return yu(t || [], e || [], di);
      }
      function P_(t, e) {
        return yu(t || [], e || [], _i);
      }
      var O_ = At(function(t) {
        var e = t.length, i = e > 1 ? t[e - 1] : n;
        return i = typeof i == "function" ? (t.pop(), i) : n, tc(t, i);
      });
      function ec(t) {
        var e = k(t);
        return e.__chain__ = !0, e;
      }
      function F_(t, e) {
        return e(t), t;
      }
      function ea(t, e) {
        return e(t);
      }
      var k_ = sr(function(t) {
        var e = t.length, i = e ? t[0] : 0, u = this.__wrapped__, R = function(M) {
          return Za(M, t);
        };
        return e > 1 || this.__actions__.length || !(u instanceof kt) || !or(i) ? this.thru(R) : (u = u.slice(i, +i + (e ? 1 : 0)), u.__actions__.push({
          func: ea,
          args: [R],
          thisArg: n
        }), new Le(u, this.__chain__).thru(function(M) {
          return e && !M.length && M.push(n), M;
        }));
      });
      function I_() {
        return ec(this);
      }
      function L_() {
        return new Le(this.value(), this.__chain__);
      }
      function M_() {
        this.__values__ === n && (this.__values__ = pc(this.value()));
        var t = this.__index__ >= this.__values__.length, e = t ? n : this.__values__[this.__index__++];
        return { done: t, value: e };
      }
      function N_() {
        return this;
      }
      function G_(t) {
        for (var e, i = this; i instanceof Un; ) {
          var u = Yu(i);
          u.__index__ = 0, u.__values__ = n, e ? R.__wrapped__ = u : e = u;
          var R = u;
          i = i.__wrapped__;
        }
        return R.__wrapped__ = t, e;
      }
      function D_() {
        var t = this.__wrapped__;
        if (t instanceof kt) {
          var e = t;
          return this.__actions__.length && (e = new kt(this)), e = e.reverse(), e.__actions__.push({
            func: ea,
            args: [Es],
            thisArg: n
          }), new Le(e, this.__chain__);
        }
        return this.thru(Es);
      }
      function B_() {
        return vu(this.__wrapped__, this.__actions__);
      }
      var U_ = Kn(function(t, e, i) {
        Gt.call(t, i) ? ++t[i] : nr(t, i, 1);
      });
      function q_(t, e, i) {
        var u = wt(t) ? Ol : F2;
        return i && de(t, e, i) && (e = n), u(t, pt(e, 3));
      }
      function H_(t, e) {
        var i = wt(t) ? pr : tu;
        return i(t, pt(e, 3));
      }
      var V_ = Tu(Xu), W_ = Tu($u);
      function z_(t, e) {
        return he(ra(t, e), 1);
      }
      function j_(t, e) {
        return he(ra(t, e), U);
      }
      function K_(t, e, i) {
        return i = i === n ? 1 : St(i), he(ra(t, e), i);
      }
      function rc(t, e) {
        var i = wt(t) ? ke : mr;
        return i(t, pt(e, 3));
      }
      function ic(t, e) {
        var i = wt(t) ? dg : Ql;
        return i(t, pt(e, 3));
      }
      var Y_ = Kn(function(t, e, i) {
        Gt.call(t, i) ? t[i].push(e) : nr(t, i, [e]);
      });
      function X_(t, e, i, u) {
        t = ve(t) ? t : Jr(t), i = i && !u ? St(i) : 0;
        var R = t.length;
        return i < 0 && (i = te(R + i, 0)), oa(t) ? i <= R && t.indexOf(e, i) > -1 : !!R && Ur(t, e, i) > -1;
      }
      var $_ = At(function(t, e, i) {
        var u = -1, R = typeof e == "function", M = ve(t) ? Y(t.length) : [];
        return mr(t, function(B) {
          M[++u] = R ? Se(e, B, i) : gi(B, e, i);
        }), M;
      }), Z_ = Kn(function(t, e, i) {
        nr(t, i, e);
      });
      function ra(t, e) {
        var i = wt(t) ? Ht : su;
        return i(t, pt(e, 3));
      }
      function J_(t, e, i, u) {
        return t == null ? [] : (wt(e) || (e = e == null ? [] : [e]), i = u ? n : i, wt(i) || (i = i == null ? [] : [i]), uu(t, e, i));
      }
      var Q_ = Kn(function(t, e, i) {
        t[i ? 0 : 1].push(e);
      }, function() {
        return [[], []];
      });
      function t5(t, e, i) {
        var u = wt(t) ? Da : Ll, R = arguments.length < 3;
        return u(t, pt(e, 4), i, R, mr);
      }
      function e5(t, e, i) {
        var u = wt(t) ? fg : Ll, R = arguments.length < 3;
        return u(t, pt(e, 4), i, R, Ql);
      }
      function r5(t, e) {
        var i = wt(t) ? pr : tu;
        return i(t, aa(pt(e, 3)));
      }
      function i5(t) {
        var e = wt(t) ? Xl : X2;
        return e(t);
      }
      function n5(t, e, i) {
        (i ? de(t, e, i) : e === n) ? e = 1 : e = St(e);
        var u = wt(t) ? A2 : $2;
        return u(t, e);
      }
      function a5(t) {
        var e = wt(t) ? R2 : J2;
        return e(t);
      }
      function s5(t) {
        if (t == null)
          return 0;
        if (ve(t))
          return oa(t) ? Hr(t) : t.length;
        var e = ue(t);
        return e == Et || e == Zt ? t.size : is(t).length;
      }
      function o5(t, e, i) {
        var u = wt(t) ? Ba : Q2;
        return i && de(t, e, i) && (e = n), u(t, pt(e, 3));
      }
      var h5 = At(function(t, e) {
        if (t == null)
          return [];
        var i = e.length;
        return i > 1 && de(t, e[0], e[1]) ? e = [] : i > 2 && de(e[0], e[1], e[2]) && (e = [e[0]]), uu(t, he(e, 1), []);
      }), ia = Hg || function() {
        return oe.Date.now();
      };
      function l5(t, e) {
        if (typeof e != "function")
          throw new Ie(h);
        return t = St(t), function() {
          if (--t < 1)
            return e.apply(this, arguments);
        };
      }
      function nc(t, e, i) {
        return e = i ? n : e, e = t && e == null ? t.length : e, ar(t, D, n, n, n, n, e);
      }
      function ac(t, e) {
        var i;
        if (typeof e != "function")
          throw new Ie(h);
        return t = St(t), function() {
          return --t > 0 && (i = e.apply(this, arguments)), t <= 1 && (e = n), i;
        };
      }
      var Rs = At(function(t, e, i) {
        var u = C;
        if (i.length) {
          var R = vr(i, $r(Rs));
          u |= E;
        }
        return ar(t, u, e, i, R);
      }), sc = At(function(t, e, i) {
        var u = C | O;
        if (i.length) {
          var R = vr(i, $r(sc));
          u |= E;
        }
        return ar(e, u, t, i, R);
      });
      function oc(t, e, i) {
        e = i ? n : e;
        var u = ar(t, f, n, n, n, n, n, e);
        return u.placeholder = oc.placeholder, u;
      }
      function hc(t, e, i) {
        e = i ? n : e;
        var u = ar(t, m, n, n, n, n, n, e);
        return u.placeholder = hc.placeholder, u;
      }
      function lc(t, e, i) {
        var u, R, M, B, q, z, rt = 0, it = !1, nt = !1, ot = !0;
        if (typeof t != "function")
          throw new Ie(h);
        e = De(e) || 0, Wt(i) && (it = !!i.leading, nt = "maxWait" in i, M = nt ? te(De(i.maxWait) || 0, e) : M, ot = "trailing" in i ? !!i.trailing : ot);
        function dt(Xt) {
          var Ke = u, ur = R;
          return u = R = n, rt = Xt, B = t.apply(ur, Ke), B;
        }
        function _t(Xt) {
          return rt = Xt, q = mi(Ot, e), it ? dt(Xt) : B;
        }
        function Ct(Xt) {
          var Ke = Xt - z, ur = Xt - rt, Tc = e - Ke;
          return nt ? le(Tc, M - ur) : Tc;
        }
        function vt(Xt) {
          var Ke = Xt - z, ur = Xt - rt;
          return z === n || Ke >= e || Ke < 0 || nt && ur >= M;
        }
        function Ot() {
          var Xt = ia();
          if (vt(Xt))
            return It(Xt);
          q = mi(Ot, Ct(Xt));
        }
        function It(Xt) {
          return q = n, ot && u ? dt(Xt) : (u = R = n, B);
        }
        function Ae() {
          q !== n && mu(q), rt = 0, u = z = R = q = n;
        }
        function fe() {
          return q === n ? B : It(ia());
        }
        function Re() {
          var Xt = ia(), Ke = vt(Xt);
          if (u = arguments, R = this, z = Xt, Ke) {
            if (q === n)
              return _t(z);
            if (nt)
              return mu(q), q = mi(Ot, e), dt(z);
          }
          return q === n && (q = mi(Ot, e)), B;
        }
        return Re.cancel = Ae, Re.flush = fe, Re;
      }
      var u5 = At(function(t, e) {
        return Jl(t, 1, e);
      }), c5 = At(function(t, e, i) {
        return Jl(t, De(e) || 0, i);
      });
      function d5(t) {
        return ar(t, L);
      }
      function na(t, e) {
        if (typeof t != "function" || e != null && typeof e != "function")
          throw new Ie(h);
        var i = function() {
          var u = arguments, R = e ? e.apply(this, u) : u[0], M = i.cache;
          if (M.has(R))
            return M.get(R);
          var B = t.apply(this, u);
          return i.cache = M.set(R, B) || M, B;
        };
        return i.cache = new (na.Cache || ir)(), i;
      }
      na.Cache = ir;
      function aa(t) {
        if (typeof t != "function")
          throw new Ie(h);
        return function() {
          var e = arguments;
          switch (e.length) {
            case 0:
              return !t.call(this);
            case 1:
              return !t.call(this, e[0]);
            case 2:
              return !t.call(this, e[0], e[1]);
            case 3:
              return !t.call(this, e[0], e[1], e[2]);
          }
          return !t.apply(this, e);
        };
      }
      function f5(t) {
        return ac(2, t);
      }
      var g5 = tp(function(t, e) {
        e = e.length == 1 && wt(e[0]) ? Ht(e[0], Ce(pt())) : Ht(he(e, 1), Ce(pt()));
        var i = e.length;
        return At(function(u) {
          for (var R = -1, M = le(u.length, i); ++R < M; )
            u[R] = e[R].call(this, u[R]);
          return Se(t, this, u);
        });
      }), Ts = At(function(t, e) {
        var i = vr(e, $r(Ts));
        return ar(t, E, n, e, i);
      }), uc = At(function(t, e) {
        var i = vr(e, $r(uc));
        return ar(t, T, n, e, i);
      }), p5 = sr(function(t, e) {
        return ar(t, I, n, n, n, e);
      });
      function _5(t, e) {
        if (typeof t != "function")
          throw new Ie(h);
        return e = e === n ? e : St(e), At(t, e);
      }
      function v5(t, e) {
        if (typeof t != "function")
          throw new Ie(h);
        return e = e == null ? 0 : te(St(e), 0), At(function(i) {
          var u = i[e], R = Sr(i, 0, e);
          return u && _r(R, u), Se(t, this, R);
        });
      }
      function y5(t, e, i) {
        var u = !0, R = !0;
        if (typeof t != "function")
          throw new Ie(h);
        return Wt(i) && (u = "leading" in i ? !!i.leading : u, R = "trailing" in i ? !!i.trailing : R), lc(t, e, {
          leading: u,
          maxWait: e,
          trailing: R
        });
      }
      function m5(t) {
        return nc(t, 1);
      }
      function b5(t, e) {
        return Ts(ds(e), t);
      }
      function w5() {
        if (!arguments.length)
          return [];
        var t = arguments[0];
        return wt(t) ? t : [t];
      }
      function S5(t) {
        return Me(t, v);
      }
      function C5(t, e) {
        return e = typeof e == "function" ? e : n, Me(t, v, e);
      }
      function x5(t) {
        return Me(t, w | v);
      }
      function E5(t, e) {
        return e = typeof e == "function" ? e : n, Me(t, w | v, e);
      }
      function A5(t, e) {
        return e == null || Zl(t, e, ae(e));
      }
      function je(t, e) {
        return t === e || t !== t && e !== e;
      }
      var R5 = Zn(ts), T5 = Zn(function(t, e) {
        return t >= e;
      }), Lr = iu(/* @__PURE__ */ function() {
        return arguments;
      }()) ? iu : function(t) {
        return jt(t) && Gt.call(t, "callee") && !Vl.call(t, "callee");
      }, wt = Y.isArray, P5 = xl ? Ce(xl) : G2;
      function ve(t) {
        return t != null && sa(t.length) && !hr(t);
      }
      function Yt(t) {
        return jt(t) && ve(t);
      }
      function O5(t) {
        return t === !0 || t === !1 || jt(t) && ce(t) == j;
      }
      var Cr = Wg || Bs, F5 = El ? Ce(El) : D2;
      function k5(t) {
        return jt(t) && t.nodeType === 1 && !bi(t);
      }
      function I5(t) {
        if (t == null)
          return !0;
        if (ve(t) && (wt(t) || typeof t == "string" || typeof t.splice == "function" || Cr(t) || Zr(t) || Lr(t)))
          return !t.length;
        var e = ue(t);
        if (e == Et || e == Zt)
          return !t.size;
        if (yi(t))
          return !is(t).length;
        for (var i in t)
          if (Gt.call(t, i))
            return !1;
        return !0;
      }
      function L5(t, e) {
        return pi(t, e);
      }
      function M5(t, e, i) {
        i = typeof i == "function" ? i : n;
        var u = i ? i(t, e) : n;
        return u === n ? pi(t, e, n, i) : !!u;
      }
      function Ps(t) {
        if (!jt(t))
          return !1;
        var e = ce(t);
        return e == ft || e == ut || typeof t.message == "string" && typeof t.name == "string" && !bi(t);
      }
      function N5(t) {
        return typeof t == "number" && zl(t);
      }
      function hr(t) {
        if (!Wt(t))
          return !1;
        var e = ce(t);
        return e == gt || e == Lt || e == V || e == gr;
      }
      function cc(t) {
        return typeof t == "number" && t == St(t);
      }
      function sa(t) {
        return typeof t == "number" && t > -1 && t % 1 == 0 && t <= K;
      }
      function Wt(t) {
        var e = typeof t;
        return t != null && (e == "object" || e == "function");
      }
      function jt(t) {
        return t != null && typeof t == "object";
      }
      var dc = Al ? Ce(Al) : U2;
      function G5(t, e) {
        return t === e || rs(t, e, ms(e));
      }
      function D5(t, e, i) {
        return i = typeof i == "function" ? i : n, rs(t, e, ms(e), i);
      }
      function B5(t) {
        return fc(t) && t != +t;
      }
      function U5(t) {
        if (Cp(t))
          throw new bt(s);
        return nu(t);
      }
      function q5(t) {
        return t === null;
      }
      function H5(t) {
        return t == null;
      }
      function fc(t) {
        return typeof t == "number" || jt(t) && ce(t) == mt;
      }
      function bi(t) {
        if (!jt(t) || ce(t) != Pt)
          return !1;
        var e = In(t);
        if (e === null)
          return !0;
        var i = Gt.call(e, "constructor") && e.constructor;
        return typeof i == "function" && i instanceof i && Pn.call(i) == Dg;
      }
      var Os = Rl ? Ce(Rl) : q2;
      function V5(t) {
        return cc(t) && t >= -9007199254740991 && t <= K;
      }
      var gc = Tl ? Ce(Tl) : H2;
      function oa(t) {
        return typeof t == "string" || !wt(t) && jt(t) && ce(t) == Jt;
      }
      function Ee(t) {
        return typeof t == "symbol" || jt(t) && ce(t) == Ut;
      }
      var Zr = Pl ? Ce(Pl) : V2;
      function W5(t) {
        return t === n;
      }
      function z5(t) {
        return jt(t) && ue(t) == ie;
      }
      function j5(t) {
        return jt(t) && ce(t) == He;
      }
      var K5 = Zn(ns), Y5 = Zn(function(t, e) {
        return t <= e;
      });
      function pc(t) {
        if (!t)
          return [];
        if (ve(t))
          return oa(t) ? We(t) : _e(t);
        if (oi && t[oi])
          return Ag(t[oi]());
        var e = ue(t), i = e == Et ? za : e == Zt ? An : Jr;
        return i(t);
      }
      function lr(t) {
        if (!t)
          return t === 0 ? t : 0;
        if (t = De(t), t === U || t === -1 / 0) {
          var e = t < 0 ? -1 : 1;
          return e * $;
        }
        return t === t ? t : 0;
      }
      function St(t) {
        var e = lr(t), i = e % 1;
        return e === e ? i ? e - i : e : 0;
      }
      function _c(t) {
        return t ? Or(St(t), 0, Q) : 0;
      }
      function De(t) {
        if (typeof t == "number")
          return t;
        if (Ee(t))
          return X;
        if (Wt(t)) {
          var e = typeof t.valueOf == "function" ? t.valueOf() : t;
          t = Wt(e) ? e + "" : e;
        }
        if (typeof t != "string")
          return t === 0 ? t : +t;
        t = Ml(t);
        var i = P1.test(t);
        return i || F1.test(t) ? lg(t.slice(2), i ? 2 : 8) : T1.test(t) ? X : +t;
      }
      function vc(t) {
        return Qe(t, ye(t));
      }
      function X5(t) {
        return t ? Or(St(t), -9007199254740991, K) : t === 0 ? t : 0;
      }
      function Nt(t) {
        return t == null ? "" : xe(t);
      }
      var $5 = Yr(function(t, e) {
        if (yi(e) || ve(e)) {
          Qe(e, ae(e), t);
          return;
        }
        for (var i in e)
          Gt.call(e, i) && di(t, i, e[i]);
      }), yc = Yr(function(t, e) {
        Qe(e, ye(e), t);
      }), ha = Yr(function(t, e, i, u) {
        Qe(e, ye(e), t, u);
      }), Z5 = Yr(function(t, e, i, u) {
        Qe(e, ae(e), t, u);
      }), J5 = sr(Za);
      function Q5(t, e) {
        var i = Kr(t);
        return e == null ? i : $l(i, e);
      }
      var t3 = At(function(t, e) {
        t = Dt(t);
        var i = -1, u = e.length, R = u > 2 ? e[2] : n;
        for (R && de(e[0], e[1], R) && (u = 1); ++i < u; )
          for (var M = e[i], B = ye(M), q = -1, z = B.length; ++q < z; ) {
            var rt = B[q], it = t[rt];
            (it === n || je(it, Wr[rt]) && !Gt.call(t, rt)) && (t[rt] = M[rt]);
          }
        return t;
      }), e3 = At(function(t) {
        return t.push(n, Mu), Se(mc, n, t);
      });
      function r3(t, e) {
        return Fl(t, pt(e, 3), Je);
      }
      function i3(t, e) {
        return Fl(t, pt(e, 3), Qa);
      }
      function n3(t, e) {
        return t == null ? t : Ja(t, pt(e, 3), ye);
      }
      function a3(t, e) {
        return t == null ? t : eu(t, pt(e, 3), ye);
      }
      function s3(t, e) {
        return t && Je(t, pt(e, 3));
      }
      function o3(t, e) {
        return t && Qa(t, pt(e, 3));
      }
      function h3(t) {
        return t == null ? [] : Vn(t, ae(t));
      }
      function l3(t) {
        return t == null ? [] : Vn(t, ye(t));
      }
      function Fs(t, e, i) {
        var u = t == null ? n : Fr(t, e);
        return u === n ? i : u;
      }
      function u3(t, e) {
        return t != null && Du(t, e, I2);
      }
      function ks(t, e) {
        return t != null && Du(t, e, L2);
      }
      var c3 = Ou(function(t, e, i) {
        e != null && typeof e.toString != "function" && (e = On.call(e)), t[e] = i;
      }, Ls(me)), d3 = Ou(function(t, e, i) {
        e != null && typeof e.toString != "function" && (e = On.call(e)), Gt.call(t, e) ? t[e].push(i) : t[e] = [i];
      }, pt), f3 = At(gi);
      function ae(t) {
        return ve(t) ? Yl(t) : is(t);
      }
      function ye(t) {
        return ve(t) ? Yl(t, !0) : W2(t);
      }
      function g3(t, e) {
        var i = {};
        return e = pt(e, 3), Je(t, function(u, R, M) {
          nr(i, e(u, R, M), u);
        }), i;
      }
      function p3(t, e) {
        var i = {};
        return e = pt(e, 3), Je(t, function(u, R, M) {
          nr(i, R, e(u, R, M));
        }), i;
      }
      var _3 = Yr(function(t, e, i) {
        Wn(t, e, i);
      }), mc = Yr(function(t, e, i, u) {
        Wn(t, e, i, u);
      }), v3 = sr(function(t, e) {
        var i = {};
        if (t == null)
          return i;
        var u = !1;
        e = Ht(e, function(M) {
          return M = wr(M, t), u || (u = M.length > 1), M;
        }), Qe(t, vs(t), i), u && (i = Me(i, w | x | v, cp));
        for (var R = e.length; R--; )
          ls(i, e[R]);
        return i;
      });
      function y3(t, e) {
        return bc(t, aa(pt(e)));
      }
      var m3 = sr(function(t, e) {
        return t == null ? {} : j2(t, e);
      });
      function bc(t, e) {
        if (t == null)
          return {};
        var i = Ht(vs(t), function(u) {
          return [u];
        });
        return e = pt(e), cu(t, i, function(u, R) {
          return e(u, R[0]);
        });
      }
      function b3(t, e, i) {
        e = wr(e, t);
        var u = -1, R = e.length;
        for (R || (R = 1, t = n); ++u < R; ) {
          var M = t == null ? n : t[tr(e[u])];
          M === n && (u = R, M = i), t = hr(M) ? M.call(t) : M;
        }
        return t;
      }
      function w3(t, e, i) {
        return t == null ? t : _i(t, e, i);
      }
      function S3(t, e, i, u) {
        return u = typeof u == "function" ? u : n, t == null ? t : _i(t, e, i, u);
      }
      var wc = Iu(ae), Sc = Iu(ye);
      function C3(t, e, i) {
        var u = wt(t), R = u || Cr(t) || Zr(t);
        if (e = pt(e, 4), i == null) {
          var M = t && t.constructor;
          R ? i = u ? new M() : [] : Wt(t) ? i = hr(M) ? Kr(In(t)) : {} : i = {};
        }
        return (R ? ke : Je)(t, function(B, q, z) {
          return e(i, B, q, z);
        }), i;
      }
      function x3(t, e) {
        return t == null ? !0 : ls(t, e);
      }
      function E3(t, e, i) {
        return t == null ? t : _u(t, e, ds(i));
      }
      function A3(t, e, i, u) {
        return u = typeof u == "function" ? u : n, t == null ? t : _u(t, e, ds(i), u);
      }
      function Jr(t) {
        return t == null ? [] : Wa(t, ae(t));
      }
      function R3(t) {
        return t == null ? [] : Wa(t, ye(t));
      }
      function T3(t, e, i) {
        return i === n && (i = e, e = n), i !== n && (i = De(i), i = i === i ? i : 0), e !== n && (e = De(e), e = e === e ? e : 0), Or(De(t), e, i);
      }
      function P3(t, e, i) {
        return e = lr(e), i === n ? (i = e, e = 0) : i = lr(i), t = De(t), M2(t, e, i);
      }
      function O3(t, e, i) {
        if (i && typeof i != "boolean" && de(t, e, i) && (e = i = n), i === n && (typeof e == "boolean" ? (i = e, e = n) : typeof t == "boolean" && (i = t, t = n)), t === n && e === n ? (t = 0, e = 1) : (t = lr(t), e === n ? (e = t, t = 0) : e = lr(e)), t > e) {
          var u = t;
          t = e, e = u;
        }
        if (i || t % 1 || e % 1) {
          var R = jl();
          return le(t + R * (e - t + hg("1e-" + ((R + "").length - 1))), e);
        }
        return ss(t, e);
      }
      var F3 = Xr(function(t, e, i) {
        return e = e.toLowerCase(), t + (i ? Cc(e) : e);
      });
      function Cc(t) {
        return Is(Nt(t).toLowerCase());
      }
      function xc(t) {
        return t = Nt(t), t && t.replace(I1, wg).replace(J1, "");
      }
      function k3(t, e, i) {
        t = Nt(t), e = xe(e);
        var u = t.length;
        i = i === n ? u : Or(St(i), 0, u);
        var R = i;
        return i -= e.length, i >= 0 && t.slice(i, R) == e;
      }
      function I3(t) {
        return t = Nt(t), t && f1.test(t) ? t.replace(el, Sg) : t;
      }
      function L3(t) {
        return t = Nt(t), t && m1.test(t) ? t.replace(Ta, "\\$&") : t;
      }
      var M3 = Xr(function(t, e, i) {
        return t + (i ? "-" : "") + e.toLowerCase();
      }), N3 = Xr(function(t, e, i) {
        return t + (i ? " " : "") + e.toLowerCase();
      }), G3 = Ru("toLowerCase");
      function D3(t, e, i) {
        t = Nt(t), e = St(e);
        var u = e ? Hr(t) : 0;
        if (!e || u >= e)
          return t;
        var R = (e - u) / 2;
        return $n(Gn(R), i) + t + $n(Nn(R), i);
      }
      function B3(t, e, i) {
        t = Nt(t), e = St(e);
        var u = e ? Hr(t) : 0;
        return e && u < e ? t + $n(e - u, i) : t;
      }
      function U3(t, e, i) {
        t = Nt(t), e = St(e);
        var u = e ? Hr(t) : 0;
        return e && u < e ? $n(e - u, i) + t : t;
      }
      function q3(t, e, i) {
        return i || e == null ? e = 0 : e && (e = +e), Yg(Nt(t).replace(Pa, ""), e || 0);
      }
      function H3(t, e, i) {
        return (i ? de(t, e, i) : e === n) ? e = 1 : e = St(e), os(Nt(t), e);
      }
      function V3() {
        var t = arguments, e = Nt(t[0]);
        return t.length < 3 ? e : e.replace(t[1], t[2]);
      }
      var W3 = Xr(function(t, e, i) {
        return t + (i ? "_" : "") + e.toLowerCase();
      });
      function z3(t, e, i) {
        return i && typeof i != "number" && de(t, e, i) && (e = i = n), i = i === n ? Q : i >>> 0, i ? (t = Nt(t), t && (typeof e == "string" || e != null && !Os(e)) && (e = xe(e), !e && qr(t)) ? Sr(We(t), 0, i) : t.split(e, i)) : [];
      }
      var j3 = Xr(function(t, e, i) {
        return t + (i ? " " : "") + Is(e);
      });
      function K3(t, e, i) {
        return t = Nt(t), i = i == null ? 0 : Or(St(i), 0, t.length), e = xe(e), t.slice(i, i + e.length) == e;
      }
      function Y3(t, e, i) {
        var u = k.templateSettings;
        i && de(t, e, i) && (e = n), t = Nt(t), e = ha({}, e, u, Lu);
        var R = ha({}, e.imports, u.imports, Lu), M = ae(R), B = Wa(R, M), q, z, rt = 0, it = e.interpolate || wn, nt = "__p += '", ot = ja(
          (e.escape || wn).source + "|" + it.source + "|" + (it === rl ? R1 : wn).source + "|" + (e.evaluate || wn).source + "|$",
          "g"
        ), dt = "//# sourceURL=" + (Gt.call(e, "sourceURL") ? (e.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++ig + "]") + `
`;
        t.replace(ot, function(vt, Ot, It, Ae, fe, Re) {
          return It || (It = Ae), nt += t.slice(rt, Re).replace(L1, Cg), Ot && (q = !0, nt += `' +
__e(` + Ot + `) +
'`), fe && (z = !0, nt += `';
` + fe + `;
__p += '`), It && (nt += `' +
((__t = (` + It + `)) == null ? '' : __t) +
'`), rt = Re + vt.length, vt;
        }), nt += `';
`;
        var _t = Gt.call(e, "variable") && e.variable;
        if (!_t)
          nt = `with (obj) {
` + nt + `
}
`;
        else if (E1.test(_t))
          throw new bt(l);
        nt = (z ? nt.replace(l1, "") : nt).replace(u1, "$1").replace(c1, "$1;"), nt = "function(" + (_t || "obj") + `) {
` + (_t ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (q ? ", __e = _.escape" : "") + (z ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + nt + `return __p
}`;
        var Ct = Ac(function() {
          return Mt(M, dt + "return " + nt).apply(n, B);
        });
        if (Ct.source = nt, Ps(Ct))
          throw Ct;
        return Ct;
      }
      function X3(t) {
        return Nt(t).toLowerCase();
      }
      function $3(t) {
        return Nt(t).toUpperCase();
      }
      function Z3(t, e, i) {
        if (t = Nt(t), t && (i || e === n))
          return Ml(t);
        if (!t || !(e = xe(e)))
          return t;
        var u = We(t), R = We(e), M = Nl(u, R), B = Gl(u, R) + 1;
        return Sr(u, M, B).join("");
      }
      function J3(t, e, i) {
        if (t = Nt(t), t && (i || e === n))
          return t.slice(0, Bl(t) + 1);
        if (!t || !(e = xe(e)))
          return t;
        var u = We(t), R = Gl(u, We(e)) + 1;
        return Sr(u, 0, R).join("");
      }
      function Q3(t, e, i) {
        if (t = Nt(t), t && (i || e === n))
          return t.replace(Pa, "");
        if (!t || !(e = xe(e)))
          return t;
        var u = We(t), R = Nl(u, We(e));
        return Sr(u, R).join("");
      }
      function t4(t, e) {
        var i = F, u = N;
        if (Wt(e)) {
          var R = "separator" in e ? e.separator : R;
          i = "length" in e ? St(e.length) : i, u = "omission" in e ? xe(e.omission) : u;
        }
        t = Nt(t);
        var M = t.length;
        if (qr(t)) {
          var B = We(t);
          M = B.length;
        }
        if (i >= M)
          return t;
        var q = i - Hr(u);
        if (q < 1)
          return u;
        var z = B ? Sr(B, 0, q).join("") : t.slice(0, q);
        if (R === n)
          return z + u;
        if (B && (q += z.length - q), Os(R)) {
          if (t.slice(q).search(R)) {
            var rt, it = z;
            for (R.global || (R = ja(R.source, Nt(il.exec(R)) + "g")), R.lastIndex = 0; rt = R.exec(it); )
              var nt = rt.index;
            z = z.slice(0, nt === n ? q : nt);
          }
        } else if (t.indexOf(xe(R), q) != q) {
          var ot = z.lastIndexOf(R);
          ot > -1 && (z = z.slice(0, ot));
        }
        return z + u;
      }
      function e4(t) {
        return t = Nt(t), t && d1.test(t) ? t.replace(tl, Og) : t;
      }
      var r4 = Xr(function(t, e, i) {
        return t + (i ? " " : "") + e.toUpperCase();
      }), Is = Ru("toUpperCase");
      function Ec(t, e, i) {
        return t = Nt(t), e = i ? n : e, e === n ? Eg(t) ? Ig(t) : _g(t) : t.match(e) || [];
      }
      var Ac = At(function(t, e) {
        try {
          return Se(t, n, e);
        } catch (i) {
          return Ps(i) ? i : new bt(i);
        }
      }), i4 = sr(function(t, e) {
        return ke(e, function(i) {
          i = tr(i), nr(t, i, Rs(t[i], t));
        }), t;
      });
      function n4(t) {
        var e = t == null ? 0 : t.length, i = pt();
        return t = e ? Ht(t, function(u) {
          if (typeof u[1] != "function")
            throw new Ie(h);
          return [i(u[0]), u[1]];
        }) : [], At(function(u) {
          for (var R = -1; ++R < e; ) {
            var M = t[R];
            if (Se(M[0], this, u))
              return Se(M[1], this, u);
          }
        });
      }
      function a4(t) {
        return O2(Me(t, w));
      }
      function Ls(t) {
        return function() {
          return t;
        };
      }
      function s4(t, e) {
        return t == null || t !== t ? e : t;
      }
      var o4 = Pu(), h4 = Pu(!0);
      function me(t) {
        return t;
      }
      function Ms(t) {
        return au(typeof t == "function" ? t : Me(t, w));
      }
      function l4(t) {
        return ou(Me(t, w));
      }
      function u4(t, e) {
        return hu(t, Me(e, w));
      }
      var c4 = At(function(t, e) {
        return function(i) {
          return gi(i, t, e);
        };
      }), d4 = At(function(t, e) {
        return function(i) {
          return gi(t, i, e);
        };
      });
      function Ns(t, e, i) {
        var u = ae(e), R = Vn(e, u);
        i == null && !(Wt(e) && (R.length || !u.length)) && (i = e, e = t, t = this, R = Vn(e, ae(e)));
        var M = !(Wt(i) && "chain" in i) || !!i.chain, B = hr(t);
        return ke(R, function(q) {
          var z = e[q];
          t[q] = z, B && (t.prototype[q] = function() {
            var rt = this.__chain__;
            if (M || rt) {
              var it = t(this.__wrapped__), nt = it.__actions__ = _e(this.__actions__);
              return nt.push({ func: z, args: arguments, thisArg: t }), it.__chain__ = rt, it;
            }
            return z.apply(t, _r([this.value()], arguments));
          });
        }), t;
      }
      function f4() {
        return oe._ === this && (oe._ = Bg), this;
      }
      function Gs() {
      }
      function g4(t) {
        return t = St(t), At(function(e) {
          return lu(e, t);
        });
      }
      var p4 = gs(Ht), _4 = gs(Ol), v4 = gs(Ba);
      function Rc(t) {
        return ws(t) ? Ua(tr(t)) : K2(t);
      }
      function y4(t) {
        return function(e) {
          return t == null ? n : Fr(t, e);
        };
      }
      var m4 = Fu(), b4 = Fu(!0);
      function Ds() {
        return [];
      }
      function Bs() {
        return !1;
      }
      function w4() {
        return {};
      }
      function S4() {
        return "";
      }
      function C4() {
        return !0;
      }
      function x4(t, e) {
        if (t = St(t), t < 1 || t > K)
          return [];
        var i = Q, u = le(t, Q);
        e = pt(e), t -= Q;
        for (var R = Va(u, e); ++i < t; )
          e(i);
        return R;
      }
      function E4(t) {
        return wt(t) ? Ht(t, tr) : Ee(t) ? [t] : _e(Ku(Nt(t)));
      }
      function A4(t) {
        var e = ++Gg;
        return Nt(t) + e;
      }
      var R4 = Xn(function(t, e) {
        return t + e;
      }, 0), T4 = ps("ceil"), P4 = Xn(function(t, e) {
        return t / e;
      }, 1), O4 = ps("floor");
      function F4(t) {
        return t && t.length ? Hn(t, me, ts) : n;
      }
      function k4(t, e) {
        return t && t.length ? Hn(t, pt(e, 2), ts) : n;
      }
      function I4(t) {
        return Il(t, me);
      }
      function L4(t, e) {
        return Il(t, pt(e, 2));
      }
      function M4(t) {
        return t && t.length ? Hn(t, me, ns) : n;
      }
      function N4(t, e) {
        return t && t.length ? Hn(t, pt(e, 2), ns) : n;
      }
      var G4 = Xn(function(t, e) {
        return t * e;
      }, 1), D4 = ps("round"), B4 = Xn(function(t, e) {
        return t - e;
      }, 0);
      function U4(t) {
        return t && t.length ? Ha(t, me) : 0;
      }
      function q4(t, e) {
        return t && t.length ? Ha(t, pt(e, 2)) : 0;
      }
      return k.after = l5, k.ary = nc, k.assign = $5, k.assignIn = yc, k.assignInWith = ha, k.assignWith = Z5, k.at = J5, k.before = ac, k.bind = Rs, k.bindAll = i4, k.bindKey = sc, k.castArray = w5, k.chain = ec, k.chunk = Op, k.compact = Fp, k.concat = kp, k.cond = n4, k.conforms = a4, k.constant = Ls, k.countBy = U_, k.create = Q5, k.curry = oc, k.curryRight = hc, k.debounce = lc, k.defaults = t3, k.defaultsDeep = e3, k.defer = u5, k.delay = c5, k.difference = Ip, k.differenceBy = Lp, k.differenceWith = Mp, k.drop = Np, k.dropRight = Gp, k.dropRightWhile = Dp, k.dropWhile = Bp, k.fill = Up, k.filter = H_, k.flatMap = z_, k.flatMapDeep = j_, k.flatMapDepth = K_, k.flatten = Zu, k.flattenDeep = qp, k.flattenDepth = Hp, k.flip = d5, k.flow = o4, k.flowRight = h4, k.fromPairs = Vp, k.functions = h3, k.functionsIn = l3, k.groupBy = Y_, k.initial = zp, k.intersection = jp, k.intersectionBy = Kp, k.intersectionWith = Yp, k.invert = c3, k.invertBy = d3, k.invokeMap = $_, k.iteratee = Ms, k.keyBy = Z_, k.keys = ae, k.keysIn = ye, k.map = ra, k.mapKeys = g3, k.mapValues = p3, k.matches = l4, k.matchesProperty = u4, k.memoize = na, k.merge = _3, k.mergeWith = mc, k.method = c4, k.methodOf = d4, k.mixin = Ns, k.negate = aa, k.nthArg = g4, k.omit = v3, k.omitBy = y3, k.once = f5, k.orderBy = J_, k.over = p4, k.overArgs = g5, k.overEvery = _4, k.overSome = v4, k.partial = Ts, k.partialRight = uc, k.partition = Q_, k.pick = m3, k.pickBy = bc, k.property = Rc, k.propertyOf = y4, k.pull = Jp, k.pullAll = Qu, k.pullAllBy = Qp, k.pullAllWith = t_, k.pullAt = e_, k.range = m4, k.rangeRight = b4, k.rearg = p5, k.reject = r5, k.remove = r_, k.rest = _5, k.reverse = Es, k.sampleSize = n5, k.set = w3, k.setWith = S3, k.shuffle = a5, k.slice = i_, k.sortBy = h5, k.sortedUniq = u_, k.sortedUniqBy = c_, k.split = z3, k.spread = v5, k.tail = d_, k.take = f_, k.takeRight = g_, k.takeRightWhile = p_, k.takeWhile = __, k.tap = F_, k.throttle = y5, k.thru = ea, k.toArray = pc, k.toPairs = wc, k.toPairsIn = Sc, k.toPath = E4, k.toPlainObject = vc, k.transform = C3, k.unary = m5, k.union = v_, k.unionBy = y_, k.unionWith = m_, k.uniq = b_, k.uniqBy = w_, k.uniqWith = S_, k.unset = x3, k.unzip = As, k.unzipWith = tc, k.update = E3, k.updateWith = A3, k.values = Jr, k.valuesIn = R3, k.without = C_, k.words = Ec, k.wrap = b5, k.xor = x_, k.xorBy = E_, k.xorWith = A_, k.zip = R_, k.zipObject = T_, k.zipObjectDeep = P_, k.zipWith = O_, k.entries = wc, k.entriesIn = Sc, k.extend = yc, k.extendWith = ha, Ns(k, k), k.add = R4, k.attempt = Ac, k.camelCase = F3, k.capitalize = Cc, k.ceil = T4, k.clamp = T3, k.clone = S5, k.cloneDeep = x5, k.cloneDeepWith = E5, k.cloneWith = C5, k.conformsTo = A5, k.deburr = xc, k.defaultTo = s4, k.divide = P4, k.endsWith = k3, k.eq = je, k.escape = I3, k.escapeRegExp = L3, k.every = q_, k.find = V_, k.findIndex = Xu, k.findKey = r3, k.findLast = W_, k.findLastIndex = $u, k.findLastKey = i3, k.floor = O4, k.forEach = rc, k.forEachRight = ic, k.forIn = n3, k.forInRight = a3, k.forOwn = s3, k.forOwnRight = o3, k.get = Fs, k.gt = R5, k.gte = T5, k.has = u3, k.hasIn = ks, k.head = Ju, k.identity = me, k.includes = X_, k.indexOf = Wp, k.inRange = P3, k.invoke = f3, k.isArguments = Lr, k.isArray = wt, k.isArrayBuffer = P5, k.isArrayLike = ve, k.isArrayLikeObject = Yt, k.isBoolean = O5, k.isBuffer = Cr, k.isDate = F5, k.isElement = k5, k.isEmpty = I5, k.isEqual = L5, k.isEqualWith = M5, k.isError = Ps, k.isFinite = N5, k.isFunction = hr, k.isInteger = cc, k.isLength = sa, k.isMap = dc, k.isMatch = G5, k.isMatchWith = D5, k.isNaN = B5, k.isNative = U5, k.isNil = H5, k.isNull = q5, k.isNumber = fc, k.isObject = Wt, k.isObjectLike = jt, k.isPlainObject = bi, k.isRegExp = Os, k.isSafeInteger = V5, k.isSet = gc, k.isString = oa, k.isSymbol = Ee, k.isTypedArray = Zr, k.isUndefined = W5, k.isWeakMap = z5, k.isWeakSet = j5, k.join = Xp, k.kebabCase = M3, k.last = Ge, k.lastIndexOf = $p, k.lowerCase = N3, k.lowerFirst = G3, k.lt = K5, k.lte = Y5, k.max = F4, k.maxBy = k4, k.mean = I4, k.meanBy = L4, k.min = M4, k.minBy = N4, k.stubArray = Ds, k.stubFalse = Bs, k.stubObject = w4, k.stubString = S4, k.stubTrue = C4, k.multiply = G4, k.nth = Zp, k.noConflict = f4, k.noop = Gs, k.now = ia, k.pad = D3, k.padEnd = B3, k.padStart = U3, k.parseInt = q3, k.random = O3, k.reduce = t5, k.reduceRight = e5, k.repeat = H3, k.replace = V3, k.result = b3, k.round = D4, k.runInContext = W, k.sample = i5, k.size = s5, k.snakeCase = W3, k.some = o5, k.sortedIndex = n_, k.sortedIndexBy = a_, k.sortedIndexOf = s_, k.sortedLastIndex = o_, k.sortedLastIndexBy = h_, k.sortedLastIndexOf = l_, k.startCase = j3, k.startsWith = K3, k.subtract = B4, k.sum = U4, k.sumBy = q4, k.template = Y3, k.times = x4, k.toFinite = lr, k.toInteger = St, k.toLength = _c, k.toLower = X3, k.toNumber = De, k.toSafeInteger = X5, k.toString = Nt, k.toUpper = $3, k.trim = Z3, k.trimEnd = J3, k.trimStart = Q3, k.truncate = t4, k.unescape = e4, k.uniqueId = A4, k.upperCase = r4, k.upperFirst = Is, k.each = rc, k.eachRight = ic, k.first = Ju, Ns(k, function() {
        var t = {};
        return Je(k, function(e, i) {
          Gt.call(k.prototype, i) || (t[i] = e);
        }), t;
      }(), { chain: !1 }), k.VERSION = o, ke(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(t) {
        k[t].placeholder = k;
      }), ke(["drop", "take"], function(t, e) {
        kt.prototype[t] = function(i) {
          i = i === n ? 1 : te(St(i), 0);
          var u = this.__filtered__ && !e ? new kt(this) : this.clone();
          return u.__filtered__ ? u.__takeCount__ = le(i, u.__takeCount__) : u.__views__.push({
            size: le(i, Q),
            type: t + (u.__dir__ < 0 ? "Right" : "")
          }), u;
        }, kt.prototype[t + "Right"] = function(i) {
          return this.reverse()[t](i).reverse();
        };
      }), ke(["filter", "map", "takeWhile"], function(t, e) {
        var i = e + 1, u = i == P || i == G;
        kt.prototype[t] = function(R) {
          var M = this.clone();
          return M.__iteratees__.push({
            iteratee: pt(R, 3),
            type: i
          }), M.__filtered__ = M.__filtered__ || u, M;
        };
      }), ke(["head", "last"], function(t, e) {
        var i = "take" + (e ? "Right" : "");
        kt.prototype[t] = function() {
          return this[i](1).value()[0];
        };
      }), ke(["initial", "tail"], function(t, e) {
        var i = "drop" + (e ? "" : "Right");
        kt.prototype[t] = function() {
          return this.__filtered__ ? new kt(this) : this[i](1);
        };
      }), kt.prototype.compact = function() {
        return this.filter(me);
      }, kt.prototype.find = function(t) {
        return this.filter(t).head();
      }, kt.prototype.findLast = function(t) {
        return this.reverse().find(t);
      }, kt.prototype.invokeMap = At(function(t, e) {
        return typeof t == "function" ? new kt(this) : this.map(function(i) {
          return gi(i, t, e);
        });
      }), kt.prototype.reject = function(t) {
        return this.filter(aa(pt(t)));
      }, kt.prototype.slice = function(t, e) {
        t = St(t);
        var i = this;
        return i.__filtered__ && (t > 0 || e < 0) ? new kt(i) : (t < 0 ? i = i.takeRight(-t) : t && (i = i.drop(t)), e !== n && (e = St(e), i = e < 0 ? i.dropRight(-e) : i.take(e - t)), i);
      }, kt.prototype.takeRightWhile = function(t) {
        return this.reverse().takeWhile(t).reverse();
      }, kt.prototype.toArray = function() {
        return this.take(Q);
      }, Je(kt.prototype, function(t, e) {
        var i = /^(?:filter|find|map|reject)|While$/.test(e), u = /^(?:head|last)$/.test(e), R = k[u ? "take" + (e == "last" ? "Right" : "") : e], M = u || /^find/.test(e);
        R && (k.prototype[e] = function() {
          var B = this.__wrapped__, q = u ? [1] : arguments, z = B instanceof kt, rt = q[0], it = z || wt(B), nt = function(Ot) {
            var It = R.apply(k, _r([Ot], q));
            return u && ot ? It[0] : It;
          };
          it && i && typeof rt == "function" && rt.length != 1 && (z = it = !1);
          var ot = this.__chain__, dt = !!this.__actions__.length, _t = M && !ot, Ct = z && !dt;
          if (!M && it) {
            B = Ct ? B : new kt(this);
            var vt = t.apply(B, q);
            return vt.__actions__.push({ func: ea, args: [nt], thisArg: n }), new Le(vt, ot);
          }
          return _t && Ct ? t.apply(this, q) : (vt = this.thru(nt), _t ? u ? vt.value()[0] : vt.value() : vt);
        });
      }), ke(["pop", "push", "shift", "sort", "splice", "unshift"], function(t) {
        var e = Rn[t], i = /^(?:push|sort|unshift)$/.test(t) ? "tap" : "thru", u = /^(?:pop|shift)$/.test(t);
        k.prototype[t] = function() {
          var R = arguments;
          if (u && !this.__chain__) {
            var M = this.value();
            return e.apply(wt(M) ? M : [], R);
          }
          return this[i](function(B) {
            return e.apply(wt(B) ? B : [], R);
          });
        };
      }), Je(kt.prototype, function(t, e) {
        var i = k[e];
        if (i) {
          var u = i.name + "";
          Gt.call(jr, u) || (jr[u] = []), jr[u].push({ name: e, func: i });
        }
      }), jr[Yn(n, O).name] = [{
        name: "wrapper",
        func: n
      }], kt.prototype.clone = e2, kt.prototype.reverse = r2, kt.prototype.value = i2, k.prototype.at = k_, k.prototype.chain = I_, k.prototype.commit = L_, k.prototype.next = M_, k.prototype.plant = G_, k.prototype.reverse = D_, k.prototype.toJSON = k.prototype.valueOf = k.prototype.value = B_, k.prototype.first = k.prototype.head, oi && (k.prototype[oi] = N_), k;
    }, Vr = Lg();
    Ar ? ((Ar.exports = Vr)._ = Vr, Ma._ = Vr) : oe._ = Vr;
  }).call(wi);
})(fa, fa.exports);
fa.exports;
Object.values(ge);
const W4 = Object.values(Er), z4 = (r) => W4.includes(r);
var fr = /* @__PURE__ */ ((r) => (r.SPOT = "spot", r.DECORATION = "decoration", r))(fr || {});
function H0(r) {
  return !r || typeof r != "object" ? !1 : "type" in r && "subType" in r ? r.type === "spot" && z4(r.subType) : !1;
}
var ri = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
function vn(r) {
  return r && r.__esModule && Object.prototype.hasOwnProperty.call(r, "default") ? r.default : r;
}
var Us, Pc;
function yn() {
  if (Pc) return Us;
  Pc = 1;
  function r(a) {
    var n = typeof a;
    return a != null && (n == "object" || n == "function");
  }
  return Us = r, Us;
}
var qs, Oc;
function V0() {
  if (Oc) return qs;
  Oc = 1;
  var r = typeof ri == "object" && ri && ri.Object === Object && ri;
  return qs = r, qs;
}
var Hs, Fc;
function Xe() {
  if (Fc) return Hs;
  Fc = 1;
  var r = V0(), a = typeof self == "object" && self && self.Object === Object && self, n = r || a || Function("return this")();
  return Hs = n, Hs;
}
var Vs, kc;
function j4() {
  if (kc) return Vs;
  kc = 1;
  var r = Xe(), a = function() {
    return r.Date.now();
  };
  return Vs = a, Vs;
}
var Ws, Ic;
function K4() {
  if (Ic) return Ws;
  Ic = 1;
  var r = /\s/;
  function a(n) {
    for (var o = n.length; o-- && r.test(n.charAt(o)); )
      ;
    return o;
  }
  return Ws = a, Ws;
}
var zs, Lc;
function Y4() {
  if (Lc) return zs;
  Lc = 1;
  var r = K4(), a = /^\s+/;
  function n(o) {
    return o && o.slice(0, r(o) + 1).replace(a, "");
  }
  return zs = n, zs;
}
var js, Mc;
function ya() {
  if (Mc) return js;
  Mc = 1;
  var r = Xe(), a = r.Symbol;
  return js = a, js;
}
var Ks, Nc;
function X4() {
  if (Nc) return Ks;
  Nc = 1;
  var r = ya(), a = Object.prototype, n = a.hasOwnProperty, o = a.toString, c = r ? r.toStringTag : void 0;
  function s(h) {
    var l = n.call(h, c), g = h[c];
    try {
      h[c] = void 0;
      var p = !0;
    } catch {
    }
    var b = o.call(h);
    return p && (l ? h[c] = g : delete h[c]), b;
  }
  return Ks = s, Ks;
}
var Ys, Gc;
function $4() {
  if (Gc) return Ys;
  Gc = 1;
  var r = Object.prototype, a = r.toString;
  function n(o) {
    return a.call(o);
  }
  return Ys = n, Ys;
}
var Xs, Dc;
function mn() {
  if (Dc) return Xs;
  Dc = 1;
  var r = ya(), a = X4(), n = $4(), o = "[object Null]", c = "[object Undefined]", s = r ? r.toStringTag : void 0;
  function h(l) {
    return l == null ? l === void 0 ? c : o : s && s in Object(l) ? a(l) : n(l);
  }
  return Xs = h, Xs;
}
var $s, Bc;
function bn() {
  if (Bc) return $s;
  Bc = 1;
  function r(a) {
    return a != null && typeof a == "object";
  }
  return $s = r, $s;
}
var Zs, Uc;
function W0() {
  if (Uc) return Zs;
  Uc = 1;
  var r = mn(), a = bn(), n = "[object Symbol]";
  function o(c) {
    return typeof c == "symbol" || a(c) && r(c) == n;
  }
  return Zs = o, Zs;
}
var Js, qc;
function jh() {
  if (qc) return Js;
  qc = 1;
  var r = Y4(), a = yn(), n = W0(), o = NaN, c = /^[-+]0x[0-9a-f]+$/i, s = /^0b[01]+$/i, h = /^0o[0-7]+$/i, l = parseInt;
  function g(p) {
    if (typeof p == "number")
      return p;
    if (n(p))
      return o;
    if (a(p)) {
      var b = typeof p.valueOf == "function" ? p.valueOf() : p;
      p = a(b) ? b + "" : b;
    }
    if (typeof p != "string")
      return p === 0 ? p : +p;
    p = r(p);
    var w = s.test(p);
    return w || h.test(p) ? l(p.slice(2), w ? 2 : 8) : c.test(p) ? o : +p;
  }
  return Js = g, Js;
}
var Qs, Hc;
function z0() {
  if (Hc) return Qs;
  Hc = 1;
  var r = yn(), a = j4(), n = jh(), o = "Expected a function", c = Math.max, s = Math.min;
  function h(l, g, p) {
    var b, w, x, v, _, S, C = 0, O = !1, d = !1, f = !0;
    if (typeof l != "function")
      throw new TypeError(o);
    g = n(g) || 0, r(p) && (O = !!p.leading, d = "maxWait" in p, x = d ? c(n(p.maxWait) || 0, g) : x, f = "trailing" in p ? !!p.trailing : f);
    function m(y) {
      var P = b, A = w;
      return b = w = void 0, C = y, v = l.apply(A, P), v;
    }
    function E(y) {
      return C = y, _ = setTimeout(I, g), O ? m(y) : v;
    }
    function T(y) {
      var P = y - S, A = y - C, G = g - P;
      return d ? s(G, x - A) : G;
    }
    function D(y) {
      var P = y - S, A = y - C;
      return S === void 0 || P >= g || P < 0 || d && A >= x;
    }
    function I() {
      var y = a();
      if (D(y))
        return L(y);
      _ = setTimeout(I, T(y));
    }
    function L(y) {
      return _ = void 0, f && b ? m(y) : (b = w = void 0, v);
    }
    function F() {
      _ !== void 0 && clearTimeout(_), C = 0, b = S = w = _ = void 0;
    }
    function N() {
      return _ === void 0 ? v : L(a());
    }
    function H() {
      var y = a(), P = D(y);
      if (b = arguments, w = this, S = y, P) {
        if (_ === void 0)
          return E(S);
        if (d)
          return clearTimeout(_), _ = setTimeout(I, g), m(S);
      }
      return _ === void 0 && (_ = setTimeout(I, g)), v;
    }
    return H.cancel = F, H.flush = N, H;
  }
  return Qs = h, Qs;
}
var to, Vc;
function Z4() {
  if (Vc) return to;
  Vc = 1;
  var r = z0(), a = yn(), n = "Expected a function";
  function o(c, s, h) {
    var l = !0, g = !0;
    if (typeof c != "function")
      throw new TypeError(n);
    return a(h) && (l = "leading" in h ? !!h.leading : l, g = "trailing" in h ? !!h.trailing : g), r(c, s, {
      leading: l,
      maxWait: s,
      trailing: g
    });
  }
  return to = o, to;
}
var J4 = Z4();
const Q4 = /* @__PURE__ */ vn(J4), Wc = (r) => {
  let a;
  const n = /* @__PURE__ */ new Set(), o = (p, b) => {
    const w = typeof p == "function" ? p(a) : p;
    if (!Object.is(w, a)) {
      const x = a;
      a = (b != null ? b : typeof w != "object" || w === null) ? w : Object.assign({}, a, w), n.forEach((v) => v(a, x));
    }
  }, c = () => a, l = { setState: o, getState: c, getInitialState: () => g, subscribe: (p) => (n.add(p), () => n.delete(p)) }, g = a = r(o, c, l);
  return l;
}, t6 = (r) => r ? Wc(r) : Wc, xt = t6(() => ({
  assetsBaseUrl: "",
  background: {
    url: null,
    height: 0,
    width: 0,
    offset: {
      x: 0,
      y: 0
    }
  },
  debug: !1,
  draggable: !0,
  elementsLayerOffsetX: 0,
  elementsMetaData: null,
  fit: _n.COVER,
  isPrintEnabled: !1,
  mapSize: {
    width: 0,
    height: 0
  },
  minScale: 0
}));
function e6(r, a) {
  const n = Math.ceil(r.width / a.width), o = Math.ceil(r.height / a.height), c = a.height, s = a.width, h = [];
  for (let l = 0; l < n; l++)
    for (let g = 0; g < o; g++) {
      const p = l * s, b = g * c;
      h.push({
        spots: [],
        rect: {
          height: c,
          width: s,
          x: p,
          y: b
        },
        visible: !1
      });
    }
  return h;
}
function r6(r, a) {
  return r.x >= a.x && r.y >= a.y && r.x <= a.x + a.width && r.y <= a.y + a.height;
}
function i6(r, a) {
  return !(a.x > r.x + r.width || a.x + a.width < r.x || a.y > r.y + r.height || a.y + a.height < r.y);
}
function n6(r, a) {
  a.forEach((n) => {
    r.forEach((o) => {
      if (r6(n, o.rect)) {
        o.spots.push(n);
        return;
      }
    });
  });
}
function Y8(r, a, n) {
  if (r.width <= a.width && r.height <= a.height)
    return [
      {
        spots: n,
        visible: !0,
        rect: {
          height: r.height,
          width: r.width,
          x: 0,
          y: 0
        }
      }
    ];
  const o = e6(r, a);
  return n6(o, n), o;
}
function a6(r, a) {
  const n = [], o = [], { elementsLayerOffsetX: c } = xt.getState();
  return r.forEach((s) => {
    const h = i6(a.rect, {
      ...s.rect,
      x: s.rect.x + c
    });
    if (s.visible === h)
      return;
    const l = s.spots.filter((g) => H0(g));
    if (s.visible = h, s.visible)
      n.push(...l);
    else {
      const g = l.map((p) => p.id);
      o.push(...g);
    }
  }), {
    elementsToAdd: n,
    elementsToRemove: o
  };
}
const X8 = Q4(
  async (r, a) => {
    const n = r.getStageInfo(), { elementsToRemove: o, elementsToAdd: c } = a6(
      a,
      n
    );
    o.length > 0 && r.removeElementsById(o), c.length > 0 && await r.addElements(c);
  },
  350
);
var da = { exports: {} }, Si = {}, eo = {}, ro = {}, zc;
function Rt() {
  return zc || (zc = 1, function(r) {
    Object.defineProperty(r, "__esModule", { value: !0 }), r._registerNode = r.Konva = r.glob = void 0;
    const a = Math.PI / 180;
    function n() {
      return typeof window != "undefined" && ({}.toString.call(window) === "[object Window]" || {}.toString.call(window) === "[object global]");
    }
    r.glob = typeof ri != "undefined" ? ri : typeof window != "undefined" ? window : typeof WorkerGlobalScope != "undefined" ? self : {}, r.Konva = {
      _global: r.glob,
      version: "9.3.16",
      isBrowser: n(),
      isUnminified: /param/.test(function(c) {
      }.toString()),
      dblClickWindow: 400,
      getAngle(c) {
        return r.Konva.angleDeg ? c * a : c;
      },
      enableTrace: !1,
      pointerEventsEnabled: !0,
      autoDrawEnabled: !0,
      hitOnDragEnabled: !1,
      capturePointerEventsEnabled: !1,
      _mouseListenClick: !1,
      _touchListenClick: !1,
      _pointerListenClick: !1,
      _mouseInDblClickWindow: !1,
      _touchInDblClickWindow: !1,
      _pointerInDblClickWindow: !1,
      _mouseDblClickPointerId: null,
      _touchDblClickPointerId: null,
      _pointerDblClickPointerId: null,
      _fixTextRendering: !1,
      pixelRatio: typeof window != "undefined" && window.devicePixelRatio || 1,
      dragDistance: 3,
      angleDeg: !0,
      showWarnings: !0,
      dragButtons: [0, 1],
      isDragging() {
        return r.Konva.DD.isDragging;
      },
      isTransforming() {
        var c;
        return (c = r.Konva.Transformer) === null || c === void 0 ? void 0 : c.isTransforming();
      },
      isDragReady() {
        return !!r.Konva.DD.node;
      },
      releaseCanvasOnDestroy: !0,
      document: r.glob.document,
      _injectGlobal(c) {
        r.glob.Konva = c;
      }
    };
    const o = (c) => {
      r.Konva[c.prototype.getClassName()] = c;
    };
    r._registerNode = o, r.Konva._injectGlobal(r.Konva);
  }(ro)), ro;
}
var io = {}, jc;
function Kt() {
  return jc || (jc = 1, function(r) {
    Object.defineProperty(r, "__esModule", { value: !0 }), r.Util = r.Transform = void 0;
    const a = Rt();
    class n {
      constructor(m = [1, 0, 0, 1, 0, 0]) {
        this.dirty = !1, this.m = m && m.slice() || [1, 0, 0, 1, 0, 0];
      }
      reset() {
        this.m[0] = 1, this.m[1] = 0, this.m[2] = 0, this.m[3] = 1, this.m[4] = 0, this.m[5] = 0;
      }
      copy() {
        return new n(this.m);
      }
      copyInto(m) {
        m.m[0] = this.m[0], m.m[1] = this.m[1], m.m[2] = this.m[2], m.m[3] = this.m[3], m.m[4] = this.m[4], m.m[5] = this.m[5];
      }
      point(m) {
        const E = this.m;
        return {
          x: E[0] * m.x + E[2] * m.y + E[4],
          y: E[1] * m.x + E[3] * m.y + E[5]
        };
      }
      translate(m, E) {
        return this.m[4] += this.m[0] * m + this.m[2] * E, this.m[5] += this.m[1] * m + this.m[3] * E, this;
      }
      scale(m, E) {
        return this.m[0] *= m, this.m[1] *= m, this.m[2] *= E, this.m[3] *= E, this;
      }
      rotate(m) {
        const E = Math.cos(m), T = Math.sin(m), D = this.m[0] * E + this.m[2] * T, I = this.m[1] * E + this.m[3] * T, L = this.m[0] * -T + this.m[2] * E, F = this.m[1] * -T + this.m[3] * E;
        return this.m[0] = D, this.m[1] = I, this.m[2] = L, this.m[3] = F, this;
      }
      getTranslation() {
        return {
          x: this.m[4],
          y: this.m[5]
        };
      }
      skew(m, E) {
        const T = this.m[0] + this.m[2] * E, D = this.m[1] + this.m[3] * E, I = this.m[2] + this.m[0] * m, L = this.m[3] + this.m[1] * m;
        return this.m[0] = T, this.m[1] = D, this.m[2] = I, this.m[3] = L, this;
      }
      multiply(m) {
        const E = this.m[0] * m.m[0] + this.m[2] * m.m[1], T = this.m[1] * m.m[0] + this.m[3] * m.m[1], D = this.m[0] * m.m[2] + this.m[2] * m.m[3], I = this.m[1] * m.m[2] + this.m[3] * m.m[3], L = this.m[0] * m.m[4] + this.m[2] * m.m[5] + this.m[4], F = this.m[1] * m.m[4] + this.m[3] * m.m[5] + this.m[5];
        return this.m[0] = E, this.m[1] = T, this.m[2] = D, this.m[3] = I, this.m[4] = L, this.m[5] = F, this;
      }
      invert() {
        const m = 1 / (this.m[0] * this.m[3] - this.m[1] * this.m[2]), E = this.m[3] * m, T = -this.m[1] * m, D = -this.m[2] * m, I = this.m[0] * m, L = m * (this.m[2] * this.m[5] - this.m[3] * this.m[4]), F = m * (this.m[1] * this.m[4] - this.m[0] * this.m[5]);
        return this.m[0] = E, this.m[1] = T, this.m[2] = D, this.m[3] = I, this.m[4] = L, this.m[5] = F, this;
      }
      getMatrix() {
        return this.m;
      }
      decompose() {
        const m = this.m[0], E = this.m[1], T = this.m[2], D = this.m[3], I = this.m[4], L = this.m[5], F = m * D - E * T, N = {
          x: I,
          y: L,
          rotation: 0,
          scaleX: 0,
          scaleY: 0,
          skewX: 0,
          skewY: 0
        };
        if (m != 0 || E != 0) {
          const H = Math.sqrt(m * m + E * E);
          N.rotation = E > 0 ? Math.acos(m / H) : -Math.acos(m / H), N.scaleX = H, N.scaleY = F / H, N.skewX = (m * T + E * D) / F, N.skewY = 0;
        } else if (T != 0 || D != 0) {
          const H = Math.sqrt(T * T + D * D);
          N.rotation = Math.PI / 2 - (D > 0 ? Math.acos(-T / H) : -Math.acos(T / H)), N.scaleX = F / H, N.scaleY = H, N.skewX = 0, N.skewY = (m * T + E * D) / F;
        }
        return N.rotation = r.Util._getRotation(N.rotation), N;
      }
    }
    r.Transform = n;
    let o = "[object Array]", c = "[object Number]", s = "[object String]", h = "[object Boolean]", l = Math.PI / 180, g = 180 / Math.PI, p = "#", b = "", w = "0", x = "Konva warning: ", v = "Konva error: ", _ = "rgb(", S = {
      aliceblue: [240, 248, 255],
      antiquewhite: [250, 235, 215],
      aqua: [0, 255, 255],
      aquamarine: [127, 255, 212],
      azure: [240, 255, 255],
      beige: [245, 245, 220],
      bisque: [255, 228, 196],
      black: [0, 0, 0],
      blanchedalmond: [255, 235, 205],
      blue: [0, 0, 255],
      blueviolet: [138, 43, 226],
      brown: [165, 42, 42],
      burlywood: [222, 184, 135],
      cadetblue: [95, 158, 160],
      chartreuse: [127, 255, 0],
      chocolate: [210, 105, 30],
      coral: [255, 127, 80],
      cornflowerblue: [100, 149, 237],
      cornsilk: [255, 248, 220],
      crimson: [220, 20, 60],
      cyan: [0, 255, 255],
      darkblue: [0, 0, 139],
      darkcyan: [0, 139, 139],
      darkgoldenrod: [184, 132, 11],
      darkgray: [169, 169, 169],
      darkgreen: [0, 100, 0],
      darkgrey: [169, 169, 169],
      darkkhaki: [189, 183, 107],
      darkmagenta: [139, 0, 139],
      darkolivegreen: [85, 107, 47],
      darkorange: [255, 140, 0],
      darkorchid: [153, 50, 204],
      darkred: [139, 0, 0],
      darksalmon: [233, 150, 122],
      darkseagreen: [143, 188, 143],
      darkslateblue: [72, 61, 139],
      darkslategray: [47, 79, 79],
      darkslategrey: [47, 79, 79],
      darkturquoise: [0, 206, 209],
      darkviolet: [148, 0, 211],
      deeppink: [255, 20, 147],
      deepskyblue: [0, 191, 255],
      dimgray: [105, 105, 105],
      dimgrey: [105, 105, 105],
      dodgerblue: [30, 144, 255],
      firebrick: [178, 34, 34],
      floralwhite: [255, 255, 240],
      forestgreen: [34, 139, 34],
      fuchsia: [255, 0, 255],
      gainsboro: [220, 220, 220],
      ghostwhite: [248, 248, 255],
      gold: [255, 215, 0],
      goldenrod: [218, 165, 32],
      gray: [128, 128, 128],
      green: [0, 128, 0],
      greenyellow: [173, 255, 47],
      grey: [128, 128, 128],
      honeydew: [240, 255, 240],
      hotpink: [255, 105, 180],
      indianred: [205, 92, 92],
      indigo: [75, 0, 130],
      ivory: [255, 255, 240],
      khaki: [240, 230, 140],
      lavender: [230, 230, 250],
      lavenderblush: [255, 240, 245],
      lawngreen: [124, 252, 0],
      lemonchiffon: [255, 250, 205],
      lightblue: [173, 216, 230],
      lightcoral: [240, 128, 128],
      lightcyan: [224, 255, 255],
      lightgoldenrodyellow: [250, 250, 210],
      lightgray: [211, 211, 211],
      lightgreen: [144, 238, 144],
      lightgrey: [211, 211, 211],
      lightpink: [255, 182, 193],
      lightsalmon: [255, 160, 122],
      lightseagreen: [32, 178, 170],
      lightskyblue: [135, 206, 250],
      lightslategray: [119, 136, 153],
      lightslategrey: [119, 136, 153],
      lightsteelblue: [176, 196, 222],
      lightyellow: [255, 255, 224],
      lime: [0, 255, 0],
      limegreen: [50, 205, 50],
      linen: [250, 240, 230],
      magenta: [255, 0, 255],
      maroon: [128, 0, 0],
      mediumaquamarine: [102, 205, 170],
      mediumblue: [0, 0, 205],
      mediumorchid: [186, 85, 211],
      mediumpurple: [147, 112, 219],
      mediumseagreen: [60, 179, 113],
      mediumslateblue: [123, 104, 238],
      mediumspringgreen: [0, 250, 154],
      mediumturquoise: [72, 209, 204],
      mediumvioletred: [199, 21, 133],
      midnightblue: [25, 25, 112],
      mintcream: [245, 255, 250],
      mistyrose: [255, 228, 225],
      moccasin: [255, 228, 181],
      navajowhite: [255, 222, 173],
      navy: [0, 0, 128],
      oldlace: [253, 245, 230],
      olive: [128, 128, 0],
      olivedrab: [107, 142, 35],
      orange: [255, 165, 0],
      orangered: [255, 69, 0],
      orchid: [218, 112, 214],
      palegoldenrod: [238, 232, 170],
      palegreen: [152, 251, 152],
      paleturquoise: [175, 238, 238],
      palevioletred: [219, 112, 147],
      papayawhip: [255, 239, 213],
      peachpuff: [255, 218, 185],
      peru: [205, 133, 63],
      pink: [255, 192, 203],
      plum: [221, 160, 203],
      powderblue: [176, 224, 230],
      purple: [128, 0, 128],
      rebeccapurple: [102, 51, 153],
      red: [255, 0, 0],
      rosybrown: [188, 143, 143],
      royalblue: [65, 105, 225],
      saddlebrown: [139, 69, 19],
      salmon: [250, 128, 114],
      sandybrown: [244, 164, 96],
      seagreen: [46, 139, 87],
      seashell: [255, 245, 238],
      sienna: [160, 82, 45],
      silver: [192, 192, 192],
      skyblue: [135, 206, 235],
      slateblue: [106, 90, 205],
      slategray: [119, 128, 144],
      slategrey: [119, 128, 144],
      snow: [255, 255, 250],
      springgreen: [0, 255, 127],
      steelblue: [70, 130, 180],
      tan: [210, 180, 140],
      teal: [0, 128, 128],
      thistle: [216, 191, 216],
      transparent: [255, 255, 255, 0],
      tomato: [255, 99, 71],
      turquoise: [64, 224, 208],
      violet: [238, 130, 238],
      wheat: [245, 222, 179],
      white: [255, 255, 255],
      whitesmoke: [245, 245, 245],
      yellow: [255, 255, 0],
      yellowgreen: [154, 205, 5]
    }, C = /rgb\((\d{1,3}),(\d{1,3}),(\d{1,3})\)/, O = [];
    const d = typeof requestAnimationFrame != "undefined" && requestAnimationFrame || function(f) {
      setTimeout(f, 60);
    };
    r.Util = {
      _isElement(f) {
        return !!(f && f.nodeType == 1);
      },
      _isFunction(f) {
        return !!(f && f.constructor && f.call && f.apply);
      },
      _isPlainObject(f) {
        return !!f && f.constructor === Object;
      },
      _isArray(f) {
        return Object.prototype.toString.call(f) === o;
      },
      _isNumber(f) {
        return Object.prototype.toString.call(f) === c && !isNaN(f) && isFinite(f);
      },
      _isString(f) {
        return Object.prototype.toString.call(f) === s;
      },
      _isBoolean(f) {
        return Object.prototype.toString.call(f) === h;
      },
      isObject(f) {
        return f instanceof Object;
      },
      isValidSelector(f) {
        if (typeof f != "string")
          return !1;
        const m = f[0];
        return m === "#" || m === "." || m === m.toUpperCase();
      },
      _sign(f) {
        return f === 0 || f > 0 ? 1 : -1;
      },
      requestAnimFrame(f) {
        O.push(f), O.length === 1 && d(function() {
          const m = O;
          O = [], m.forEach(function(E) {
            E();
          });
        });
      },
      createCanvasElement() {
        const f = document.createElement("canvas");
        try {
          f.style = f.style || {};
        } catch {
        }
        return f;
      },
      createImageElement() {
        return document.createElement("img");
      },
      _isInDocument(f) {
        for (; f = f.parentNode; )
          if (f == document)
            return !0;
        return !1;
      },
      _urlToImage(f, m) {
        const E = r.Util.createImageElement();
        E.onload = function() {
          m(E);
        }, E.src = f;
      },
      _rgbToHex(f, m, E) {
        return ((1 << 24) + (f << 16) + (m << 8) + E).toString(16).slice(1);
      },
      _hexToRgb(f) {
        f = f.replace(p, b);
        const m = parseInt(f, 16);
        return {
          r: m >> 16 & 255,
          g: m >> 8 & 255,
          b: m & 255
        };
      },
      getRandomColor() {
        let f = (Math.random() * 16777215 << 0).toString(16);
        for (; f.length < 6; )
          f = w + f;
        return p + f;
      },
      getRGB(f) {
        let m;
        return f in S ? (m = S[f], {
          r: m[0],
          g: m[1],
          b: m[2]
        }) : f[0] === p ? this._hexToRgb(f.substring(1)) : f.substr(0, 4) === _ ? (m = C.exec(f.replace(/ /g, "")), {
          r: parseInt(m[1], 10),
          g: parseInt(m[2], 10),
          b: parseInt(m[3], 10)
        }) : {
          r: 0,
          g: 0,
          b: 0
        };
      },
      colorToRGBA(f) {
        return f = f || "black", r.Util._namedColorToRBA(f) || r.Util._hex3ColorToRGBA(f) || r.Util._hex4ColorToRGBA(f) || r.Util._hex6ColorToRGBA(f) || r.Util._hex8ColorToRGBA(f) || r.Util._rgbColorToRGBA(f) || r.Util._rgbaColorToRGBA(f) || r.Util._hslColorToRGBA(f);
      },
      _namedColorToRBA(f) {
        const m = S[f.toLowerCase()];
        return m ? {
          r: m[0],
          g: m[1],
          b: m[2],
          a: 1
        } : null;
      },
      _rgbColorToRGBA(f) {
        if (f.indexOf("rgb(") === 0) {
          f = f.match(/rgb\(([^)]+)\)/)[1];
          const m = f.split(/ *, */).map(Number);
          return {
            r: m[0],
            g: m[1],
            b: m[2],
            a: 1
          };
        }
      },
      _rgbaColorToRGBA(f) {
        if (f.indexOf("rgba(") === 0) {
          f = f.match(/rgba\(([^)]+)\)/)[1];
          const m = f.split(/ *, */).map((E, T) => E.slice(-1) === "%" ? T === 3 ? parseInt(E) / 100 : parseInt(E) / 100 * 255 : Number(E));
          return {
            r: m[0],
            g: m[1],
            b: m[2],
            a: m[3]
          };
        }
      },
      _hex8ColorToRGBA(f) {
        if (f[0] === "#" && f.length === 9)
          return {
            r: parseInt(f.slice(1, 3), 16),
            g: parseInt(f.slice(3, 5), 16),
            b: parseInt(f.slice(5, 7), 16),
            a: parseInt(f.slice(7, 9), 16) / 255
          };
      },
      _hex6ColorToRGBA(f) {
        if (f[0] === "#" && f.length === 7)
          return {
            r: parseInt(f.slice(1, 3), 16),
            g: parseInt(f.slice(3, 5), 16),
            b: parseInt(f.slice(5, 7), 16),
            a: 1
          };
      },
      _hex4ColorToRGBA(f) {
        if (f[0] === "#" && f.length === 5)
          return {
            r: parseInt(f[1] + f[1], 16),
            g: parseInt(f[2] + f[2], 16),
            b: parseInt(f[3] + f[3], 16),
            a: parseInt(f[4] + f[4], 16) / 255
          };
      },
      _hex3ColorToRGBA(f) {
        if (f[0] === "#" && f.length === 4)
          return {
            r: parseInt(f[1] + f[1], 16),
            g: parseInt(f[2] + f[2], 16),
            b: parseInt(f[3] + f[3], 16),
            a: 1
          };
      },
      _hslColorToRGBA(f) {
        if (/hsl\((\d+),\s*([\d.]+)%,\s*([\d.]+)%\)/g.test(f)) {
          const [m, ...E] = /hsl\((\d+),\s*([\d.]+)%,\s*([\d.]+)%\)/g.exec(f), T = Number(E[0]) / 360, D = Number(E[1]) / 100, I = Number(E[2]) / 100;
          let L, F, N;
          if (D === 0)
            return N = I * 255, {
              r: Math.round(N),
              g: Math.round(N),
              b: Math.round(N),
              a: 1
            };
          I < 0.5 ? L = I * (1 + D) : L = I + D - I * D;
          const H = 2 * I - L, y = [0, 0, 0];
          for (let P = 0; P < 3; P++)
            F = T + 1 / 3 * -(P - 1), F < 0 && F++, F > 1 && F--, 6 * F < 1 ? N = H + (L - H) * 6 * F : 2 * F < 1 ? N = L : 3 * F < 2 ? N = H + (L - H) * (2 / 3 - F) * 6 : N = H, y[P] = N * 255;
          return {
            r: Math.round(y[0]),
            g: Math.round(y[1]),
            b: Math.round(y[2]),
            a: 1
          };
        }
      },
      haveIntersection(f, m) {
        return !(m.x > f.x + f.width || m.x + m.width < f.x || m.y > f.y + f.height || m.y + m.height < f.y);
      },
      cloneObject(f) {
        const m = {};
        for (const E in f)
          this._isPlainObject(f[E]) ? m[E] = this.cloneObject(f[E]) : this._isArray(f[E]) ? m[E] = this.cloneArray(f[E]) : m[E] = f[E];
        return m;
      },
      cloneArray(f) {
        return f.slice(0);
      },
      degToRad(f) {
        return f * l;
      },
      radToDeg(f) {
        return f * g;
      },
      _degToRad(f) {
        return r.Util.warn("Util._degToRad is removed. Please use public Util.degToRad instead."), r.Util.degToRad(f);
      },
      _radToDeg(f) {
        return r.Util.warn("Util._radToDeg is removed. Please use public Util.radToDeg instead."), r.Util.radToDeg(f);
      },
      _getRotation(f) {
        return a.Konva.angleDeg ? r.Util.radToDeg(f) : f;
      },
      _capitalize(f) {
        return f.charAt(0).toUpperCase() + f.slice(1);
      },
      throw(f) {
        throw new Error(v + f);
      },
      error(f) {
        console.error(v + f);
      },
      warn(f) {
        a.Konva.showWarnings && console.warn(x + f);
      },
      each(f, m) {
        for (const E in f)
          m(E, f[E]);
      },
      _inRange(f, m, E) {
        return m <= f && f < E;
      },
      _getProjectionToSegment(f, m, E, T, D, I) {
        let L, F, N;
        const H = (f - E) * (f - E) + (m - T) * (m - T);
        if (H == 0)
          L = f, F = m, N = (D - E) * (D - E) + (I - T) * (I - T);
        else {
          const y = ((D - f) * (E - f) + (I - m) * (T - m)) / H;
          y < 0 ? (L = f, F = m, N = (f - D) * (f - D) + (m - I) * (m - I)) : y > 1 ? (L = E, F = T, N = (E - D) * (E - D) + (T - I) * (T - I)) : (L = f + y * (E - f), F = m + y * (T - m), N = (L - D) * (L - D) + (F - I) * (F - I));
        }
        return [L, F, N];
      },
      _getProjectionToLine(f, m, E) {
        const T = r.Util.cloneObject(f);
        let D = Number.MAX_VALUE;
        return m.forEach(function(I, L) {
          if (!E && L === m.length - 1)
            return;
          const F = m[(L + 1) % m.length], N = r.Util._getProjectionToSegment(I.x, I.y, F.x, F.y, f.x, f.y), H = N[0], y = N[1], P = N[2];
          P < D && (T.x = H, T.y = y, D = P);
        }), T;
      },
      _prepareArrayForTween(f, m, E) {
        let T, D = [], I = [];
        if (f.length > m.length) {
          const F = m;
          m = f, f = F;
        }
        for (T = 0; T < f.length; T += 2)
          D.push({
            x: f[T],
            y: f[T + 1]
          });
        for (T = 0; T < m.length; T += 2)
          I.push({
            x: m[T],
            y: m[T + 1]
          });
        const L = [];
        return I.forEach(function(F) {
          const N = r.Util._getProjectionToLine(F, D, E);
          L.push(N.x), L.push(N.y);
        }), L;
      },
      _prepareToStringify(f) {
        let m;
        f.visitedByCircularReferenceRemoval = !0;
        for (const E in f)
          if (f.hasOwnProperty(E) && f[E] && typeof f[E] == "object") {
            if (m = Object.getOwnPropertyDescriptor(f, E), f[E].visitedByCircularReferenceRemoval || r.Util._isElement(f[E]))
              if (m.configurable)
                delete f[E];
              else
                return null;
            else if (r.Util._prepareToStringify(f[E]) === null)
              if (m.configurable)
                delete f[E];
              else
                return null;
          }
        return delete f.visitedByCircularReferenceRemoval, f;
      },
      _assign(f, m) {
        for (const E in m)
          f[E] = m[E];
        return f;
      },
      _getFirstPointerId(f) {
        return f.touches ? f.changedTouches[0].identifier : f.pointerId || 999;
      },
      releaseCanvas(...f) {
        a.Konva.releaseCanvasOnDestroy && f.forEach((m) => {
          m.width = 0, m.height = 0;
        });
      },
      drawRoundedRectPath(f, m, E, T) {
        let D = 0, I = 0, L = 0, F = 0;
        typeof T == "number" ? D = I = L = F = Math.min(T, m / 2, E / 2) : (D = Math.min(T[0] || 0, m / 2, E / 2), I = Math.min(T[1] || 0, m / 2, E / 2), F = Math.min(T[2] || 0, m / 2, E / 2), L = Math.min(T[3] || 0, m / 2, E / 2)), f.moveTo(D, 0), f.lineTo(m - I, 0), f.arc(m - I, I, I, Math.PI * 3 / 2, 0, !1), f.lineTo(m, E - F), f.arc(m - F, E - F, F, 0, Math.PI / 2, !1), f.lineTo(L, E), f.arc(L, E - L, L, Math.PI / 2, Math.PI, !1), f.lineTo(0, D), f.arc(D, D, D, Math.PI, Math.PI * 3 / 2, !1);
      }
    };
  }(io)), io;
}
var Ci = {}, no = {}, be = {}, Kc;
function Ft() {
  if (Kc) return be;
  Kc = 1, Object.defineProperty(be, "__esModule", { value: !0 }), be.RGBComponent = o, be.alphaComponent = c, be.getNumberValidator = s, be.getNumberOrArrayOfNumbersValidator = h, be.getNumberOrAutoValidator = l, be.getStringValidator = g, be.getStringOrGradientValidator = p, be.getFunctionValidator = b, be.getNumberArrayValidator = w, be.getBooleanValidator = x, be.getComponentValidator = v;
  const r = Rt(), a = Kt();
  function n(_) {
    return a.Util._isString(_) ? '"' + _ + '"' : Object.prototype.toString.call(_) === "[object Number]" || a.Util._isBoolean(_) ? _ : Object.prototype.toString.call(_);
  }
  function o(_) {
    return _ > 255 ? 255 : _ < 0 ? 0 : Math.round(_);
  }
  function c(_) {
    return _ > 1 ? 1 : _ < 1e-4 ? 1e-4 : _;
  }
  function s() {
    if (r.Konva.isUnminified)
      return function(_, S) {
        return a.Util._isNumber(_) || a.Util.warn(n(_) + ' is a not valid value for "' + S + '" attribute. The value should be a number.'), _;
      };
  }
  function h(_) {
    if (r.Konva.isUnminified)
      return function(S, C) {
        const O = a.Util._isNumber(S), d = a.Util._isArray(S) && S.length == _;
        return !O && !d && a.Util.warn(n(S) + ' is a not valid value for "' + C + '" attribute. The value should be a number or Array<number>(' + _ + ")"), S;
      };
  }
  function l() {
    if (r.Konva.isUnminified)
      return function(_, S) {
        return a.Util._isNumber(_) || _ === "auto" || a.Util.warn(n(_) + ' is a not valid value for "' + S + '" attribute. The value should be a number or "auto".'), _;
      };
  }
  function g() {
    if (r.Konva.isUnminified)
      return function(_, S) {
        return a.Util._isString(_) || a.Util.warn(n(_) + ' is a not valid value for "' + S + '" attribute. The value should be a string.'), _;
      };
  }
  function p() {
    if (r.Konva.isUnminified)
      return function(_, S) {
        const C = a.Util._isString(_), O = Object.prototype.toString.call(_) === "[object CanvasGradient]" || _ && _.addColorStop;
        return C || O || a.Util.warn(n(_) + ' is a not valid value for "' + S + '" attribute. The value should be a string or a native gradient.'), _;
      };
  }
  function b() {
    if (r.Konva.isUnminified)
      return function(_, S) {
        return a.Util._isFunction(_) || a.Util.warn(n(_) + ' is a not valid value for "' + S + '" attribute. The value should be a function.'), _;
      };
  }
  function w() {
    if (r.Konva.isUnminified)
      return function(_, S) {
        const C = Int8Array ? Object.getPrototypeOf(Int8Array) : null;
        return C && _ instanceof C || (a.Util._isArray(_) ? _.forEach(function(O) {
          a.Util._isNumber(O) || a.Util.warn('"' + S + '" attribute has non numeric element ' + O + ". Make sure that all elements are numbers.");
        }) : a.Util.warn(n(_) + ' is a not valid value for "' + S + '" attribute. The value should be a array of numbers.')), _;
      };
  }
  function x() {
    if (r.Konva.isUnminified)
      return function(_, S) {
        return _ === !0 || _ === !1 || a.Util.warn(n(_) + ' is a not valid value for "' + S + '" attribute. The value should be a boolean.'), _;
      };
  }
  function v(_) {
    if (r.Konva.isUnminified)
      return function(S, C) {
        return S == null || a.Util.isObject(S) || a.Util.warn(n(S) + ' is a not valid value for "' + C + '" attribute. The value should be an object with properties ' + _), S;
      };
  }
  return be;
}
var Yc;
function Tt() {
  return Yc || (Yc = 1, function(r) {
    Object.defineProperty(r, "__esModule", { value: !0 }), r.Factory = void 0;
    const a = Kt(), n = Ft(), o = "get", c = "set";
    r.Factory = {
      addGetterSetter(s, h, l, g, p) {
        r.Factory.addGetter(s, h, l), r.Factory.addSetter(s, h, g, p), r.Factory.addOverloadedGetterSetter(s, h);
      },
      addGetter(s, h, l) {
        const g = o + a.Util._capitalize(h);
        s.prototype[g] = s.prototype[g] || function() {
          const p = this.attrs[h];
          return p === void 0 ? l : p;
        };
      },
      addSetter(s, h, l, g) {
        const p = c + a.Util._capitalize(h);
        s.prototype[p] || r.Factory.overWriteSetter(s, h, l, g);
      },
      overWriteSetter(s, h, l, g) {
        const p = c + a.Util._capitalize(h);
        s.prototype[p] = function(b) {
          return l && b !== void 0 && b !== null && (b = l.call(this, b, h)), this._setAttr(h, b), g && g.call(this), this;
        };
      },
      addComponentsGetterSetter(s, h, l, g, p) {
        let b = l.length, w = a.Util._capitalize, x = o + w(h), v = c + w(h), _, S;
        s.prototype[x] = function() {
          const O = {};
          for (_ = 0; _ < b; _++)
            S = l[_], O[S] = this.getAttr(h + w(S));
          return O;
        };
        const C = (0, n.getComponentValidator)(l);
        s.prototype[v] = function(O) {
          let d = this.attrs[h], f;
          g && (O = g.call(this, O)), C && C.call(this, O, h);
          for (f in O)
            O.hasOwnProperty(f) && this._setAttr(h + w(f), O[f]);
          return O || l.forEach((m) => {
            this._setAttr(h + w(m), void 0);
          }), this._fireChangeEvent(h, d, O), p && p.call(this), this;
        }, r.Factory.addOverloadedGetterSetter(s, h);
      },
      addOverloadedGetterSetter(s, h) {
        const l = a.Util._capitalize(h), g = c + l, p = o + l;
        s.prototype[h] = function() {
          return arguments.length ? (this[g](arguments[0]), this) : this[p]();
        };
      },
      addDeprecatedGetterSetter(s, h, l, g) {
        a.Util.error("Adding deprecated " + h);
        const p = o + a.Util._capitalize(h), b = h + " property is deprecated and will be removed soon. Look at Konva change log for more information.";
        s.prototype[p] = function() {
          a.Util.error(b);
          const w = this.attrs[h];
          return w === void 0 ? l : w;
        }, r.Factory.addSetter(s, h, g, function() {
          a.Util.error(b);
        }), r.Factory.addOverloadedGetterSetter(s, h);
      },
      backCompat(s, h) {
        a.Util.each(h, function(l, g) {
          const p = s.prototype[g], b = o + a.Util._capitalize(l), w = c + a.Util._capitalize(l);
          function x() {
            p.apply(this, arguments), a.Util.error('"' + l + '" method is deprecated and will be removed soon. Use ""' + g + '" instead.');
          }
          s.prototype[l] = x, s.prototype[b] = x, s.prototype[w] = x;
        });
      },
      afterSetFilter() {
        this._filterUpToDate = !1;
      }
    };
  }(no)), no;
}
var cr = {}, dr = {}, Xc;
function j0() {
  if (Xc) return dr;
  Xc = 1, Object.defineProperty(dr, "__esModule", { value: !0 }), dr.HitContext = dr.SceneContext = dr.Context = void 0;
  const r = Kt(), a = Rt();
  function n(O) {
    let d = [], f = O.length, m = r.Util, E, T;
    for (E = 0; E < f; E++)
      T = O[E], m._isNumber(T) ? T = Math.round(T * 1e3) / 1e3 : m._isString(T) || (T = T + ""), d.push(T);
    return d;
  }
  const o = ",", c = "(", s = ")", h = "([", l = "])", g = ";", p = "()", b = "=", w = [
    "arc",
    "arcTo",
    "beginPath",
    "bezierCurveTo",
    "clearRect",
    "clip",
    "closePath",
    "createLinearGradient",
    "createPattern",
    "createRadialGradient",
    "drawImage",
    "ellipse",
    "fill",
    "fillText",
    "getImageData",
    "createImageData",
    "lineTo",
    "moveTo",
    "putImageData",
    "quadraticCurveTo",
    "rect",
    "roundRect",
    "restore",
    "rotate",
    "save",
    "scale",
    "setLineDash",
    "setTransform",
    "stroke",
    "strokeText",
    "transform",
    "translate"
  ], x = [
    "fillStyle",
    "strokeStyle",
    "shadowColor",
    "shadowBlur",
    "shadowOffsetX",
    "shadowOffsetY",
    "letterSpacing",
    "lineCap",
    "lineDashOffset",
    "lineJoin",
    "lineWidth",
    "miterLimit",
    "direction",
    "font",
    "textAlign",
    "textBaseline",
    "globalAlpha",
    "globalCompositeOperation",
    "imageSmoothingEnabled"
  ], v = 100;
  let _ = class {
    constructor(d) {
      this.canvas = d, a.Konva.enableTrace && (this.traceArr = [], this._enableTrace());
    }
    fillShape(d) {
      d.fillEnabled() && this._fill(d);
    }
    _fill(d) {
    }
    strokeShape(d) {
      d.hasStroke() && this._stroke(d);
    }
    _stroke(d) {
    }
    fillStrokeShape(d) {
      d.attrs.fillAfterStrokeEnabled ? (this.strokeShape(d), this.fillShape(d)) : (this.fillShape(d), this.strokeShape(d));
    }
    getTrace(d, f) {
      let m = this.traceArr, E = m.length, T = "", D, I, L, F;
      for (D = 0; D < E; D++)
        I = m[D], L = I.method, L ? (F = I.args, T += L, d ? T += p : r.Util._isArray(F[0]) ? T += h + F.join(o) + l : (f && (F = F.map((N) => typeof N == "number" ? Math.floor(N) : N)), T += c + F.join(o) + s)) : (T += I.property, d || (T += b + I.val)), T += g;
      return T;
    }
    clearTrace() {
      this.traceArr = [];
    }
    _trace(d) {
      let f = this.traceArr, m;
      f.push(d), m = f.length, m >= v && f.shift();
    }
    reset() {
      const d = this.getCanvas().getPixelRatio();
      this.setTransform(1 * d, 0, 0, 1 * d, 0, 0);
    }
    getCanvas() {
      return this.canvas;
    }
    clear(d) {
      const f = this.getCanvas();
      d ? this.clearRect(d.x || 0, d.y || 0, d.width || 0, d.height || 0) : this.clearRect(0, 0, f.getWidth() / f.pixelRatio, f.getHeight() / f.pixelRatio);
    }
    _applyLineCap(d) {
      const f = d.attrs.lineCap;
      f && this.setAttr("lineCap", f);
    }
    _applyOpacity(d) {
      const f = d.getAbsoluteOpacity();
      f !== 1 && this.setAttr("globalAlpha", f);
    }
    _applyLineJoin(d) {
      const f = d.attrs.lineJoin;
      f && this.setAttr("lineJoin", f);
    }
    setAttr(d, f) {
      this._context[d] = f;
    }
    arc(d, f, m, E, T, D) {
      this._context.arc(d, f, m, E, T, D);
    }
    arcTo(d, f, m, E, T) {
      this._context.arcTo(d, f, m, E, T);
    }
    beginPath() {
      this._context.beginPath();
    }
    bezierCurveTo(d, f, m, E, T, D) {
      this._context.bezierCurveTo(d, f, m, E, T, D);
    }
    clearRect(d, f, m, E) {
      this._context.clearRect(d, f, m, E);
    }
    clip(...d) {
      this._context.clip.apply(this._context, d);
    }
    closePath() {
      this._context.closePath();
    }
    createImageData(d, f) {
      const m = arguments;
      if (m.length === 2)
        return this._context.createImageData(d, f);
      if (m.length === 1)
        return this._context.createImageData(d);
    }
    createLinearGradient(d, f, m, E) {
      return this._context.createLinearGradient(d, f, m, E);
    }
    createPattern(d, f) {
      return this._context.createPattern(d, f);
    }
    createRadialGradient(d, f, m, E, T, D) {
      return this._context.createRadialGradient(d, f, m, E, T, D);
    }
    drawImage(d, f, m, E, T, D, I, L, F) {
      const N = arguments, H = this._context;
      N.length === 3 ? H.drawImage(d, f, m) : N.length === 5 ? H.drawImage(d, f, m, E, T) : N.length === 9 && H.drawImage(d, f, m, E, T, D, I, L, F);
    }
    ellipse(d, f, m, E, T, D, I, L) {
      this._context.ellipse(d, f, m, E, T, D, I, L);
    }
    isPointInPath(d, f, m, E) {
      return m ? this._context.isPointInPath(m, d, f, E) : this._context.isPointInPath(d, f, E);
    }
    fill(...d) {
      this._context.fill.apply(this._context, d);
    }
    fillRect(d, f, m, E) {
      this._context.fillRect(d, f, m, E);
    }
    strokeRect(d, f, m, E) {
      this._context.strokeRect(d, f, m, E);
    }
    fillText(d, f, m, E) {
      E ? this._context.fillText(d, f, m, E) : this._context.fillText(d, f, m);
    }
    measureText(d) {
      return this._context.measureText(d);
    }
    getImageData(d, f, m, E) {
      return this._context.getImageData(d, f, m, E);
    }
    lineTo(d, f) {
      this._context.lineTo(d, f);
    }
    moveTo(d, f) {
      this._context.moveTo(d, f);
    }
    rect(d, f, m, E) {
      this._context.rect(d, f, m, E);
    }
    roundRect(d, f, m, E, T) {
      this._context.roundRect(d, f, m, E, T);
    }
    putImageData(d, f, m) {
      this._context.putImageData(d, f, m);
    }
    quadraticCurveTo(d, f, m, E) {
      this._context.quadraticCurveTo(d, f, m, E);
    }
    restore() {
      this._context.restore();
    }
    rotate(d) {
      this._context.rotate(d);
    }
    save() {
      this._context.save();
    }
    scale(d, f) {
      this._context.scale(d, f);
    }
    setLineDash(d) {
      this._context.setLineDash ? this._context.setLineDash(d) : "mozDash" in this._context ? this._context.mozDash = d : "webkitLineDash" in this._context && (this._context.webkitLineDash = d);
    }
    getLineDash() {
      return this._context.getLineDash();
    }
    setTransform(d, f, m, E, T, D) {
      this._context.setTransform(d, f, m, E, T, D);
    }
    stroke(d) {
      d ? this._context.stroke(d) : this._context.stroke();
    }
    strokeText(d, f, m, E) {
      this._context.strokeText(d, f, m, E);
    }
    transform(d, f, m, E, T, D) {
      this._context.transform(d, f, m, E, T, D);
    }
    translate(d, f) {
      this._context.translate(d, f);
    }
    _enableTrace() {
      let d = this, f = w.length, m = this.setAttr, E, T;
      const D = function(I) {
        let L = d[I], F;
        d[I] = function() {
          return T = n(Array.prototype.slice.call(arguments, 0)), F = L.apply(d, arguments), d._trace({
            method: I,
            args: T
          }), F;
        };
      };
      for (E = 0; E < f; E++)
        D(w[E]);
      d.setAttr = function() {
        m.apply(d, arguments);
        const I = arguments[0];
        let L = arguments[1];
        (I === "shadowOffsetX" || I === "shadowOffsetY" || I === "shadowBlur") && (L = L / this.canvas.getPixelRatio()), d._trace({
          property: I,
          val: L
        });
      };
    }
    _applyGlobalCompositeOperation(d) {
      const f = d.attrs.globalCompositeOperation;
      !f || f === "source-over" || this.setAttr("globalCompositeOperation", f);
    }
  };
  dr.Context = _, x.forEach(function(O) {
    Object.defineProperty(_.prototype, O, {
      get() {
        return this._context[O];
      },
      set(d) {
        this._context[O] = d;
      }
    });
  });
  class S extends _ {
    constructor(d, { willReadFrequently: f = !1 } = {}) {
      super(d), this._context = d._canvas.getContext("2d", {
        willReadFrequently: f
      });
    }
    _fillColor(d) {
      const f = d.fill();
      this.setAttr("fillStyle", f), d._fillFunc(this);
    }
    _fillPattern(d) {
      this.setAttr("fillStyle", d._getFillPattern()), d._fillFunc(this);
    }
    _fillLinearGradient(d) {
      const f = d._getLinearGradient();
      f && (this.setAttr("fillStyle", f), d._fillFunc(this));
    }
    _fillRadialGradient(d) {
      const f = d._getRadialGradient();
      f && (this.setAttr("fillStyle", f), d._fillFunc(this));
    }
    _fill(d) {
      const f = d.fill(), m = d.getFillPriority();
      if (f && m === "color") {
        this._fillColor(d);
        return;
      }
      const E = d.getFillPatternImage();
      if (E && m === "pattern") {
        this._fillPattern(d);
        return;
      }
      const T = d.getFillLinearGradientColorStops();
      if (T && m === "linear-gradient") {
        this._fillLinearGradient(d);
        return;
      }
      const D = d.getFillRadialGradientColorStops();
      if (D && m === "radial-gradient") {
        this._fillRadialGradient(d);
        return;
      }
      f ? this._fillColor(d) : E ? this._fillPattern(d) : T ? this._fillLinearGradient(d) : D && this._fillRadialGradient(d);
    }
    _strokeLinearGradient(d) {
      const f = d.getStrokeLinearGradientStartPoint(), m = d.getStrokeLinearGradientEndPoint(), E = d.getStrokeLinearGradientColorStops(), T = this.createLinearGradient(f.x, f.y, m.x, m.y);
      if (E) {
        for (let D = 0; D < E.length; D += 2)
          T.addColorStop(E[D], E[D + 1]);
        this.setAttr("strokeStyle", T);
      }
    }
    _stroke(d) {
      const f = d.dash(), m = d.getStrokeScaleEnabled();
      if (d.hasStroke()) {
        if (!m) {
          this.save();
          const T = this.getCanvas().getPixelRatio();
          this.setTransform(T, 0, 0, T, 0, 0);
        }
        this._applyLineCap(d), f && d.dashEnabled() && (this.setLineDash(f), this.setAttr("lineDashOffset", d.dashOffset())), this.setAttr("lineWidth", d.strokeWidth()), d.getShadowForStrokeEnabled() || this.setAttr("shadowColor", "rgba(0,0,0,0)"), d.getStrokeLinearGradientColorStops() ? this._strokeLinearGradient(d) : this.setAttr("strokeStyle", d.stroke()), d._strokeFunc(this), m || this.restore();
      }
    }
    _applyShadow(d) {
      var f, m, E;
      const T = (f = d.getShadowRGBA()) !== null && f !== void 0 ? f : "black", D = (m = d.getShadowBlur()) !== null && m !== void 0 ? m : 5, I = (E = d.getShadowOffset()) !== null && E !== void 0 ? E : {
        x: 0,
        y: 0
      }, L = d.getAbsoluteScale(), F = this.canvas.getPixelRatio(), N = L.x * F, H = L.y * F;
      this.setAttr("shadowColor", T), this.setAttr("shadowBlur", D * Math.min(Math.abs(N), Math.abs(H))), this.setAttr("shadowOffsetX", I.x * N), this.setAttr("shadowOffsetY", I.y * H);
    }
  }
  dr.SceneContext = S;
  class C extends _ {
    constructor(d) {
      super(d), this._context = d._canvas.getContext("2d", {
        willReadFrequently: !0
      });
    }
    _fill(d) {
      this.save(), this.setAttr("fillStyle", d.colorKey), d._fillFuncHit(this), this.restore();
    }
    strokeShape(d) {
      d.hasHitStroke() && this._stroke(d);
    }
    _stroke(d) {
      if (d.hasHitStroke()) {
        const f = d.getStrokeScaleEnabled();
        if (!f) {
          this.save();
          const T = this.getCanvas().getPixelRatio();
          this.setTransform(T, 0, 0, T, 0, 0);
        }
        this._applyLineCap(d);
        const m = d.hitStrokeWidth(), E = m === "auto" ? d.strokeWidth() : m;
        this.setAttr("lineWidth", E), this.setAttr("strokeStyle", d.colorKey), d._strokeFuncHit(this), f || this.restore();
      }
    }
  }
  return dr.HitContext = C, dr;
}
var $c;
function ma() {
  if ($c) return cr;
  $c = 1, Object.defineProperty(cr, "__esModule", { value: !0 }), cr.HitCanvas = cr.SceneCanvas = cr.Canvas = void 0;
  const r = Kt(), a = j0(), n = Rt(), o = Tt(), c = Ft();
  let s;
  function h() {
    if (s)
      return s;
    const b = r.Util.createCanvasElement(), w = b.getContext("2d");
    return s = function() {
      const x = n.Konva._global.devicePixelRatio || 1, v = w.webkitBackingStorePixelRatio || w.mozBackingStorePixelRatio || w.msBackingStorePixelRatio || w.oBackingStorePixelRatio || w.backingStorePixelRatio || 1;
      return x / v;
    }(), r.Util.releaseCanvas(b), s;
  }
  let l = class {
    constructor(w) {
      this.pixelRatio = 1, this.width = 0, this.height = 0, this.isCache = !1;
      const v = (w || {}).pixelRatio || n.Konva.pixelRatio || h();
      this.pixelRatio = v, this._canvas = r.Util.createCanvasElement(), this._canvas.style.padding = "0", this._canvas.style.margin = "0", this._canvas.style.border = "0", this._canvas.style.background = "transparent", this._canvas.style.position = "absolute", this._canvas.style.top = "0", this._canvas.style.left = "0";
    }
    getContext() {
      return this.context;
    }
    getPixelRatio() {
      return this.pixelRatio;
    }
    setPixelRatio(w) {
      const x = this.pixelRatio;
      this.pixelRatio = w, this.setSize(this.getWidth() / x, this.getHeight() / x);
    }
    setWidth(w) {
      this.width = this._canvas.width = w * this.pixelRatio, this._canvas.style.width = w + "px";
      const x = this.pixelRatio;
      this.getContext()._context.scale(x, x);
    }
    setHeight(w) {
      this.height = this._canvas.height = w * this.pixelRatio, this._canvas.style.height = w + "px";
      const x = this.pixelRatio;
      this.getContext()._context.scale(x, x);
    }
    getWidth() {
      return this.width;
    }
    getHeight() {
      return this.height;
    }
    setSize(w, x) {
      this.setWidth(w || 0), this.setHeight(x || 0);
    }
    toDataURL(w, x) {
      try {
        return this._canvas.toDataURL(w, x);
      } catch {
        try {
          return this._canvas.toDataURL();
        } catch (_) {
          return r.Util.error("Unable to get data URL. " + _.message + " For more info read https://konvajs.org/docs/posts/Tainted_Canvas.html."), "";
        }
      }
    }
  };
  cr.Canvas = l, o.Factory.addGetterSetter(l, "pixelRatio", void 0, (0, c.getNumberValidator)());
  class g extends l {
    constructor(w = { width: 0, height: 0, willReadFrequently: !1 }) {
      super(w), this.context = new a.SceneContext(this, {
        willReadFrequently: w.willReadFrequently
      }), this.setSize(w.width, w.height);
    }
  }
  cr.SceneCanvas = g;
  class p extends l {
    constructor(w = { width: 0, height: 0 }) {
      super(w), this.hitCanvas = !0, this.context = new a.HitContext(this), this.setSize(w.width, w.height);
    }
  }
  return cr.HitCanvas = p, cr;
}
var ao = {}, Zc;
function Kh() {
  return Zc || (Zc = 1, function(r) {
    Object.defineProperty(r, "__esModule", { value: !0 }), r.DD = void 0;
    const a = Rt(), n = Kt();
    r.DD = {
      get isDragging() {
        let o = !1;
        return r.DD._dragElements.forEach((c) => {
          c.dragStatus === "dragging" && (o = !0);
        }), o;
      },
      justDragged: !1,
      get node() {
        let o;
        return r.DD._dragElements.forEach((c) => {
          o = c.node;
        }), o;
      },
      _dragElements: /* @__PURE__ */ new Map(),
      _drag(o) {
        const c = [];
        r.DD._dragElements.forEach((s, h) => {
          const { node: l } = s, g = l.getStage();
          g.setPointersPositions(o), s.pointerId === void 0 && (s.pointerId = n.Util._getFirstPointerId(o));
          const p = g._changedPointerPositions.find((b) => b.id === s.pointerId);
          if (p) {
            if (s.dragStatus !== "dragging") {
              const b = l.dragDistance();
              if (Math.max(Math.abs(p.x - s.startPointerPos.x), Math.abs(p.y - s.startPointerPos.y)) < b || (l.startDrag({ evt: o }), !l.isDragging()))
                return;
            }
            l._setDragPosition(o, s), c.push(l);
          }
        }), c.forEach((s) => {
          s.fire("dragmove", {
            type: "dragmove",
            target: s,
            evt: o
          }, !0);
        });
      },
      _endDragBefore(o) {
        const c = [];
        r.DD._dragElements.forEach((s) => {
          const { node: h } = s, l = h.getStage();
          if (o && l.setPointersPositions(o), !l._changedPointerPositions.find((b) => b.id === s.pointerId))
            return;
          (s.dragStatus === "dragging" || s.dragStatus === "stopped") && (r.DD.justDragged = !0, a.Konva._mouseListenClick = !1, a.Konva._touchListenClick = !1, a.Konva._pointerListenClick = !1, s.dragStatus = "stopped");
          const p = s.node.getLayer() || s.node instanceof a.Konva.Stage && s.node;
          p && c.indexOf(p) === -1 && c.push(p);
        }), c.forEach((s) => {
          s.draw();
        });
      },
      _endDragAfter(o) {
        r.DD._dragElements.forEach((c, s) => {
          c.dragStatus === "stopped" && c.node.fire("dragend", {
            type: "dragend",
            target: c.node,
            evt: o
          }, !0), c.dragStatus !== "dragging" && r.DD._dragElements.delete(s);
        });
      }
    }, a.Konva.isBrowser && (window.addEventListener("mouseup", r.DD._endDragBefore, !0), window.addEventListener("touchend", r.DD._endDragBefore, !0), window.addEventListener("touchcancel", r.DD._endDragBefore, !0), window.addEventListener("mousemove", r.DD._drag), window.addEventListener("touchmove", r.DD._drag), window.addEventListener("mouseup", r.DD._endDragAfter, !1), window.addEventListener("touchend", r.DD._endDragAfter, !1), window.addEventListener("touchcancel", r.DD._endDragAfter, !1));
  }(ao)), ao;
}
var Jc;
function $t() {
  if (Jc) return Ci;
  Jc = 1, Object.defineProperty(Ci, "__esModule", { value: !0 }), Ci.Node = void 0;
  const r = Kt(), a = Tt(), n = ma(), o = Rt(), c = Kh(), s = Ft(), h = "absoluteOpacity", l = "allEventListeners", g = "absoluteTransform", p = "absoluteScale", b = "canvas", w = "Change", x = "children", v = "konva", _ = "listening", S = "mouseenter", C = "mouseleave", O = "set", d = "Shape", f = " ", m = "stage", E = "transform", T = "Stage", D = "visible", I = [
    "xChange.konva",
    "yChange.konva",
    "scaleXChange.konva",
    "scaleYChange.konva",
    "skewXChange.konva",
    "skewYChange.konva",
    "rotationChange.konva",
    "offsetXChange.konva",
    "offsetYChange.konva",
    "transformsEnabledChange.konva"
  ].join(f);
  let L = 1, F = class Wh {
    constructor(y) {
      this._id = L++, this.eventListeners = {}, this.attrs = {}, this.index = 0, this._allEventListeners = null, this.parent = null, this._cache = /* @__PURE__ */ new Map(), this._attachedDepsListeners = /* @__PURE__ */ new Map(), this._lastPos = null, this._batchingTransformChange = !1, this._needClearTransformCache = !1, this._filterUpToDate = !1, this._isUnderCache = !1, this._dragEventId = null, this._shouldFireChangeEvents = !1, this.setAttrs(y), this._shouldFireChangeEvents = !0;
    }
    hasChildren() {
      return !1;
    }
    _clearCache(y) {
      (y === E || y === g) && this._cache.get(y) ? this._cache.get(y).dirty = !0 : y ? this._cache.delete(y) : this._cache.clear();
    }
    _getCache(y, P) {
      let A = this._cache.get(y);
      return (A === void 0 || (y === E || y === g) && A.dirty === !0) && (A = P.call(this), this._cache.set(y, A)), A;
    }
    _calculate(y, P, A) {
      if (!this._attachedDepsListeners.get(y)) {
        const G = P.map((U) => U + "Change.konva").join(f);
        this.on(G, () => {
          this._clearCache(y);
        }), this._attachedDepsListeners.set(y, !0);
      }
      return this._getCache(y, A);
    }
    _getCanvasCache() {
      return this._cache.get(b);
    }
    _clearSelfAndDescendantCache(y) {
      this._clearCache(y), y === g && this.fire("absoluteTransformChange");
    }
    clearCache() {
      if (this._cache.has(b)) {
        const { scene: y, filter: P, hit: A } = this._cache.get(b);
        r.Util.releaseCanvas(y, P, A), this._cache.delete(b);
      }
      return this._clearSelfAndDescendantCache(), this._requestDraw(), this;
    }
    cache(y) {
      const P = y || {};
      let A = {};
      (P.x === void 0 || P.y === void 0 || P.width === void 0 || P.height === void 0) && (A = this.getClientRect({
        skipTransform: !0,
        relativeTo: this.getParent() || void 0
      }));
      let G = Math.ceil(P.width || A.width), U = Math.ceil(P.height || A.height), K = P.pixelRatio, $ = P.x === void 0 ? Math.floor(A.x) : P.x, X = P.y === void 0 ? Math.floor(A.y) : P.y, Q = P.offset || 0, st = P.drawBorder || !1, Z = P.hitCanvasPixelRatio || 1;
      if (!G || !U) {
        r.Util.error("Can not cache the node. Width or height of the node equals 0. Caching is skipped.");
        return;
      }
      const at = Math.abs(Math.round(A.x) - $) > 0.5 ? 1 : 0, ht = Math.abs(Math.round(A.y) - X) > 0.5 ? 1 : 0;
      G += Q * 2 + at, U += Q * 2 + ht, $ -= Q, X -= Q;
      const ct = new n.SceneCanvas({
        pixelRatio: K,
        width: G,
        height: U
      }), V = new n.SceneCanvas({
        pixelRatio: K,
        width: 0,
        height: 0,
        willReadFrequently: !0
      }), j = new n.HitCanvas({
        pixelRatio: Z,
        width: G,
        height: U
      }), et = ct.getContext(), ut = j.getContext();
      return j.isCache = !0, ct.isCache = !0, this._cache.delete(b), this._filterUpToDate = !1, P.imageSmoothingEnabled === !1 && (ct.getContext()._context.imageSmoothingEnabled = !1, V.getContext()._context.imageSmoothingEnabled = !1), et.save(), ut.save(), et.translate(-$, -X), ut.translate(-$, -X), this._isUnderCache = !0, this._clearSelfAndDescendantCache(h), this._clearSelfAndDescendantCache(p), this.drawScene(ct, this), this.drawHit(j, this), this._isUnderCache = !1, et.restore(), ut.restore(), st && (et.save(), et.beginPath(), et.rect(0, 0, G, U), et.closePath(), et.setAttr("strokeStyle", "red"), et.setAttr("lineWidth", 5), et.stroke(), et.restore()), this._cache.set(b, {
        scene: ct,
        filter: V,
        hit: j,
        x: $,
        y: X
      }), this._requestDraw(), this;
    }
    isCached() {
      return this._cache.has(b);
    }
    getClientRect(y) {
      throw new Error('abstract "getClientRect" method call');
    }
    _transformedRect(y, P) {
      const A = [
        { x: y.x, y: y.y },
        { x: y.x + y.width, y: y.y },
        { x: y.x + y.width, y: y.y + y.height },
        { x: y.x, y: y.y + y.height }
      ];
      let G = 1 / 0, U = 1 / 0, K = -1 / 0, $ = -1 / 0;
      const X = this.getAbsoluteTransform(P);
      return A.forEach(function(Q) {
        const st = X.point(Q);
        G === void 0 && (G = K = st.x, U = $ = st.y), G = Math.min(G, st.x), U = Math.min(U, st.y), K = Math.max(K, st.x), $ = Math.max($, st.y);
      }), {
        x: G,
        y: U,
        width: K - G,
        height: $ - U
      };
    }
    _drawCachedSceneCanvas(y) {
      y.save(), y._applyOpacity(this), y._applyGlobalCompositeOperation(this);
      const P = this._getCanvasCache();
      y.translate(P.x, P.y);
      const A = this._getCachedSceneCanvas(), G = A.pixelRatio;
      y.drawImage(A._canvas, 0, 0, A.width / G, A.height / G), y.restore();
    }
    _drawCachedHitCanvas(y) {
      const P = this._getCanvasCache(), A = P.hit;
      y.save(), y.translate(P.x, P.y), y.drawImage(A._canvas, 0, 0, A.width / A.pixelRatio, A.height / A.pixelRatio), y.restore();
    }
    _getCachedSceneCanvas() {
      let y = this.filters(), P = this._getCanvasCache(), A = P.scene, G = P.filter, U = G.getContext(), K, $, X, Q;
      if (y) {
        if (!this._filterUpToDate) {
          const st = A.pixelRatio;
          G.setSize(A.width / A.pixelRatio, A.height / A.pixelRatio);
          try {
            for (K = y.length, U.clear(), U.drawImage(A._canvas, 0, 0, A.getWidth() / st, A.getHeight() / st), $ = U.getImageData(0, 0, G.getWidth(), G.getHeight()), X = 0; X < K; X++) {
              if (Q = y[X], typeof Q != "function") {
                r.Util.error("Filter should be type of function, but got " + typeof Q + " instead. Please check correct filters");
                continue;
              }
              Q.call(this, $), U.putImageData($, 0, 0);
            }
          } catch (Z) {
            r.Util.error("Unable to apply filter. " + Z.message + " This post my help you https://konvajs.org/docs/posts/Tainted_Canvas.html.");
          }
          this._filterUpToDate = !0;
        }
        return G;
      }
      return A;
    }
    on(y, P) {
      if (this._cache && this._cache.delete(l), arguments.length === 3)
        return this._delegate.apply(this, arguments);
      let A = y.split(f), G = A.length, U, K, $, X, Q;
      for (U = 0; U < G; U++)
        K = A[U], $ = K.split("."), X = $[0], Q = $[1] || "", this.eventListeners[X] || (this.eventListeners[X] = []), this.eventListeners[X].push({
          name: Q,
          handler: P
        });
      return this;
    }
    off(y, P) {
      let A = (y || "").split(f), G = A.length, U, K, $, X, Q, st;
      if (this._cache && this._cache.delete(l), !y)
        for (K in this.eventListeners)
          this._off(K);
      for (U = 0; U < G; U++)
        if ($ = A[U], X = $.split("."), Q = X[0], st = X[1], Q)
          this.eventListeners[Q] && this._off(Q, st, P);
        else
          for (K in this.eventListeners)
            this._off(K, st, P);
      return this;
    }
    dispatchEvent(y) {
      const P = {
        target: this,
        type: y.type,
        evt: y
      };
      return this.fire(y.type, P), this;
    }
    addEventListener(y, P) {
      return this.on(y, function(A) {
        P.call(this, A.evt);
      }), this;
    }
    removeEventListener(y) {
      return this.off(y), this;
    }
    _delegate(y, P, A) {
      const G = this;
      this.on(y, function(U) {
        const K = U.target.findAncestors(P, !0, G);
        for (let $ = 0; $ < K.length; $++)
          U = r.Util.cloneObject(U), U.currentTarget = K[$], A.call(K[$], U);
      });
    }
    remove() {
      return this.isDragging() && this.stopDrag(), c.DD._dragElements.delete(this._id), this._remove(), this;
    }
    _clearCaches() {
      this._clearSelfAndDescendantCache(g), this._clearSelfAndDescendantCache(h), this._clearSelfAndDescendantCache(p), this._clearSelfAndDescendantCache(m), this._clearSelfAndDescendantCache(D), this._clearSelfAndDescendantCache(_);
    }
    _remove() {
      this._clearCaches();
      const y = this.getParent();
      y && y.children && (y.children.splice(this.index, 1), y._setChildrenIndices(), this.parent = null);
    }
    destroy() {
      return this.remove(), this.clearCache(), this;
    }
    getAttr(y) {
      const P = "get" + r.Util._capitalize(y);
      return r.Util._isFunction(this[P]) ? this[P]() : this.attrs[y];
    }
    getAncestors() {
      let y = this.getParent(), P = [];
      for (; y; )
        P.push(y), y = y.getParent();
      return P;
    }
    getAttrs() {
      return this.attrs || {};
    }
    setAttrs(y) {
      return this._batchTransformChanges(() => {
        let P, A;
        if (!y)
          return this;
        for (P in y)
          P !== x && (A = O + r.Util._capitalize(P), r.Util._isFunction(this[A]) ? this[A](y[P]) : this._setAttr(P, y[P]));
      }), this;
    }
    isListening() {
      return this._getCache(_, this._isListening);
    }
    _isListening(y) {
      if (!this.listening())
        return !1;
      const A = this.getParent();
      return A && A !== y && this !== y ? A._isListening(y) : !0;
    }
    isVisible() {
      return this._getCache(D, this._isVisible);
    }
    _isVisible(y) {
      if (!this.visible())
        return !1;
      const A = this.getParent();
      return A && A !== y && this !== y ? A._isVisible(y) : !0;
    }
    shouldDrawHit(y, P = !1) {
      if (y)
        return this._isVisible(y) && this._isListening(y);
      const A = this.getLayer();
      let G = !1;
      c.DD._dragElements.forEach((K) => {
        K.dragStatus === "dragging" && (K.node.nodeType === "Stage" || K.node.getLayer() === A) && (G = !0);
      });
      const U = !P && !o.Konva.hitOnDragEnabled && (G || o.Konva.isTransforming());
      return this.isListening() && this.isVisible() && !U;
    }
    show() {
      return this.visible(!0), this;
    }
    hide() {
      return this.visible(!1), this;
    }
    getZIndex() {
      return this.index || 0;
    }
    getAbsoluteZIndex() {
      let y = this.getDepth(), P = this, A = 0, G, U, K, $;
      function X(st) {
        for (G = [], U = st.length, K = 0; K < U; K++)
          $ = st[K], A++, $.nodeType !== d && (G = G.concat($.getChildren().slice())), $._id === P._id && (K = U);
        G.length > 0 && G[0].getDepth() <= y && X(G);
      }
      const Q = this.getStage();
      return P.nodeType !== T && Q && X(Q.getChildren()), A;
    }
    getDepth() {
      let y = 0, P = this.parent;
      for (; P; )
        y++, P = P.parent;
      return y;
    }
    _batchTransformChanges(y) {
      this._batchingTransformChange = !0, y(), this._batchingTransformChange = !1, this._needClearTransformCache && (this._clearCache(E), this._clearSelfAndDescendantCache(g)), this._needClearTransformCache = !1;
    }
    setPosition(y) {
      return this._batchTransformChanges(() => {
        this.x(y.x), this.y(y.y);
      }), this;
    }
    getPosition() {
      return {
        x: this.x(),
        y: this.y()
      };
    }
    getRelativePointerPosition() {
      const y = this.getStage();
      if (!y)
        return null;
      const P = y.getPointerPosition();
      if (!P)
        return null;
      const A = this.getAbsoluteTransform().copy();
      return A.invert(), A.point(P);
    }
    getAbsolutePosition(y) {
      let P = !1, A = this.parent;
      for (; A; ) {
        if (A.isCached()) {
          P = !0;
          break;
        }
        A = A.parent;
      }
      P && !y && (y = !0);
      const G = this.getAbsoluteTransform(y).getMatrix(), U = new r.Transform(), K = this.offset();
      return U.m = G.slice(), U.translate(K.x, K.y), U.getTranslation();
    }
    setAbsolutePosition(y) {
      const { x: P, y: A, ...G } = this._clearTransform();
      this.attrs.x = P, this.attrs.y = A, this._clearCache(E);
      const U = this._getAbsoluteTransform().copy();
      return U.invert(), U.translate(y.x, y.y), y = {
        x: this.attrs.x + U.getTranslation().x,
        y: this.attrs.y + U.getTranslation().y
      }, this._setTransform(G), this.setPosition({ x: y.x, y: y.y }), this._clearCache(E), this._clearSelfAndDescendantCache(g), this;
    }
    _setTransform(y) {
      let P;
      for (P in y)
        this.attrs[P] = y[P];
    }
    _clearTransform() {
      const y = {
        x: this.x(),
        y: this.y(),
        rotation: this.rotation(),
        scaleX: this.scaleX(),
        scaleY: this.scaleY(),
        offsetX: this.offsetX(),
        offsetY: this.offsetY(),
        skewX: this.skewX(),
        skewY: this.skewY()
      };
      return this.attrs.x = 0, this.attrs.y = 0, this.attrs.rotation = 0, this.attrs.scaleX = 1, this.attrs.scaleY = 1, this.attrs.offsetX = 0, this.attrs.offsetY = 0, this.attrs.skewX = 0, this.attrs.skewY = 0, y;
    }
    move(y) {
      let P = y.x, A = y.y, G = this.x(), U = this.y();
      return P !== void 0 && (G += P), A !== void 0 && (U += A), this.setPosition({ x: G, y: U }), this;
    }
    _eachAncestorReverse(y, P) {
      let A = [], G = this.getParent(), U, K;
      if (!(P && P._id === this._id)) {
        for (A.unshift(this); G && (!P || G._id !== P._id); )
          A.unshift(G), G = G.parent;
        for (U = A.length, K = 0; K < U; K++)
          y(A[K]);
      }
    }
    rotate(y) {
      return this.rotation(this.rotation() + y), this;
    }
    moveToTop() {
      if (!this.parent)
        return r.Util.warn("Node has no parent. moveToTop function is ignored."), !1;
      const y = this.index, P = this.parent.getChildren().length;
      return y < P - 1 ? (this.parent.children.splice(y, 1), this.parent.children.push(this), this.parent._setChildrenIndices(), !0) : !1;
    }
    moveUp() {
      if (!this.parent)
        return r.Util.warn("Node has no parent. moveUp function is ignored."), !1;
      const y = this.index, P = this.parent.getChildren().length;
      return y < P - 1 ? (this.parent.children.splice(y, 1), this.parent.children.splice(y + 1, 0, this), this.parent._setChildrenIndices(), !0) : !1;
    }
    moveDown() {
      if (!this.parent)
        return r.Util.warn("Node has no parent. moveDown function is ignored."), !1;
      const y = this.index;
      return y > 0 ? (this.parent.children.splice(y, 1), this.parent.children.splice(y - 1, 0, this), this.parent._setChildrenIndices(), !0) : !1;
    }
    moveToBottom() {
      if (!this.parent)
        return r.Util.warn("Node has no parent. moveToBottom function is ignored."), !1;
      const y = this.index;
      return y > 0 ? (this.parent.children.splice(y, 1), this.parent.children.unshift(this), this.parent._setChildrenIndices(), !0) : !1;
    }
    setZIndex(y) {
      if (!this.parent)
        return r.Util.warn("Node has no parent. zIndex parameter is ignored."), this;
      (y < 0 || y >= this.parent.children.length) && r.Util.warn("Unexpected value " + y + " for zIndex property. zIndex is just index of a node in children of its parent. Expected value is from 0 to " + (this.parent.children.length - 1) + ".");
      const P = this.index;
      return this.parent.children.splice(P, 1), this.parent.children.splice(y, 0, this), this.parent._setChildrenIndices(), this;
    }
    getAbsoluteOpacity() {
      return this._getCache(h, this._getAbsoluteOpacity);
    }
    _getAbsoluteOpacity() {
      let y = this.opacity();
      const P = this.getParent();
      return P && !P._isUnderCache && (y *= P.getAbsoluteOpacity()), y;
    }
    moveTo(y) {
      return this.getParent() !== y && (this._remove(), y.add(this)), this;
    }
    toObject() {
      let y = this.getAttrs(), P, A, G, U, K;
      const $ = {
        attrs: {},
        className: this.getClassName()
      };
      for (P in y)
        A = y[P], K = r.Util.isObject(A) && !r.Util._isPlainObject(A) && !r.Util._isArray(A), !K && (G = typeof this[P] == "function" && this[P], delete y[P], U = G ? G.call(this) : null, y[P] = A, U !== A && ($.attrs[P] = A));
      return r.Util._prepareToStringify($);
    }
    toJSON() {
      return JSON.stringify(this.toObject());
    }
    getParent() {
      return this.parent;
    }
    findAncestors(y, P, A) {
      const G = [];
      P && this._isMatch(y) && G.push(this);
      let U = this.parent;
      for (; U; ) {
        if (U === A)
          return G;
        U._isMatch(y) && G.push(U), U = U.parent;
      }
      return G;
    }
    isAncestorOf(y) {
      return !1;
    }
    findAncestor(y, P, A) {
      return this.findAncestors(y, P, A)[0];
    }
    _isMatch(y) {
      if (!y)
        return !1;
      if (typeof y == "function")
        return y(this);
      let P = y.replace(/ /g, "").split(","), A = P.length, G, U;
      for (G = 0; G < A; G++)
        if (U = P[G], r.Util.isValidSelector(U) || (r.Util.warn('Selector "' + U + '" is invalid. Allowed selectors examples are "#foo", ".bar" or "Group".'), r.Util.warn('If you have a custom shape with such className, please change it to start with upper letter like "Triangle".'), r.Util.warn("Konva is awesome, right?")), U.charAt(0) === "#") {
          if (this.id() === U.slice(1))
            return !0;
        } else if (U.charAt(0) === ".") {
          if (this.hasName(U.slice(1)))
            return !0;
        } else if (this.className === U || this.nodeType === U)
          return !0;
      return !1;
    }
    getLayer() {
      const y = this.getParent();
      return y ? y.getLayer() : null;
    }
    getStage() {
      return this._getCache(m, this._getStage);
    }
    _getStage() {
      const y = this.getParent();
      return y ? y.getStage() : null;
    }
    fire(y, P = {}, A) {
      return P.target = P.target || this, A ? this._fireAndBubble(y, P) : this._fire(y, P), this;
    }
    getAbsoluteTransform(y) {
      return y ? this._getAbsoluteTransform(y) : this._getCache(g, this._getAbsoluteTransform);
    }
    _getAbsoluteTransform(y) {
      let P;
      if (y)
        return P = new r.Transform(), this._eachAncestorReverse(function(A) {
          const G = A.transformsEnabled();
          G === "all" ? P.multiply(A.getTransform()) : G === "position" && P.translate(A.x() - A.offsetX(), A.y() - A.offsetY());
        }, y), P;
      {
        P = this._cache.get(g) || new r.Transform(), this.parent ? this.parent.getAbsoluteTransform().copyInto(P) : P.reset();
        const A = this.transformsEnabled();
        if (A === "all")
          P.multiply(this.getTransform());
        else if (A === "position") {
          const G = this.attrs.x || 0, U = this.attrs.y || 0, K = this.attrs.offsetX || 0, $ = this.attrs.offsetY || 0;
          P.translate(G - K, U - $);
        }
        return P.dirty = !1, P;
      }
    }
    getAbsoluteScale(y) {
      let P = this;
      for (; P; )
        P._isUnderCache && (y = P), P = P.getParent();
      const G = this.getAbsoluteTransform(y).decompose();
      return {
        x: G.scaleX,
        y: G.scaleY
      };
    }
    getAbsoluteRotation() {
      return this.getAbsoluteTransform().decompose().rotation;
    }
    getTransform() {
      return this._getCache(E, this._getTransform);
    }
    _getTransform() {
      var y, P;
      const A = this._cache.get(E) || new r.Transform();
      A.reset();
      const G = this.x(), U = this.y(), K = o.Konva.getAngle(this.rotation()), $ = (y = this.attrs.scaleX) !== null && y !== void 0 ? y : 1, X = (P = this.attrs.scaleY) !== null && P !== void 0 ? P : 1, Q = this.attrs.skewX || 0, st = this.attrs.skewY || 0, Z = this.attrs.offsetX || 0, at = this.attrs.offsetY || 0;
      return (G !== 0 || U !== 0) && A.translate(G, U), K !== 0 && A.rotate(K), (Q !== 0 || st !== 0) && A.skew(Q, st), ($ !== 1 || X !== 1) && A.scale($, X), (Z !== 0 || at !== 0) && A.translate(-1 * Z, -1 * at), A.dirty = !1, A;
    }
    clone(y) {
      let P = r.Util.cloneObject(this.attrs), A, G, U, K, $;
      for (A in y)
        P[A] = y[A];
      const X = new this.constructor(P);
      for (A in this.eventListeners)
        for (G = this.eventListeners[A], U = G.length, K = 0; K < U; K++)
          $ = G[K], $.name.indexOf(v) < 0 && (X.eventListeners[A] || (X.eventListeners[A] = []), X.eventListeners[A].push($));
      return X;
    }
    _toKonvaCanvas(y) {
      y = y || {};
      const P = this.getClientRect(), A = this.getStage(), G = y.x !== void 0 ? y.x : Math.floor(P.x), U = y.y !== void 0 ? y.y : Math.floor(P.y), K = y.pixelRatio || 1, $ = new n.SceneCanvas({
        width: y.width || Math.ceil(P.width) || (A ? A.width() : 0),
        height: y.height || Math.ceil(P.height) || (A ? A.height() : 0),
        pixelRatio: K
      }), X = $.getContext(), Q = new n.SceneCanvas({
        width: $.width / $.pixelRatio + Math.abs(G),
        height: $.height / $.pixelRatio + Math.abs(U),
        pixelRatio: $.pixelRatio
      });
      return y.imageSmoothingEnabled === !1 && (X._context.imageSmoothingEnabled = !1), X.save(), (G || U) && X.translate(-1 * G, -1 * U), this.drawScene($, void 0, Q), X.restore(), $;
    }
    toCanvas(y) {
      return this._toKonvaCanvas(y)._canvas;
    }
    toDataURL(y) {
      y = y || {};
      const P = y.mimeType || null, A = y.quality || null, G = this._toKonvaCanvas(y).toDataURL(P, A);
      return y.callback && y.callback(G), G;
    }
    toImage(y) {
      return new Promise((P, A) => {
        try {
          const G = y == null ? void 0 : y.callback;
          G && delete y.callback, r.Util._urlToImage(this.toDataURL(y), function(U) {
            P(U), G == null || G(U);
          });
        } catch (G) {
          A(G);
        }
      });
    }
    toBlob(y) {
      return new Promise((P, A) => {
        try {
          const G = y == null ? void 0 : y.callback;
          G && delete y.callback, this.toCanvas(y).toBlob((U) => {
            P(U), G == null || G(U);
          }, y == null ? void 0 : y.mimeType, y == null ? void 0 : y.quality);
        } catch (G) {
          A(G);
        }
      });
    }
    setSize(y) {
      return this.width(y.width), this.height(y.height), this;
    }
    getSize() {
      return {
        width: this.width(),
        height: this.height()
      };
    }
    getClassName() {
      return this.className || this.nodeType;
    }
    getType() {
      return this.nodeType;
    }
    getDragDistance() {
      return this.attrs.dragDistance !== void 0 ? this.attrs.dragDistance : this.parent ? this.parent.getDragDistance() : o.Konva.dragDistance;
    }
    _off(y, P, A) {
      let G = this.eventListeners[y], U, K, $;
      for (U = 0; U < G.length; U++)
        if (K = G[U].name, $ = G[U].handler, (K !== "konva" || P === "konva") && (!P || K === P) && (!A || A === $)) {
          if (G.splice(U, 1), G.length === 0) {
            delete this.eventListeners[y];
            break;
          }
          U--;
        }
    }
    _fireChangeEvent(y, P, A) {
      this._fire(y + w, {
        oldVal: P,
        newVal: A
      });
    }
    addName(y) {
      if (!this.hasName(y)) {
        const P = this.name(), A = P ? P + " " + y : y;
        this.name(A);
      }
      return this;
    }
    hasName(y) {
      if (!y)
        return !1;
      const P = this.name();
      return P ? (P || "").split(/\s/g).indexOf(y) !== -1 : !1;
    }
    removeName(y) {
      const P = (this.name() || "").split(/\s/g), A = P.indexOf(y);
      return A !== -1 && (P.splice(A, 1), this.name(P.join(" "))), this;
    }
    setAttr(y, P) {
      const A = this[O + r.Util._capitalize(y)];
      return r.Util._isFunction(A) ? A.call(this, P) : this._setAttr(y, P), this;
    }
    _requestDraw() {
      if (o.Konva.autoDrawEnabled) {
        const y = this.getLayer() || this.getStage();
        y == null || y.batchDraw();
      }
    }
    _setAttr(y, P) {
      const A = this.attrs[y];
      A === P && !r.Util.isObject(P) || (P == null ? delete this.attrs[y] : this.attrs[y] = P, this._shouldFireChangeEvents && this._fireChangeEvent(y, A, P), this._requestDraw());
    }
    _setComponentAttr(y, P, A) {
      let G;
      A !== void 0 && (G = this.attrs[y], G || (this.attrs[y] = this.getAttr(y)), this.attrs[y][P] = A, this._fireChangeEvent(y, G, A));
    }
    _fireAndBubble(y, P, A) {
      if (P && this.nodeType === d && (P.target = this), !((y === S || y === C) && (A && (this === A || this.isAncestorOf && this.isAncestorOf(A)) || this.nodeType === "Stage" && !A))) {
        this._fire(y, P);
        const U = (y === S || y === C) && A && A.isAncestorOf && A.isAncestorOf(this) && !A.isAncestorOf(this.parent);
        (P && !P.cancelBubble || !P) && this.parent && this.parent.isListening() && !U && (A && A.parent ? this._fireAndBubble.call(this.parent, y, P, A) : this._fireAndBubble.call(this.parent, y, P));
      }
    }
    _getProtoListeners(y) {
      var P, A, G;
      const U = (P = this._cache.get(l)) !== null && P !== void 0 ? P : {};
      let K = U == null ? void 0 : U[y];
      if (K === void 0) {
        K = [];
        let $ = Object.getPrototypeOf(this);
        for (; $; ) {
          const X = (G = (A = $.eventListeners) === null || A === void 0 ? void 0 : A[y]) !== null && G !== void 0 ? G : [];
          K.push(...X), $ = Object.getPrototypeOf($);
        }
        U[y] = K, this._cache.set(l, U);
      }
      return K;
    }
    _fire(y, P) {
      P = P || {}, P.currentTarget = this, P.type = y;
      const A = this._getProtoListeners(y);
      if (A)
        for (var G = 0; G < A.length; G++)
          A[G].handler.call(this, P);
      const U = this.eventListeners[y];
      if (U)
        for (var G = 0; G < U.length; G++)
          U[G].handler.call(this, P);
    }
    draw() {
      return this.drawScene(), this.drawHit(), this;
    }
    _createDragElement(y) {
      const P = y ? y.pointerId : void 0, A = this.getStage(), G = this.getAbsolutePosition();
      if (!A)
        return;
      const U = A._getPointerById(P) || A._changedPointerPositions[0] || G;
      c.DD._dragElements.set(this._id, {
        node: this,
        startPointerPos: U,
        offset: {
          x: U.x - G.x,
          y: U.y - G.y
        },
        dragStatus: "ready",
        pointerId: P
      });
    }
    startDrag(y, P = !0) {
      c.DD._dragElements.has(this._id) || this._createDragElement(y);
      const A = c.DD._dragElements.get(this._id);
      A.dragStatus = "dragging", this.fire("dragstart", {
        type: "dragstart",
        target: this,
        evt: y && y.evt
      }, P);
    }
    _setDragPosition(y, P) {
      const A = this.getStage()._getPointerById(P.pointerId);
      if (!A)
        return;
      let G = {
        x: A.x - P.offset.x,
        y: A.y - P.offset.y
      };
      const U = this.dragBoundFunc();
      if (U !== void 0) {
        const K = U.call(this, G, y);
        K ? G = K : r.Util.warn("dragBoundFunc did not return any value. That is unexpected behavior. You must return new absolute position from dragBoundFunc.");
      }
      (!this._lastPos || this._lastPos.x !== G.x || this._lastPos.y !== G.y) && (this.setAbsolutePosition(G), this._requestDraw()), this._lastPos = G;
    }
    stopDrag(y) {
      const P = c.DD._dragElements.get(this._id);
      P && (P.dragStatus = "stopped"), c.DD._endDragBefore(y), c.DD._endDragAfter(y);
    }
    setDraggable(y) {
      this._setAttr("draggable", y), this._dragChange();
    }
    isDragging() {
      const y = c.DD._dragElements.get(this._id);
      return y ? y.dragStatus === "dragging" : !1;
    }
    _listenDrag() {
      this._dragCleanup(), this.on("mousedown.konva touchstart.konva", function(y) {
        if (!(!(y.evt.button !== void 0) || o.Konva.dragButtons.indexOf(y.evt.button) >= 0) || this.isDragging())
          return;
        let G = !1;
        c.DD._dragElements.forEach((U) => {
          this.isAncestorOf(U.node) && (G = !0);
        }), G || this._createDragElement(y);
      });
    }
    _dragChange() {
      if (this.attrs.draggable)
        this._listenDrag();
      else {
        if (this._dragCleanup(), !this.getStage())
          return;
        const P = c.DD._dragElements.get(this._id), A = P && P.dragStatus === "dragging", G = P && P.dragStatus === "ready";
        A ? this.stopDrag() : G && c.DD._dragElements.delete(this._id);
      }
    }
    _dragCleanup() {
      this.off("mousedown.konva"), this.off("touchstart.konva");
    }
    isClientRectOnScreen(y = { x: 0, y: 0 }) {
      const P = this.getStage();
      if (!P)
        return !1;
      const A = {
        x: -y.x,
        y: -y.y,
        width: P.width() + 2 * y.x,
        height: P.height() + 2 * y.y
      };
      return r.Util.haveIntersection(A, this.getClientRect());
    }
    static create(y, P) {
      return r.Util._isString(y) && (y = JSON.parse(y)), this._createNode(y, P);
    }
    static _createNode(y, P) {
      let A = Wh.prototype.getClassName.call(y), G = y.children, U, K, $;
      P && (y.attrs.container = P), o.Konva[A] || (r.Util.warn('Can not find a node with class name "' + A + '". Fallback to "Shape".'), A = "Shape");
      const X = o.Konva[A];
      if (U = new X(y.attrs), G)
        for (K = G.length, $ = 0; $ < K; $++)
          U.add(Wh._createNode(G[$]));
      return U;
    }
  };
  Ci.Node = F, F.prototype.nodeType = "Node", F.prototype._attrsAffectingSize = [], F.prototype.eventListeners = {}, F.prototype.on.call(F.prototype, I, function() {
    if (this._batchingTransformChange) {
      this._needClearTransformCache = !0;
      return;
    }
    this._clearCache(E), this._clearSelfAndDescendantCache(g);
  }), F.prototype.on.call(F.prototype, "visibleChange.konva", function() {
    this._clearSelfAndDescendantCache(D);
  }), F.prototype.on.call(F.prototype, "listeningChange.konva", function() {
    this._clearSelfAndDescendantCache(_);
  }), F.prototype.on.call(F.prototype, "opacityChange.konva", function() {
    this._clearSelfAndDescendantCache(h);
  });
  const N = a.Factory.addGetterSetter;
  return N(F, "zIndex"), N(F, "absolutePosition"), N(F, "position"), N(F, "x", 0, (0, s.getNumberValidator)()), N(F, "y", 0, (0, s.getNumberValidator)()), N(F, "globalCompositeOperation", "source-over", (0, s.getStringValidator)()), N(F, "opacity", 1, (0, s.getNumberValidator)()), N(F, "name", "", (0, s.getStringValidator)()), N(F, "id", "", (0, s.getStringValidator)()), N(F, "rotation", 0, (0, s.getNumberValidator)()), a.Factory.addComponentsGetterSetter(F, "scale", ["x", "y"]), N(F, "scaleX", 1, (0, s.getNumberValidator)()), N(F, "scaleY", 1, (0, s.getNumberValidator)()), a.Factory.addComponentsGetterSetter(F, "skew", ["x", "y"]), N(F, "skewX", 0, (0, s.getNumberValidator)()), N(F, "skewY", 0, (0, s.getNumberValidator)()), a.Factory.addComponentsGetterSetter(F, "offset", ["x", "y"]), N(F, "offsetX", 0, (0, s.getNumberValidator)()), N(F, "offsetY", 0, (0, s.getNumberValidator)()), N(F, "dragDistance", null, (0, s.getNumberValidator)()), N(F, "width", 0, (0, s.getNumberValidator)()), N(F, "height", 0, (0, s.getNumberValidator)()), N(F, "listening", !0, (0, s.getBooleanValidator)()), N(F, "preventDefault", !0, (0, s.getBooleanValidator)()), N(F, "filters", null, function(H) {
    return this._filterUpToDate = !1, H;
  }), N(F, "visible", !0, (0, s.getBooleanValidator)()), N(F, "transformsEnabled", "all", (0, s.getStringValidator)()), N(F, "size"), N(F, "dragBoundFunc"), N(F, "draggable", !1, (0, s.getBooleanValidator)()), a.Factory.backCompat(F, {
    rotateDeg: "rotate",
    setRotationDeg: "setRotation",
    getRotationDeg: "getRotation"
  }), Ci;
}
var xi = {}, Qc;
function ba() {
  if (Qc) return xi;
  Qc = 1, Object.defineProperty(xi, "__esModule", { value: !0 }), xi.Container = void 0;
  const r = Tt(), a = $t(), n = Ft();
  let o = class extends a.Node {
    constructor() {
      super(...arguments), this.children = [];
    }
    getChildren(s) {
      if (!s)
        return this.children || [];
      const h = this.children || [], l = [];
      return h.forEach(function(g) {
        s(g) && l.push(g);
      }), l;
    }
    hasChildren() {
      return this.getChildren().length > 0;
    }
    removeChildren() {
      return this.getChildren().forEach((s) => {
        s.parent = null, s.index = 0, s.remove();
      }), this.children = [], this._requestDraw(), this;
    }
    destroyChildren() {
      return this.getChildren().forEach((s) => {
        s.parent = null, s.index = 0, s.destroy();
      }), this.children = [], this._requestDraw(), this;
    }
    add(...s) {
      if (s.length === 0)
        return this;
      if (s.length > 1) {
        for (let l = 0; l < s.length; l++)
          this.add(s[l]);
        return this;
      }
      const h = s[0];
      return h.getParent() ? (h.moveTo(this), this) : (this._validateAdd(h), h.index = this.getChildren().length, h.parent = this, h._clearCaches(), this.getChildren().push(h), this._fire("add", {
        child: h
      }), this._requestDraw(), this);
    }
    destroy() {
      return this.hasChildren() && this.destroyChildren(), super.destroy(), this;
    }
    find(s) {
      return this._generalFind(s, !1);
    }
    findOne(s) {
      const h = this._generalFind(s, !0);
      return h.length > 0 ? h[0] : void 0;
    }
    _generalFind(s, h) {
      const l = [];
      return this._descendants((g) => {
        const p = g._isMatch(s);
        return p && l.push(g), !!(p && h);
      }), l;
    }
    _descendants(s) {
      let h = !1;
      const l = this.getChildren();
      for (const g of l) {
        if (h = s(g), h)
          return !0;
        if (g.hasChildren() && (h = g._descendants(s), h))
          return !0;
      }
      return !1;
    }
    toObject() {
      const s = a.Node.prototype.toObject.call(this);
      return s.children = [], this.getChildren().forEach((h) => {
        s.children.push(h.toObject());
      }), s;
    }
    isAncestorOf(s) {
      let h = s.getParent();
      for (; h; ) {
        if (h._id === this._id)
          return !0;
        h = h.getParent();
      }
      return !1;
    }
    clone(s) {
      const h = a.Node.prototype.clone.call(this, s);
      return this.getChildren().forEach(function(l) {
        h.add(l.clone());
      }), h;
    }
    getAllIntersections(s) {
      const h = [];
      return this.find("Shape").forEach((l) => {
        l.isVisible() && l.intersects(s) && h.push(l);
      }), h;
    }
    _clearSelfAndDescendantCache(s) {
      var h;
      super._clearSelfAndDescendantCache(s), !this.isCached() && ((h = this.children) === null || h === void 0 || h.forEach(function(l) {
        l._clearSelfAndDescendantCache(s);
      }));
    }
    _setChildrenIndices() {
      var s;
      (s = this.children) === null || s === void 0 || s.forEach(function(h, l) {
        h.index = l;
      }), this._requestDraw();
    }
    drawScene(s, h, l) {
      const g = this.getLayer(), p = s || g && g.getCanvas(), b = p && p.getContext(), w = this._getCanvasCache(), x = w && w.scene, v = p && p.isCache;
      if (!this.isVisible() && !v)
        return this;
      if (x) {
        b.save();
        const _ = this.getAbsoluteTransform(h).getMatrix();
        b.transform(_[0], _[1], _[2], _[3], _[4], _[5]), this._drawCachedSceneCanvas(b), b.restore();
      } else
        this._drawChildren("drawScene", p, h, l);
      return this;
    }
    drawHit(s, h) {
      if (!this.shouldDrawHit(h))
        return this;
      const l = this.getLayer(), g = s || l && l.hitCanvas, p = g && g.getContext(), b = this._getCanvasCache();
      if (b && b.hit) {
        p.save();
        const x = this.getAbsoluteTransform(h).getMatrix();
        p.transform(x[0], x[1], x[2], x[3], x[4], x[5]), this._drawCachedHitCanvas(p), p.restore();
      } else
        this._drawChildren("drawHit", g, h);
      return this;
    }
    _drawChildren(s, h, l, g) {
      var p;
      const b = h && h.getContext(), w = this.clipWidth(), x = this.clipHeight(), v = this.clipFunc(), _ = typeof w == "number" && typeof x == "number" || v, S = l === this;
      if (_) {
        b.save();
        const O = this.getAbsoluteTransform(l);
        let d = O.getMatrix();
        b.transform(d[0], d[1], d[2], d[3], d[4], d[5]), b.beginPath();
        let f;
        if (v)
          f = v.call(this, b, this);
        else {
          const m = this.clipX(), E = this.clipY();
          b.rect(m || 0, E || 0, w, x);
        }
        b.clip.apply(b, f), d = O.copy().invert().getMatrix(), b.transform(d[0], d[1], d[2], d[3], d[4], d[5]);
      }
      const C = !S && this.globalCompositeOperation() !== "source-over" && s === "drawScene";
      C && (b.save(), b._applyGlobalCompositeOperation(this)), (p = this.children) === null || p === void 0 || p.forEach(function(O) {
        O[s](h, l, g);
      }), C && b.restore(), _ && b.restore();
    }
    getClientRect(s = {}) {
      var h;
      const l = s.skipTransform, g = s.relativeTo;
      let p, b, w, x, v = {
        x: 1 / 0,
        y: 1 / 0,
        width: 0,
        height: 0
      };
      const _ = this;
      (h = this.children) === null || h === void 0 || h.forEach(function(O) {
        if (!O.visible())
          return;
        const d = O.getClientRect({
          relativeTo: _,
          skipShadow: s.skipShadow,
          skipStroke: s.skipStroke
        });
        d.width === 0 && d.height === 0 || (p === void 0 ? (p = d.x, b = d.y, w = d.x + d.width, x = d.y + d.height) : (p = Math.min(p, d.x), b = Math.min(b, d.y), w = Math.max(w, d.x + d.width), x = Math.max(x, d.y + d.height)));
      });
      const S = this.find("Shape");
      let C = !1;
      for (let O = 0; O < S.length; O++)
        if (S[O]._isVisible(this)) {
          C = !0;
          break;
        }
      return C && p !== void 0 ? v = {
        x: p,
        y: b,
        width: w - p,
        height: x - b
      } : v = {
        x: 0,
        y: 0,
        width: 0,
        height: 0
      }, l ? v : this._transformedRect(v, g);
    }
  };
  return xi.Container = o, r.Factory.addComponentsGetterSetter(o, "clip", [
    "x",
    "y",
    "width",
    "height"
  ]), r.Factory.addGetterSetter(o, "clipX", void 0, (0, n.getNumberValidator)()), r.Factory.addGetterSetter(o, "clipY", void 0, (0, n.getNumberValidator)()), r.Factory.addGetterSetter(o, "clipWidth", void 0, (0, n.getNumberValidator)()), r.Factory.addGetterSetter(o, "clipHeight", void 0, (0, n.getNumberValidator)()), r.Factory.addGetterSetter(o, "clipFunc"), xi;
}
var so = {}, xr = {}, td;
function K0() {
  if (td) return xr;
  td = 1, Object.defineProperty(xr, "__esModule", { value: !0 }), xr.getCapturedShape = o, xr.createEvent = c, xr.hasPointerCapture = s, xr.setPointerCapture = h, xr.releaseCapture = l;
  const r = Rt(), a = /* @__PURE__ */ new Map(), n = r.Konva._global.PointerEvent !== void 0;
  function o(g) {
    return a.get(g);
  }
  function c(g) {
    return {
      evt: g,
      pointerId: g.pointerId
    };
  }
  function s(g, p) {
    return a.get(g) === p;
  }
  function h(g, p) {
    l(g), p.getStage() && (a.set(g, p), n && p._fire("gotpointercapture", c(new PointerEvent("gotpointercapture"))));
  }
  function l(g, p) {
    const b = a.get(g);
    if (!b)
      return;
    const w = b.getStage();
    w && w.content, a.delete(g), n && b._fire("lostpointercapture", c(new PointerEvent("lostpointercapture")));
  }
  return xr;
}
var ed;
function s6() {
  return ed || (ed = 1, function(r) {
    Object.defineProperty(r, "__esModule", { value: !0 }), r.Stage = r.stages = void 0;
    const a = Kt(), n = Tt(), o = ba(), c = Rt(), s = ma(), h = Kh(), l = Rt(), g = K0(), p = "Stage", b = "string", w = "px", x = "mouseout", v = "mouseleave", _ = "mouseover", S = "mouseenter", C = "mousemove", O = "mousedown", d = "mouseup", f = "pointermove", m = "pointerdown", E = "pointerup", T = "pointercancel", D = "lostpointercapture", I = "pointerout", L = "pointerleave", F = "pointerover", N = "pointerenter", H = "contextmenu", y = "touchstart", P = "touchend", A = "touchmove", G = "touchcancel", U = "wheel", K = 5, $ = [
      [S, "_pointerenter"],
      [O, "_pointerdown"],
      [C, "_pointermove"],
      [d, "_pointerup"],
      [v, "_pointerleave"],
      [y, "_pointerdown"],
      [A, "_pointermove"],
      [P, "_pointerup"],
      [G, "_pointercancel"],
      [_, "_pointerover"],
      [U, "_wheel"],
      [H, "_contextmenu"],
      [m, "_pointerdown"],
      [f, "_pointermove"],
      [E, "_pointerup"],
      [T, "_pointercancel"],
      [D, "_lostpointercapture"]
    ], X = {
      mouse: {
        [I]: x,
        [L]: v,
        [F]: _,
        [N]: S,
        [f]: C,
        [m]: O,
        [E]: d,
        [T]: "mousecancel",
        pointerclick: "click",
        pointerdblclick: "dblclick"
      },
      touch: {
        [I]: "touchout",
        [L]: "touchleave",
        [F]: "touchover",
        [N]: "touchenter",
        [f]: A,
        [m]: y,
        [E]: P,
        [T]: G,
        pointerclick: "tap",
        pointerdblclick: "dbltap"
      },
      pointer: {
        [I]: I,
        [L]: L,
        [F]: F,
        [N]: N,
        [f]: f,
        [m]: m,
        [E]: E,
        [T]: T,
        pointerclick: "pointerclick",
        pointerdblclick: "pointerdblclick"
      }
    }, Q = (ct) => ct.indexOf("pointer") >= 0 ? "pointer" : ct.indexOf("touch") >= 0 ? "touch" : "mouse", st = (ct) => {
      const V = Q(ct);
      if (V === "pointer")
        return c.Konva.pointerEventsEnabled && X.pointer;
      if (V === "touch")
        return X.touch;
      if (V === "mouse")
        return X.mouse;
    };
    function Z(ct = {}) {
      return (ct.clipFunc || ct.clipWidth || ct.clipHeight) && a.Util.warn("Stage does not support clipping. Please use clip for Layers or Groups."), ct;
    }
    const at = "Pointer position is missing and not registered by the stage. Looks like it is outside of the stage container. You can set it manually from event: stage.setPointersPositions(event);";
    r.stages = [];
    class ht extends o.Container {
      constructor(V) {
        super(Z(V)), this._pointerPositions = [], this._changedPointerPositions = [], this._buildDOM(), this._bindContentEvents(), r.stages.push(this), this.on("widthChange.konva heightChange.konva", this._resizeDOM), this.on("visibleChange.konva", this._checkVisibility), this.on("clipWidthChange.konva clipHeightChange.konva clipFuncChange.konva", () => {
          Z(this.attrs);
        }), this._checkVisibility();
      }
      _validateAdd(V) {
        const j = V.getType() === "Layer", et = V.getType() === "FastLayer";
        j || et || a.Util.throw("You may only add layers to the stage.");
      }
      _checkVisibility() {
        if (!this.content)
          return;
        const V = this.visible() ? "" : "none";
        this.content.style.display = V;
      }
      setContainer(V) {
        if (typeof V === b) {
          if (V.charAt(0) === ".") {
            const et = V.slice(1);
            V = document.getElementsByClassName(et)[0];
          } else {
            var j;
            V.charAt(0) !== "#" ? j = V : j = V.slice(1), V = document.getElementById(j);
          }
          if (!V)
            throw "Can not find container in document with id " + j;
        }
        return this._setAttr("container", V), this.content && (this.content.parentElement && this.content.parentElement.removeChild(this.content), V.appendChild(this.content)), this;
      }
      shouldDrawHit() {
        return !0;
      }
      clear() {
        let V = this.children, j = V.length, et;
        for (et = 0; et < j; et++)
          V[et].clear();
        return this;
      }
      clone(V) {
        return V || (V = {}), V.container = typeof document != "undefined" && document.createElement("div"), o.Container.prototype.clone.call(this, V);
      }
      destroy() {
        super.destroy();
        const V = this.content;
        V && a.Util._isInDocument(V) && this.container().removeChild(V);
        const j = r.stages.indexOf(this);
        return j > -1 && r.stages.splice(j, 1), a.Util.releaseCanvas(this.bufferCanvas._canvas, this.bufferHitCanvas._canvas), this;
      }
      getPointerPosition() {
        const V = this._pointerPositions[0] || this._changedPointerPositions[0];
        return V ? {
          x: V.x,
          y: V.y
        } : (a.Util.warn(at), null);
      }
      _getPointerById(V) {
        return this._pointerPositions.find((j) => j.id === V);
      }
      getPointersPositions() {
        return this._pointerPositions;
      }
      getStage() {
        return this;
      }
      getContent() {
        return this.content;
      }
      _toKonvaCanvas(V) {
        V = V || {}, V.x = V.x || 0, V.y = V.y || 0, V.width = V.width || this.width(), V.height = V.height || this.height();
        const j = new s.SceneCanvas({
          width: V.width,
          height: V.height,
          pixelRatio: V.pixelRatio || 1
        }), et = j.getContext()._context, ut = this.children;
        return (V.x || V.y) && et.translate(-1 * V.x, -1 * V.y), ut.forEach(function(ft) {
          if (!ft.isVisible())
            return;
          const gt = ft._toKonvaCanvas(V);
          et.drawImage(gt._canvas, V.x, V.y, gt.getWidth() / gt.getPixelRatio(), gt.getHeight() / gt.getPixelRatio());
        }), j;
      }
      getIntersection(V) {
        if (!V)
          return null;
        let j = this.children, et = j.length, ut = et - 1, ft;
        for (ft = ut; ft >= 0; ft--) {
          const gt = j[ft].getIntersection(V);
          if (gt)
            return gt;
        }
        return null;
      }
      _resizeDOM() {
        const V = this.width(), j = this.height();
        this.content && (this.content.style.width = V + w, this.content.style.height = j + w), this.bufferCanvas.setSize(V, j), this.bufferHitCanvas.setSize(V, j), this.children.forEach((et) => {
          et.setSize({ width: V, height: j }), et.draw();
        });
      }
      add(V, ...j) {
        if (arguments.length > 1) {
          for (let ut = 0; ut < arguments.length; ut++)
            this.add(arguments[ut]);
          return this;
        }
        super.add(V);
        const et = this.children.length;
        return et > K && a.Util.warn("The stage has " + et + " layers. Recommended maximum number of layers is 3-5. Adding more layers into the stage may drop the performance. Rethink your tree structure, you can use Konva.Group."), V.setSize({ width: this.width(), height: this.height() }), V.draw(), c.Konva.isBrowser && this.content.appendChild(V.canvas._canvas), this;
      }
      getParent() {
        return null;
      }
      getLayer() {
        return null;
      }
      hasPointerCapture(V) {
        return g.hasPointerCapture(V, this);
      }
      setPointerCapture(V) {
        g.setPointerCapture(V, this);
      }
      releaseCapture(V) {
        g.releaseCapture(V, this);
      }
      getLayers() {
        return this.children;
      }
      _bindContentEvents() {
        c.Konva.isBrowser && $.forEach(([V, j]) => {
          this.content.addEventListener(V, (et) => {
            this[j](et);
          }, { passive: !1 });
        });
      }
      _pointerenter(V) {
        this.setPointersPositions(V);
        const j = st(V.type);
        j && this._fire(j.pointerenter, {
          evt: V,
          target: this,
          currentTarget: this
        });
      }
      _pointerover(V) {
        this.setPointersPositions(V);
        const j = st(V.type);
        j && this._fire(j.pointerover, {
          evt: V,
          target: this,
          currentTarget: this
        });
      }
      _getTargetShape(V) {
        let j = this[V + "targetShape"];
        return j && !j.getStage() && (j = null), j;
      }
      _pointerleave(V) {
        const j = st(V.type), et = Q(V.type);
        if (!j)
          return;
        this.setPointersPositions(V);
        const ut = this._getTargetShape(et), ft = !(c.Konva.isDragging() || c.Konva.isTransforming()) || c.Konva.hitOnDragEnabled;
        ut && ft ? (ut._fireAndBubble(j.pointerout, { evt: V }), ut._fireAndBubble(j.pointerleave, { evt: V }), this._fire(j.pointerleave, {
          evt: V,
          target: this,
          currentTarget: this
        }), this[et + "targetShape"] = null) : ft && (this._fire(j.pointerleave, {
          evt: V,
          target: this,
          currentTarget: this
        }), this._fire(j.pointerout, {
          evt: V,
          target: this,
          currentTarget: this
        })), this.pointerPos = null, this._pointerPositions = [];
      }
      _pointerdown(V) {
        const j = st(V.type), et = Q(V.type);
        if (!j)
          return;
        this.setPointersPositions(V);
        let ut = !1;
        this._changedPointerPositions.forEach((ft) => {
          const gt = this.getIntersection(ft);
          if (h.DD.justDragged = !1, c.Konva["_" + et + "ListenClick"] = !0, !gt || !gt.isListening()) {
            this[et + "ClickStartShape"] = void 0;
            return;
          }
          c.Konva.capturePointerEventsEnabled && gt.setPointerCapture(ft.id), this[et + "ClickStartShape"] = gt, gt._fireAndBubble(j.pointerdown, {
            evt: V,
            pointerId: ft.id
          }), ut = !0;
          const Lt = V.type.indexOf("touch") >= 0;
          gt.preventDefault() && V.cancelable && Lt && V.preventDefault();
        }), ut || this._fire(j.pointerdown, {
          evt: V,
          target: this,
          currentTarget: this,
          pointerId: this._pointerPositions[0].id
        });
      }
      _pointermove(V) {
        const j = st(V.type), et = Q(V.type);
        if (!j || (c.Konva.isDragging() && h.DD.node.preventDefault() && V.cancelable && V.preventDefault(), this.setPointersPositions(V), !(!(c.Konva.isDragging() || c.Konva.isTransforming()) || c.Konva.hitOnDragEnabled)))
          return;
        const ft = {};
        let gt = !1;
        const Lt = this._getTargetShape(et);
        this._changedPointerPositions.forEach((Et) => {
          const mt = g.getCapturedShape(Et.id) || this.getIntersection(Et), ee = Et.id, Pt = { evt: V, pointerId: ee }, Vt = Lt !== mt;
          if (Vt && Lt && (Lt._fireAndBubble(j.pointerout, { ...Pt }, mt), Lt._fireAndBubble(j.pointerleave, { ...Pt }, mt)), mt) {
            if (ft[mt._id])
              return;
            ft[mt._id] = !0;
          }
          mt && mt.isListening() ? (gt = !0, Vt && (mt._fireAndBubble(j.pointerover, { ...Pt }, Lt), mt._fireAndBubble(j.pointerenter, { ...Pt }, Lt), this[et + "targetShape"] = mt), mt._fireAndBubble(j.pointermove, { ...Pt })) : Lt && (this._fire(j.pointerover, {
            evt: V,
            target: this,
            currentTarget: this,
            pointerId: ee
          }), this[et + "targetShape"] = null);
        }), gt || this._fire(j.pointermove, {
          evt: V,
          target: this,
          currentTarget: this,
          pointerId: this._changedPointerPositions[0].id
        });
      }
      _pointerup(V) {
        const j = st(V.type), et = Q(V.type);
        if (!j)
          return;
        this.setPointersPositions(V);
        const ut = this[et + "ClickStartShape"], ft = this[et + "ClickEndShape"], gt = {};
        let Lt = !1;
        this._changedPointerPositions.forEach((Et) => {
          const mt = g.getCapturedShape(Et.id) || this.getIntersection(Et);
          if (mt) {
            if (mt.releaseCapture(Et.id), gt[mt._id])
              return;
            gt[mt._id] = !0;
          }
          const ee = Et.id, Pt = { evt: V, pointerId: ee };
          let Vt = !1;
          c.Konva["_" + et + "InDblClickWindow"] ? (Vt = !0, clearTimeout(this[et + "DblTimeout"])) : h.DD.justDragged || (c.Konva["_" + et + "InDblClickWindow"] = !0, clearTimeout(this[et + "DblTimeout"])), this[et + "DblTimeout"] = setTimeout(function() {
            c.Konva["_" + et + "InDblClickWindow"] = !1;
          }, c.Konva.dblClickWindow), mt && mt.isListening() ? (Lt = !0, this[et + "ClickEndShape"] = mt, mt._fireAndBubble(j.pointerup, { ...Pt }), c.Konva["_" + et + "ListenClick"] && ut && ut === mt && (mt._fireAndBubble(j.pointerclick, { ...Pt }), Vt && ft && ft === mt && mt._fireAndBubble(j.pointerdblclick, { ...Pt }))) : (this[et + "ClickEndShape"] = null, c.Konva["_" + et + "ListenClick"] && this._fire(j.pointerclick, {
            evt: V,
            target: this,
            currentTarget: this,
            pointerId: ee
          }), Vt && this._fire(j.pointerdblclick, {
            evt: V,
            target: this,
            currentTarget: this,
            pointerId: ee
          }));
        }), Lt || this._fire(j.pointerup, {
          evt: V,
          target: this,
          currentTarget: this,
          pointerId: this._changedPointerPositions[0].id
        }), c.Konva["_" + et + "ListenClick"] = !1, V.cancelable && et !== "touch" && V.preventDefault();
      }
      _contextmenu(V) {
        this.setPointersPositions(V);
        const j = this.getIntersection(this.getPointerPosition());
        j && j.isListening() ? j._fireAndBubble(H, { evt: V }) : this._fire(H, {
          evt: V,
          target: this,
          currentTarget: this
        });
      }
      _wheel(V) {
        this.setPointersPositions(V);
        const j = this.getIntersection(this.getPointerPosition());
        j && j.isListening() ? j._fireAndBubble(U, { evt: V }) : this._fire(U, {
          evt: V,
          target: this,
          currentTarget: this
        });
      }
      _pointercancel(V) {
        this.setPointersPositions(V);
        const j = g.getCapturedShape(V.pointerId) || this.getIntersection(this.getPointerPosition());
        j && j._fireAndBubble(E, g.createEvent(V)), g.releaseCapture(V.pointerId);
      }
      _lostpointercapture(V) {
        g.releaseCapture(V.pointerId);
      }
      setPointersPositions(V) {
        let j = this._getContentPosition(), et = null, ut = null;
        V = V || window.event, V.touches !== void 0 ? (this._pointerPositions = [], this._changedPointerPositions = [], Array.prototype.forEach.call(V.touches, (ft) => {
          this._pointerPositions.push({
            id: ft.identifier,
            x: (ft.clientX - j.left) / j.scaleX,
            y: (ft.clientY - j.top) / j.scaleY
          });
        }), Array.prototype.forEach.call(V.changedTouches || V.touches, (ft) => {
          this._changedPointerPositions.push({
            id: ft.identifier,
            x: (ft.clientX - j.left) / j.scaleX,
            y: (ft.clientY - j.top) / j.scaleY
          });
        })) : (et = (V.clientX - j.left) / j.scaleX, ut = (V.clientY - j.top) / j.scaleY, this.pointerPos = {
          x: et,
          y: ut
        }, this._pointerPositions = [{ x: et, y: ut, id: a.Util._getFirstPointerId(V) }], this._changedPointerPositions = [
          { x: et, y: ut, id: a.Util._getFirstPointerId(V) }
        ]);
      }
      _setPointerPosition(V) {
        a.Util.warn('Method _setPointerPosition is deprecated. Use "stage.setPointersPositions(event)" instead.'), this.setPointersPositions(V);
      }
      _getContentPosition() {
        if (!this.content || !this.content.getBoundingClientRect)
          return {
            top: 0,
            left: 0,
            scaleX: 1,
            scaleY: 1
          };
        const V = this.content.getBoundingClientRect();
        return {
          top: V.top,
          left: V.left,
          scaleX: V.width / this.content.clientWidth || 1,
          scaleY: V.height / this.content.clientHeight || 1
        };
      }
      _buildDOM() {
        if (this.bufferCanvas = new s.SceneCanvas({
          width: this.width(),
          height: this.height()
        }), this.bufferHitCanvas = new s.HitCanvas({
          pixelRatio: 1,
          width: this.width(),
          height: this.height()
        }), !c.Konva.isBrowser)
          return;
        const V = this.container();
        if (!V)
          throw "Stage has no container. A container is required.";
        V.innerHTML = "", this.content = document.createElement("div"), this.content.style.position = "relative", this.content.style.userSelect = "none", this.content.className = "konvajs-content", this.content.setAttribute("role", "presentation"), V.appendChild(this.content), this._resizeDOM();
      }
      cache() {
        return a.Util.warn("Cache function is not allowed for stage. You may use cache only for layers, groups and shapes."), this;
      }
      clearCache() {
        return this;
      }
      batchDraw() {
        return this.getChildren().forEach(function(V) {
          V.batchDraw();
        }), this;
      }
    }
    r.Stage = ht, ht.prototype.nodeType = p, (0, l._registerNode)(ht), n.Factory.addGetterSetter(ht, "container"), c.Konva.isBrowser && document.addEventListener("visibilitychange", () => {
      r.stages.forEach((ct) => {
        ct.batchDraw();
      });
    });
  }(so)), so;
}
var Ei = {}, oo = {}, rd;
function se() {
  return rd || (rd = 1, function(r) {
    Object.defineProperty(r, "__esModule", { value: !0 }), r.Shape = r.shapes = void 0;
    const a = Rt(), n = Kt(), o = Tt(), c = $t(), s = Ft(), h = Rt(), l = K0(), g = "hasShadow", p = "shadowRGBA", b = "patternImage", w = "linearGradient", x = "radialGradient";
    let v;
    function _() {
      return v || (v = n.Util.createCanvasElement().getContext("2d"), v);
    }
    r.shapes = {};
    function S(L) {
      const F = this.attrs.fillRule;
      F ? L.fill(F) : L.fill();
    }
    function C(L) {
      L.stroke();
    }
    function O(L) {
      const F = this.attrs.fillRule;
      F ? L.fill(F) : L.fill();
    }
    function d(L) {
      L.stroke();
    }
    function f() {
      this._clearCache(g);
    }
    function m() {
      this._clearCache(p);
    }
    function E() {
      this._clearCache(b);
    }
    function T() {
      this._clearCache(w);
    }
    function D() {
      this._clearCache(x);
    }
    class I extends c.Node {
      constructor(F) {
        super(F);
        let N;
        for (; N = n.Util.getRandomColor(), !(N && !(N in r.shapes)); )
          ;
        this.colorKey = N, r.shapes[N] = this;
      }
      getContext() {
        return n.Util.warn("shape.getContext() method is deprecated. Please do not use it."), this.getLayer().getContext();
      }
      getCanvas() {
        return n.Util.warn("shape.getCanvas() method is deprecated. Please do not use it."), this.getLayer().getCanvas();
      }
      getSceneFunc() {
        return this.attrs.sceneFunc || this._sceneFunc;
      }
      getHitFunc() {
        return this.attrs.hitFunc || this._hitFunc;
      }
      hasShadow() {
        return this._getCache(g, this._hasShadow);
      }
      _hasShadow() {
        return this.shadowEnabled() && this.shadowOpacity() !== 0 && !!(this.shadowColor() || this.shadowBlur() || this.shadowOffsetX() || this.shadowOffsetY());
      }
      _getFillPattern() {
        return this._getCache(b, this.__getFillPattern);
      }
      __getFillPattern() {
        if (this.fillPatternImage()) {
          const N = _().createPattern(this.fillPatternImage(), this.fillPatternRepeat() || "repeat");
          if (N && N.setTransform) {
            const H = new n.Transform();
            H.translate(this.fillPatternX(), this.fillPatternY()), H.rotate(a.Konva.getAngle(this.fillPatternRotation())), H.scale(this.fillPatternScaleX(), this.fillPatternScaleY()), H.translate(-1 * this.fillPatternOffsetX(), -1 * this.fillPatternOffsetY());
            const y = H.getMatrix(), P = typeof DOMMatrix == "undefined" ? {
              a: y[0],
              b: y[1],
              c: y[2],
              d: y[3],
              e: y[4],
              f: y[5]
            } : new DOMMatrix(y);
            N.setTransform(P);
          }
          return N;
        }
      }
      _getLinearGradient() {
        return this._getCache(w, this.__getLinearGradient);
      }
      __getLinearGradient() {
        const F = this.fillLinearGradientColorStops();
        if (F) {
          const N = _(), H = this.fillLinearGradientStartPoint(), y = this.fillLinearGradientEndPoint(), P = N.createLinearGradient(H.x, H.y, y.x, y.y);
          for (let A = 0; A < F.length; A += 2)
            P.addColorStop(F[A], F[A + 1]);
          return P;
        }
      }
      _getRadialGradient() {
        return this._getCache(x, this.__getRadialGradient);
      }
      __getRadialGradient() {
        const F = this.fillRadialGradientColorStops();
        if (F) {
          const N = _(), H = this.fillRadialGradientStartPoint(), y = this.fillRadialGradientEndPoint(), P = N.createRadialGradient(H.x, H.y, this.fillRadialGradientStartRadius(), y.x, y.y, this.fillRadialGradientEndRadius());
          for (let A = 0; A < F.length; A += 2)
            P.addColorStop(F[A], F[A + 1]);
          return P;
        }
      }
      getShadowRGBA() {
        return this._getCache(p, this._getShadowRGBA);
      }
      _getShadowRGBA() {
        if (!this.hasShadow())
          return;
        const F = n.Util.colorToRGBA(this.shadowColor());
        if (F)
          return "rgba(" + F.r + "," + F.g + "," + F.b + "," + F.a * (this.shadowOpacity() || 1) + ")";
      }
      hasFill() {
        return this._calculate("hasFill", [
          "fillEnabled",
          "fill",
          "fillPatternImage",
          "fillLinearGradientColorStops",
          "fillRadialGradientColorStops"
        ], () => this.fillEnabled() && !!(this.fill() || this.fillPatternImage() || this.fillLinearGradientColorStops() || this.fillRadialGradientColorStops()));
      }
      hasStroke() {
        return this._calculate("hasStroke", [
          "strokeEnabled",
          "strokeWidth",
          "stroke",
          "strokeLinearGradientColorStops"
        ], () => this.strokeEnabled() && this.strokeWidth() && !!(this.stroke() || this.strokeLinearGradientColorStops()));
      }
      hasHitStroke() {
        const F = this.hitStrokeWidth();
        return F === "auto" ? this.hasStroke() : this.strokeEnabled() && !!F;
      }
      intersects(F) {
        const N = this.getStage();
        if (!N)
          return !1;
        const H = N.bufferHitCanvas;
        return H.getContext().clear(), this.drawHit(H, void 0, !0), H.context.getImageData(Math.round(F.x), Math.round(F.y), 1, 1).data[3] > 0;
      }
      destroy() {
        return c.Node.prototype.destroy.call(this), delete r.shapes[this.colorKey], delete this.colorKey, this;
      }
      _useBufferCanvas(F) {
        var N;
        if (!((N = this.attrs.perfectDrawEnabled) !== null && N !== void 0 ? N : !0))
          return !1;
        const y = F || this.hasFill(), P = this.hasStroke(), A = this.getAbsoluteOpacity() !== 1;
        if (y && P && A)
          return !0;
        const G = this.hasShadow(), U = this.shadowForStrokeEnabled();
        return !!(y && P && G && U);
      }
      setStrokeHitEnabled(F) {
        n.Util.warn("strokeHitEnabled property is deprecated. Please use hitStrokeWidth instead."), F ? this.hitStrokeWidth("auto") : this.hitStrokeWidth(0);
      }
      getStrokeHitEnabled() {
        return this.hitStrokeWidth() !== 0;
      }
      getSelfRect() {
        const F = this.size();
        return {
          x: this._centroid ? -F.width / 2 : 0,
          y: this._centroid ? -F.height / 2 : 0,
          width: F.width,
          height: F.height
        };
      }
      getClientRect(F = {}) {
        let N = !1, H = this.getParent();
        for (; H; ) {
          if (H.isCached()) {
            N = !0;
            break;
          }
          H = H.getParent();
        }
        const y = F.skipTransform, P = F.relativeTo || N && this.getStage() || void 0, A = this.getSelfRect(), U = !F.skipStroke && this.hasStroke() && this.strokeWidth() || 0, K = A.width + U, $ = A.height + U, X = !F.skipShadow && this.hasShadow(), Q = X ? this.shadowOffsetX() : 0, st = X ? this.shadowOffsetY() : 0, Z = K + Math.abs(Q), at = $ + Math.abs(st), ht = X && this.shadowBlur() || 0, ct = Z + ht * 2, V = at + ht * 2, j = {
          width: ct,
          height: V,
          x: -(U / 2 + ht) + Math.min(Q, 0) + A.x,
          y: -(U / 2 + ht) + Math.min(st, 0) + A.y
        };
        return y ? j : this._transformedRect(j, P);
      }
      drawScene(F, N, H) {
        const y = this.getLayer();
        let P = F || y.getCanvas(), A = P.getContext(), G = this._getCanvasCache(), U = this.getSceneFunc(), K = this.hasShadow(), $, X;
        const Q = P.isCache, st = N === this;
        if (!this.isVisible() && !st)
          return this;
        if (G) {
          A.save();
          const at = this.getAbsoluteTransform(N).getMatrix();
          return A.transform(at[0], at[1], at[2], at[3], at[4], at[5]), this._drawCachedSceneCanvas(A), A.restore(), this;
        }
        if (!U)
          return this;
        if (A.save(), this._useBufferCanvas() && !Q) {
          $ = this.getStage();
          const at = H || $.bufferCanvas;
          X = at.getContext(), X.clear(), X.save(), X._applyLineJoin(this);
          var Z = this.getAbsoluteTransform(N).getMatrix();
          X.transform(Z[0], Z[1], Z[2], Z[3], Z[4], Z[5]), U.call(this, X, this), X.restore();
          const ht = at.pixelRatio;
          K && A._applyShadow(this), A._applyOpacity(this), A._applyGlobalCompositeOperation(this), A.drawImage(at._canvas, 0, 0, at.width / ht, at.height / ht);
        } else {
          if (A._applyLineJoin(this), !st) {
            var Z = this.getAbsoluteTransform(N).getMatrix();
            A.transform(Z[0], Z[1], Z[2], Z[3], Z[4], Z[5]), A._applyOpacity(this), A._applyGlobalCompositeOperation(this);
          }
          K && A._applyShadow(this), U.call(this, A, this);
        }
        return A.restore(), this;
      }
      drawHit(F, N, H = !1) {
        if (!this.shouldDrawHit(N, H))
          return this;
        const y = this.getLayer(), P = F || y.hitCanvas, A = P && P.getContext(), G = this.hitFunc() || this.sceneFunc(), U = this._getCanvasCache(), K = U && U.hit;
        if (this.colorKey || n.Util.warn("Looks like your canvas has a destroyed shape in it. Do not reuse shape after you destroyed it. If you want to reuse shape you should call remove() instead of destroy()"), K) {
          A.save();
          const X = this.getAbsoluteTransform(N).getMatrix();
          return A.transform(X[0], X[1], X[2], X[3], X[4], X[5]), this._drawCachedHitCanvas(A), A.restore(), this;
        }
        if (!G)
          return this;
        if (A.save(), A._applyLineJoin(this), !(this === N)) {
          const X = this.getAbsoluteTransform(N).getMatrix();
          A.transform(X[0], X[1], X[2], X[3], X[4], X[5]);
        }
        return G.call(this, A, this), A.restore(), this;
      }
      drawHitFromCache(F = 0) {
        let N = this._getCanvasCache(), H = this._getCachedSceneCanvas(), y = N.hit, P = y.getContext(), A = y.getWidth(), G = y.getHeight(), U, K, $, X, Q, st;
        P.clear(), P.drawImage(H._canvas, 0, 0, A, G);
        try {
          for (U = P.getImageData(0, 0, A, G), K = U.data, $ = K.length, X = n.Util._hexToRgb(this.colorKey), Q = 0; Q < $; Q += 4)
            st = K[Q + 3], st > F ? (K[Q] = X.r, K[Q + 1] = X.g, K[Q + 2] = X.b, K[Q + 3] = 255) : K[Q + 3] = 0;
          P.putImageData(U, 0, 0);
        } catch (Z) {
          n.Util.error("Unable to draw hit graph from cached scene canvas. " + Z.message);
        }
        return this;
      }
      hasPointerCapture(F) {
        return l.hasPointerCapture(F, this);
      }
      setPointerCapture(F) {
        l.setPointerCapture(F, this);
      }
      releaseCapture(F) {
        l.releaseCapture(F, this);
      }
    }
    r.Shape = I, I.prototype._fillFunc = S, I.prototype._strokeFunc = C, I.prototype._fillFuncHit = O, I.prototype._strokeFuncHit = d, I.prototype._centroid = !1, I.prototype.nodeType = "Shape", (0, h._registerNode)(I), I.prototype.eventListeners = {}, I.prototype.on.call(I.prototype, "shadowColorChange.konva shadowBlurChange.konva shadowOffsetChange.konva shadowOpacityChange.konva shadowEnabledChange.konva", f), I.prototype.on.call(I.prototype, "shadowColorChange.konva shadowOpacityChange.konva shadowEnabledChange.konva", m), I.prototype.on.call(I.prototype, "fillPriorityChange.konva fillPatternImageChange.konva fillPatternRepeatChange.konva fillPatternScaleXChange.konva fillPatternScaleYChange.konva fillPatternOffsetXChange.konva fillPatternOffsetYChange.konva fillPatternXChange.konva fillPatternYChange.konva fillPatternRotationChange.konva", E), I.prototype.on.call(I.prototype, "fillPriorityChange.konva fillLinearGradientColorStopsChange.konva fillLinearGradientStartPointXChange.konva fillLinearGradientStartPointYChange.konva fillLinearGradientEndPointXChange.konva fillLinearGradientEndPointYChange.konva", T), I.prototype.on.call(I.prototype, "fillPriorityChange.konva fillRadialGradientColorStopsChange.konva fillRadialGradientStartPointXChange.konva fillRadialGradientStartPointYChange.konva fillRadialGradientEndPointXChange.konva fillRadialGradientEndPointYChange.konva fillRadialGradientStartRadiusChange.konva fillRadialGradientEndRadiusChange.konva", D), o.Factory.addGetterSetter(I, "stroke", void 0, (0, s.getStringOrGradientValidator)()), o.Factory.addGetterSetter(I, "strokeWidth", 2, (0, s.getNumberValidator)()), o.Factory.addGetterSetter(I, "fillAfterStrokeEnabled", !1), o.Factory.addGetterSetter(I, "hitStrokeWidth", "auto", (0, s.getNumberOrAutoValidator)()), o.Factory.addGetterSetter(I, "strokeHitEnabled", !0, (0, s.getBooleanValidator)()), o.Factory.addGetterSetter(I, "perfectDrawEnabled", !0, (0, s.getBooleanValidator)()), o.Factory.addGetterSetter(I, "shadowForStrokeEnabled", !0, (0, s.getBooleanValidator)()), o.Factory.addGetterSetter(I, "lineJoin"), o.Factory.addGetterSetter(I, "lineCap"), o.Factory.addGetterSetter(I, "sceneFunc"), o.Factory.addGetterSetter(I, "hitFunc"), o.Factory.addGetterSetter(I, "dash"), o.Factory.addGetterSetter(I, "dashOffset", 0, (0, s.getNumberValidator)()), o.Factory.addGetterSetter(I, "shadowColor", void 0, (0, s.getStringValidator)()), o.Factory.addGetterSetter(I, "shadowBlur", 0, (0, s.getNumberValidator)()), o.Factory.addGetterSetter(I, "shadowOpacity", 1, (0, s.getNumberValidator)()), o.Factory.addComponentsGetterSetter(I, "shadowOffset", ["x", "y"]), o.Factory.addGetterSetter(I, "shadowOffsetX", 0, (0, s.getNumberValidator)()), o.Factory.addGetterSetter(I, "shadowOffsetY", 0, (0, s.getNumberValidator)()), o.Factory.addGetterSetter(I, "fillPatternImage"), o.Factory.addGetterSetter(I, "fill", void 0, (0, s.getStringOrGradientValidator)()), o.Factory.addGetterSetter(I, "fillPatternX", 0, (0, s.getNumberValidator)()), o.Factory.addGetterSetter(I, "fillPatternY", 0, (0, s.getNumberValidator)()), o.Factory.addGetterSetter(I, "fillLinearGradientColorStops"), o.Factory.addGetterSetter(I, "strokeLinearGradientColorStops"), o.Factory.addGetterSetter(I, "fillRadialGradientStartRadius", 0), o.Factory.addGetterSetter(I, "fillRadialGradientEndRadius", 0), o.Factory.addGetterSetter(I, "fillRadialGradientColorStops"), o.Factory.addGetterSetter(I, "fillPatternRepeat", "repeat"), o.Factory.addGetterSetter(I, "fillEnabled", !0), o.Factory.addGetterSetter(I, "strokeEnabled", !0), o.Factory.addGetterSetter(I, "shadowEnabled", !0), o.Factory.addGetterSetter(I, "dashEnabled", !0), o.Factory.addGetterSetter(I, "strokeScaleEnabled", !0), o.Factory.addGetterSetter(I, "fillPriority", "color"), o.Factory.addComponentsGetterSetter(I, "fillPatternOffset", ["x", "y"]), o.Factory.addGetterSetter(I, "fillPatternOffsetX", 0, (0, s.getNumberValidator)()), o.Factory.addGetterSetter(I, "fillPatternOffsetY", 0, (0, s.getNumberValidator)()), o.Factory.addComponentsGetterSetter(I, "fillPatternScale", ["x", "y"]), o.Factory.addGetterSetter(I, "fillPatternScaleX", 1, (0, s.getNumberValidator)()), o.Factory.addGetterSetter(I, "fillPatternScaleY", 1, (0, s.getNumberValidator)()), o.Factory.addComponentsGetterSetter(I, "fillLinearGradientStartPoint", [
      "x",
      "y"
    ]), o.Factory.addComponentsGetterSetter(I, "strokeLinearGradientStartPoint", [
      "x",
      "y"
    ]), o.Factory.addGetterSetter(I, "fillLinearGradientStartPointX", 0), o.Factory.addGetterSetter(I, "strokeLinearGradientStartPointX", 0), o.Factory.addGetterSetter(I, "fillLinearGradientStartPointY", 0), o.Factory.addGetterSetter(I, "strokeLinearGradientStartPointY", 0), o.Factory.addComponentsGetterSetter(I, "fillLinearGradientEndPoint", [
      "x",
      "y"
    ]), o.Factory.addComponentsGetterSetter(I, "strokeLinearGradientEndPoint", [
      "x",
      "y"
    ]), o.Factory.addGetterSetter(I, "fillLinearGradientEndPointX", 0), o.Factory.addGetterSetter(I, "strokeLinearGradientEndPointX", 0), o.Factory.addGetterSetter(I, "fillLinearGradientEndPointY", 0), o.Factory.addGetterSetter(I, "strokeLinearGradientEndPointY", 0), o.Factory.addComponentsGetterSetter(I, "fillRadialGradientStartPoint", [
      "x",
      "y"
    ]), o.Factory.addGetterSetter(I, "fillRadialGradientStartPointX", 0), o.Factory.addGetterSetter(I, "fillRadialGradientStartPointY", 0), o.Factory.addComponentsGetterSetter(I, "fillRadialGradientEndPoint", [
      "x",
      "y"
    ]), o.Factory.addGetterSetter(I, "fillRadialGradientEndPointX", 0), o.Factory.addGetterSetter(I, "fillRadialGradientEndPointY", 0), o.Factory.addGetterSetter(I, "fillPatternRotation", 0), o.Factory.addGetterSetter(I, "fillRule", void 0, (0, s.getStringValidator)()), o.Factory.backCompat(I, {
      dashArray: "dash",
      getDashArray: "getDash",
      setDashArray: "getDash",
      drawFunc: "sceneFunc",
      getDrawFunc: "getSceneFunc",
      setDrawFunc: "setSceneFunc",
      drawHitFunc: "hitFunc",
      getDrawHitFunc: "getHitFunc",
      setDrawHitFunc: "setHitFunc"
    });
  }(oo)), oo;
}
var id;
function Y0() {
  if (id) return Ei;
  id = 1, Object.defineProperty(Ei, "__esModule", { value: !0 }), Ei.Layer = void 0;
  const r = Kt(), a = ba(), n = $t(), o = Tt(), c = ma(), s = Ft(), h = se(), l = Rt(), g = "#", p = "beforeDraw", b = "draw", w = [
    { x: 0, y: 0 },
    { x: -1, y: -1 },
    { x: 1, y: -1 },
    { x: 1, y: 1 },
    { x: -1, y: 1 }
  ], x = w.length;
  let v = class extends a.Container {
    constructor(S) {
      super(S), this.canvas = new c.SceneCanvas(), this.hitCanvas = new c.HitCanvas({
        pixelRatio: 1
      }), this._waitingForDraw = !1, this.on("visibleChange.konva", this._checkVisibility), this._checkVisibility(), this.on("imageSmoothingEnabledChange.konva", this._setSmoothEnabled), this._setSmoothEnabled();
    }
    createPNGStream() {
      return this.canvas._canvas.createPNGStream();
    }
    getCanvas() {
      return this.canvas;
    }
    getNativeCanvasElement() {
      return this.canvas._canvas;
    }
    getHitCanvas() {
      return this.hitCanvas;
    }
    getContext() {
      return this.getCanvas().getContext();
    }
    clear(S) {
      return this.getContext().clear(S), this.getHitCanvas().getContext().clear(S), this;
    }
    setZIndex(S) {
      super.setZIndex(S);
      const C = this.getStage();
      return C && C.content && (C.content.removeChild(this.getNativeCanvasElement()), S < C.children.length - 1 ? C.content.insertBefore(this.getNativeCanvasElement(), C.children[S + 1].getCanvas()._canvas) : C.content.appendChild(this.getNativeCanvasElement())), this;
    }
    moveToTop() {
      n.Node.prototype.moveToTop.call(this);
      const S = this.getStage();
      return S && S.content && (S.content.removeChild(this.getNativeCanvasElement()), S.content.appendChild(this.getNativeCanvasElement())), !0;
    }
    moveUp() {
      if (!n.Node.prototype.moveUp.call(this))
        return !1;
      const C = this.getStage();
      return !C || !C.content ? !1 : (C.content.removeChild(this.getNativeCanvasElement()), this.index < C.children.length - 1 ? C.content.insertBefore(this.getNativeCanvasElement(), C.children[this.index + 1].getCanvas()._canvas) : C.content.appendChild(this.getNativeCanvasElement()), !0);
    }
    moveDown() {
      if (n.Node.prototype.moveDown.call(this)) {
        const S = this.getStage();
        if (S) {
          const C = S.children;
          S.content && (S.content.removeChild(this.getNativeCanvasElement()), S.content.insertBefore(this.getNativeCanvasElement(), C[this.index + 1].getCanvas()._canvas));
        }
        return !0;
      }
      return !1;
    }
    moveToBottom() {
      if (n.Node.prototype.moveToBottom.call(this)) {
        const S = this.getStage();
        if (S) {
          const C = S.children;
          S.content && (S.content.removeChild(this.getNativeCanvasElement()), S.content.insertBefore(this.getNativeCanvasElement(), C[1].getCanvas()._canvas));
        }
        return !0;
      }
      return !1;
    }
    getLayer() {
      return this;
    }
    remove() {
      const S = this.getNativeCanvasElement();
      return n.Node.prototype.remove.call(this), S && S.parentNode && r.Util._isInDocument(S) && S.parentNode.removeChild(S), this;
    }
    getStage() {
      return this.parent;
    }
    setSize({ width: S, height: C }) {
      return this.canvas.setSize(S, C), this.hitCanvas.setSize(S, C), this._setSmoothEnabled(), this;
    }
    _validateAdd(S) {
      const C = S.getType();
      C !== "Group" && C !== "Shape" && r.Util.throw("You may only add groups and shapes to a layer.");
    }
    _toKonvaCanvas(S) {
      return S = S || {}, S.width = S.width || this.getWidth(), S.height = S.height || this.getHeight(), S.x = S.x !== void 0 ? S.x : this.x(), S.y = S.y !== void 0 ? S.y : this.y(), n.Node.prototype._toKonvaCanvas.call(this, S);
    }
    _checkVisibility() {
      this.visible() ? this.canvas._canvas.style.display = "block" : this.canvas._canvas.style.display = "none";
    }
    _setSmoothEnabled() {
      this.getContext()._context.imageSmoothingEnabled = this.imageSmoothingEnabled();
    }
    getWidth() {
      if (this.parent)
        return this.parent.width();
    }
    setWidth() {
      r.Util.warn('Can not change width of layer. Use "stage.width(value)" function instead.');
    }
    getHeight() {
      if (this.parent)
        return this.parent.height();
    }
    setHeight() {
      r.Util.warn('Can not change height of layer. Use "stage.height(value)" function instead.');
    }
    batchDraw() {
      return this._waitingForDraw || (this._waitingForDraw = !0, r.Util.requestAnimFrame(() => {
        this.draw(), this._waitingForDraw = !1;
      })), this;
    }
    getIntersection(S) {
      if (!this.isListening() || !this.isVisible())
        return null;
      let C = 1, O = !1;
      for (; ; ) {
        for (let d = 0; d < x; d++) {
          const f = w[d], m = this._getIntersection({
            x: S.x + f.x * C,
            y: S.y + f.y * C
          }), E = m.shape;
          if (E)
            return E;
          if (O = !!m.antialiased, !m.antialiased)
            break;
        }
        if (O)
          C += 1;
        else
          return null;
      }
    }
    _getIntersection(S) {
      const C = this.hitCanvas.pixelRatio, O = this.hitCanvas.context.getImageData(Math.round(S.x * C), Math.round(S.y * C), 1, 1).data, d = O[3];
      if (d === 255) {
        const f = r.Util._rgbToHex(O[0], O[1], O[2]), m = h.shapes[g + f];
        return m ? {
          shape: m
        } : {
          antialiased: !0
        };
      } else if (d > 0)
        return {
          antialiased: !0
        };
      return {};
    }
    drawScene(S, C) {
      const O = this.getLayer(), d = S || O && O.getCanvas();
      return this._fire(p, {
        node: this
      }), this.clearBeforeDraw() && d.getContext().clear(), a.Container.prototype.drawScene.call(this, d, C), this._fire(b, {
        node: this
      }), this;
    }
    drawHit(S, C) {
      const O = this.getLayer(), d = S || O && O.hitCanvas;
      return O && O.clearBeforeDraw() && O.getHitCanvas().getContext().clear(), a.Container.prototype.drawHit.call(this, d, C), this;
    }
    enableHitGraph() {
      return this.hitGraphEnabled(!0), this;
    }
    disableHitGraph() {
      return this.hitGraphEnabled(!1), this;
    }
    setHitGraphEnabled(S) {
      r.Util.warn("hitGraphEnabled method is deprecated. Please use layer.listening() instead."), this.listening(S);
    }
    getHitGraphEnabled(S) {
      return r.Util.warn("hitGraphEnabled method is deprecated. Please use layer.listening() instead."), this.listening();
    }
    toggleHitCanvas() {
      if (!this.parent || !this.parent.content)
        return;
      const S = this.parent;
      !!this.hitCanvas._canvas.parentNode ? S.content.removeChild(this.hitCanvas._canvas) : S.content.appendChild(this.hitCanvas._canvas);
    }
    destroy() {
      return r.Util.releaseCanvas(this.getNativeCanvasElement(), this.getHitCanvas()._canvas), super.destroy();
    }
  };
  return Ei.Layer = v, v.prototype.nodeType = "Layer", (0, l._registerNode)(v), o.Factory.addGetterSetter(v, "imageSmoothingEnabled", !0), o.Factory.addGetterSetter(v, "clearBeforeDraw", !0), o.Factory.addGetterSetter(v, "hitGraphEnabled", !0, (0, s.getBooleanValidator)()), Ei;
}
var Ai = {}, nd;
function o6() {
  if (nd) return Ai;
  nd = 1, Object.defineProperty(Ai, "__esModule", { value: !0 }), Ai.FastLayer = void 0;
  const r = Kt(), a = Y0(), n = Rt();
  let o = class extends a.Layer {
    constructor(s) {
      super(s), this.listening(!1), r.Util.warn('Konva.Fast layer is deprecated. Please use "new Konva.Layer({ listening: false })" instead.');
    }
  };
  return Ai.FastLayer = o, o.prototype.nodeType = "FastLayer", (0, n._registerNode)(o), Ai;
}
var Ri = {}, ad;
function Yh() {
  if (ad) return Ri;
  ad = 1, Object.defineProperty(Ri, "__esModule", { value: !0 }), Ri.Group = void 0;
  const r = Kt(), a = ba(), n = Rt();
  let o = class extends a.Container {
    _validateAdd(s) {
      const h = s.getType();
      h !== "Group" && h !== "Shape" && r.Util.throw("You may only add groups and shapes to groups.");
    }
  };
  return Ri.Group = o, o.prototype.nodeType = "Group", (0, n._registerNode)(o), Ri;
}
var Ti = {}, sd;
function Xh() {
  if (sd) return Ti;
  sd = 1, Object.defineProperty(Ti, "__esModule", { value: !0 }), Ti.Animation = void 0;
  const r = Rt(), a = Kt(), n = function() {
    return r.glob.performance && r.glob.performance.now ? function() {
      return r.glob.performance.now();
    } : function() {
      return (/* @__PURE__ */ new Date()).getTime();
    };
  }();
  let o = class ei {
    constructor(s, h) {
      this.id = ei.animIdCounter++, this.frame = {
        time: 0,
        timeDiff: 0,
        lastTime: n(),
        frameRate: 0
      }, this.func = s, this.setLayers(h);
    }
    setLayers(s) {
      let h = [];
      return s && (h = Array.isArray(s) ? s : [s]), this.layers = h, this;
    }
    getLayers() {
      return this.layers;
    }
    addLayer(s) {
      const h = this.layers, l = h.length;
      for (let g = 0; g < l; g++)
        if (h[g]._id === s._id)
          return !1;
      return this.layers.push(s), !0;
    }
    isRunning() {
      const h = ei.animations, l = h.length;
      for (let g = 0; g < l; g++)
        if (h[g].id === this.id)
          return !0;
      return !1;
    }
    start() {
      return this.stop(), this.frame.timeDiff = 0, this.frame.lastTime = n(), ei._addAnimation(this), this;
    }
    stop() {
      return ei._removeAnimation(this), this;
    }
    _updateFrameObject(s) {
      this.frame.timeDiff = s - this.frame.lastTime, this.frame.lastTime = s, this.frame.time += this.frame.timeDiff, this.frame.frameRate = 1e3 / this.frame.timeDiff;
    }
    static _addAnimation(s) {
      this.animations.push(s), this._handleAnimation();
    }
    static _removeAnimation(s) {
      const h = s.id, l = this.animations, g = l.length;
      for (let p = 0; p < g; p++)
        if (l[p].id === h) {
          this.animations.splice(p, 1);
          break;
        }
    }
    static _runFrames() {
      const s = {}, h = this.animations;
      for (let l = 0; l < h.length; l++) {
        const g = h[l], p = g.layers, b = g.func;
        g._updateFrameObject(n());
        const w = p.length;
        let x;
        if (b ? x = b.call(g, g.frame) !== !1 : x = !0, !!x)
          for (let v = 0; v < w; v++) {
            const _ = p[v];
            _._id !== void 0 && (s[_._id] = _);
          }
      }
      for (const l in s)
        s.hasOwnProperty(l) && s[l].batchDraw();
    }
    static _animationLoop() {
      const s = ei;
      s.animations.length ? (s._runFrames(), a.Util.requestAnimFrame(s._animationLoop)) : s.animRunning = !1;
    }
    static _handleAnimation() {
      this.animRunning || (this.animRunning = !0, a.Util.requestAnimFrame(this._animationLoop));
    }
  };
  return Ti.Animation = o, o.animations = [], o.animIdCounter = 0, o.animRunning = !1, Ti;
}
var ho = {}, od;
function h6() {
  return od || (od = 1, function(r) {
    Object.defineProperty(r, "__esModule", { value: !0 }), r.Easings = r.Tween = void 0;
    const a = Kt(), n = Xh(), o = $t(), c = Rt();
    let s = {
      node: 1,
      duration: 1,
      easing: 1,
      onFinish: 1,
      yoyo: 1
    }, h = 1, l = 2, g = 3, p = 0, b = ["fill", "stroke", "shadowColor"];
    class w {
      constructor(_, S, C, O, d, f, m) {
        this.prop = _, this.propFunc = S, this.begin = O, this._pos = O, this.duration = f, this._change = 0, this.prevPos = 0, this.yoyo = m, this._time = 0, this._position = 0, this._startTime = 0, this._finish = 0, this.func = C, this._change = d - this.begin, this.pause();
      }
      fire(_) {
        const S = this[_];
        S && S();
      }
      setTime(_) {
        _ > this.duration ? this.yoyo ? (this._time = this.duration, this.reverse()) : this.finish() : _ < 0 ? this.yoyo ? (this._time = 0, this.play()) : this.reset() : (this._time = _, this.update());
      }
      getTime() {
        return this._time;
      }
      setPosition(_) {
        this.prevPos = this._pos, this.propFunc(_), this._pos = _;
      }
      getPosition(_) {
        return _ === void 0 && (_ = this._time), this.func(_, this.begin, this._change, this.duration);
      }
      play() {
        this.state = l, this._startTime = this.getTimer() - this._time, this.onEnterFrame(), this.fire("onPlay");
      }
      reverse() {
        this.state = g, this._time = this.duration - this._time, this._startTime = this.getTimer() - this._time, this.onEnterFrame(), this.fire("onReverse");
      }
      seek(_) {
        this.pause(), this._time = _, this.update(), this.fire("onSeek");
      }
      reset() {
        this.pause(), this._time = 0, this.update(), this.fire("onReset");
      }
      finish() {
        this.pause(), this._time = this.duration, this.update(), this.fire("onFinish");
      }
      update() {
        this.setPosition(this.getPosition(this._time)), this.fire("onUpdate");
      }
      onEnterFrame() {
        const _ = this.getTimer() - this._startTime;
        this.state === l ? this.setTime(_) : this.state === g && this.setTime(this.duration - _);
      }
      pause() {
        this.state = h, this.fire("onPause");
      }
      getTimer() {
        return (/* @__PURE__ */ new Date()).getTime();
      }
    }
    class x {
      constructor(_) {
        let S = this, C = _.node, O = C._id, d, f = _.easing || r.Easings.Linear, m = !!_.yoyo, E;
        typeof _.duration == "undefined" ? d = 0.3 : _.duration === 0 ? d = 1e-3 : d = _.duration, this.node = C, this._id = p++;
        const T = C.getLayer() || (C instanceof c.Konva.Stage ? C.getLayers() : null);
        T || a.Util.error("Tween constructor have `node` that is not in a layer. Please add node into layer first."), this.anim = new n.Animation(function() {
          S.tween.onEnterFrame();
        }, T), this.tween = new w(E, function(D) {
          S._tweenFunc(D);
        }, f, 0, 1, d * 1e3, m), this._addListeners(), x.attrs[O] || (x.attrs[O] = {}), x.attrs[O][this._id] || (x.attrs[O][this._id] = {}), x.tweens[O] || (x.tweens[O] = {});
        for (E in _)
          s[E] === void 0 && this._addAttr(E, _[E]);
        this.reset(), this.onFinish = _.onFinish, this.onReset = _.onReset, this.onUpdate = _.onUpdate;
      }
      _addAttr(_, S) {
        let C = this.node, O = C._id, d, f, m, E, T, D, I, L;
        if (m = x.tweens[O][_], m && delete x.attrs[O][m][_], d = C.getAttr(_), a.Util._isArray(S))
          if (f = [], T = Math.max(S.length, d.length), _ === "points" && S.length !== d.length && (S.length > d.length ? (I = d, d = a.Util._prepareArrayForTween(d, S, C.closed())) : (D = S, S = a.Util._prepareArrayForTween(S, d, C.closed()))), _.indexOf("fill") === 0)
            for (E = 0; E < T; E++)
              if (E % 2 === 0)
                f.push(S[E] - d[E]);
              else {
                const F = a.Util.colorToRGBA(d[E]);
                L = a.Util.colorToRGBA(S[E]), d[E] = F, f.push({
                  r: L.r - F.r,
                  g: L.g - F.g,
                  b: L.b - F.b,
                  a: L.a - F.a
                });
              }
          else
            for (E = 0; E < T; E++)
              f.push(S[E] - d[E]);
        else b.indexOf(_) !== -1 ? (d = a.Util.colorToRGBA(d), L = a.Util.colorToRGBA(S), f = {
          r: L.r - d.r,
          g: L.g - d.g,
          b: L.b - d.b,
          a: L.a - d.a
        }) : f = S - d;
        x.attrs[O][this._id][_] = {
          start: d,
          diff: f,
          end: S,
          trueEnd: D,
          trueStart: I
        }, x.tweens[O][_] = this._id;
      }
      _tweenFunc(_) {
        let S = this.node, C = x.attrs[S._id][this._id], O, d, f, m, E, T, D, I;
        for (O in C) {
          if (d = C[O], f = d.start, m = d.diff, I = d.end, a.Util._isArray(f))
            if (E = [], D = Math.max(f.length, I.length), O.indexOf("fill") === 0)
              for (T = 0; T < D; T++)
                T % 2 === 0 ? E.push((f[T] || 0) + m[T] * _) : E.push("rgba(" + Math.round(f[T].r + m[T].r * _) + "," + Math.round(f[T].g + m[T].g * _) + "," + Math.round(f[T].b + m[T].b * _) + "," + (f[T].a + m[T].a * _) + ")");
            else
              for (T = 0; T < D; T++)
                E.push((f[T] || 0) + m[T] * _);
          else b.indexOf(O) !== -1 ? E = "rgba(" + Math.round(f.r + m.r * _) + "," + Math.round(f.g + m.g * _) + "," + Math.round(f.b + m.b * _) + "," + (f.a + m.a * _) + ")" : E = f + m * _;
          S.setAttr(O, E);
        }
      }
      _addListeners() {
        this.tween.onPlay = () => {
          this.anim.start();
        }, this.tween.onReverse = () => {
          this.anim.start();
        }, this.tween.onPause = () => {
          this.anim.stop();
        }, this.tween.onFinish = () => {
          const _ = this.node, S = x.attrs[_._id][this._id];
          S.points && S.points.trueEnd && _.setAttr("points", S.points.trueEnd), this.onFinish && this.onFinish.call(this);
        }, this.tween.onReset = () => {
          const _ = this.node, S = x.attrs[_._id][this._id];
          S.points && S.points.trueStart && _.points(S.points.trueStart), this.onReset && this.onReset();
        }, this.tween.onUpdate = () => {
          this.onUpdate && this.onUpdate.call(this);
        };
      }
      play() {
        return this.tween.play(), this;
      }
      reverse() {
        return this.tween.reverse(), this;
      }
      reset() {
        return this.tween.reset(), this;
      }
      seek(_) {
        return this.tween.seek(_ * 1e3), this;
      }
      pause() {
        return this.tween.pause(), this;
      }
      finish() {
        return this.tween.finish(), this;
      }
      destroy() {
        let _ = this.node._id, S = this._id, C = x.tweens[_], O;
        this.pause();
        for (O in C)
          delete x.tweens[_][O];
        delete x.attrs[_][S];
      }
    }
    r.Tween = x, x.attrs = {}, x.tweens = {}, o.Node.prototype.to = function(v) {
      const _ = v.onFinish;
      v.node = this, v.onFinish = function() {
        this.destroy(), _ && _();
      }, new x(v).play();
    }, r.Easings = {
      BackEaseIn(v, _, S, C) {
        return S * (v /= C) * v * ((1.70158 + 1) * v - 1.70158) + _;
      },
      BackEaseOut(v, _, S, C) {
        return S * ((v = v / C - 1) * v * ((1.70158 + 1) * v + 1.70158) + 1) + _;
      },
      BackEaseInOut(v, _, S, C) {
        let O = 1.70158;
        return (v /= C / 2) < 1 ? S / 2 * (v * v * (((O *= 1.525) + 1) * v - O)) + _ : S / 2 * ((v -= 2) * v * (((O *= 1.525) + 1) * v + O) + 2) + _;
      },
      ElasticEaseIn(v, _, S, C, O, d) {
        let f = 0;
        return v === 0 ? _ : (v /= C) === 1 ? _ + S : (d || (d = C * 0.3), !O || O < Math.abs(S) ? (O = S, f = d / 4) : f = d / (2 * Math.PI) * Math.asin(S / O), -(O * Math.pow(2, 10 * (v -= 1)) * Math.sin((v * C - f) * (2 * Math.PI) / d)) + _);
      },
      ElasticEaseOut(v, _, S, C, O, d) {
        let f = 0;
        return v === 0 ? _ : (v /= C) === 1 ? _ + S : (d || (d = C * 0.3), !O || O < Math.abs(S) ? (O = S, f = d / 4) : f = d / (2 * Math.PI) * Math.asin(S / O), O * Math.pow(2, -10 * v) * Math.sin((v * C - f) * (2 * Math.PI) / d) + S + _);
      },
      ElasticEaseInOut(v, _, S, C, O, d) {
        let f = 0;
        return v === 0 ? _ : (v /= C / 2) === 2 ? _ + S : (d || (d = C * (0.3 * 1.5)), !O || O < Math.abs(S) ? (O = S, f = d / 4) : f = d / (2 * Math.PI) * Math.asin(S / O), v < 1 ? -0.5 * (O * Math.pow(2, 10 * (v -= 1)) * Math.sin((v * C - f) * (2 * Math.PI) / d)) + _ : O * Math.pow(2, -10 * (v -= 1)) * Math.sin((v * C - f) * (2 * Math.PI) / d) * 0.5 + S + _);
      },
      BounceEaseOut(v, _, S, C) {
        return (v /= C) < 1 / 2.75 ? S * (7.5625 * v * v) + _ : v < 2 / 2.75 ? S * (7.5625 * (v -= 1.5 / 2.75) * v + 0.75) + _ : v < 2.5 / 2.75 ? S * (7.5625 * (v -= 2.25 / 2.75) * v + 0.9375) + _ : S * (7.5625 * (v -= 2.625 / 2.75) * v + 0.984375) + _;
      },
      BounceEaseIn(v, _, S, C) {
        return S - r.Easings.BounceEaseOut(C - v, 0, S, C) + _;
      },
      BounceEaseInOut(v, _, S, C) {
        return v < C / 2 ? r.Easings.BounceEaseIn(v * 2, 0, S, C) * 0.5 + _ : r.Easings.BounceEaseOut(v * 2 - C, 0, S, C) * 0.5 + S * 0.5 + _;
      },
      EaseIn(v, _, S, C) {
        return S * (v /= C) * v + _;
      },
      EaseOut(v, _, S, C) {
        return -S * (v /= C) * (v - 2) + _;
      },
      EaseInOut(v, _, S, C) {
        return (v /= C / 2) < 1 ? S / 2 * v * v + _ : -S / 2 * (--v * (v - 2) - 1) + _;
      },
      StrongEaseIn(v, _, S, C) {
        return S * (v /= C) * v * v * v * v + _;
      },
      StrongEaseOut(v, _, S, C) {
        return S * ((v = v / C - 1) * v * v * v * v + 1) + _;
      },
      StrongEaseInOut(v, _, S, C) {
        return (v /= C / 2) < 1 ? S / 2 * v * v * v * v * v + _ : S / 2 * ((v -= 2) * v * v * v * v + 2) + _;
      },
      Linear(v, _, S, C) {
        return S * v / C + _;
      }
    };
  }(ho)), ho;
}
var hd;
function l6() {
  return hd || (hd = 1, function(r) {
    Object.defineProperty(r, "__esModule", { value: !0 }), r.Konva = void 0;
    const a = Rt(), n = Kt(), o = $t(), c = ba(), s = s6(), h = Y0(), l = o6(), g = Yh(), p = Kh(), b = se(), w = Xh(), x = h6(), v = j0(), _ = ma();
    r.Konva = n.Util._assign(a.Konva, {
      Util: n.Util,
      Transform: n.Transform,
      Node: o.Node,
      Container: c.Container,
      Stage: s.Stage,
      stages: s.stages,
      Layer: h.Layer,
      FastLayer: l.FastLayer,
      Group: g.Group,
      DD: p.DD,
      Shape: b.Shape,
      shapes: b.shapes,
      Animation: w.Animation,
      Tween: x.Tween,
      Easings: x.Easings,
      Context: v.Context,
      Canvas: _.Canvas
    }), r.default = r.Konva;
  }(eo)), eo;
}
var Pi = {}, ld;
function u6() {
  if (ld) return Pi;
  ld = 1, Object.defineProperty(Pi, "__esModule", { value: !0 }), Pi.Arc = void 0;
  const r = Tt(), a = se(), n = Rt(), o = Ft(), c = Rt();
  let s = class extends a.Shape {
    _sceneFunc(l) {
      const g = n.Konva.getAngle(this.angle()), p = this.clockwise();
      l.beginPath(), l.arc(0, 0, this.outerRadius(), 0, g, p), l.arc(0, 0, this.innerRadius(), g, 0, !p), l.closePath(), l.fillStrokeShape(this);
    }
    getWidth() {
      return this.outerRadius() * 2;
    }
    getHeight() {
      return this.outerRadius() * 2;
    }
    setWidth(l) {
      this.outerRadius(l / 2);
    }
    setHeight(l) {
      this.outerRadius(l / 2);
    }
    getSelfRect() {
      const l = this.innerRadius(), g = this.outerRadius(), p = this.clockwise(), b = n.Konva.getAngle(p ? 360 - this.angle() : this.angle()), w = Math.cos(Math.min(b, Math.PI)), x = 1, v = Math.sin(Math.min(Math.max(Math.PI, b), 3 * Math.PI / 2)), _ = Math.sin(Math.min(b, Math.PI / 2)), S = w * (w > 0 ? l : g), C = x * g, O = v * (v > 0 ? l : g), d = _ * (_ > 0 ? g : l);
      return {
        x: S,
        y: p ? -1 * d : O,
        width: C - S,
        height: d - O
      };
    }
  };
  return Pi.Arc = s, s.prototype._centroid = !0, s.prototype.className = "Arc", s.prototype._attrsAffectingSize = ["innerRadius", "outerRadius"], (0, c._registerNode)(s), r.Factory.addGetterSetter(s, "innerRadius", 0, (0, o.getNumberValidator)()), r.Factory.addGetterSetter(s, "outerRadius", 0, (0, o.getNumberValidator)()), r.Factory.addGetterSetter(s, "angle", 0, (0, o.getNumberValidator)()), r.Factory.addGetterSetter(s, "clockwise", !1, (0, o.getBooleanValidator)()), Pi;
}
var Oi = {}, Fi = {}, ud;
function X0() {
  if (ud) return Fi;
  ud = 1, Object.defineProperty(Fi, "__esModule", { value: !0 }), Fi.Line = void 0;
  const r = Tt(), a = Rt(), n = se(), o = Ft();
  function c(l, g, p, b, w, x, v) {
    const _ = Math.sqrt(Math.pow(p - l, 2) + Math.pow(b - g, 2)), S = Math.sqrt(Math.pow(w - p, 2) + Math.pow(x - b, 2)), C = v * _ / (_ + S), O = v * S / (_ + S), d = p - C * (w - l), f = b - C * (x - g), m = p + O * (w - l), E = b + O * (x - g);
    return [d, f, m, E];
  }
  function s(l, g) {
    const p = l.length, b = [];
    for (let w = 2; w < p - 2; w += 2) {
      const x = c(l[w - 2], l[w - 1], l[w], l[w + 1], l[w + 2], l[w + 3], g);
      isNaN(x[0]) || (b.push(x[0]), b.push(x[1]), b.push(l[w]), b.push(l[w + 1]), b.push(x[2]), b.push(x[3]));
    }
    return b;
  }
  let h = class extends n.Shape {
    constructor(g) {
      super(g), this.on("pointsChange.konva tensionChange.konva closedChange.konva bezierChange.konva", function() {
        this._clearCache("tensionPoints");
      });
    }
    _sceneFunc(g) {
      let p = this.points(), b = p.length, w = this.tension(), x = this.closed(), v = this.bezier(), _, S, C;
      if (b) {
        if (g.beginPath(), g.moveTo(p[0], p[1]), w !== 0 && b > 4) {
          for (_ = this.getTensionPoints(), S = _.length, C = x ? 0 : 4, x || g.quadraticCurveTo(_[0], _[1], _[2], _[3]); C < S - 2; )
            g.bezierCurveTo(_[C++], _[C++], _[C++], _[C++], _[C++], _[C++]);
          x || g.quadraticCurveTo(_[S - 2], _[S - 1], p[b - 2], p[b - 1]);
        } else if (v)
          for (C = 2; C < b; )
            g.bezierCurveTo(p[C++], p[C++], p[C++], p[C++], p[C++], p[C++]);
        else
          for (C = 2; C < b; C += 2)
            g.lineTo(p[C], p[C + 1]);
        x ? (g.closePath(), g.fillStrokeShape(this)) : g.strokeShape(this);
      }
    }
    getTensionPoints() {
      return this._getCache("tensionPoints", this._getTensionPoints);
    }
    _getTensionPoints() {
      return this.closed() ? this._getTensionPointsClosed() : s(this.points(), this.tension());
    }
    _getTensionPointsClosed() {
      const g = this.points(), p = g.length, b = this.tension(), w = c(g[p - 2], g[p - 1], g[0], g[1], g[2], g[3], b), x = c(g[p - 4], g[p - 3], g[p - 2], g[p - 1], g[0], g[1], b), v = s(g, b);
      return [w[2], w[3]].concat(v).concat([
        x[0],
        x[1],
        g[p - 2],
        g[p - 1],
        x[2],
        x[3],
        w[0],
        w[1],
        g[0],
        g[1]
      ]);
    }
    getWidth() {
      return this.getSelfRect().width;
    }
    getHeight() {
      return this.getSelfRect().height;
    }
    getSelfRect() {
      let g = this.points();
      if (g.length < 4)
        return {
          x: g[0] || 0,
          y: g[1] || 0,
          width: 0,
          height: 0
        };
      this.tension() !== 0 ? g = [
        g[0],
        g[1],
        ...this._getTensionPoints(),
        g[g.length - 2],
        g[g.length - 1]
      ] : g = this.points();
      let p = g[0], b = g[0], w = g[1], x = g[1], v, _;
      for (let S = 0; S < g.length / 2; S++)
        v = g[S * 2], _ = g[S * 2 + 1], p = Math.min(p, v), b = Math.max(b, v), w = Math.min(w, _), x = Math.max(x, _);
      return {
        x: p,
        y: w,
        width: b - p,
        height: x - w
      };
    }
  };
  return Fi.Line = h, h.prototype.className = "Line", h.prototype._attrsAffectingSize = ["points", "bezier", "tension"], (0, a._registerNode)(h), r.Factory.addGetterSetter(h, "closed", !1), r.Factory.addGetterSetter(h, "bezier", !1), r.Factory.addGetterSetter(h, "tension", 0, (0, o.getNumberValidator)()), r.Factory.addGetterSetter(h, "points", [], (0, o.getNumberArrayValidator)()), Fi;
}
var ki = {}, lo = {}, cd;
function c6() {
  return cd || (cd = 1, function(r) {
    Object.defineProperty(r, "__esModule", { value: !0 }), r.t2length = r.getQuadraticArcLength = r.getCubicArcLength = r.binomialCoefficients = r.cValues = r.tValues = void 0, r.tValues = [
      [],
      [],
      [
        -0.5773502691896257,
        0.5773502691896257
      ],
      [
        0,
        -0.7745966692414834,
        0.7745966692414834
      ],
      [
        -0.33998104358485626,
        0.33998104358485626,
        -0.8611363115940526,
        0.8611363115940526
      ],
      [
        0,
        -0.5384693101056831,
        0.5384693101056831,
        -0.906179845938664,
        0.906179845938664
      ],
      [
        0.6612093864662645,
        -0.6612093864662645,
        -0.2386191860831969,
        0.2386191860831969,
        -0.932469514203152,
        0.932469514203152
      ],
      [
        0,
        0.4058451513773972,
        -0.4058451513773972,
        -0.7415311855993945,
        0.7415311855993945,
        -0.9491079123427585,
        0.9491079123427585
      ],
      [
        -0.1834346424956498,
        0.1834346424956498,
        -0.525532409916329,
        0.525532409916329,
        -0.7966664774136267,
        0.7966664774136267,
        -0.9602898564975363,
        0.9602898564975363
      ],
      [
        0,
        -0.8360311073266358,
        0.8360311073266358,
        -0.9681602395076261,
        0.9681602395076261,
        -0.3242534234038089,
        0.3242534234038089,
        -0.6133714327005904,
        0.6133714327005904
      ],
      [
        -0.14887433898163122,
        0.14887433898163122,
        -0.4333953941292472,
        0.4333953941292472,
        -0.6794095682990244,
        0.6794095682990244,
        -0.8650633666889845,
        0.8650633666889845,
        -0.9739065285171717,
        0.9739065285171717
      ],
      [
        0,
        -0.26954315595234496,
        0.26954315595234496,
        -0.5190961292068118,
        0.5190961292068118,
        -0.7301520055740494,
        0.7301520055740494,
        -0.8870625997680953,
        0.8870625997680953,
        -0.978228658146057,
        0.978228658146057
      ],
      [
        -0.1252334085114689,
        0.1252334085114689,
        -0.3678314989981802,
        0.3678314989981802,
        -0.5873179542866175,
        0.5873179542866175,
        -0.7699026741943047,
        0.7699026741943047,
        -0.9041172563704749,
        0.9041172563704749,
        -0.9815606342467192,
        0.9815606342467192
      ],
      [
        0,
        -0.2304583159551348,
        0.2304583159551348,
        -0.44849275103644687,
        0.44849275103644687,
        -0.6423493394403402,
        0.6423493394403402,
        -0.8015780907333099,
        0.8015780907333099,
        -0.9175983992229779,
        0.9175983992229779,
        -0.9841830547185881,
        0.9841830547185881
      ],
      [
        -0.10805494870734367,
        0.10805494870734367,
        -0.31911236892788974,
        0.31911236892788974,
        -0.5152486363581541,
        0.5152486363581541,
        -0.6872929048116855,
        0.6872929048116855,
        -0.827201315069765,
        0.827201315069765,
        -0.9284348836635735,
        0.9284348836635735,
        -0.9862838086968123,
        0.9862838086968123
      ],
      [
        0,
        -0.20119409399743451,
        0.20119409399743451,
        -0.3941513470775634,
        0.3941513470775634,
        -0.5709721726085388,
        0.5709721726085388,
        -0.7244177313601701,
        0.7244177313601701,
        -0.8482065834104272,
        0.8482065834104272,
        -0.937273392400706,
        0.937273392400706,
        -0.9879925180204854,
        0.9879925180204854
      ],
      [
        -0.09501250983763744,
        0.09501250983763744,
        -0.2816035507792589,
        0.2816035507792589,
        -0.45801677765722737,
        0.45801677765722737,
        -0.6178762444026438,
        0.6178762444026438,
        -0.755404408355003,
        0.755404408355003,
        -0.8656312023878318,
        0.8656312023878318,
        -0.9445750230732326,
        0.9445750230732326,
        -0.9894009349916499,
        0.9894009349916499
      ],
      [
        0,
        -0.17848418149584785,
        0.17848418149584785,
        -0.3512317634538763,
        0.3512317634538763,
        -0.5126905370864769,
        0.5126905370864769,
        -0.6576711592166907,
        0.6576711592166907,
        -0.7815140038968014,
        0.7815140038968014,
        -0.8802391537269859,
        0.8802391537269859,
        -0.9506755217687678,
        0.9506755217687678,
        -0.9905754753144174,
        0.9905754753144174
      ],
      [
        -0.0847750130417353,
        0.0847750130417353,
        -0.2518862256915055,
        0.2518862256915055,
        -0.41175116146284263,
        0.41175116146284263,
        -0.5597708310739475,
        0.5597708310739475,
        -0.6916870430603532,
        0.6916870430603532,
        -0.8037049589725231,
        0.8037049589725231,
        -0.8926024664975557,
        0.8926024664975557,
        -0.9558239495713977,
        0.9558239495713977,
        -0.9915651684209309,
        0.9915651684209309
      ],
      [
        0,
        -0.16035864564022537,
        0.16035864564022537,
        -0.31656409996362983,
        0.31656409996362983,
        -0.46457074137596094,
        0.46457074137596094,
        -0.600545304661681,
        0.600545304661681,
        -0.7209661773352294,
        0.7209661773352294,
        -0.8227146565371428,
        0.8227146565371428,
        -0.9031559036148179,
        0.9031559036148179,
        -0.96020815213483,
        0.96020815213483,
        -0.9924068438435844,
        0.9924068438435844
      ],
      [
        -0.07652652113349734,
        0.07652652113349734,
        -0.22778585114164507,
        0.22778585114164507,
        -0.37370608871541955,
        0.37370608871541955,
        -0.5108670019508271,
        0.5108670019508271,
        -0.636053680726515,
        0.636053680726515,
        -0.7463319064601508,
        0.7463319064601508,
        -0.8391169718222188,
        0.8391169718222188,
        -0.912234428251326,
        0.912234428251326,
        -0.9639719272779138,
        0.9639719272779138,
        -0.9931285991850949,
        0.9931285991850949
      ],
      [
        0,
        -0.1455618541608951,
        0.1455618541608951,
        -0.2880213168024011,
        0.2880213168024011,
        -0.4243421202074388,
        0.4243421202074388,
        -0.5516188358872198,
        0.5516188358872198,
        -0.6671388041974123,
        0.6671388041974123,
        -0.7684399634756779,
        0.7684399634756779,
        -0.8533633645833173,
        0.8533633645833173,
        -0.9200993341504008,
        0.9200993341504008,
        -0.9672268385663063,
        0.9672268385663063,
        -0.9937521706203895,
        0.9937521706203895
      ],
      [
        -0.06973927331972223,
        0.06973927331972223,
        -0.20786042668822127,
        0.20786042668822127,
        -0.34193582089208424,
        0.34193582089208424,
        -0.469355837986757,
        0.469355837986757,
        -0.5876404035069116,
        0.5876404035069116,
        -0.6944872631866827,
        0.6944872631866827,
        -0.7878168059792081,
        0.7878168059792081,
        -0.8658125777203002,
        0.8658125777203002,
        -0.926956772187174,
        0.926956772187174,
        -0.9700604978354287,
        0.9700604978354287,
        -0.9942945854823992,
        0.9942945854823992
      ],
      [
        0,
        -0.1332568242984661,
        0.1332568242984661,
        -0.26413568097034495,
        0.26413568097034495,
        -0.3903010380302908,
        0.3903010380302908,
        -0.5095014778460075,
        0.5095014778460075,
        -0.6196098757636461,
        0.6196098757636461,
        -0.7186613631319502,
        0.7186613631319502,
        -0.8048884016188399,
        0.8048884016188399,
        -0.8767523582704416,
        0.8767523582704416,
        -0.9329710868260161,
        0.9329710868260161,
        -0.9725424712181152,
        0.9725424712181152,
        -0.9947693349975522,
        0.9947693349975522
      ],
      [
        -0.06405689286260563,
        0.06405689286260563,
        -0.1911188674736163,
        0.1911188674736163,
        -0.3150426796961634,
        0.3150426796961634,
        -0.4337935076260451,
        0.4337935076260451,
        -0.5454214713888396,
        0.5454214713888396,
        -0.6480936519369755,
        0.6480936519369755,
        -0.7401241915785544,
        0.7401241915785544,
        -0.820001985973903,
        0.820001985973903,
        -0.8864155270044011,
        0.8864155270044011,
        -0.9382745520027328,
        0.9382745520027328,
        -0.9747285559713095,
        0.9747285559713095,
        -0.9951872199970213,
        0.9951872199970213
      ]
    ], r.cValues = [
      [],
      [],
      [1, 1],
      [
        0.8888888888888888,
        0.5555555555555556,
        0.5555555555555556
      ],
      [
        0.6521451548625461,
        0.6521451548625461,
        0.34785484513745385,
        0.34785484513745385
      ],
      [
        0.5688888888888889,
        0.47862867049936647,
        0.47862867049936647,
        0.23692688505618908,
        0.23692688505618908
      ],
      [
        0.3607615730481386,
        0.3607615730481386,
        0.46791393457269104,
        0.46791393457269104,
        0.17132449237917036,
        0.17132449237917036
      ],
      [
        0.4179591836734694,
        0.3818300505051189,
        0.3818300505051189,
        0.27970539148927664,
        0.27970539148927664,
        0.1294849661688697,
        0.1294849661688697
      ],
      [
        0.362683783378362,
        0.362683783378362,
        0.31370664587788727,
        0.31370664587788727,
        0.22238103445337448,
        0.22238103445337448,
        0.10122853629037626,
        0.10122853629037626
      ],
      [
        0.3302393550012598,
        0.1806481606948574,
        0.1806481606948574,
        0.08127438836157441,
        0.08127438836157441,
        0.31234707704000286,
        0.31234707704000286,
        0.26061069640293544,
        0.26061069640293544
      ],
      [
        0.29552422471475287,
        0.29552422471475287,
        0.26926671930999635,
        0.26926671930999635,
        0.21908636251598204,
        0.21908636251598204,
        0.1494513491505806,
        0.1494513491505806,
        0.06667134430868814,
        0.06667134430868814
      ],
      [
        0.2729250867779006,
        0.26280454451024665,
        0.26280454451024665,
        0.23319376459199048,
        0.23319376459199048,
        0.18629021092773426,
        0.18629021092773426,
        0.1255803694649046,
        0.1255803694649046,
        0.05566856711617366,
        0.05566856711617366
      ],
      [
        0.24914704581340277,
        0.24914704581340277,
        0.2334925365383548,
        0.2334925365383548,
        0.20316742672306592,
        0.20316742672306592,
        0.16007832854334622,
        0.16007832854334622,
        0.10693932599531843,
        0.10693932599531843,
        0.04717533638651183,
        0.04717533638651183
      ],
      [
        0.2325515532308739,
        0.22628318026289723,
        0.22628318026289723,
        0.2078160475368885,
        0.2078160475368885,
        0.17814598076194574,
        0.17814598076194574,
        0.13887351021978725,
        0.13887351021978725,
        0.09212149983772845,
        0.09212149983772845,
        0.04048400476531588,
        0.04048400476531588
      ],
      [
        0.2152638534631578,
        0.2152638534631578,
        0.2051984637212956,
        0.2051984637212956,
        0.18553839747793782,
        0.18553839747793782,
        0.15720316715819355,
        0.15720316715819355,
        0.12151857068790319,
        0.12151857068790319,
        0.08015808715976021,
        0.08015808715976021,
        0.03511946033175186,
        0.03511946033175186
      ],
      [
        0.2025782419255613,
        0.19843148532711158,
        0.19843148532711158,
        0.1861610000155622,
        0.1861610000155622,
        0.16626920581699392,
        0.16626920581699392,
        0.13957067792615432,
        0.13957067792615432,
        0.10715922046717194,
        0.10715922046717194,
        0.07036604748810812,
        0.07036604748810812,
        0.03075324199611727,
        0.03075324199611727
      ],
      [
        0.1894506104550685,
        0.1894506104550685,
        0.18260341504492358,
        0.18260341504492358,
        0.16915651939500254,
        0.16915651939500254,
        0.14959598881657674,
        0.14959598881657674,
        0.12462897125553388,
        0.12462897125553388,
        0.09515851168249279,
        0.09515851168249279,
        0.062253523938647894,
        0.062253523938647894,
        0.027152459411754096,
        0.027152459411754096
      ],
      [
        0.17944647035620653,
        0.17656270536699264,
        0.17656270536699264,
        0.16800410215645004,
        0.16800410215645004,
        0.15404576107681028,
        0.15404576107681028,
        0.13513636846852548,
        0.13513636846852548,
        0.11188384719340397,
        0.11188384719340397,
        0.08503614831717918,
        0.08503614831717918,
        0.0554595293739872,
        0.0554595293739872,
        0.02414830286854793,
        0.02414830286854793
      ],
      [
        0.1691423829631436,
        0.1691423829631436,
        0.16427648374583273,
        0.16427648374583273,
        0.15468467512626524,
        0.15468467512626524,
        0.14064291467065065,
        0.14064291467065065,
        0.12255520671147846,
        0.12255520671147846,
        0.10094204410628717,
        0.10094204410628717,
        0.07642573025488905,
        0.07642573025488905,
        0.0497145488949698,
        0.0497145488949698,
        0.02161601352648331,
        0.02161601352648331
      ],
      [
        0.1610544498487837,
        0.15896884339395434,
        0.15896884339395434,
        0.15276604206585967,
        0.15276604206585967,
        0.1426067021736066,
        0.1426067021736066,
        0.12875396253933621,
        0.12875396253933621,
        0.11156664554733399,
        0.11156664554733399,
        0.09149002162245,
        0.09149002162245,
        0.06904454273764123,
        0.06904454273764123,
        0.0448142267656996,
        0.0448142267656996,
        0.019461788229726478,
        0.019461788229726478
      ],
      [
        0.15275338713072584,
        0.15275338713072584,
        0.14917298647260374,
        0.14917298647260374,
        0.14209610931838204,
        0.14209610931838204,
        0.13168863844917664,
        0.13168863844917664,
        0.11819453196151841,
        0.11819453196151841,
        0.10193011981724044,
        0.10193011981724044,
        0.08327674157670475,
        0.08327674157670475,
        0.06267204833410907,
        0.06267204833410907,
        0.04060142980038694,
        0.04060142980038694,
        0.017614007139152118,
        0.017614007139152118
      ],
      [
        0.14608113364969041,
        0.14452440398997005,
        0.14452440398997005,
        0.13988739479107315,
        0.13988739479107315,
        0.13226893863333747,
        0.13226893863333747,
        0.12183141605372853,
        0.12183141605372853,
        0.10879729916714838,
        0.10879729916714838,
        0.09344442345603386,
        0.09344442345603386,
        0.0761001136283793,
        0.0761001136283793,
        0.057134425426857205,
        0.057134425426857205,
        0.036953789770852494,
        0.036953789770852494,
        0.016017228257774335,
        0.016017228257774335
      ],
      [
        0.13925187285563198,
        0.13925187285563198,
        0.13654149834601517,
        0.13654149834601517,
        0.13117350478706238,
        0.13117350478706238,
        0.12325237681051242,
        0.12325237681051242,
        0.11293229608053922,
        0.11293229608053922,
        0.10041414444288096,
        0.10041414444288096,
        0.08594160621706773,
        0.08594160621706773,
        0.06979646842452049,
        0.06979646842452049,
        0.052293335152683286,
        0.052293335152683286,
        0.03377490158481415,
        0.03377490158481415,
        0.0146279952982722,
        0.0146279952982722
      ],
      [
        0.13365457218610619,
        0.1324620394046966,
        0.1324620394046966,
        0.12890572218808216,
        0.12890572218808216,
        0.12304908430672953,
        0.12304908430672953,
        0.11499664022241136,
        0.11499664022241136,
        0.10489209146454141,
        0.10489209146454141,
        0.09291576606003515,
        0.09291576606003515,
        0.07928141177671895,
        0.07928141177671895,
        0.06423242140852585,
        0.06423242140852585,
        0.04803767173108467,
        0.04803767173108467,
        0.030988005856979445,
        0.030988005856979445,
        0.013411859487141771,
        0.013411859487141771
      ],
      [
        0.12793819534675216,
        0.12793819534675216,
        0.1258374563468283,
        0.1258374563468283,
        0.12167047292780339,
        0.12167047292780339,
        0.1155056680537256,
        0.1155056680537256,
        0.10744427011596563,
        0.10744427011596563,
        0.09761865210411388,
        0.09761865210411388,
        0.08619016153195327,
        0.08619016153195327,
        0.0733464814110803,
        0.0733464814110803,
        0.05929858491543678,
        0.05929858491543678,
        0.04427743881741981,
        0.04427743881741981,
        0.028531388628933663,
        0.028531388628933663,
        0.0123412297999872,
        0.0123412297999872
      ]
    ], r.binomialCoefficients = [[1], [1, 1], [1, 2, 1], [1, 3, 3, 1]];
    const a = (h, l, g) => {
      let p, b;
      const x = g / 2;
      p = 0;
      for (let v = 0; v < 20; v++)
        b = x * r.tValues[20][v] + x, p += r.cValues[20][v] * o(h, l, b);
      return x * p;
    };
    r.getCubicArcLength = a;
    const n = (h, l, g) => {
      g === void 0 && (g = 1);
      const p = h[0] - 2 * h[1] + h[2], b = l[0] - 2 * l[1] + l[2], w = 2 * h[1] - 2 * h[0], x = 2 * l[1] - 2 * l[0], v = 4 * (p * p + b * b), _ = 4 * (p * w + b * x), S = w * w + x * x;
      if (v === 0)
        return g * Math.sqrt(Math.pow(h[2] - h[0], 2) + Math.pow(l[2] - l[0], 2));
      const C = _ / (2 * v), O = S / v, d = g + C, f = O - C * C, m = d * d + f > 0 ? Math.sqrt(d * d + f) : 0, E = C * C + f > 0 ? Math.sqrt(C * C + f) : 0, T = C + Math.sqrt(C * C + f) !== 0 ? f * Math.log(Math.abs((d + m) / (C + E))) : 0;
      return Math.sqrt(v) / 2 * (d * m - C * E + T);
    };
    r.getQuadraticArcLength = n;
    function o(h, l, g) {
      const p = c(1, g, h), b = c(1, g, l), w = p * p + b * b;
      return Math.sqrt(w);
    }
    const c = (h, l, g) => {
      const p = g.length - 1;
      let b, w;
      if (p === 0)
        return 0;
      if (h === 0) {
        w = 0;
        for (let x = 0; x <= p; x++)
          w += r.binomialCoefficients[p][x] * Math.pow(1 - l, p - x) * Math.pow(l, x) * g[x];
        return w;
      } else {
        b = new Array(p);
        for (let x = 0; x < p; x++)
          b[x] = p * (g[x + 1] - g[x]);
        return c(h - 1, l, b);
      }
    }, s = (h, l, g) => {
      let p = 1, b = h / l, w = (h - g(b)) / l, x = 0;
      for (; p > 1e-3; ) {
        const v = g(b + w), _ = Math.abs(h - v) / l;
        if (_ < p)
          p = _, b += w;
        else {
          const S = g(b - w), C = Math.abs(h - S) / l;
          C < p ? (p = C, b -= w) : w /= 2;
        }
        if (x++, x > 500)
          break;
      }
      return b;
    };
    r.t2length = s;
  }(lo)), lo;
}
var dd;
function $h() {
  if (dd) return ki;
  dd = 1, Object.defineProperty(ki, "__esModule", { value: !0 }), ki.Path = void 0;
  const r = Tt(), a = se(), n = Rt(), o = c6();
  let c = class we extends a.Shape {
    constructor(h) {
      super(h), this.dataArray = [], this.pathLength = 0, this._readDataAttribute(), this.on("dataChange.konva", function() {
        this._readDataAttribute();
      });
    }
    _readDataAttribute() {
      this.dataArray = we.parsePathData(this.data()), this.pathLength = we.getPathLength(this.dataArray);
    }
    _sceneFunc(h) {
      const l = this.dataArray;
      h.beginPath();
      let g = !1;
      for (let m = 0; m < l.length; m++) {
        const E = l[m].command, T = l[m].points;
        switch (E) {
          case "L":
            h.lineTo(T[0], T[1]);
            break;
          case "M":
            h.moveTo(T[0], T[1]);
            break;
          case "C":
            h.bezierCurveTo(T[0], T[1], T[2], T[3], T[4], T[5]);
            break;
          case "Q":
            h.quadraticCurveTo(T[0], T[1], T[2], T[3]);
            break;
          case "A":
            var p = T[0], b = T[1], w = T[2], x = T[3], v = T[4], _ = T[5], S = T[6], C = T[7], O = w > x ? w : x, d = w > x ? 1 : w / x, f = w > x ? x / w : 1;
            h.translate(p, b), h.rotate(S), h.scale(d, f), h.arc(0, 0, O, v, v + _, 1 - C), h.scale(1 / d, 1 / f), h.rotate(-S), h.translate(-p, -b);
            break;
          case "z":
            g = !0, h.closePath();
            break;
        }
      }
      !g && !this.hasFill() ? h.strokeShape(this) : h.fillStrokeShape(this);
    }
    getSelfRect() {
      let h = [];
      this.dataArray.forEach(function(v) {
        if (v.command === "A") {
          const _ = v.points[4], S = v.points[5], C = v.points[4] + S;
          let O = Math.PI / 180;
          if (Math.abs(_ - C) < O && (O = Math.abs(_ - C)), S < 0)
            for (let d = _ - O; d > C; d -= O) {
              const f = we.getPointOnEllipticalArc(v.points[0], v.points[1], v.points[2], v.points[3], d, 0);
              h.push(f.x, f.y);
            }
          else
            for (let d = _ + O; d < C; d += O) {
              const f = we.getPointOnEllipticalArc(v.points[0], v.points[1], v.points[2], v.points[3], d, 0);
              h.push(f.x, f.y);
            }
        } else if (v.command === "C")
          for (let _ = 0; _ <= 1; _ += 0.01) {
            const S = we.getPointOnCubicBezier(_, v.start.x, v.start.y, v.points[0], v.points[1], v.points[2], v.points[3], v.points[4], v.points[5]);
            h.push(S.x, S.y);
          }
        else
          h = h.concat(v.points);
      });
      let l = h[0], g = h[0], p = h[1], b = h[1], w, x;
      for (let v = 0; v < h.length / 2; v++)
        w = h[v * 2], x = h[v * 2 + 1], isNaN(w) || (l = Math.min(l, w), g = Math.max(g, w)), isNaN(x) || (p = Math.min(p, x), b = Math.max(b, x));
      return {
        x: l,
        y: p,
        width: g - l,
        height: b - p
      };
    }
    getLength() {
      return this.pathLength;
    }
    getPointAtLength(h) {
      return we.getPointAtLengthOfDataArray(h, this.dataArray);
    }
    static getLineLength(h, l, g, p) {
      return Math.sqrt((g - h) * (g - h) + (p - l) * (p - l));
    }
    static getPathLength(h) {
      let l = 0;
      for (let g = 0; g < h.length; ++g)
        l += h[g].pathLength;
      return l;
    }
    static getPointAtLengthOfDataArray(h, l) {
      let g, p = 0, b = l.length;
      if (!b)
        return null;
      for (; p < b && h > l[p].pathLength; )
        h -= l[p].pathLength, ++p;
      if (p === b)
        return g = l[p - 1].points.slice(-2), {
          x: g[0],
          y: g[1]
        };
      if (h < 0.01)
        return g = l[p].points.slice(0, 2), {
          x: g[0],
          y: g[1]
        };
      const w = l[p], x = w.points;
      switch (w.command) {
        case "L":
          return we.getPointOnLine(h, w.start.x, w.start.y, x[0], x[1]);
        case "C":
          return we.getPointOnCubicBezier((0, o.t2length)(h, we.getPathLength(l), (m) => (0, o.getCubicArcLength)([w.start.x, x[0], x[2], x[4]], [w.start.y, x[1], x[3], x[5]], m)), w.start.x, w.start.y, x[0], x[1], x[2], x[3], x[4], x[5]);
        case "Q":
          return we.getPointOnQuadraticBezier((0, o.t2length)(h, we.getPathLength(l), (m) => (0, o.getQuadraticArcLength)([w.start.x, x[0], x[2]], [w.start.y, x[1], x[3]], m)), w.start.x, w.start.y, x[0], x[1], x[2], x[3]);
        case "A":
          var v = x[0], _ = x[1], S = x[2], C = x[3], O = x[4], d = x[5], f = x[6];
          return O += d * h / w.pathLength, we.getPointOnEllipticalArc(v, _, S, C, O, f);
      }
      return null;
    }
    static getPointOnLine(h, l, g, p, b, w, x) {
      w = w != null ? w : l, x = x != null ? x : g;
      const v = this.getLineLength(l, g, p, b);
      if (v < 1e-10)
        return { x: l, y: g };
      if (p === l)
        return { x: w, y: x + (b > g ? h : -h) };
      const _ = (b - g) / (p - l), S = Math.sqrt(h * h / (1 + _ * _)) * (p < l ? -1 : 1), C = _ * S;
      if (Math.abs(x - g - _ * (w - l)) < 1e-10)
        return { x: w + S, y: x + C };
      const O = ((w - l) * (p - l) + (x - g) * (b - g)) / (v * v), d = l + O * (p - l), f = g + O * (b - g), m = this.getLineLength(w, x, d, f), E = Math.sqrt(h * h - m * m), T = Math.sqrt(E * E / (1 + _ * _)) * (p < l ? -1 : 1), D = _ * T;
      return { x: d + T, y: f + D };
    }
    static getPointOnCubicBezier(h, l, g, p, b, w, x, v, _) {
      function S(E) {
        return E * E * E;
      }
      function C(E) {
        return 3 * E * E * (1 - E);
      }
      function O(E) {
        return 3 * E * (1 - E) * (1 - E);
      }
      function d(E) {
        return (1 - E) * (1 - E) * (1 - E);
      }
      const f = v * S(h) + w * C(h) + p * O(h) + l * d(h), m = _ * S(h) + x * C(h) + b * O(h) + g * d(h);
      return {
        x: f,
        y: m
      };
    }
    static getPointOnQuadraticBezier(h, l, g, p, b, w, x) {
      function v(d) {
        return d * d;
      }
      function _(d) {
        return 2 * d * (1 - d);
      }
      function S(d) {
        return (1 - d) * (1 - d);
      }
      const C = w * v(h) + p * _(h) + l * S(h), O = x * v(h) + b * _(h) + g * S(h);
      return {
        x: C,
        y: O
      };
    }
    static getPointOnEllipticalArc(h, l, g, p, b, w) {
      const x = Math.cos(w), v = Math.sin(w), _ = {
        x: g * Math.cos(b),
        y: p * Math.sin(b)
      };
      return {
        x: h + (_.x * x - _.y * v),
        y: l + (_.x * v + _.y * x)
      };
    }
    static parsePathData(h) {
      if (!h)
        return [];
      let l = h;
      const g = [
        "m",
        "M",
        "l",
        "L",
        "v",
        "V",
        "h",
        "H",
        "z",
        "Z",
        "c",
        "C",
        "q",
        "Q",
        "t",
        "T",
        "s",
        "S",
        "a",
        "A"
      ];
      l = l.replace(new RegExp(" ", "g"), ",");
      for (var p = 0; p < g.length; p++)
        l = l.replace(new RegExp(g[p], "g"), "|" + g[p]);
      const b = l.split("|"), w = [], x = [];
      let v = 0, _ = 0;
      const S = /([-+]?((\d+\.\d+)|((\d+)|(\.\d+)))(?:e[-+]?\d+)?)/gi;
      let C;
      for (p = 1; p < b.length; p++) {
        let y = b[p], P = y.charAt(0);
        for (y = y.slice(1), x.length = 0; C = S.exec(y); )
          x.push(C[0]);
        const A = [];
        for (let G = 0, U = x.length; G < U; G++) {
          if (x[G] === "00") {
            A.push(0, 0);
            continue;
          }
          const K = parseFloat(x[G]);
          isNaN(K) ? A.push(0) : A.push(K);
        }
        for (; A.length > 0 && !isNaN(A[0]); ) {
          let G = "", U = [];
          const K = v, $ = _;
          var O, d, f, m, E, T, D, I, L, F;
          switch (P) {
            case "l":
              v += A.shift(), _ += A.shift(), G = "L", U.push(v, _);
              break;
            case "L":
              v = A.shift(), _ = A.shift(), U.push(v, _);
              break;
            case "m":
              var N = A.shift(), H = A.shift();
              if (v += N, _ += H, G = "M", w.length > 2 && w[w.length - 1].command === "z") {
                for (let X = w.length - 2; X >= 0; X--)
                  if (w[X].command === "M") {
                    v = w[X].points[0] + N, _ = w[X].points[1] + H;
                    break;
                  }
              }
              U.push(v, _), P = "l";
              break;
            case "M":
              v = A.shift(), _ = A.shift(), G = "M", U.push(v, _), P = "L";
              break;
            case "h":
              v += A.shift(), G = "L", U.push(v, _);
              break;
            case "H":
              v = A.shift(), G = "L", U.push(v, _);
              break;
            case "v":
              _ += A.shift(), G = "L", U.push(v, _);
              break;
            case "V":
              _ = A.shift(), G = "L", U.push(v, _);
              break;
            case "C":
              U.push(A.shift(), A.shift(), A.shift(), A.shift()), v = A.shift(), _ = A.shift(), U.push(v, _);
              break;
            case "c":
              U.push(v + A.shift(), _ + A.shift(), v + A.shift(), _ + A.shift()), v += A.shift(), _ += A.shift(), G = "C", U.push(v, _);
              break;
            case "S":
              d = v, f = _, O = w[w.length - 1], O.command === "C" && (d = v + (v - O.points[2]), f = _ + (_ - O.points[3])), U.push(d, f, A.shift(), A.shift()), v = A.shift(), _ = A.shift(), G = "C", U.push(v, _);
              break;
            case "s":
              d = v, f = _, O = w[w.length - 1], O.command === "C" && (d = v + (v - O.points[2]), f = _ + (_ - O.points[3])), U.push(d, f, v + A.shift(), _ + A.shift()), v += A.shift(), _ += A.shift(), G = "C", U.push(v, _);
              break;
            case "Q":
              U.push(A.shift(), A.shift()), v = A.shift(), _ = A.shift(), U.push(v, _);
              break;
            case "q":
              U.push(v + A.shift(), _ + A.shift()), v += A.shift(), _ += A.shift(), G = "Q", U.push(v, _);
              break;
            case "T":
              d = v, f = _, O = w[w.length - 1], O.command === "Q" && (d = v + (v - O.points[0]), f = _ + (_ - O.points[1])), v = A.shift(), _ = A.shift(), G = "Q", U.push(d, f, v, _);
              break;
            case "t":
              d = v, f = _, O = w[w.length - 1], O.command === "Q" && (d = v + (v - O.points[0]), f = _ + (_ - O.points[1])), v += A.shift(), _ += A.shift(), G = "Q", U.push(d, f, v, _);
              break;
            case "A":
              m = A.shift(), E = A.shift(), T = A.shift(), D = A.shift(), I = A.shift(), L = v, F = _, v = A.shift(), _ = A.shift(), G = "A", U = this.convertEndpointToCenterParameterization(L, F, v, _, D, I, m, E, T);
              break;
            case "a":
              m = A.shift(), E = A.shift(), T = A.shift(), D = A.shift(), I = A.shift(), L = v, F = _, v += A.shift(), _ += A.shift(), G = "A", U = this.convertEndpointToCenterParameterization(L, F, v, _, D, I, m, E, T);
              break;
          }
          w.push({
            command: G || P,
            points: U,
            start: {
              x: K,
              y: $
            },
            pathLength: this.calcLength(K, $, G || P, U)
          });
        }
        (P === "z" || P === "Z") && w.push({
          command: "z",
          points: [],
          start: void 0,
          pathLength: 0
        });
      }
      return w;
    }
    static calcLength(h, l, g, p) {
      let b, w, x, v;
      const _ = we;
      switch (g) {
        case "L":
          return _.getLineLength(h, l, p[0], p[1]);
        case "C":
          return (0, o.getCubicArcLength)([h, p[0], p[2], p[4]], [l, p[1], p[3], p[5]], 1);
        case "Q":
          return (0, o.getQuadraticArcLength)([h, p[0], p[2]], [l, p[1], p[3]], 1);
        case "A":
          b = 0;
          var S = p[4], C = p[5], O = p[4] + C, d = Math.PI / 180;
          if (Math.abs(S - O) < d && (d = Math.abs(S - O)), w = _.getPointOnEllipticalArc(p[0], p[1], p[2], p[3], S, 0), C < 0)
            for (v = S - d; v > O; v -= d)
              x = _.getPointOnEllipticalArc(p[0], p[1], p[2], p[3], v, 0), b += _.getLineLength(w.x, w.y, x.x, x.y), w = x;
          else
            for (v = S + d; v < O; v += d)
              x = _.getPointOnEllipticalArc(p[0], p[1], p[2], p[3], v, 0), b += _.getLineLength(w.x, w.y, x.x, x.y), w = x;
          return x = _.getPointOnEllipticalArc(p[0], p[1], p[2], p[3], O, 0), b += _.getLineLength(w.x, w.y, x.x, x.y), b;
      }
      return 0;
    }
    static convertEndpointToCenterParameterization(h, l, g, p, b, w, x, v, _) {
      const S = _ * (Math.PI / 180), C = Math.cos(S) * (h - g) / 2 + Math.sin(S) * (l - p) / 2, O = -1 * Math.sin(S) * (h - g) / 2 + Math.cos(S) * (l - p) / 2, d = C * C / (x * x) + O * O / (v * v);
      d > 1 && (x *= Math.sqrt(d), v *= Math.sqrt(d));
      let f = Math.sqrt((x * x * (v * v) - x * x * (O * O) - v * v * (C * C)) / (x * x * (O * O) + v * v * (C * C)));
      b === w && (f *= -1), isNaN(f) && (f = 0);
      const m = f * x * O / v, E = f * -v * C / x, T = (h + g) / 2 + Math.cos(S) * m - Math.sin(S) * E, D = (l + p) / 2 + Math.sin(S) * m + Math.cos(S) * E, I = function(A) {
        return Math.sqrt(A[0] * A[0] + A[1] * A[1]);
      }, L = function(A, G) {
        return (A[0] * G[0] + A[1] * G[1]) / (I(A) * I(G));
      }, F = function(A, G) {
        return (A[0] * G[1] < A[1] * G[0] ? -1 : 1) * Math.acos(L(A, G));
      }, N = F([1, 0], [(C - m) / x, (O - E) / v]), H = [(C - m) / x, (O - E) / v], y = [(-1 * C - m) / x, (-1 * O - E) / v];
      let P = F(H, y);
      return L(H, y) <= -1 && (P = Math.PI), L(H, y) >= 1 && (P = 0), w === 0 && P > 0 && (P = P - 2 * Math.PI), w === 1 && P < 0 && (P = P + 2 * Math.PI), [T, D, x, v, N, P, S, w];
    }
  };
  return ki.Path = c, c.prototype.className = "Path", c.prototype._attrsAffectingSize = ["data"], (0, n._registerNode)(c), r.Factory.addGetterSetter(c, "data"), ki;
}
var fd;
function d6() {
  if (fd) return Oi;
  fd = 1, Object.defineProperty(Oi, "__esModule", { value: !0 }), Oi.Arrow = void 0;
  const r = Tt(), a = X0(), n = Ft(), o = Rt(), c = $h();
  let s = class extends a.Line {
    _sceneFunc(l) {
      super._sceneFunc(l);
      const g = Math.PI * 2, p = this.points();
      let b = p;
      const w = this.tension() !== 0 && p.length > 4;
      w && (b = this.getTensionPoints());
      const x = this.pointerLength(), v = p.length;
      let _, S;
      if (w) {
        const d = [
          b[b.length - 4],
          b[b.length - 3],
          b[b.length - 2],
          b[b.length - 1],
          p[v - 2],
          p[v - 1]
        ], f = c.Path.calcLength(b[b.length - 4], b[b.length - 3], "C", d), m = c.Path.getPointOnQuadraticBezier(Math.min(1, 1 - x / f), d[0], d[1], d[2], d[3], d[4], d[5]);
        _ = p[v - 2] - m.x, S = p[v - 1] - m.y;
      } else
        _ = p[v - 2] - p[v - 4], S = p[v - 1] - p[v - 3];
      const C = (Math.atan2(S, _) + g) % g, O = this.pointerWidth();
      this.pointerAtEnding() && (l.save(), l.beginPath(), l.translate(p[v - 2], p[v - 1]), l.rotate(C), l.moveTo(0, 0), l.lineTo(-x, O / 2), l.lineTo(-x, -O / 2), l.closePath(), l.restore(), this.__fillStroke(l)), this.pointerAtBeginning() && (l.save(), l.beginPath(), l.translate(p[0], p[1]), w ? (_ = (b[0] + b[2]) / 2 - p[0], S = (b[1] + b[3]) / 2 - p[1]) : (_ = p[2] - p[0], S = p[3] - p[1]), l.rotate((Math.atan2(-S, -_) + g) % g), l.moveTo(0, 0), l.lineTo(-x, O / 2), l.lineTo(-x, -O / 2), l.closePath(), l.restore(), this.__fillStroke(l));
    }
    __fillStroke(l) {
      const g = this.dashEnabled();
      g && (this.attrs.dashEnabled = !1, l.setLineDash([])), l.fillStrokeShape(this), g && (this.attrs.dashEnabled = !0);
    }
    getSelfRect() {
      const l = super.getSelfRect(), g = this.pointerWidth() / 2;
      return {
        x: l.x - g,
        y: l.y - g,
        width: l.width + g * 2,
        height: l.height + g * 2
      };
    }
  };
  return Oi.Arrow = s, s.prototype.className = "Arrow", (0, o._registerNode)(s), r.Factory.addGetterSetter(s, "pointerLength", 10, (0, n.getNumberValidator)()), r.Factory.addGetterSetter(s, "pointerWidth", 10, (0, n.getNumberValidator)()), r.Factory.addGetterSetter(s, "pointerAtBeginning", !1), r.Factory.addGetterSetter(s, "pointerAtEnding", !0), Oi;
}
var Ii = {}, gd;
function f6() {
  if (gd) return Ii;
  gd = 1, Object.defineProperty(Ii, "__esModule", { value: !0 }), Ii.Circle = void 0;
  const r = Tt(), a = se(), n = Ft(), o = Rt();
  let c = class extends a.Shape {
    _sceneFunc(h) {
      h.beginPath(), h.arc(0, 0, this.attrs.radius || 0, 0, Math.PI * 2, !1), h.closePath(), h.fillStrokeShape(this);
    }
    getWidth() {
      return this.radius() * 2;
    }
    getHeight() {
      return this.radius() * 2;
    }
    setWidth(h) {
      this.radius() !== h / 2 && this.radius(h / 2);
    }
    setHeight(h) {
      this.radius() !== h / 2 && this.radius(h / 2);
    }
  };
  return Ii.Circle = c, c.prototype._centroid = !0, c.prototype.className = "Circle", c.prototype._attrsAffectingSize = ["radius"], (0, o._registerNode)(c), r.Factory.addGetterSetter(c, "radius", 0, (0, n.getNumberValidator)()), Ii;
}
var Li = {}, pd;
function g6() {
  if (pd) return Li;
  pd = 1, Object.defineProperty(Li, "__esModule", { value: !0 }), Li.Ellipse = void 0;
  const r = Tt(), a = se(), n = Ft(), o = Rt();
  let c = class extends a.Shape {
    _sceneFunc(h) {
      const l = this.radiusX(), g = this.radiusY();
      h.beginPath(), h.save(), l !== g && h.scale(1, g / l), h.arc(0, 0, l, 0, Math.PI * 2, !1), h.restore(), h.closePath(), h.fillStrokeShape(this);
    }
    getWidth() {
      return this.radiusX() * 2;
    }
    getHeight() {
      return this.radiusY() * 2;
    }
    setWidth(h) {
      this.radiusX(h / 2);
    }
    setHeight(h) {
      this.radiusY(h / 2);
    }
  };
  return Li.Ellipse = c, c.prototype.className = "Ellipse", c.prototype._centroid = !0, c.prototype._attrsAffectingSize = ["radiusX", "radiusY"], (0, o._registerNode)(c), r.Factory.addComponentsGetterSetter(c, "radius", ["x", "y"]), r.Factory.addGetterSetter(c, "radiusX", 0, (0, n.getNumberValidator)()), r.Factory.addGetterSetter(c, "radiusY", 0, (0, n.getNumberValidator)()), Li;
}
var Mi = {}, _d;
function p6() {
  if (_d) return Mi;
  _d = 1, Object.defineProperty(Mi, "__esModule", { value: !0 }), Mi.Image = void 0;
  const r = Kt(), a = Tt(), n = se(), o = Rt(), c = Ft();
  let s = class $0 extends n.Shape {
    constructor(l) {
      super(l), this.on("imageChange.konva", () => {
        this._setImageLoad();
      }), this._setImageLoad();
    }
    _setImageLoad() {
      const l = this.image();
      l && l.complete || l && l.readyState === 4 || l && l.addEventListener && l.addEventListener("load", () => {
        this._requestDraw();
      });
    }
    _useBufferCanvas() {
      const l = !!this.cornerRadius(), g = this.hasShadow();
      return l && g ? !0 : super._useBufferCanvas(!0);
    }
    _sceneFunc(l) {
      const g = this.getWidth(), p = this.getHeight(), b = this.cornerRadius(), w = this.attrs.image;
      let x;
      if (w) {
        const v = this.attrs.cropWidth, _ = this.attrs.cropHeight;
        v && _ ? x = [
          w,
          this.cropX(),
          this.cropY(),
          v,
          _,
          0,
          0,
          g,
          p
        ] : x = [w, 0, 0, g, p];
      }
      (this.hasFill() || this.hasStroke() || b) && (l.beginPath(), b ? r.Util.drawRoundedRectPath(l, g, p, b) : l.rect(0, 0, g, p), l.closePath(), l.fillStrokeShape(this)), w && (b && l.clip(), l.drawImage.apply(l, x));
    }
    _hitFunc(l) {
      const g = this.width(), p = this.height(), b = this.cornerRadius();
      l.beginPath(), b ? r.Util.drawRoundedRectPath(l, g, p, b) : l.rect(0, 0, g, p), l.closePath(), l.fillStrokeShape(this);
    }
    getWidth() {
      var l, g;
      return (l = this.attrs.width) !== null && l !== void 0 ? l : (g = this.image()) === null || g === void 0 ? void 0 : g.width;
    }
    getHeight() {
      var l, g;
      return (l = this.attrs.height) !== null && l !== void 0 ? l : (g = this.image()) === null || g === void 0 ? void 0 : g.height;
    }
    static fromURL(l, g, p = null) {
      const b = r.Util.createImageElement();
      b.onload = function() {
        const w = new $0({
          image: b
        });
        g(w);
      }, b.onerror = p, b.crossOrigin = "Anonymous", b.src = l;
    }
  };
  return Mi.Image = s, s.prototype.className = "Image", (0, o._registerNode)(s), a.Factory.addGetterSetter(s, "cornerRadius", 0, (0, c.getNumberOrArrayOfNumbersValidator)(4)), a.Factory.addGetterSetter(s, "image"), a.Factory.addComponentsGetterSetter(s, "crop", ["x", "y", "width", "height"]), a.Factory.addGetterSetter(s, "cropX", 0, (0, c.getNumberValidator)()), a.Factory.addGetterSetter(s, "cropY", 0, (0, c.getNumberValidator)()), a.Factory.addGetterSetter(s, "cropWidth", 0, (0, c.getNumberValidator)()), a.Factory.addGetterSetter(s, "cropHeight", 0, (0, c.getNumberValidator)()), Mi;
}
var Mr = {}, vd;
function _6() {
  if (vd) return Mr;
  vd = 1, Object.defineProperty(Mr, "__esModule", { value: !0 }), Mr.Tag = Mr.Label = void 0;
  const r = Tt(), a = se(), n = Yh(), o = Ft(), c = Rt(), s = [
    "fontFamily",
    "fontSize",
    "fontStyle",
    "padding",
    "lineHeight",
    "text",
    "width",
    "height",
    "pointerDirection",
    "pointerWidth",
    "pointerHeight"
  ], h = "Change.konva", l = "none", g = "up", p = "right", b = "down", w = "left", x = s.length;
  let v = class extends n.Group {
    constructor(C) {
      super(C), this.on("add.konva", function(O) {
        this._addListeners(O.child), this._sync();
      });
    }
    getText() {
      return this.find("Text")[0];
    }
    getTag() {
      return this.find("Tag")[0];
    }
    _addListeners(C) {
      let O = this, d;
      const f = function() {
        O._sync();
      };
      for (d = 0; d < x; d++)
        C.on(s[d] + h, f);
    }
    getWidth() {
      return this.getText().width();
    }
    getHeight() {
      return this.getText().height();
    }
    _sync() {
      let C = this.getText(), O = this.getTag(), d, f, m, E, T, D, I;
      if (C && O) {
        switch (d = C.width(), f = C.height(), m = O.pointerDirection(), E = O.pointerWidth(), I = O.pointerHeight(), T = 0, D = 0, m) {
          case g:
            T = d / 2, D = -1 * I;
            break;
          case p:
            T = d + E, D = f / 2;
            break;
          case b:
            T = d / 2, D = f + I;
            break;
          case w:
            T = -1 * E, D = f / 2;
            break;
        }
        O.setAttrs({
          x: -1 * T,
          y: -1 * D,
          width: d,
          height: f
        }), C.setAttrs({
          x: -1 * T,
          y: -1 * D
        });
      }
    }
  };
  Mr.Label = v, v.prototype.className = "Label", (0, c._registerNode)(v);
  class _ extends a.Shape {
    _sceneFunc(C) {
      const O = this.width(), d = this.height(), f = this.pointerDirection(), m = this.pointerWidth(), E = this.pointerHeight(), T = this.cornerRadius();
      let D = 0, I = 0, L = 0, F = 0;
      typeof T == "number" ? D = I = L = F = Math.min(T, O / 2, d / 2) : (D = Math.min(T[0] || 0, O / 2, d / 2), I = Math.min(T[1] || 0, O / 2, d / 2), F = Math.min(T[2] || 0, O / 2, d / 2), L = Math.min(T[3] || 0, O / 2, d / 2)), C.beginPath(), C.moveTo(D, 0), f === g && (C.lineTo((O - m) / 2, 0), C.lineTo(O / 2, -1 * E), C.lineTo((O + m) / 2, 0)), C.lineTo(O - I, 0), C.arc(O - I, I, I, Math.PI * 3 / 2, 0, !1), f === p && (C.lineTo(O, (d - E) / 2), C.lineTo(O + m, d / 2), C.lineTo(O, (d + E) / 2)), C.lineTo(O, d - F), C.arc(O - F, d - F, F, 0, Math.PI / 2, !1), f === b && (C.lineTo((O + m) / 2, d), C.lineTo(O / 2, d + E), C.lineTo((O - m) / 2, d)), C.lineTo(L, d), C.arc(L, d - L, L, Math.PI / 2, Math.PI, !1), f === w && (C.lineTo(0, (d + E) / 2), C.lineTo(-1 * m, d / 2), C.lineTo(0, (d - E) / 2)), C.lineTo(0, D), C.arc(D, D, D, Math.PI, Math.PI * 3 / 2, !1), C.closePath(), C.fillStrokeShape(this);
    }
    getSelfRect() {
      let C = 0, O = 0, d = this.pointerWidth(), f = this.pointerHeight(), m = this.pointerDirection(), E = this.width(), T = this.height();
      return m === g ? (O -= f, T += f) : m === b ? T += f : m === w ? (C -= d * 1.5, E += d) : m === p && (E += d * 1.5), {
        x: C,
        y: O,
        width: E,
        height: T
      };
    }
  }
  return Mr.Tag = _, _.prototype.className = "Tag", (0, c._registerNode)(_), r.Factory.addGetterSetter(_, "pointerDirection", l), r.Factory.addGetterSetter(_, "pointerWidth", 0, (0, o.getNumberValidator)()), r.Factory.addGetterSetter(_, "pointerHeight", 0, (0, o.getNumberValidator)()), r.Factory.addGetterSetter(_, "cornerRadius", 0, (0, o.getNumberOrArrayOfNumbersValidator)(4)), Mr;
}
var Ni = {}, yd;
function Z0() {
  if (yd) return Ni;
  yd = 1, Object.defineProperty(Ni, "__esModule", { value: !0 }), Ni.Rect = void 0;
  const r = Tt(), a = se(), n = Rt(), o = Kt(), c = Ft();
  let s = class extends a.Shape {
    _sceneFunc(l) {
      const g = this.cornerRadius(), p = this.width(), b = this.height();
      l.beginPath(), g ? o.Util.drawRoundedRectPath(l, p, b, g) : l.rect(0, 0, p, b), l.closePath(), l.fillStrokeShape(this);
    }
  };
  return Ni.Rect = s, s.prototype.className = "Rect", (0, n._registerNode)(s), r.Factory.addGetterSetter(s, "cornerRadius", 0, (0, c.getNumberOrArrayOfNumbersValidator)(4)), Ni;
}
var Gi = {}, md;
function v6() {
  if (md) return Gi;
  md = 1, Object.defineProperty(Gi, "__esModule", { value: !0 }), Gi.RegularPolygon = void 0;
  const r = Tt(), a = se(), n = Ft(), o = Rt();
  let c = class extends a.Shape {
    _sceneFunc(h) {
      const l = this._getPoints();
      h.beginPath(), h.moveTo(l[0].x, l[0].y);
      for (let g = 1; g < l.length; g++)
        h.lineTo(l[g].x, l[g].y);
      h.closePath(), h.fillStrokeShape(this);
    }
    _getPoints() {
      const h = this.attrs.sides, l = this.attrs.radius || 0, g = [];
      for (let p = 0; p < h; p++)
        g.push({
          x: l * Math.sin(p * 2 * Math.PI / h),
          y: -1 * l * Math.cos(p * 2 * Math.PI / h)
        });
      return g;
    }
    getSelfRect() {
      const h = this._getPoints();
      let l = h[0].x, g = h[0].y, p = h[0].x, b = h[0].y;
      return h.forEach((w) => {
        l = Math.min(l, w.x), g = Math.max(g, w.x), p = Math.min(p, w.y), b = Math.max(b, w.y);
      }), {
        x: l,
        y: p,
        width: g - l,
        height: b - p
      };
    }
    getWidth() {
      return this.radius() * 2;
    }
    getHeight() {
      return this.radius() * 2;
    }
    setWidth(h) {
      this.radius(h / 2);
    }
    setHeight(h) {
      this.radius(h / 2);
    }
  };
  return Gi.RegularPolygon = c, c.prototype.className = "RegularPolygon", c.prototype._centroid = !0, c.prototype._attrsAffectingSize = ["radius"], (0, o._registerNode)(c), r.Factory.addGetterSetter(c, "radius", 0, (0, n.getNumberValidator)()), r.Factory.addGetterSetter(c, "sides", 0, (0, n.getNumberValidator)()), Gi;
}
var Di = {}, bd;
function y6() {
  if (bd) return Di;
  bd = 1, Object.defineProperty(Di, "__esModule", { value: !0 }), Di.Ring = void 0;
  const r = Tt(), a = se(), n = Ft(), o = Rt(), c = Math.PI * 2;
  let s = class extends a.Shape {
    _sceneFunc(l) {
      l.beginPath(), l.arc(0, 0, this.innerRadius(), 0, c, !1), l.moveTo(this.outerRadius(), 0), l.arc(0, 0, this.outerRadius(), c, 0, !0), l.closePath(), l.fillStrokeShape(this);
    }
    getWidth() {
      return this.outerRadius() * 2;
    }
    getHeight() {
      return this.outerRadius() * 2;
    }
    setWidth(l) {
      this.outerRadius(l / 2);
    }
    setHeight(l) {
      this.outerRadius(l / 2);
    }
  };
  return Di.Ring = s, s.prototype.className = "Ring", s.prototype._centroid = !0, s.prototype._attrsAffectingSize = ["innerRadius", "outerRadius"], (0, o._registerNode)(s), r.Factory.addGetterSetter(s, "innerRadius", 0, (0, n.getNumberValidator)()), r.Factory.addGetterSetter(s, "outerRadius", 0, (0, n.getNumberValidator)()), Di;
}
var Bi = {}, wd;
function m6() {
  if (wd) return Bi;
  wd = 1, Object.defineProperty(Bi, "__esModule", { value: !0 }), Bi.Sprite = void 0;
  const r = Tt(), a = se(), n = Xh(), o = Ft(), c = Rt();
  let s = class extends a.Shape {
    constructor(l) {
      super(l), this._updated = !0, this.anim = new n.Animation(() => {
        const g = this._updated;
        return this._updated = !1, g;
      }), this.on("animationChange.konva", function() {
        this.frameIndex(0);
      }), this.on("frameIndexChange.konva", function() {
        this._updated = !0;
      }), this.on("frameRateChange.konva", function() {
        this.anim.isRunning() && (clearInterval(this.interval), this._setInterval());
      });
    }
    _sceneFunc(l) {
      const g = this.animation(), p = this.frameIndex(), b = p * 4, w = this.animations()[g], x = this.frameOffsets(), v = w[b + 0], _ = w[b + 1], S = w[b + 2], C = w[b + 3], O = this.image();
      if ((this.hasFill() || this.hasStroke()) && (l.beginPath(), l.rect(0, 0, S, C), l.closePath(), l.fillStrokeShape(this)), O)
        if (x) {
          const d = x[g], f = p * 2;
          l.drawImage(O, v, _, S, C, d[f + 0], d[f + 1], S, C);
        } else
          l.drawImage(O, v, _, S, C, 0, 0, S, C);
    }
    _hitFunc(l) {
      const g = this.animation(), p = this.frameIndex(), b = p * 4, w = this.animations()[g], x = this.frameOffsets(), v = w[b + 2], _ = w[b + 3];
      if (l.beginPath(), x) {
        const S = x[g], C = p * 2;
        l.rect(S[C + 0], S[C + 1], v, _);
      } else
        l.rect(0, 0, v, _);
      l.closePath(), l.fillShape(this);
    }
    _useBufferCanvas() {
      return super._useBufferCanvas(!0);
    }
    _setInterval() {
      const l = this;
      this.interval = setInterval(function() {
        l._updateIndex();
      }, 1e3 / this.frameRate());
    }
    start() {
      if (this.isRunning())
        return;
      const l = this.getLayer();
      this.anim.setLayers(l), this._setInterval(), this.anim.start();
    }
    stop() {
      this.anim.stop(), clearInterval(this.interval);
    }
    isRunning() {
      return this.anim.isRunning();
    }
    _updateIndex() {
      const l = this.frameIndex(), g = this.animation(), p = this.animations(), b = p[g], w = b.length / 4;
      l < w - 1 ? this.frameIndex(l + 1) : this.frameIndex(0);
    }
  };
  return Bi.Sprite = s, s.prototype.className = "Sprite", (0, c._registerNode)(s), r.Factory.addGetterSetter(s, "animation"), r.Factory.addGetterSetter(s, "animations"), r.Factory.addGetterSetter(s, "frameOffsets"), r.Factory.addGetterSetter(s, "image"), r.Factory.addGetterSetter(s, "frameIndex", 0, (0, o.getNumberValidator)()), r.Factory.addGetterSetter(s, "frameRate", 17, (0, o.getNumberValidator)()), r.Factory.backCompat(s, {
    index: "frameIndex",
    getIndex: "getFrameIndex",
    setIndex: "setFrameIndex"
  }), Bi;
}
var Ui = {}, Sd;
function b6() {
  if (Sd) return Ui;
  Sd = 1, Object.defineProperty(Ui, "__esModule", { value: !0 }), Ui.Star = void 0;
  const r = Tt(), a = se(), n = Ft(), o = Rt();
  let c = class extends a.Shape {
    _sceneFunc(h) {
      const l = this.innerRadius(), g = this.outerRadius(), p = this.numPoints();
      h.beginPath(), h.moveTo(0, 0 - g);
      for (let b = 1; b < p * 2; b++) {
        const w = b % 2 === 0 ? g : l, x = w * Math.sin(b * Math.PI / p), v = -1 * w * Math.cos(b * Math.PI / p);
        h.lineTo(x, v);
      }
      h.closePath(), h.fillStrokeShape(this);
    }
    getWidth() {
      return this.outerRadius() * 2;
    }
    getHeight() {
      return this.outerRadius() * 2;
    }
    setWidth(h) {
      this.outerRadius(h / 2);
    }
    setHeight(h) {
      this.outerRadius(h / 2);
    }
  };
  return Ui.Star = c, c.prototype.className = "Star", c.prototype._centroid = !0, c.prototype._attrsAffectingSize = ["innerRadius", "outerRadius"], (0, o._registerNode)(c), r.Factory.addGetterSetter(c, "numPoints", 5, (0, n.getNumberValidator)()), r.Factory.addGetterSetter(c, "innerRadius", 0, (0, n.getNumberValidator)()), r.Factory.addGetterSetter(c, "outerRadius", 0, (0, n.getNumberValidator)()), Ui;
}
var Qr = {}, Cd;
function J0() {
  if (Cd) return Qr;
  Cd = 1, Object.defineProperty(Qr, "__esModule", { value: !0 }), Qr.Text = void 0, Qr.stringToArray = h;
  const r = Kt(), a = Tt(), n = se(), o = Rt(), c = Ft(), s = Rt();
  function h(st) {
    return [...st].reduce((Z, at, ht, ct) => (/\p{Emoji_Modifier_Base}\p{Emoji_Modifier}?(?:\u200D\p{Emoji_Presentation})+/u.test(at) ? Z.push(at) : /\p{Regional_Indicator}{2}/u.test(at + (ct[ht + 1] || "")) ? Z.push(at + ct[ht + 1]) : ht > 0 && /\p{Mn}|\p{Me}|\p{Mc}/u.test(at) ? Z[Z.length - 1] += at : Z.push(at), Z), []);
  }
  const l = "auto", g = "center", p = "inherit", b = "justify", w = "Change.konva", x = "2d", v = "-", _ = "left", S = "text", C = "Text", O = "top", d = "bottom", f = "middle", m = "normal", E = "px ", T = " ", D = "right", I = "rtl", L = "word", F = "char", N = "none", H = "…", y = [
    "direction",
    "fontFamily",
    "fontSize",
    "fontStyle",
    "fontVariant",
    "padding",
    "align",
    "verticalAlign",
    "lineHeight",
    "text",
    "width",
    "height",
    "wrap",
    "ellipsis",
    "letterSpacing"
  ], P = y.length;
  function A(st) {
    return st.split(",").map((Z) => {
      Z = Z.trim();
      const at = Z.indexOf(" ") >= 0, ht = Z.indexOf('"') >= 0 || Z.indexOf("'") >= 0;
      return at && !ht && (Z = `"${Z}"`), Z;
    }).join(", ");
  }
  let G;
  function U() {
    return G || (G = r.Util.createCanvasElement().getContext(x), G);
  }
  function K(st) {
    st.fillText(this._partialText, this._partialTextX, this._partialTextY);
  }
  function $(st) {
    st.setAttr("miterLimit", 2), st.strokeText(this._partialText, this._partialTextX, this._partialTextY);
  }
  function X(st) {
    return st = st || {}, !st.fillLinearGradientColorStops && !st.fillRadialGradientColorStops && !st.fillPatternImage && (st.fill = st.fill || "black"), st;
  }
  let Q = class extends n.Shape {
    constructor(Z) {
      super(X(Z)), this._partialTextX = 0, this._partialTextY = 0;
      for (let at = 0; at < P; at++)
        this.on(y[at] + w, this._setTextData);
      this._setTextData();
    }
    _sceneFunc(Z) {
      const at = this.textArr, ht = at.length;
      if (!this.text())
        return;
      let ct = this.padding(), V = this.fontSize(), j = this.lineHeight() * V, et = this.verticalAlign(), ut = this.direction(), ft = 0, gt = this.align(), Lt = this.getWidth(), Et = this.letterSpacing(), mt = this.fill(), ee = this.textDecoration(), Pt = ee.indexOf("underline") !== -1, Vt = ee.indexOf("line-through") !== -1, gr;
      ut = ut === p ? Z.direction : ut;
      let re = j / 2, Zt = f;
      if (o.Konva._fixTextRendering) {
        const $e = this.measureSize("M");
        Zt = "alphabetic", re = ($e.fontBoundingBoxAscent - $e.fontBoundingBoxDescent) / 2 + j / 2;
      }
      var Jt = 0, Ut = 0;
      for (ut === I && Z.setAttr("direction", ut), Z.setAttr("font", this._getContextFont()), Z.setAttr("textBaseline", Zt), Z.setAttr("textAlign", _), et === f ? ft = (this.getHeight() - ht * j - ct * 2) / 2 : et === d && (ft = this.getHeight() - ht * j - ct * 2), Z.translate(ct, ft + ct), gr = 0; gr < ht; gr++) {
        var Jt = 0, Ut = 0, qe = at[gr], ie = qe.text, He = qe.width, zt = qe.lastInParagraph, ne, Pe, pe;
        if (Z.save(), gt === D ? Jt += Lt - He - ct * 2 : gt === g && (Jt += (Lt - He - ct * 2) / 2), Pt) {
          Z.save(), Z.beginPath();
          const Ve = o.Konva._fixTextRendering ? Math.round(V / 4) : Math.round(V / 2), Oe = Jt, Ze = re + Ut + Ve;
          Z.moveTo(Oe, Ze), ne = ie.split(" ").length - 1, Pe = ne === 0, pe = gt === b && !zt ? Lt - ct * 2 : He, Z.lineTo(Oe + Math.round(pe), Ze), Z.lineWidth = V / 15;
          const ai = this._getLinearGradient();
          Z.strokeStyle = ai || mt, Z.stroke(), Z.restore();
        }
        if (Vt) {
          Z.save(), Z.beginPath();
          const Ve = o.Konva._fixTextRendering ? -Math.round(V / 4) : 0;
          Z.moveTo(Jt, re + Ut + Ve), ne = ie.split(" ").length - 1, Pe = ne === 0, pe = gt === b && zt && !Pe ? Lt - ct * 2 : He, Z.lineTo(Jt + Math.round(pe), re + Ut + Ve), Z.lineWidth = V / 15;
          const Oe = this._getLinearGradient();
          Z.strokeStyle = Oe || mt, Z.stroke(), Z.restore();
        }
        if (ut !== I && (Et !== 0 || gt === b)) {
          ne = ie.split(" ").length - 1;
          const Ve = h(ie);
          for (let Oe = 0; Oe < Ve.length; Oe++) {
            const Ze = Ve[Oe];
            Ze === " " && !zt && gt === b && (Jt += (Lt - ct * 2 - He) / ne), this._partialTextX = Jt, this._partialTextY = re + Ut, this._partialText = Ze, Z.fillStrokeShape(this), Jt += this.measureSize(Ze).width + Et;
          }
        } else
          Et !== 0 && Z.setAttr("letterSpacing", `${Et}px`), this._partialTextX = Jt, this._partialTextY = re + Ut, this._partialText = ie, Z.fillStrokeShape(this);
        Z.restore(), ht > 1 && (re += j);
      }
    }
    _hitFunc(Z) {
      const at = this.getWidth(), ht = this.getHeight();
      Z.beginPath(), Z.rect(0, 0, at, ht), Z.closePath(), Z.fillStrokeShape(this);
    }
    setText(Z) {
      const at = r.Util._isString(Z) ? Z : Z == null ? "" : Z + "";
      return this._setAttr(S, at), this;
    }
    getWidth() {
      return this.attrs.width === l || this.attrs.width === void 0 ? this.getTextWidth() + this.padding() * 2 : this.attrs.width;
    }
    getHeight() {
      return this.attrs.height === l || this.attrs.height === void 0 ? this.fontSize() * this.textArr.length * this.lineHeight() + this.padding() * 2 : this.attrs.height;
    }
    getTextWidth() {
      return this.textWidth;
    }
    getTextHeight() {
      return r.Util.warn("text.getTextHeight() method is deprecated. Use text.height() - for full height and text.fontSize() - for one line height."), this.textHeight;
    }
    measureSize(Z) {
      var at, ht, ct, V, j, et, ut, ft, gt, Lt, Et;
      let mt = U(), ee = this.fontSize(), Pt;
      mt.save(), mt.font = this._getContextFont(), Pt = mt.measureText(Z), mt.restore();
      const Vt = ee / 100;
      return {
        actualBoundingBoxAscent: (at = Pt.actualBoundingBoxAscent) !== null && at !== void 0 ? at : 71.58203125 * Vt,
        actualBoundingBoxDescent: (ht = Pt.actualBoundingBoxDescent) !== null && ht !== void 0 ? ht : 0,
        actualBoundingBoxLeft: (ct = Pt.actualBoundingBoxLeft) !== null && ct !== void 0 ? ct : -7.421875 * Vt,
        actualBoundingBoxRight: (V = Pt.actualBoundingBoxRight) !== null && V !== void 0 ? V : 75.732421875 * Vt,
        alphabeticBaseline: (j = Pt.alphabeticBaseline) !== null && j !== void 0 ? j : 0,
        emHeightAscent: (et = Pt.emHeightAscent) !== null && et !== void 0 ? et : 100 * Vt,
        emHeightDescent: (ut = Pt.emHeightDescent) !== null && ut !== void 0 ? ut : -20 * Vt,
        fontBoundingBoxAscent: (ft = Pt.fontBoundingBoxAscent) !== null && ft !== void 0 ? ft : 91 * Vt,
        fontBoundingBoxDescent: (gt = Pt.fontBoundingBoxDescent) !== null && gt !== void 0 ? gt : 21 * Vt,
        hangingBaseline: (Lt = Pt.hangingBaseline) !== null && Lt !== void 0 ? Lt : 72.80000305175781 * Vt,
        ideographicBaseline: (Et = Pt.ideographicBaseline) !== null && Et !== void 0 ? Et : -21 * Vt,
        width: Pt.width,
        height: ee
      };
    }
    _getContextFont() {
      return this.fontStyle() + T + this.fontVariant() + T + (this.fontSize() + E) + A(this.fontFamily());
    }
    _addTextLine(Z) {
      this.align() === b && (Z = Z.trim());
      const ht = this._getTextWidth(Z);
      return this.textArr.push({
        text: Z,
        width: ht,
        lastInParagraph: !1
      });
    }
    _getTextWidth(Z) {
      const at = this.letterSpacing(), ht = Z.length;
      return U().measureText(Z).width + (ht ? at * (ht - 1) : 0);
    }
    _setTextData() {
      let Z = this.text().split(`
`), at = +this.fontSize(), ht = 0, ct = this.lineHeight() * at, V = this.attrs.width, j = this.attrs.height, et = V !== l && V !== void 0, ut = j !== l && j !== void 0, ft = this.padding(), gt = V - ft * 2, Lt = j - ft * 2, Et = 0, mt = this.wrap(), ee = mt !== N, Pt = mt !== F && ee, Vt = this.ellipsis();
      this.textArr = [], U().font = this._getContextFont();
      const gr = Vt ? this._getTextWidth(H) : 0;
      for (let Zt = 0, Jt = Z.length; Zt < Jt; ++Zt) {
        let Ut = Z[Zt], qe = this._getTextWidth(Ut);
        if (et && qe > gt)
          for (; Ut.length > 0; ) {
            let ie = 0, He = Ut.length, zt = "", ne = 0;
            for (; ie < He; ) {
              const Pe = ie + He >>> 1, pe = Ut.slice(0, Pe + 1), $e = this._getTextWidth(pe) + gr;
              $e <= gt ? (ie = Pe + 1, zt = pe, ne = $e) : He = Pe;
            }
            if (zt) {
              if (Pt) {
                var re;
                const pe = Ut[zt.length];
                (pe === T || pe === v) && ne <= gt ? re = zt.length : re = Math.max(zt.lastIndexOf(T), zt.lastIndexOf(v)) + 1, re > 0 && (ie = re, zt = zt.slice(0, ie), ne = this._getTextWidth(zt));
              }
              if (zt = zt.trimRight(), this._addTextLine(zt), ht = Math.max(ht, ne), Et += ct, this._shouldHandleEllipsis(Et)) {
                this._tryToAddEllipsisToLastLine();
                break;
              }
              if (Ut = Ut.slice(ie), Ut = Ut.trimLeft(), Ut.length > 0 && (qe = this._getTextWidth(Ut), qe <= gt)) {
                this._addTextLine(Ut), Et += ct, ht = Math.max(ht, qe);
                break;
              }
            } else
              break;
          }
        else
          this._addTextLine(Ut), Et += ct, ht = Math.max(ht, qe), this._shouldHandleEllipsis(Et) && Zt < Jt - 1 && this._tryToAddEllipsisToLastLine();
        if (this.textArr[this.textArr.length - 1] && (this.textArr[this.textArr.length - 1].lastInParagraph = !0), ut && Et + ct > Lt)
          break;
      }
      this.textHeight = at, this.textWidth = ht;
    }
    _shouldHandleEllipsis(Z) {
      const at = +this.fontSize(), ht = this.lineHeight() * at, ct = this.attrs.height, V = ct !== l && ct !== void 0, j = this.padding(), et = ct - j * 2;
      return !(this.wrap() !== N) || V && Z + ht > et;
    }
    _tryToAddEllipsisToLastLine() {
      const Z = this.attrs.width, at = Z !== l && Z !== void 0, ht = this.padding(), ct = Z - ht * 2, V = this.ellipsis(), j = this.textArr[this.textArr.length - 1];
      !j || !V || (at && (this._getTextWidth(j.text + H) < ct || (j.text = j.text.slice(0, j.text.length - 3))), this.textArr.splice(this.textArr.length - 1, 1), this._addTextLine(j.text + H));
    }
    getStrokeScaleEnabled() {
      return !0;
    }
    _useBufferCanvas() {
      const Z = this.textDecoration().indexOf("underline") !== -1 || this.textDecoration().indexOf("line-through") !== -1, at = this.hasShadow();
      return Z && at ? !0 : super._useBufferCanvas();
    }
  };
  return Qr.Text = Q, Q.prototype._fillFunc = K, Q.prototype._strokeFunc = $, Q.prototype.className = C, Q.prototype._attrsAffectingSize = [
    "text",
    "fontSize",
    "padding",
    "wrap",
    "lineHeight",
    "letterSpacing"
  ], (0, s._registerNode)(Q), a.Factory.overWriteSetter(Q, "width", (0, c.getNumberOrAutoValidator)()), a.Factory.overWriteSetter(Q, "height", (0, c.getNumberOrAutoValidator)()), a.Factory.addGetterSetter(Q, "direction", p), a.Factory.addGetterSetter(Q, "fontFamily", "Arial"), a.Factory.addGetterSetter(Q, "fontSize", 12, (0, c.getNumberValidator)()), a.Factory.addGetterSetter(Q, "fontStyle", m), a.Factory.addGetterSetter(Q, "fontVariant", m), a.Factory.addGetterSetter(Q, "padding", 0, (0, c.getNumberValidator)()), a.Factory.addGetterSetter(Q, "align", _), a.Factory.addGetterSetter(Q, "verticalAlign", O), a.Factory.addGetterSetter(Q, "lineHeight", 1, (0, c.getNumberValidator)()), a.Factory.addGetterSetter(Q, "wrap", L), a.Factory.addGetterSetter(Q, "ellipsis", !1, (0, c.getBooleanValidator)()), a.Factory.addGetterSetter(Q, "letterSpacing", 0, (0, c.getNumberValidator)()), a.Factory.addGetterSetter(Q, "text", "", (0, c.getStringValidator)()), a.Factory.addGetterSetter(Q, "textDecoration", ""), Qr;
}
var qi = {}, xd;
function w6() {
  if (xd) return qi;
  xd = 1, Object.defineProperty(qi, "__esModule", { value: !0 }), qi.TextPath = void 0;
  const r = Kt(), a = Tt(), n = se(), o = $h(), c = J0(), s = Ft(), h = Rt(), l = "", g = "normal";
  function p(x) {
    x.fillText(this.partialText, 0, 0);
  }
  function b(x) {
    x.strokeText(this.partialText, 0, 0);
  }
  let w = class extends n.Shape {
    constructor(v) {
      super(v), this.dummyCanvas = r.Util.createCanvasElement(), this.dataArray = [], this._readDataAttribute(), this.on("dataChange.konva", function() {
        this._readDataAttribute(), this._setTextData();
      }), this.on("textChange.konva alignChange.konva letterSpacingChange.konva kerningFuncChange.konva fontSizeChange.konva fontFamilyChange.konva", this._setTextData), this._setTextData();
    }
    _getTextPathLength() {
      return o.Path.getPathLength(this.dataArray);
    }
    _getPointAtLength(v) {
      if (!this.attrs.data)
        return null;
      const _ = this.pathLength;
      return v - 1 > _ ? null : o.Path.getPointAtLengthOfDataArray(v, this.dataArray);
    }
    _readDataAttribute() {
      this.dataArray = o.Path.parsePathData(this.attrs.data), this.pathLength = this._getTextPathLength();
    }
    _sceneFunc(v) {
      v.setAttr("font", this._getContextFont()), v.setAttr("textBaseline", this.textBaseline()), v.setAttr("textAlign", "left"), v.save();
      const _ = this.textDecoration(), S = this.fill(), C = this.fontSize(), O = this.glyphInfo;
      _ === "underline" && v.beginPath();
      for (let d = 0; d < O.length; d++) {
        v.save();
        const f = O[d].p0;
        v.translate(f.x, f.y), v.rotate(O[d].rotation), this.partialText = O[d].text, v.fillStrokeShape(this), _ === "underline" && (d === 0 && v.moveTo(0, C / 2 + 1), v.lineTo(C, C / 2 + 1)), v.restore();
      }
      _ === "underline" && (v.strokeStyle = S, v.lineWidth = C / 20, v.stroke()), v.restore();
    }
    _hitFunc(v) {
      v.beginPath();
      const _ = this.glyphInfo;
      if (_.length >= 1) {
        const S = _[0].p0;
        v.moveTo(S.x, S.y);
      }
      for (let S = 0; S < _.length; S++) {
        const C = _[S].p1;
        v.lineTo(C.x, C.y);
      }
      v.setAttr("lineWidth", this.fontSize()), v.setAttr("strokeStyle", this.colorKey), v.stroke();
    }
    getTextWidth() {
      return this.textWidth;
    }
    getTextHeight() {
      return r.Util.warn("text.getTextHeight() method is deprecated. Use text.height() - for full height and text.fontSize() - for one line height."), this.textHeight;
    }
    setText(v) {
      return c.Text.prototype.setText.call(this, v);
    }
    _getContextFont() {
      return c.Text.prototype._getContextFont.call(this);
    }
    _getTextSize(v) {
      const S = this.dummyCanvas.getContext("2d");
      S.save(), S.font = this._getContextFont();
      const C = S.measureText(v);
      return S.restore(), {
        width: C.width,
        height: parseInt(`${this.fontSize()}`, 10)
      };
    }
    _setTextData() {
      const { width: v, height: _ } = this._getTextSize(this.attrs.text);
      if (this.textWidth = v, this.textHeight = _, this.glyphInfo = [], !this.attrs.data)
        return null;
      const S = this.letterSpacing(), C = this.align(), O = this.kerningFunc(), d = Math.max(this.textWidth + ((this.attrs.text || "").length - 1) * S, 0);
      let f = 0;
      C === "center" && (f = Math.max(0, this.pathLength / 2 - d / 2)), C === "right" && (f = Math.max(0, this.pathLength - d));
      const m = (0, c.stringToArray)(this.text());
      let E = f;
      for (let T = 0; T < m.length; T++) {
        const D = this._getPointAtLength(E);
        if (!D)
          return;
        let I = this._getTextSize(m[T]).width + S;
        if (m[T] === " " && C === "justify") {
          const P = this.text().split(" ").length - 1;
          I += (this.pathLength - d) / P;
        }
        const L = this._getPointAtLength(E + I);
        if (!L)
          return;
        const F = o.Path.getLineLength(D.x, D.y, L.x, L.y);
        let N = 0;
        if (O)
          try {
            N = O(m[T - 1], m[T]) * this.fontSize();
          } catch {
            N = 0;
          }
        D.x += N, L.x += N, this.textWidth += N;
        const H = o.Path.getPointOnLine(N + F / 2, D.x, D.y, L.x, L.y), y = Math.atan2(L.y - D.y, L.x - D.x);
        this.glyphInfo.push({
          transposeX: H.x,
          transposeY: H.y,
          text: m[T],
          rotation: y,
          p0: D,
          p1: L
        }), E += I;
      }
    }
    getSelfRect() {
      if (!this.glyphInfo.length)
        return {
          x: 0,
          y: 0,
          width: 0,
          height: 0
        };
      const v = [];
      this.glyphInfo.forEach(function(E) {
        v.push(E.p0.x), v.push(E.p0.y), v.push(E.p1.x), v.push(E.p1.y);
      });
      let _ = v[0] || 0, S = v[0] || 0, C = v[1] || 0, O = v[1] || 0, d, f;
      for (let E = 0; E < v.length / 2; E++)
        d = v[E * 2], f = v[E * 2 + 1], _ = Math.min(_, d), S = Math.max(S, d), C = Math.min(C, f), O = Math.max(O, f);
      const m = this.fontSize();
      return {
        x: _ - m / 2,
        y: C - m / 2,
        width: S - _ + m,
        height: O - C + m
      };
    }
    destroy() {
      return r.Util.releaseCanvas(this.dummyCanvas), super.destroy();
    }
  };
  return qi.TextPath = w, w.prototype._fillFunc = p, w.prototype._strokeFunc = b, w.prototype._fillFuncHit = p, w.prototype._strokeFuncHit = b, w.prototype.className = "TextPath", w.prototype._attrsAffectingSize = ["text", "fontSize", "data"], (0, h._registerNode)(w), a.Factory.addGetterSetter(w, "data"), a.Factory.addGetterSetter(w, "fontFamily", "Arial"), a.Factory.addGetterSetter(w, "fontSize", 12, (0, s.getNumberValidator)()), a.Factory.addGetterSetter(w, "fontStyle", g), a.Factory.addGetterSetter(w, "align", "left"), a.Factory.addGetterSetter(w, "letterSpacing", 0, (0, s.getNumberValidator)()), a.Factory.addGetterSetter(w, "textBaseline", "middle"), a.Factory.addGetterSetter(w, "fontVariant", g), a.Factory.addGetterSetter(w, "text", l), a.Factory.addGetterSetter(w, "textDecoration", null), a.Factory.addGetterSetter(w, "kerningFunc", null), qi;
}
var Hi = {}, Ed;
function S6() {
  if (Ed) return Hi;
  Ed = 1, Object.defineProperty(Hi, "__esModule", { value: !0 }), Hi.Transformer = void 0;
  const r = Kt(), a = Tt(), n = $t(), o = se(), c = Z0(), s = Yh(), h = Rt(), l = Ft(), g = Rt(), p = "tr-konva", b = [
    "resizeEnabledChange",
    "rotateAnchorOffsetChange",
    "rotateEnabledChange",
    "enabledAnchorsChange",
    "anchorSizeChange",
    "borderEnabledChange",
    "borderStrokeChange",
    "borderStrokeWidthChange",
    "borderDashChange",
    "anchorStrokeChange",
    "anchorStrokeWidthChange",
    "anchorFillChange",
    "anchorCornerRadiusChange",
    "ignoreStrokeChange",
    "anchorStyleFuncChange"
  ].map((I) => I + `.${p}`).join(" "), w = "nodesRect", x = [
    "widthChange",
    "heightChange",
    "scaleXChange",
    "scaleYChange",
    "skewXChange",
    "skewYChange",
    "rotationChange",
    "offsetXChange",
    "offsetYChange",
    "transformsEnabledChange",
    "strokeWidthChange"
  ], v = {
    "top-left": -45,
    "top-center": 0,
    "top-right": 45,
    "middle-right": -90,
    "middle-left": 90,
    "bottom-left": -135,
    "bottom-center": 180,
    "bottom-right": 135
  }, _ = "ontouchstart" in h.Konva._global;
  function S(I, L, F) {
    if (I === "rotater")
      return F;
    L += r.Util.degToRad(v[I] || 0);
    const N = (r.Util.radToDeg(L) % 360 + 360) % 360;
    return r.Util._inRange(N, 315 + 22.5, 360) || r.Util._inRange(N, 0, 22.5) ? "ns-resize" : r.Util._inRange(N, 45 - 22.5, 45 + 22.5) ? "nesw-resize" : r.Util._inRange(N, 90 - 22.5, 90 + 22.5) ? "ew-resize" : r.Util._inRange(N, 135 - 22.5, 135 + 22.5) ? "nwse-resize" : r.Util._inRange(N, 180 - 22.5, 180 + 22.5) ? "ns-resize" : r.Util._inRange(N, 225 - 22.5, 225 + 22.5) ? "nesw-resize" : r.Util._inRange(N, 270 - 22.5, 270 + 22.5) ? "ew-resize" : r.Util._inRange(N, 315 - 22.5, 315 + 22.5) ? "nwse-resize" : (r.Util.error("Transformer has unknown angle for cursor detection: " + N), "pointer");
  }
  const C = [
    "top-left",
    "top-center",
    "top-right",
    "middle-right",
    "middle-left",
    "bottom-left",
    "bottom-center",
    "bottom-right"
  ];
  function O(I) {
    return {
      x: I.x + I.width / 2 * Math.cos(I.rotation) + I.height / 2 * Math.sin(-I.rotation),
      y: I.y + I.height / 2 * Math.cos(I.rotation) + I.width / 2 * Math.sin(I.rotation)
    };
  }
  function d(I, L, F) {
    const N = F.x + (I.x - F.x) * Math.cos(L) - (I.y - F.y) * Math.sin(L), H = F.y + (I.x - F.x) * Math.sin(L) + (I.y - F.y) * Math.cos(L);
    return {
      ...I,
      rotation: I.rotation + L,
      x: N,
      y: H
    };
  }
  function f(I, L) {
    const F = O(I);
    return d(I, L, F);
  }
  function m(I, L, F) {
    let N = L;
    for (let H = 0; H < I.length; H++) {
      const y = h.Konva.getAngle(I[H]), P = Math.abs(y - L) % (Math.PI * 2);
      Math.min(P, Math.PI * 2 - P) < F && (N = y);
    }
    return N;
  }
  let E = 0, T = class extends s.Group {
    constructor(L) {
      super(L), this._movingAnchorName = null, this._transforming = !1, this._createElements(), this._handleMouseMove = this._handleMouseMove.bind(this), this._handleMouseUp = this._handleMouseUp.bind(this), this.update = this.update.bind(this), this.on(b, this.update), this.getNode() && this.update();
    }
    attachTo(L) {
      return this.setNode(L), this;
    }
    setNode(L) {
      return r.Util.warn("tr.setNode(shape), tr.node(shape) and tr.attachTo(shape) methods are deprecated. Please use tr.nodes(nodesArray) instead."), this.setNodes([L]);
    }
    getNode() {
      return this._nodes && this._nodes[0];
    }
    _getEventNamespace() {
      return p + this._id;
    }
    setNodes(L = []) {
      this._nodes && this._nodes.length && this.detach();
      const F = L.filter((H) => H.isAncestorOf(this) ? (r.Util.error("Konva.Transformer cannot be an a child of the node you are trying to attach"), !1) : !0);
      return this._nodes = L = F, L.length === 1 && this.useSingleNodeRotation() ? this.rotation(L[0].getAbsoluteRotation()) : this.rotation(0), this._nodes.forEach((H) => {
        const y = () => {
          this.nodes().length === 1 && this.useSingleNodeRotation() && this.rotation(this.nodes()[0].getAbsoluteRotation()), this._resetTransformCache(), !this._transforming && !this.isDragging() && this.update();
        }, P = H._attrsAffectingSize.map((A) => A + "Change." + this._getEventNamespace()).join(" ");
        H.on(P, y), H.on(x.map((A) => A + `.${this._getEventNamespace()}`).join(" "), y), H.on(`absoluteTransformChange.${this._getEventNamespace()}`, y), this._proxyDrag(H);
      }), this._resetTransformCache(), !!this.findOne(".top-left") && this.update(), this;
    }
    _proxyDrag(L) {
      let F;
      L.on(`dragstart.${this._getEventNamespace()}`, (N) => {
        F = L.getAbsolutePosition(), !this.isDragging() && L !== this.findOne(".back") && this.startDrag(N, !1);
      }), L.on(`dragmove.${this._getEventNamespace()}`, (N) => {
        if (!F)
          return;
        const H = L.getAbsolutePosition(), y = H.x - F.x, P = H.y - F.y;
        this.nodes().forEach((A) => {
          if (A === L || A.isDragging())
            return;
          const G = A.getAbsolutePosition();
          A.setAbsolutePosition({
            x: G.x + y,
            y: G.y + P
          }), A.startDrag(N);
        }), F = null;
      });
    }
    getNodes() {
      return this._nodes || [];
    }
    getActiveAnchor() {
      return this._movingAnchorName;
    }
    detach() {
      this._nodes && this._nodes.forEach((L) => {
        L.off("." + this._getEventNamespace());
      }), this._nodes = [], this._resetTransformCache();
    }
    _resetTransformCache() {
      this._clearCache(w), this._clearCache("transform"), this._clearSelfAndDescendantCache("absoluteTransform");
    }
    _getNodeRect() {
      return this._getCache(w, this.__getNodeRect);
    }
    __getNodeShape(L, F = this.rotation(), N) {
      const H = L.getClientRect({
        skipTransform: !0,
        skipShadow: !0,
        skipStroke: this.ignoreStroke()
      }), y = L.getAbsoluteScale(N), P = L.getAbsolutePosition(N), A = H.x * y.x - L.offsetX() * y.x, G = H.y * y.y - L.offsetY() * y.y, U = (h.Konva.getAngle(L.getAbsoluteRotation()) + Math.PI * 2) % (Math.PI * 2), K = {
        x: P.x + A * Math.cos(U) + G * Math.sin(-U),
        y: P.y + G * Math.cos(U) + A * Math.sin(U),
        width: H.width * y.x,
        height: H.height * y.y,
        rotation: U
      };
      return d(K, -h.Konva.getAngle(F), {
        x: 0,
        y: 0
      });
    }
    __getNodeRect() {
      if (!this.getNode())
        return {
          x: -1e8,
          y: -1e8,
          width: 0,
          height: 0,
          rotation: 0
        };
      const F = [];
      this.nodes().map((U) => {
        const K = U.getClientRect({
          skipTransform: !0,
          skipShadow: !0,
          skipStroke: this.ignoreStroke()
        }), $ = [
          { x: K.x, y: K.y },
          { x: K.x + K.width, y: K.y },
          { x: K.x + K.width, y: K.y + K.height },
          { x: K.x, y: K.y + K.height }
        ], X = U.getAbsoluteTransform();
        $.forEach(function(Q) {
          const st = X.point(Q);
          F.push(st);
        });
      });
      const N = new r.Transform();
      N.rotate(-h.Konva.getAngle(this.rotation()));
      let H = 1 / 0, y = 1 / 0, P = -1 / 0, A = -1 / 0;
      F.forEach(function(U) {
        const K = N.point(U);
        H === void 0 && (H = P = K.x, y = A = K.y), H = Math.min(H, K.x), y = Math.min(y, K.y), P = Math.max(P, K.x), A = Math.max(A, K.y);
      }), N.invert();
      const G = N.point({ x: H, y });
      return {
        x: G.x,
        y: G.y,
        width: P - H,
        height: A - y,
        rotation: h.Konva.getAngle(this.rotation())
      };
    }
    getX() {
      return this._getNodeRect().x;
    }
    getY() {
      return this._getNodeRect().y;
    }
    getWidth() {
      return this._getNodeRect().width;
    }
    getHeight() {
      return this._getNodeRect().height;
    }
    _createElements() {
      this._createBack(), C.forEach((L) => {
        this._createAnchor(L);
      }), this._createAnchor("rotater");
    }
    _createAnchor(L) {
      const F = new c.Rect({
        stroke: "rgb(0, 161, 255)",
        fill: "white",
        strokeWidth: 1,
        name: L + " _anchor",
        dragDistance: 0,
        draggable: !0,
        hitStrokeWidth: _ ? 10 : "auto"
      }), N = this;
      F.on("mousedown touchstart", function(H) {
        N._handleMouseDown(H);
      }), F.on("dragstart", (H) => {
        F.stopDrag(), H.cancelBubble = !0;
      }), F.on("dragend", (H) => {
        H.cancelBubble = !0;
      }), F.on("mouseenter", () => {
        const H = h.Konva.getAngle(this.rotation()), y = this.rotateAnchorCursor(), P = S(L, H, y);
        F.getStage().content && (F.getStage().content.style.cursor = P), this._cursorChange = !0;
      }), F.on("mouseout", () => {
        F.getStage().content && (F.getStage().content.style.cursor = ""), this._cursorChange = !1;
      }), this.add(F);
    }
    _createBack() {
      const L = new o.Shape({
        name: "back",
        width: 0,
        height: 0,
        draggable: !0,
        sceneFunc(F, N) {
          const H = N.getParent(), y = H.padding();
          F.beginPath(), F.rect(-y, -y, N.width() + y * 2, N.height() + y * 2), F.moveTo(N.width() / 2, -y), H.rotateEnabled() && H.rotateLineVisible() && F.lineTo(N.width() / 2, -H.rotateAnchorOffset() * r.Util._sign(N.height()) - y), F.fillStrokeShape(N);
        },
        hitFunc: (F, N) => {
          if (!this.shouldOverdrawWholeArea())
            return;
          const H = this.padding();
          F.beginPath(), F.rect(-H, -H, N.width() + H * 2, N.height() + H * 2), F.fillStrokeShape(N);
        }
      });
      this.add(L), this._proxyDrag(L), L.on("dragstart", (F) => {
        F.cancelBubble = !0;
      }), L.on("dragmove", (F) => {
        F.cancelBubble = !0;
      }), L.on("dragend", (F) => {
        F.cancelBubble = !0;
      }), this.on("dragmove", (F) => {
        this.update();
      });
    }
    _handleMouseDown(L) {
      if (this._transforming)
        return;
      this._movingAnchorName = L.target.name().split(" ")[0];
      const F = this._getNodeRect(), N = F.width, H = F.height, y = Math.sqrt(Math.pow(N, 2) + Math.pow(H, 2));
      this.sin = Math.abs(H / y), this.cos = Math.abs(N / y), typeof window != "undefined" && (window.addEventListener("mousemove", this._handleMouseMove), window.addEventListener("touchmove", this._handleMouseMove), window.addEventListener("mouseup", this._handleMouseUp, !0), window.addEventListener("touchend", this._handleMouseUp, !0)), this._transforming = !0;
      const P = L.target.getAbsolutePosition(), A = L.target.getStage().getPointerPosition();
      this._anchorDragOffset = {
        x: A.x - P.x,
        y: A.y - P.y
      }, E++, this._fire("transformstart", { evt: L.evt, target: this.getNode() }), this._nodes.forEach((G) => {
        G._fire("transformstart", { evt: L.evt, target: G });
      });
    }
    _handleMouseMove(L) {
      let F, N, H;
      const y = this.findOne("." + this._movingAnchorName), P = y.getStage();
      P.setPointersPositions(L);
      const A = P.getPointerPosition();
      let G = {
        x: A.x - this._anchorDragOffset.x,
        y: A.y - this._anchorDragOffset.y
      };
      const U = y.getAbsolutePosition();
      this.anchorDragBoundFunc() && (G = this.anchorDragBoundFunc()(U, G, L)), y.setAbsolutePosition(G);
      const K = y.getAbsolutePosition();
      if (U.x === K.x && U.y === K.y)
        return;
      if (this._movingAnchorName === "rotater") {
        const et = this._getNodeRect();
        F = y.x() - et.width / 2, N = -y.y() + et.height / 2;
        let ut = Math.atan2(-N, F) + Math.PI / 2;
        et.height < 0 && (ut -= Math.PI);
        const gt = h.Konva.getAngle(this.rotation()) + ut, Lt = h.Konva.getAngle(this.rotationSnapTolerance()), mt = m(this.rotationSnaps(), gt, Lt) - et.rotation, ee = f(et, mt);
        this._fitNodesInto(ee, L);
        return;
      }
      const $ = this.shiftBehavior();
      let X;
      $ === "inverted" ? X = this.keepRatio() && !L.shiftKey : $ === "none" ? X = this.keepRatio() : X = this.keepRatio() || L.shiftKey;
      var ht = this.centeredScaling() || L.altKey;
      if (this._movingAnchorName === "top-left") {
        if (X) {
          var Q = ht ? {
            x: this.width() / 2,
            y: this.height() / 2
          } : {
            x: this.findOne(".bottom-right").x(),
            y: this.findOne(".bottom-right").y()
          };
          H = Math.sqrt(Math.pow(Q.x - y.x(), 2) + Math.pow(Q.y - y.y(), 2));
          var st = this.findOne(".top-left").x() > Q.x ? -1 : 1, Z = this.findOne(".top-left").y() > Q.y ? -1 : 1;
          F = H * this.cos * st, N = H * this.sin * Z, this.findOne(".top-left").x(Q.x - F), this.findOne(".top-left").y(Q.y - N);
        }
      } else if (this._movingAnchorName === "top-center")
        this.findOne(".top-left").y(y.y());
      else if (this._movingAnchorName === "top-right") {
        if (X) {
          var Q = ht ? {
            x: this.width() / 2,
            y: this.height() / 2
          } : {
            x: this.findOne(".bottom-left").x(),
            y: this.findOne(".bottom-left").y()
          };
          H = Math.sqrt(Math.pow(y.x() - Q.x, 2) + Math.pow(Q.y - y.y(), 2));
          var st = this.findOne(".top-right").x() < Q.x ? -1 : 1, Z = this.findOne(".top-right").y() > Q.y ? -1 : 1;
          F = H * this.cos * st, N = H * this.sin * Z, this.findOne(".top-right").x(Q.x + F), this.findOne(".top-right").y(Q.y - N);
        }
        var at = y.position();
        this.findOne(".top-left").y(at.y), this.findOne(".bottom-right").x(at.x);
      } else if (this._movingAnchorName === "middle-left")
        this.findOne(".top-left").x(y.x());
      else if (this._movingAnchorName === "middle-right")
        this.findOne(".bottom-right").x(y.x());
      else if (this._movingAnchorName === "bottom-left") {
        if (X) {
          var Q = ht ? {
            x: this.width() / 2,
            y: this.height() / 2
          } : {
            x: this.findOne(".top-right").x(),
            y: this.findOne(".top-right").y()
          };
          H = Math.sqrt(Math.pow(Q.x - y.x(), 2) + Math.pow(y.y() - Q.y, 2));
          var st = Q.x < y.x() ? -1 : 1, Z = y.y() < Q.y ? -1 : 1;
          F = H * this.cos * st, N = H * this.sin * Z, y.x(Q.x - F), y.y(Q.y + N);
        }
        at = y.position(), this.findOne(".top-left").x(at.x), this.findOne(".bottom-right").y(at.y);
      } else if (this._movingAnchorName === "bottom-center")
        this.findOne(".bottom-right").y(y.y());
      else if (this._movingAnchorName === "bottom-right") {
        if (X) {
          var Q = ht ? {
            x: this.width() / 2,
            y: this.height() / 2
          } : {
            x: this.findOne(".top-left").x(),
            y: this.findOne(".top-left").y()
          };
          H = Math.sqrt(Math.pow(y.x() - Q.x, 2) + Math.pow(y.y() - Q.y, 2));
          var st = this.findOne(".bottom-right").x() < Q.x ? -1 : 1, Z = this.findOne(".bottom-right").y() < Q.y ? -1 : 1;
          F = H * this.cos * st, N = H * this.sin * Z, this.findOne(".bottom-right").x(Q.x + F), this.findOne(".bottom-right").y(Q.y + N);
        }
      } else
        console.error(new Error("Wrong position argument of selection resizer: " + this._movingAnchorName));
      var ht = this.centeredScaling() || L.altKey;
      if (ht) {
        const et = this.findOne(".top-left"), ut = this.findOne(".bottom-right"), ft = et.x(), gt = et.y(), Lt = this.getWidth() - ut.x(), Et = this.getHeight() - ut.y();
        ut.move({
          x: -ft,
          y: -gt
        }), et.move({
          x: Lt,
          y: Et
        });
      }
      const ct = this.findOne(".top-left").getAbsolutePosition();
      F = ct.x, N = ct.y;
      const V = this.findOne(".bottom-right").x() - this.findOne(".top-left").x(), j = this.findOne(".bottom-right").y() - this.findOne(".top-left").y();
      this._fitNodesInto({
        x: F,
        y: N,
        width: V,
        height: j,
        rotation: h.Konva.getAngle(this.rotation())
      }, L);
    }
    _handleMouseUp(L) {
      this._removeEvents(L);
    }
    getAbsoluteTransform() {
      return this.getTransform();
    }
    _removeEvents(L) {
      var F;
      if (this._transforming) {
        this._transforming = !1, typeof window != "undefined" && (window.removeEventListener("mousemove", this._handleMouseMove), window.removeEventListener("touchmove", this._handleMouseMove), window.removeEventListener("mouseup", this._handleMouseUp, !0), window.removeEventListener("touchend", this._handleMouseUp, !0));
        const N = this.getNode();
        E--, this._fire("transformend", { evt: L, target: N }), (F = this.getLayer()) === null || F === void 0 || F.batchDraw(), N && this._nodes.forEach((H) => {
          var y;
          H._fire("transformend", { evt: L, target: H }), (y = H.getLayer()) === null || y === void 0 || y.batchDraw();
        }), this._movingAnchorName = null;
      }
    }
    _fitNodesInto(L, F) {
      const N = this._getNodeRect(), H = 1;
      if (r.Util._inRange(L.width, -this.padding() * 2 - H, H)) {
        this.update();
        return;
      }
      if (r.Util._inRange(L.height, -this.padding() * 2 - H, H)) {
        this.update();
        return;
      }
      const y = new r.Transform();
      if (y.rotate(h.Konva.getAngle(this.rotation())), this._movingAnchorName && L.width < 0 && this._movingAnchorName.indexOf("left") >= 0) {
        const X = y.point({
          x: -this.padding() * 2,
          y: 0
        });
        L.x += X.x, L.y += X.y, L.width += this.padding() * 2, this._movingAnchorName = this._movingAnchorName.replace("left", "right"), this._anchorDragOffset.x -= X.x, this._anchorDragOffset.y -= X.y;
      } else if (this._movingAnchorName && L.width < 0 && this._movingAnchorName.indexOf("right") >= 0) {
        const X = y.point({
          x: this.padding() * 2,
          y: 0
        });
        this._movingAnchorName = this._movingAnchorName.replace("right", "left"), this._anchorDragOffset.x -= X.x, this._anchorDragOffset.y -= X.y, L.width += this.padding() * 2;
      }
      if (this._movingAnchorName && L.height < 0 && this._movingAnchorName.indexOf("top") >= 0) {
        const X = y.point({
          x: 0,
          y: -this.padding() * 2
        });
        L.x += X.x, L.y += X.y, this._movingAnchorName = this._movingAnchorName.replace("top", "bottom"), this._anchorDragOffset.x -= X.x, this._anchorDragOffset.y -= X.y, L.height += this.padding() * 2;
      } else if (this._movingAnchorName && L.height < 0 && this._movingAnchorName.indexOf("bottom") >= 0) {
        const X = y.point({
          x: 0,
          y: this.padding() * 2
        });
        this._movingAnchorName = this._movingAnchorName.replace("bottom", "top"), this._anchorDragOffset.x -= X.x, this._anchorDragOffset.y -= X.y, L.height += this.padding() * 2;
      }
      if (this.boundBoxFunc()) {
        const X = this.boundBoxFunc()(N, L);
        X ? L = X : r.Util.warn("boundBoxFunc returned falsy. You should return new bound rect from it!");
      }
      const P = 1e7, A = new r.Transform();
      A.translate(N.x, N.y), A.rotate(N.rotation), A.scale(N.width / P, N.height / P);
      const G = new r.Transform(), U = L.width / P, K = L.height / P;
      this.flipEnabled() === !1 ? (G.translate(L.x, L.y), G.rotate(L.rotation), G.translate(L.width < 0 ? L.width : 0, L.height < 0 ? L.height : 0), G.scale(Math.abs(U), Math.abs(K))) : (G.translate(L.x, L.y), G.rotate(L.rotation), G.scale(U, K));
      const $ = G.multiply(A.invert());
      this._nodes.forEach((X) => {
        var Q;
        const st = X.getParent().getAbsoluteTransform(), Z = X.getTransform().copy();
        Z.translate(X.offsetX(), X.offsetY());
        const at = new r.Transform();
        at.multiply(st.copy().invert()).multiply($).multiply(st).multiply(Z);
        const ht = at.decompose();
        X.setAttrs(ht), (Q = X.getLayer()) === null || Q === void 0 || Q.batchDraw();
      }), this.rotation(r.Util._getRotation(L.rotation)), this._nodes.forEach((X) => {
        this._fire("transform", { evt: F, target: X }), X._fire("transform", { evt: F, target: X });
      }), this._resetTransformCache(), this.update(), this.getLayer().batchDraw();
    }
    forceUpdate() {
      this._resetTransformCache(), this.update();
    }
    _batchChangeChild(L, F) {
      this.findOne(L).setAttrs(F);
    }
    update() {
      var L;
      const F = this._getNodeRect();
      this.rotation(r.Util._getRotation(F.rotation));
      const N = F.width, H = F.height, y = this.enabledAnchors(), P = this.resizeEnabled(), A = this.padding(), G = this.anchorSize(), U = this.find("._anchor");
      U.forEach(($) => {
        $.setAttrs({
          width: G,
          height: G,
          offsetX: G / 2,
          offsetY: G / 2,
          stroke: this.anchorStroke(),
          strokeWidth: this.anchorStrokeWidth(),
          fill: this.anchorFill(),
          cornerRadius: this.anchorCornerRadius()
        });
      }), this._batchChangeChild(".top-left", {
        x: 0,
        y: 0,
        offsetX: G / 2 + A,
        offsetY: G / 2 + A,
        visible: P && y.indexOf("top-left") >= 0
      }), this._batchChangeChild(".top-center", {
        x: N / 2,
        y: 0,
        offsetY: G / 2 + A,
        visible: P && y.indexOf("top-center") >= 0
      }), this._batchChangeChild(".top-right", {
        x: N,
        y: 0,
        offsetX: G / 2 - A,
        offsetY: G / 2 + A,
        visible: P && y.indexOf("top-right") >= 0
      }), this._batchChangeChild(".middle-left", {
        x: 0,
        y: H / 2,
        offsetX: G / 2 + A,
        visible: P && y.indexOf("middle-left") >= 0
      }), this._batchChangeChild(".middle-right", {
        x: N,
        y: H / 2,
        offsetX: G / 2 - A,
        visible: P && y.indexOf("middle-right") >= 0
      }), this._batchChangeChild(".bottom-left", {
        x: 0,
        y: H,
        offsetX: G / 2 + A,
        offsetY: G / 2 - A,
        visible: P && y.indexOf("bottom-left") >= 0
      }), this._batchChangeChild(".bottom-center", {
        x: N / 2,
        y: H,
        offsetY: G / 2 - A,
        visible: P && y.indexOf("bottom-center") >= 0
      }), this._batchChangeChild(".bottom-right", {
        x: N,
        y: H,
        offsetX: G / 2 - A,
        offsetY: G / 2 - A,
        visible: P && y.indexOf("bottom-right") >= 0
      }), this._batchChangeChild(".rotater", {
        x: N / 2,
        y: -this.rotateAnchorOffset() * r.Util._sign(H) - A,
        visible: this.rotateEnabled()
      }), this._batchChangeChild(".back", {
        width: N,
        height: H,
        visible: this.borderEnabled(),
        stroke: this.borderStroke(),
        strokeWidth: this.borderStrokeWidth(),
        dash: this.borderDash(),
        x: 0,
        y: 0
      });
      const K = this.anchorStyleFunc();
      K && U.forEach(($) => {
        K($);
      }), (L = this.getLayer()) === null || L === void 0 || L.batchDraw();
    }
    isTransforming() {
      return this._transforming;
    }
    stopTransform() {
      if (this._transforming) {
        this._removeEvents();
        const L = this.findOne("." + this._movingAnchorName);
        L && L.stopDrag();
      }
    }
    destroy() {
      return this.getStage() && this._cursorChange && this.getStage().content && (this.getStage().content.style.cursor = ""), s.Group.prototype.destroy.call(this), this.detach(), this._removeEvents(), this;
    }
    toObject() {
      return n.Node.prototype.toObject.call(this);
    }
    clone(L) {
      return n.Node.prototype.clone.call(this, L);
    }
    getClientRect() {
      return this.nodes().length > 0 ? super.getClientRect() : { x: 0, y: 0, width: 0, height: 0 };
    }
  };
  Hi.Transformer = T, T.isTransforming = () => E > 0;
  function D(I) {
    return I instanceof Array || r.Util.warn("enabledAnchors value should be an array"), I instanceof Array && I.forEach(function(L) {
      C.indexOf(L) === -1 && r.Util.warn("Unknown anchor name: " + L + ". Available names are: " + C.join(", "));
    }), I || [];
  }
  return T.prototype.className = "Transformer", (0, g._registerNode)(T), a.Factory.addGetterSetter(T, "enabledAnchors", C, D), a.Factory.addGetterSetter(T, "flipEnabled", !0, (0, l.getBooleanValidator)()), a.Factory.addGetterSetter(T, "resizeEnabled", !0), a.Factory.addGetterSetter(T, "anchorSize", 10, (0, l.getNumberValidator)()), a.Factory.addGetterSetter(T, "rotateEnabled", !0), a.Factory.addGetterSetter(T, "rotateLineVisible", !0), a.Factory.addGetterSetter(T, "rotationSnaps", []), a.Factory.addGetterSetter(T, "rotateAnchorOffset", 50, (0, l.getNumberValidator)()), a.Factory.addGetterSetter(T, "rotateAnchorCursor", "crosshair"), a.Factory.addGetterSetter(T, "rotationSnapTolerance", 5, (0, l.getNumberValidator)()), a.Factory.addGetterSetter(T, "borderEnabled", !0), a.Factory.addGetterSetter(T, "anchorStroke", "rgb(0, 161, 255)"), a.Factory.addGetterSetter(T, "anchorStrokeWidth", 1, (0, l.getNumberValidator)()), a.Factory.addGetterSetter(T, "anchorFill", "white"), a.Factory.addGetterSetter(T, "anchorCornerRadius", 0, (0, l.getNumberValidator)()), a.Factory.addGetterSetter(T, "borderStroke", "rgb(0, 161, 255)"), a.Factory.addGetterSetter(T, "borderStrokeWidth", 1, (0, l.getNumberValidator)()), a.Factory.addGetterSetter(T, "borderDash"), a.Factory.addGetterSetter(T, "keepRatio", !0), a.Factory.addGetterSetter(T, "shiftBehavior", "default"), a.Factory.addGetterSetter(T, "centeredScaling", !1), a.Factory.addGetterSetter(T, "ignoreStroke", !1), a.Factory.addGetterSetter(T, "padding", 0, (0, l.getNumberValidator)()), a.Factory.addGetterSetter(T, "node"), a.Factory.addGetterSetter(T, "nodes"), a.Factory.addGetterSetter(T, "boundBoxFunc"), a.Factory.addGetterSetter(T, "anchorDragBoundFunc"), a.Factory.addGetterSetter(T, "anchorStyleFunc"), a.Factory.addGetterSetter(T, "shouldOverdrawWholeArea", !1), a.Factory.addGetterSetter(T, "useSingleNodeRotation", !0), a.Factory.backCompat(T, {
    lineEnabled: "borderEnabled",
    rotateHandlerOffset: "rotateAnchorOffset",
    enabledHandlers: "enabledAnchors"
  }), Hi;
}
var Vi = {}, Ad;
function C6() {
  if (Ad) return Vi;
  Ad = 1, Object.defineProperty(Vi, "__esModule", { value: !0 }), Vi.Wedge = void 0;
  const r = Tt(), a = se(), n = Rt(), o = Ft(), c = Rt();
  let s = class extends a.Shape {
    _sceneFunc(l) {
      l.beginPath(), l.arc(0, 0, this.radius(), 0, n.Konva.getAngle(this.angle()), this.clockwise()), l.lineTo(0, 0), l.closePath(), l.fillStrokeShape(this);
    }
    getWidth() {
      return this.radius() * 2;
    }
    getHeight() {
      return this.radius() * 2;
    }
    setWidth(l) {
      this.radius(l / 2);
    }
    setHeight(l) {
      this.radius(l / 2);
    }
  };
  return Vi.Wedge = s, s.prototype.className = "Wedge", s.prototype._centroid = !0, s.prototype._attrsAffectingSize = ["radius"], (0, c._registerNode)(s), r.Factory.addGetterSetter(s, "radius", 0, (0, o.getNumberValidator)()), r.Factory.addGetterSetter(s, "angle", 0, (0, o.getNumberValidator)()), r.Factory.addGetterSetter(s, "clockwise", !1), r.Factory.backCompat(s, {
    angleDeg: "angle",
    getAngleDeg: "getAngle",
    setAngleDeg: "setAngle"
  }), Vi;
}
var Wi = {}, Rd;
function x6() {
  if (Rd) return Wi;
  Rd = 1, Object.defineProperty(Wi, "__esModule", { value: !0 }), Wi.Blur = void 0;
  const r = Tt(), a = $t(), n = Ft();
  function o() {
    this.r = 0, this.g = 0, this.b = 0, this.a = 0, this.next = null;
  }
  const c = [
    512,
    512,
    456,
    512,
    328,
    456,
    335,
    512,
    405,
    328,
    271,
    456,
    388,
    335,
    292,
    512,
    454,
    405,
    364,
    328,
    298,
    271,
    496,
    456,
    420,
    388,
    360,
    335,
    312,
    292,
    273,
    512,
    482,
    454,
    428,
    405,
    383,
    364,
    345,
    328,
    312,
    298,
    284,
    271,
    259,
    496,
    475,
    456,
    437,
    420,
    404,
    388,
    374,
    360,
    347,
    335,
    323,
    312,
    302,
    292,
    282,
    273,
    265,
    512,
    497,
    482,
    468,
    454,
    441,
    428,
    417,
    405,
    394,
    383,
    373,
    364,
    354,
    345,
    337,
    328,
    320,
    312,
    305,
    298,
    291,
    284,
    278,
    271,
    265,
    259,
    507,
    496,
    485,
    475,
    465,
    456,
    446,
    437,
    428,
    420,
    412,
    404,
    396,
    388,
    381,
    374,
    367,
    360,
    354,
    347,
    341,
    335,
    329,
    323,
    318,
    312,
    307,
    302,
    297,
    292,
    287,
    282,
    278,
    273,
    269,
    265,
    261,
    512,
    505,
    497,
    489,
    482,
    475,
    468,
    461,
    454,
    447,
    441,
    435,
    428,
    422,
    417,
    411,
    405,
    399,
    394,
    389,
    383,
    378,
    373,
    368,
    364,
    359,
    354,
    350,
    345,
    341,
    337,
    332,
    328,
    324,
    320,
    316,
    312,
    309,
    305,
    301,
    298,
    294,
    291,
    287,
    284,
    281,
    278,
    274,
    271,
    268,
    265,
    262,
    259,
    257,
    507,
    501,
    496,
    491,
    485,
    480,
    475,
    470,
    465,
    460,
    456,
    451,
    446,
    442,
    437,
    433,
    428,
    424,
    420,
    416,
    412,
    408,
    404,
    400,
    396,
    392,
    388,
    385,
    381,
    377,
    374,
    370,
    367,
    363,
    360,
    357,
    354,
    350,
    347,
    344,
    341,
    338,
    335,
    332,
    329,
    326,
    323,
    320,
    318,
    315,
    312,
    310,
    307,
    304,
    302,
    299,
    297,
    294,
    292,
    289,
    287,
    285,
    282,
    280,
    278,
    275,
    273,
    271,
    269,
    267,
    265,
    263,
    261,
    259
  ], s = [
    9,
    11,
    12,
    13,
    13,
    14,
    14,
    15,
    15,
    15,
    15,
    16,
    16,
    16,
    16,
    17,
    17,
    17,
    17,
    17,
    17,
    17,
    18,
    18,
    18,
    18,
    18,
    18,
    18,
    18,
    18,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24
  ];
  function h(g, p) {
    const b = g.data, w = g.width, x = g.height;
    let v, _, S, C, O, d, f, m, E, T, D, I, L, F, N, H, y, P, A, G, U, K, $, X, Q = p + p + 1, st = w - 1, Z = x - 1, at = p + 1, ht = at * (at + 1) / 2, ct = new o(), V = null, j = ct, et = null, ut = null, ft = c[p], gt = s[p];
    for (S = 1; S < Q; S++)
      j = j.next = new o(), S === at && (V = j);
    for (j.next = ct, f = d = 0, _ = 0; _ < x; _++) {
      for (H = y = P = A = m = E = T = D = 0, I = at * (G = b[d]), L = at * (U = b[d + 1]), F = at * (K = b[d + 2]), N = at * ($ = b[d + 3]), m += ht * G, E += ht * U, T += ht * K, D += ht * $, j = ct, S = 0; S < at; S++)
        j.r = G, j.g = U, j.b = K, j.a = $, j = j.next;
      for (S = 1; S < at; S++)
        C = d + ((st < S ? st : S) << 2), m += (j.r = G = b[C]) * (X = at - S), E += (j.g = U = b[C + 1]) * X, T += (j.b = K = b[C + 2]) * X, D += (j.a = $ = b[C + 3]) * X, H += G, y += U, P += K, A += $, j = j.next;
      for (et = ct, ut = V, v = 0; v < w; v++)
        b[d + 3] = $ = D * ft >> gt, $ !== 0 ? ($ = 255 / $, b[d] = (m * ft >> gt) * $, b[d + 1] = (E * ft >> gt) * $, b[d + 2] = (T * ft >> gt) * $) : b[d] = b[d + 1] = b[d + 2] = 0, m -= I, E -= L, T -= F, D -= N, I -= et.r, L -= et.g, F -= et.b, N -= et.a, C = f + ((C = v + p + 1) < st ? C : st) << 2, H += et.r = b[C], y += et.g = b[C + 1], P += et.b = b[C + 2], A += et.a = b[C + 3], m += H, E += y, T += P, D += A, et = et.next, I += G = ut.r, L += U = ut.g, F += K = ut.b, N += $ = ut.a, H -= G, y -= U, P -= K, A -= $, ut = ut.next, d += 4;
      f += w;
    }
    for (v = 0; v < w; v++) {
      for (y = P = A = H = E = T = D = m = 0, d = v << 2, I = at * (G = b[d]), L = at * (U = b[d + 1]), F = at * (K = b[d + 2]), N = at * ($ = b[d + 3]), m += ht * G, E += ht * U, T += ht * K, D += ht * $, j = ct, S = 0; S < at; S++)
        j.r = G, j.g = U, j.b = K, j.a = $, j = j.next;
      for (O = w, S = 1; S <= p; S++)
        d = O + v << 2, m += (j.r = G = b[d]) * (X = at - S), E += (j.g = U = b[d + 1]) * X, T += (j.b = K = b[d + 2]) * X, D += (j.a = $ = b[d + 3]) * X, H += G, y += U, P += K, A += $, j = j.next, S < Z && (O += w);
      for (d = v, et = ct, ut = V, _ = 0; _ < x; _++)
        C = d << 2, b[C + 3] = $ = D * ft >> gt, $ > 0 ? ($ = 255 / $, b[C] = (m * ft >> gt) * $, b[C + 1] = (E * ft >> gt) * $, b[C + 2] = (T * ft >> gt) * $) : b[C] = b[C + 1] = b[C + 2] = 0, m -= I, E -= L, T -= F, D -= N, I -= et.r, L -= et.g, F -= et.b, N -= et.a, C = v + ((C = _ + at) < Z ? C : Z) * w << 2, m += H += et.r = b[C], E += y += et.g = b[C + 1], T += P += et.b = b[C + 2], D += A += et.a = b[C + 3], et = et.next, I += G = ut.r, L += U = ut.g, F += K = ut.b, N += $ = ut.a, H -= G, y -= U, P -= K, A -= $, ut = ut.next, d += w;
    }
  }
  const l = function(p) {
    const b = Math.round(this.blurRadius());
    b > 0 && h(p, b);
  };
  return Wi.Blur = l, r.Factory.addGetterSetter(a.Node, "blurRadius", 0, (0, n.getNumberValidator)(), r.Factory.afterSetFilter), Wi;
}
var zi = {}, Td;
function E6() {
  if (Td) return zi;
  Td = 1, Object.defineProperty(zi, "__esModule", { value: !0 }), zi.Brighten = void 0;
  const r = Tt(), a = $t(), n = Ft(), o = function(c) {
    let s = this.brightness() * 255, h = c.data, l = h.length, g;
    for (g = 0; g < l; g += 4)
      h[g] += s, h[g + 1] += s, h[g + 2] += s;
  };
  return zi.Brighten = o, r.Factory.addGetterSetter(a.Node, "brightness", 0, (0, n.getNumberValidator)(), r.Factory.afterSetFilter), zi;
}
var ji = {}, Pd;
function A6() {
  if (Pd) return ji;
  Pd = 1, Object.defineProperty(ji, "__esModule", { value: !0 }), ji.Contrast = void 0;
  const r = Tt(), a = $t(), n = Ft(), o = function(c) {
    const s = Math.pow((this.contrast() + 100) / 100, 2);
    let h = c.data, l = h.length, g = 150, p = 150, b = 150, w;
    for (w = 0; w < l; w += 4)
      g = h[w], p = h[w + 1], b = h[w + 2], g /= 255, g -= 0.5, g *= s, g += 0.5, g *= 255, p /= 255, p -= 0.5, p *= s, p += 0.5, p *= 255, b /= 255, b -= 0.5, b *= s, b += 0.5, b *= 255, g = g < 0 ? 0 : g > 255 ? 255 : g, p = p < 0 ? 0 : p > 255 ? 255 : p, b = b < 0 ? 0 : b > 255 ? 255 : b, h[w] = g, h[w + 1] = p, h[w + 2] = b;
  };
  return ji.Contrast = o, r.Factory.addGetterSetter(a.Node, "contrast", 0, (0, n.getNumberValidator)(), r.Factory.afterSetFilter), ji;
}
var Ki = {}, Od;
function R6() {
  if (Od) return Ki;
  Od = 1, Object.defineProperty(Ki, "__esModule", { value: !0 }), Ki.Emboss = void 0;
  const r = Tt(), a = $t(), n = Kt(), o = Ft(), c = function(s) {
    let h = this.embossStrength() * 10, l = this.embossWhiteLevel() * 255, g = this.embossDirection(), p = this.embossBlend(), b = 0, w = 0, x = s.data, v = s.width, _ = s.height, S = v * 4, C = _;
    switch (g) {
      case "top-left":
        b = -1, w = -1;
        break;
      case "top":
        b = -1, w = 0;
        break;
      case "top-right":
        b = -1, w = 1;
        break;
      case "right":
        b = 0, w = 1;
        break;
      case "bottom-right":
        b = 1, w = 1;
        break;
      case "bottom":
        b = 1, w = 0;
        break;
      case "bottom-left":
        b = 1, w = -1;
        break;
      case "left":
        b = 0, w = -1;
        break;
      default:
        n.Util.error("Unknown emboss direction: " + g);
    }
    do {
      const O = (C - 1) * S;
      let d = b;
      C + d < 1 && (d = 0), C + d > _ && (d = 0);
      const f = (C - 1 + d) * v * 4;
      let m = v;
      do {
        const E = O + (m - 1) * 4;
        let T = w;
        m + T < 1 && (T = 0), m + T > v && (T = 0);
        const D = f + (m - 1 + T) * 4, I = x[E] - x[D], L = x[E + 1] - x[D + 1], F = x[E + 2] - x[D + 2];
        let N = I;
        const H = N > 0 ? N : -N, y = L > 0 ? L : -L, P = F > 0 ? F : -F;
        if (y > H && (N = L), P > H && (N = F), N *= h, p) {
          const A = x[E] + N, G = x[E + 1] + N, U = x[E + 2] + N;
          x[E] = A > 255 ? 255 : A < 0 ? 0 : A, x[E + 1] = G > 255 ? 255 : G < 0 ? 0 : G, x[E + 2] = U > 255 ? 255 : U < 0 ? 0 : U;
        } else {
          let A = l - N;
          A < 0 ? A = 0 : A > 255 && (A = 255), x[E] = x[E + 1] = x[E + 2] = A;
        }
      } while (--m);
    } while (--C);
  };
  return Ki.Emboss = c, r.Factory.addGetterSetter(a.Node, "embossStrength", 0.5, (0, o.getNumberValidator)(), r.Factory.afterSetFilter), r.Factory.addGetterSetter(a.Node, "embossWhiteLevel", 0.5, (0, o.getNumberValidator)(), r.Factory.afterSetFilter), r.Factory.addGetterSetter(a.Node, "embossDirection", "top-left", null, r.Factory.afterSetFilter), r.Factory.addGetterSetter(a.Node, "embossBlend", !1, null, r.Factory.afterSetFilter), Ki;
}
var Yi = {}, Fd;
function T6() {
  if (Fd) return Yi;
  Fd = 1, Object.defineProperty(Yi, "__esModule", { value: !0 }), Yi.Enhance = void 0;
  const r = Tt(), a = $t(), n = Ft();
  function o(s, h, l, g, p) {
    let b = l - h, w = p - g, x;
    return b === 0 ? g + w / 2 : w === 0 ? g : (x = (s - h) / b, x = w * x + g, x);
  }
  const c = function(s) {
    let h = s.data, l = h.length, g = h[0], p = g, b, w = h[1], x = w, v, _ = h[2], S = _, C, O;
    const d = this.enhance();
    if (d === 0)
      return;
    for (O = 0; O < l; O += 4)
      b = h[O + 0], b < g ? g = b : b > p && (p = b), v = h[O + 1], v < w ? w = v : v > x && (x = v), C = h[O + 2], C < _ ? _ = C : C > S && (S = C);
    p === g && (p = 255, g = 0), x === w && (x = 255, w = 0), S === _ && (S = 255, _ = 0);
    let f, m, E, T, D, I, L, F, N;
    for (d > 0 ? (m = p + d * (255 - p), E = g - d * (g - 0), D = x + d * (255 - x), I = w - d * (w - 0), F = S + d * (255 - S), N = _ - d * (_ - 0)) : (f = (p + g) * 0.5, m = p + d * (p - f), E = g + d * (g - f), T = (x + w) * 0.5, D = x + d * (x - T), I = w + d * (w - T), L = (S + _) * 0.5, F = S + d * (S - L), N = _ + d * (_ - L)), O = 0; O < l; O += 4)
      h[O + 0] = o(h[O + 0], g, p, E, m), h[O + 1] = o(h[O + 1], w, x, I, D), h[O + 2] = o(h[O + 2], _, S, N, F);
  };
  return Yi.Enhance = c, r.Factory.addGetterSetter(a.Node, "enhance", 0, (0, n.getNumberValidator)(), r.Factory.afterSetFilter), Yi;
}
var Xi = {}, kd;
function P6() {
  if (kd) return Xi;
  kd = 1, Object.defineProperty(Xi, "__esModule", { value: !0 }), Xi.Grayscale = void 0;
  const r = function(a) {
    let n = a.data, o = n.length, c, s;
    for (c = 0; c < o; c += 4)
      s = 0.34 * n[c] + 0.5 * n[c + 1] + 0.16 * n[c + 2], n[c] = s, n[c + 1] = s, n[c + 2] = s;
  };
  return Xi.Grayscale = r, Xi;
}
var $i = {}, Id;
function O6() {
  if (Id) return $i;
  Id = 1, Object.defineProperty($i, "__esModule", { value: !0 }), $i.HSL = void 0;
  const r = Tt(), a = $t(), n = Ft();
  r.Factory.addGetterSetter(a.Node, "hue", 0, (0, n.getNumberValidator)(), r.Factory.afterSetFilter), r.Factory.addGetterSetter(a.Node, "saturation", 0, (0, n.getNumberValidator)(), r.Factory.afterSetFilter), r.Factory.addGetterSetter(a.Node, "luminance", 0, (0, n.getNumberValidator)(), r.Factory.afterSetFilter);
  const o = function(c) {
    let s = c.data, h = s.length, l = 1, g = Math.pow(2, this.saturation()), p = Math.abs(this.hue() + 360) % 360, b = this.luminance() * 127, w;
    const x = l * g * Math.cos(p * Math.PI / 180), v = l * g * Math.sin(p * Math.PI / 180), _ = 0.299 * l + 0.701 * x + 0.167 * v, S = 0.587 * l - 0.587 * x + 0.33 * v, C = 0.114 * l - 0.114 * x - 0.497 * v, O = 0.299 * l - 0.299 * x - 0.328 * v, d = 0.587 * l + 0.413 * x + 0.035 * v, f = 0.114 * l - 0.114 * x + 0.293 * v, m = 0.299 * l - 0.3 * x + 1.25 * v, E = 0.587 * l - 0.586 * x - 1.05 * v, T = 0.114 * l + 0.886 * x - 0.2 * v;
    let D, I, L, F;
    for (w = 0; w < h; w += 4)
      D = s[w + 0], I = s[w + 1], L = s[w + 2], F = s[w + 3], s[w + 0] = _ * D + S * I + C * L + b, s[w + 1] = O * D + d * I + f * L + b, s[w + 2] = m * D + E * I + T * L + b, s[w + 3] = F;
  };
  return $i.HSL = o, $i;
}
var Zi = {}, Ld;
function F6() {
  if (Ld) return Zi;
  Ld = 1, Object.defineProperty(Zi, "__esModule", { value: !0 }), Zi.HSV = void 0;
  const r = Tt(), a = $t(), n = Ft(), o = function(c) {
    const s = c.data, h = s.length, l = Math.pow(2, this.value()), g = Math.pow(2, this.saturation()), p = Math.abs(this.hue() + 360) % 360, b = l * g * Math.cos(p * Math.PI / 180), w = l * g * Math.sin(p * Math.PI / 180), x = 0.299 * l + 0.701 * b + 0.167 * w, v = 0.587 * l - 0.587 * b + 0.33 * w, _ = 0.114 * l - 0.114 * b - 0.497 * w, S = 0.299 * l - 0.299 * b - 0.328 * w, C = 0.587 * l + 0.413 * b + 0.035 * w, O = 0.114 * l - 0.114 * b + 0.293 * w, d = 0.299 * l - 0.3 * b + 1.25 * w, f = 0.587 * l - 0.586 * b - 1.05 * w, m = 0.114 * l + 0.886 * b - 0.2 * w;
    let E, T, D, I;
    for (let L = 0; L < h; L += 4)
      E = s[L + 0], T = s[L + 1], D = s[L + 2], I = s[L + 3], s[L + 0] = x * E + v * T + _ * D, s[L + 1] = S * E + C * T + O * D, s[L + 2] = d * E + f * T + m * D, s[L + 3] = I;
  };
  return Zi.HSV = o, r.Factory.addGetterSetter(a.Node, "hue", 0, (0, n.getNumberValidator)(), r.Factory.afterSetFilter), r.Factory.addGetterSetter(a.Node, "saturation", 0, (0, n.getNumberValidator)(), r.Factory.afterSetFilter), r.Factory.addGetterSetter(a.Node, "value", 0, (0, n.getNumberValidator)(), r.Factory.afterSetFilter), Zi;
}
var Ji = {}, Md;
function k6() {
  if (Md) return Ji;
  Md = 1, Object.defineProperty(Ji, "__esModule", { value: !0 }), Ji.Invert = void 0;
  const r = function(a) {
    let n = a.data, o = n.length, c;
    for (c = 0; c < o; c += 4)
      n[c] = 255 - n[c], n[c + 1] = 255 - n[c + 1], n[c + 2] = 255 - n[c + 2];
  };
  return Ji.Invert = r, Ji;
}
var Qi = {}, Nd;
function I6() {
  if (Nd) return Qi;
  Nd = 1, Object.defineProperty(Qi, "__esModule", { value: !0 }), Qi.Kaleidoscope = void 0;
  const r = Tt(), a = $t(), n = Kt(), o = Ft(), c = function(l, g, p) {
    let b = l.data, w = g.data, x = l.width, v = l.height, _ = p.polarCenterX || x / 2, S = p.polarCenterY || v / 2, C, O, d, f = 0, m = 0, E = 0, T = 0, D, I = Math.sqrt(_ * _ + S * S);
    O = x - _, d = v - S, D = Math.sqrt(O * O + d * d), I = D > I ? D : I;
    let L = v, F = x, N, H, y = 360 / F * Math.PI / 180, P, A;
    for (H = 0; H < F; H += 1)
      for (P = Math.sin(H * y), A = Math.cos(H * y), N = 0; N < L; N += 1)
        O = Math.floor(_ + I * N / L * A), d = Math.floor(S + I * N / L * P), C = (d * x + O) * 4, f = b[C + 0], m = b[C + 1], E = b[C + 2], T = b[C + 3], C = (H + N * x) * 4, w[C + 0] = f, w[C + 1] = m, w[C + 2] = E, w[C + 3] = T;
  }, s = function(l, g, p) {
    let b = l.data, w = g.data, x = l.width, v = l.height, _ = p.polarCenterX || x / 2, S = p.polarCenterY || v / 2, C, O, d, f, m, E = 0, T = 0, D = 0, I = 0, L, F = Math.sqrt(_ * _ + S * S);
    O = x - _, d = v - S, L = Math.sqrt(O * O + d * d), F = L > F ? L : F;
    let N = v, H = x, y, P, A = 0, G, U;
    for (O = 0; O < x; O += 1)
      for (d = 0; d < v; d += 1)
        f = O - _, m = d - S, y = Math.sqrt(f * f + m * m) * N / F, P = (Math.atan2(m, f) * 180 / Math.PI + 360 + A) % 360, P = P * H / 360, G = Math.floor(P), U = Math.floor(y), C = (U * x + G) * 4, E = b[C + 0], T = b[C + 1], D = b[C + 2], I = b[C + 3], C = (d * x + O) * 4, w[C + 0] = E, w[C + 1] = T, w[C + 2] = D, w[C + 3] = I;
  }, h = function(l) {
    const g = l.width, p = l.height;
    let b, w, x, v, _, S, C, O, d, f, m = Math.round(this.kaleidoscopePower());
    const E = Math.round(this.kaleidoscopeAngle()), T = Math.floor(g * (E % 360) / 360);
    if (m < 1)
      return;
    const D = n.Util.createCanvasElement();
    D.width = g, D.height = p;
    const I = D.getContext("2d").getImageData(0, 0, g, p);
    n.Util.releaseCanvas(D), c(l, I, {
      polarCenterX: g / 2,
      polarCenterY: p / 2
    });
    let L = g / Math.pow(2, m);
    for (; L <= 8; )
      L = L * 2, m -= 1;
    L = Math.ceil(L);
    let F = L, N = 0, H = F, y = 1;
    for (T + L > g && (N = F, H = 0, y = -1), w = 0; w < p; w += 1)
      for (b = N; b !== H; b += y)
        x = Math.round(b + T) % g, d = (g * w + x) * 4, _ = I.data[d + 0], S = I.data[d + 1], C = I.data[d + 2], O = I.data[d + 3], f = (g * w + b) * 4, I.data[f + 0] = _, I.data[f + 1] = S, I.data[f + 2] = C, I.data[f + 3] = O;
    for (w = 0; w < p; w += 1)
      for (F = Math.floor(L), v = 0; v < m; v += 1) {
        for (b = 0; b < F + 1; b += 1)
          d = (g * w + b) * 4, _ = I.data[d + 0], S = I.data[d + 1], C = I.data[d + 2], O = I.data[d + 3], f = (g * w + F * 2 - b - 1) * 4, I.data[f + 0] = _, I.data[f + 1] = S, I.data[f + 2] = C, I.data[f + 3] = O;
        F *= 2;
      }
    s(I, l, {});
  };
  return Qi.Kaleidoscope = h, r.Factory.addGetterSetter(a.Node, "kaleidoscopePower", 2, (0, o.getNumberValidator)(), r.Factory.afterSetFilter), r.Factory.addGetterSetter(a.Node, "kaleidoscopeAngle", 0, (0, o.getNumberValidator)(), r.Factory.afterSetFilter), Qi;
}
var tn = {}, Gd;
function L6() {
  if (Gd) return tn;
  Gd = 1, Object.defineProperty(tn, "__esModule", { value: !0 }), tn.Mask = void 0;
  const r = Tt(), a = $t(), n = Ft();
  function o(x, v, _) {
    let S = (_ * x.width + v) * 4;
    const C = [];
    return C.push(x.data[S++], x.data[S++], x.data[S++], x.data[S++]), C;
  }
  function c(x, v) {
    return Math.sqrt(Math.pow(x[0] - v[0], 2) + Math.pow(x[1] - v[1], 2) + Math.pow(x[2] - v[2], 2));
  }
  function s(x) {
    const v = [0, 0, 0];
    for (let _ = 0; _ < x.length; _++)
      v[0] += x[_][0], v[1] += x[_][1], v[2] += x[_][2];
    return v[0] /= x.length, v[1] /= x.length, v[2] /= x.length, v;
  }
  function h(x, v) {
    const _ = o(x, 0, 0), S = o(x, x.width - 1, 0), C = o(x, 0, x.height - 1), O = o(x, x.width - 1, x.height - 1), d = v || 10;
    if (c(_, S) < d && c(S, O) < d && c(O, C) < d && c(C, _) < d) {
      const f = s([S, _, O, C]), m = [];
      for (let E = 0; E < x.width * x.height; E++) {
        const T = c(f, [
          x.data[E * 4],
          x.data[E * 4 + 1],
          x.data[E * 4 + 2]
        ]);
        m[E] = T < d ? 0 : 255;
      }
      return m;
    }
  }
  function l(x, v) {
    for (let _ = 0; _ < x.width * x.height; _++)
      x.data[4 * _ + 3] = v[_];
  }
  function g(x, v, _) {
    const S = [1, 1, 1, 1, 0, 1, 1, 1, 1], C = Math.round(Math.sqrt(S.length)), O = Math.floor(C / 2), d = [];
    for (let f = 0; f < _; f++)
      for (let m = 0; m < v; m++) {
        const E = f * v + m;
        let T = 0;
        for (let D = 0; D < C; D++)
          for (let I = 0; I < C; I++) {
            const L = f + D - O, F = m + I - O;
            if (L >= 0 && L < _ && F >= 0 && F < v) {
              const N = L * v + F, H = S[D * C + I];
              T += x[N] * H;
            }
          }
        d[E] = T === 255 * 8 ? 255 : 0;
      }
    return d;
  }
  function p(x, v, _) {
    const S = [1, 1, 1, 1, 1, 1, 1, 1, 1], C = Math.round(Math.sqrt(S.length)), O = Math.floor(C / 2), d = [];
    for (let f = 0; f < _; f++)
      for (let m = 0; m < v; m++) {
        const E = f * v + m;
        let T = 0;
        for (let D = 0; D < C; D++)
          for (let I = 0; I < C; I++) {
            const L = f + D - O, F = m + I - O;
            if (L >= 0 && L < _ && F >= 0 && F < v) {
              const N = L * v + F, H = S[D * C + I];
              T += x[N] * H;
            }
          }
        d[E] = T >= 255 * 4 ? 255 : 0;
      }
    return d;
  }
  function b(x, v, _) {
    const S = [0.1111111111111111, 0.1111111111111111, 0.1111111111111111, 0.1111111111111111, 0.1111111111111111, 0.1111111111111111, 0.1111111111111111, 0.1111111111111111, 0.1111111111111111], C = Math.round(Math.sqrt(S.length)), O = Math.floor(C / 2), d = [];
    for (let f = 0; f < _; f++)
      for (let m = 0; m < v; m++) {
        const E = f * v + m;
        let T = 0;
        for (let D = 0; D < C; D++)
          for (let I = 0; I < C; I++) {
            const L = f + D - O, F = m + I - O;
            if (L >= 0 && L < _ && F >= 0 && F < v) {
              const N = L * v + F, H = S[D * C + I];
              T += x[N] * H;
            }
          }
        d[E] = T;
      }
    return d;
  }
  const w = function(x) {
    let v = this.threshold(), _ = h(x, v);
    return _ && (_ = g(_, x.width, x.height), _ = p(_, x.width, x.height), _ = b(_, x.width, x.height), l(x, _)), x;
  };
  return tn.Mask = w, r.Factory.addGetterSetter(a.Node, "threshold", 0, (0, n.getNumberValidator)(), r.Factory.afterSetFilter), tn;
}
var en = {}, Dd;
function M6() {
  if (Dd) return en;
  Dd = 1, Object.defineProperty(en, "__esModule", { value: !0 }), en.Noise = void 0;
  const r = Tt(), a = $t(), n = Ft(), o = function(c) {
    const s = this.noise() * 255, h = c.data, l = h.length, g = s / 2;
    for (let p = 0; p < l; p += 4)
      h[p + 0] += g - 2 * g * Math.random(), h[p + 1] += g - 2 * g * Math.random(), h[p + 2] += g - 2 * g * Math.random();
  };
  return en.Noise = o, r.Factory.addGetterSetter(a.Node, "noise", 0.2, (0, n.getNumberValidator)(), r.Factory.afterSetFilter), en;
}
var rn = {}, Bd;
function N6() {
  if (Bd) return rn;
  Bd = 1, Object.defineProperty(rn, "__esModule", { value: !0 }), rn.Pixelate = void 0;
  const r = Tt(), a = Kt(), n = $t(), o = Ft(), c = function(s) {
    let h = Math.ceil(this.pixelSize()), l = s.width, g = s.height, p, b, w, x, v, _, S, C = Math.ceil(l / h), O = Math.ceil(g / h), d, f, m, E, T, D, I, L = s.data;
    if (h <= 0) {
      a.Util.error("pixelSize value can not be <= 0");
      return;
    }
    for (T = 0; T < C; T += 1)
      for (D = 0; D < O; D += 1) {
        for (x = 0, v = 0, _ = 0, S = 0, d = T * h, f = d + h, m = D * h, E = m + h, I = 0, p = d; p < f; p += 1)
          if (!(p >= l))
            for (b = m; b < E; b += 1)
              b >= g || (w = (l * b + p) * 4, x += L[w + 0], v += L[w + 1], _ += L[w + 2], S += L[w + 3], I += 1);
        for (x = x / I, v = v / I, _ = _ / I, S = S / I, p = d; p < f; p += 1)
          if (!(p >= l))
            for (b = m; b < E; b += 1)
              b >= g || (w = (l * b + p) * 4, L[w + 0] = x, L[w + 1] = v, L[w + 2] = _, L[w + 3] = S);
      }
  };
  return rn.Pixelate = c, r.Factory.addGetterSetter(n.Node, "pixelSize", 8, (0, o.getNumberValidator)(), r.Factory.afterSetFilter), rn;
}
var nn = {}, Ud;
function G6() {
  if (Ud) return nn;
  Ud = 1, Object.defineProperty(nn, "__esModule", { value: !0 }), nn.Posterize = void 0;
  const r = Tt(), a = $t(), n = Ft(), o = function(c) {
    let s = Math.round(this.levels() * 254) + 1, h = c.data, l = h.length, g = 255 / s, p;
    for (p = 0; p < l; p += 1)
      h[p] = Math.floor(h[p] / g) * g;
  };
  return nn.Posterize = o, r.Factory.addGetterSetter(a.Node, "levels", 0.5, (0, n.getNumberValidator)(), r.Factory.afterSetFilter), nn;
}
var an = {}, qd;
function D6() {
  if (qd) return an;
  qd = 1, Object.defineProperty(an, "__esModule", { value: !0 }), an.RGB = void 0;
  const r = Tt(), a = $t(), n = Ft(), o = function(c) {
    let s = c.data, h = s.length, l = this.red(), g = this.green(), p = this.blue(), b, w;
    for (b = 0; b < h; b += 4)
      w = (0.34 * s[b] + 0.5 * s[b + 1] + 0.16 * s[b + 2]) / 255, s[b] = w * l, s[b + 1] = w * g, s[b + 2] = w * p, s[b + 3] = s[b + 3];
  };
  return an.RGB = o, r.Factory.addGetterSetter(a.Node, "red", 0, function(c) {
    return this._filterUpToDate = !1, c > 255 ? 255 : c < 0 ? 0 : Math.round(c);
  }), r.Factory.addGetterSetter(a.Node, "green", 0, function(c) {
    return this._filterUpToDate = !1, c > 255 ? 255 : c < 0 ? 0 : Math.round(c);
  }), r.Factory.addGetterSetter(a.Node, "blue", 0, n.RGBComponent, r.Factory.afterSetFilter), an;
}
var sn = {}, Hd;
function B6() {
  if (Hd) return sn;
  Hd = 1, Object.defineProperty(sn, "__esModule", { value: !0 }), sn.RGBA = void 0;
  const r = Tt(), a = $t(), n = Ft(), o = function(c) {
    const s = c.data, h = s.length, l = this.red(), g = this.green(), p = this.blue(), b = this.alpha();
    for (let w = 0; w < h; w += 4) {
      const x = 1 - b;
      s[w] = l * b + s[w] * x, s[w + 1] = g * b + s[w + 1] * x, s[w + 2] = p * b + s[w + 2] * x;
    }
  };
  return sn.RGBA = o, r.Factory.addGetterSetter(a.Node, "red", 0, function(c) {
    return this._filterUpToDate = !1, c > 255 ? 255 : c < 0 ? 0 : Math.round(c);
  }), r.Factory.addGetterSetter(a.Node, "green", 0, function(c) {
    return this._filterUpToDate = !1, c > 255 ? 255 : c < 0 ? 0 : Math.round(c);
  }), r.Factory.addGetterSetter(a.Node, "blue", 0, n.RGBComponent, r.Factory.afterSetFilter), r.Factory.addGetterSetter(a.Node, "alpha", 1, function(c) {
    return this._filterUpToDate = !1, c > 1 ? 1 : c < 0 ? 0 : c;
  }), sn;
}
var on = {}, Vd;
function U6() {
  if (Vd) return on;
  Vd = 1, Object.defineProperty(on, "__esModule", { value: !0 }), on.Sepia = void 0;
  const r = function(a) {
    let n = a.data, o = n.length, c, s, h, l;
    for (c = 0; c < o; c += 4)
      s = n[c + 0], h = n[c + 1], l = n[c + 2], n[c + 0] = Math.min(255, s * 0.393 + h * 0.769 + l * 0.189), n[c + 1] = Math.min(255, s * 0.349 + h * 0.686 + l * 0.168), n[c + 2] = Math.min(255, s * 0.272 + h * 0.534 + l * 0.131);
  };
  return on.Sepia = r, on;
}
var hn = {}, Wd;
function q6() {
  if (Wd) return hn;
  Wd = 1, Object.defineProperty(hn, "__esModule", { value: !0 }), hn.Solarize = void 0;
  const r = function(a) {
    const n = a.data, o = a.width, c = a.height, s = o * 4;
    let h = c;
    do {
      const l = (h - 1) * s;
      let g = o;
      do {
        const p = l + (g - 1) * 4;
        let b = n[p], w = n[p + 1], x = n[p + 2];
        b > 127 && (b = 255 - b), w > 127 && (w = 255 - w), x > 127 && (x = 255 - x), n[p] = b, n[p + 1] = w, n[p + 2] = x;
      } while (--g);
    } while (--h);
  };
  return hn.Solarize = r, hn;
}
var ln = {}, zd;
function H6() {
  if (zd) return ln;
  zd = 1, Object.defineProperty(ln, "__esModule", { value: !0 }), ln.Threshold = void 0;
  const r = Tt(), a = $t(), n = Ft(), o = function(c) {
    const s = this.threshold() * 255, h = c.data, l = h.length;
    for (let g = 0; g < l; g += 1)
      h[g] = h[g] < s ? 0 : 255;
  };
  return ln.Threshold = o, r.Factory.addGetterSetter(a.Node, "threshold", 0.5, (0, n.getNumberValidator)(), r.Factory.afterSetFilter), ln;
}
var jd;
function V6() {
  if (jd) return Si;
  jd = 1, Object.defineProperty(Si, "__esModule", { value: !0 }), Si.Konva = void 0;
  const r = l6(), a = u6(), n = d6(), o = f6(), c = g6(), s = p6(), h = _6(), l = X0(), g = $h(), p = Z0(), b = v6(), w = y6(), x = m6(), v = b6(), _ = J0(), S = w6(), C = S6(), O = C6(), d = x6(), f = E6(), m = A6(), E = R6(), T = T6(), D = P6(), I = O6(), L = F6(), F = k6(), N = I6(), H = L6(), y = M6(), P = N6(), A = G6(), G = D6(), U = B6(), K = U6(), $ = q6(), X = H6();
  return Si.Konva = r.Konva.Util._assign(r.Konva, {
    Arc: a.Arc,
    Arrow: n.Arrow,
    Circle: o.Circle,
    Ellipse: c.Ellipse,
    Image: s.Image,
    Label: h.Label,
    Tag: h.Tag,
    Line: l.Line,
    Path: g.Path,
    Rect: p.Rect,
    RegularPolygon: b.RegularPolygon,
    Ring: w.Ring,
    Sprite: x.Sprite,
    Star: v.Star,
    Text: _.Text,
    TextPath: S.TextPath,
    Transformer: C.Transformer,
    Wedge: O.Wedge,
    Filters: {
      Blur: d.Blur,
      Brighten: f.Brighten,
      Contrast: m.Contrast,
      Emboss: E.Emboss,
      Enhance: T.Enhance,
      Grayscale: D.Grayscale,
      HSL: I.HSL,
      HSV: L.HSV,
      Invert: F.Invert,
      Kaleidoscope: N.Kaleidoscope,
      Mask: H.Mask,
      Noise: y.Noise,
      Pixelate: P.Pixelate,
      Posterize: A.Posterize,
      RGB: G.RGB,
      RGBA: U.RGBA,
      Sepia: K.Sepia,
      Solarize: $.Solarize,
      Threshold: X.Threshold
    }
  }), Si;
}
var W6 = da.exports, Kd;
function z6() {
  if (Kd) return da.exports;
  Kd = 1, Object.defineProperty(W6, "__esModule", { value: !0 });
  const r = V6();
  return da.exports = r.Konva, da.exports;
}
var j6 = z6();
const yt = /* @__PURE__ */ vn(j6);
var K6 = z0();
const Y6 = /* @__PURE__ */ vn(K6);
var uo, Yd;
function X6() {
  if (Yd) return uo;
  Yd = 1;
  function r() {
    this.__data__ = [], this.size = 0;
  }
  return uo = r, uo;
}
var co, Xd;
function Q0() {
  if (Xd) return co;
  Xd = 1;
  function r(a, n) {
    return a === n || a !== a && n !== n;
  }
  return co = r, co;
}
var fo, $d;
function wa() {
  if ($d) return fo;
  $d = 1;
  var r = Q0();
  function a(n, o) {
    for (var c = n.length; c--; )
      if (r(n[c][0], o))
        return c;
    return -1;
  }
  return fo = a, fo;
}
var go, Zd;
function $6() {
  if (Zd) return go;
  Zd = 1;
  var r = wa(), a = Array.prototype, n = a.splice;
  function o(c) {
    var s = this.__data__, h = r(s, c);
    if (h < 0)
      return !1;
    var l = s.length - 1;
    return h == l ? s.pop() : n.call(s, h, 1), --this.size, !0;
  }
  return go = o, go;
}
var po, Jd;
function Z6() {
  if (Jd) return po;
  Jd = 1;
  var r = wa();
  function a(n) {
    var o = this.__data__, c = r(o, n);
    return c < 0 ? void 0 : o[c][1];
  }
  return po = a, po;
}
var _o, Qd;
function J6() {
  if (Qd) return _o;
  Qd = 1;
  var r = wa();
  function a(n) {
    return r(this.__data__, n) > -1;
  }
  return _o = a, _o;
}
var vo, tf;
function Q6() {
  if (tf) return vo;
  tf = 1;
  var r = wa();
  function a(n, o) {
    var c = this.__data__, s = r(c, n);
    return s < 0 ? (++this.size, c.push([n, o])) : c[s][1] = o, this;
  }
  return vo = a, vo;
}
var yo, ef;
function Sa() {
  if (ef) return yo;
  ef = 1;
  var r = X6(), a = $6(), n = Z6(), o = J6(), c = Q6();
  function s(h) {
    var l = -1, g = h == null ? 0 : h.length;
    for (this.clear(); ++l < g; ) {
      var p = h[l];
      this.set(p[0], p[1]);
    }
  }
  return s.prototype.clear = r, s.prototype.delete = a, s.prototype.get = n, s.prototype.has = o, s.prototype.set = c, yo = s, yo;
}
var mo, rf;
function tv() {
  if (rf) return mo;
  rf = 1;
  var r = Sa();
  function a() {
    this.__data__ = new r(), this.size = 0;
  }
  return mo = a, mo;
}
var bo, nf;
function ev() {
  if (nf) return bo;
  nf = 1;
  function r(a) {
    var n = this.__data__, o = n.delete(a);
    return this.size = n.size, o;
  }
  return bo = r, bo;
}
var wo, af;
function rv() {
  if (af) return wo;
  af = 1;
  function r(a) {
    return this.__data__.get(a);
  }
  return wo = r, wo;
}
var So, sf;
function iv() {
  if (sf) return So;
  sf = 1;
  function r(a) {
    return this.__data__.has(a);
  }
  return So = r, So;
}
var Co, of;
function t1() {
  if (of) return Co;
  of = 1;
  var r = mn(), a = yn(), n = "[object AsyncFunction]", o = "[object Function]", c = "[object GeneratorFunction]", s = "[object Proxy]";
  function h(l) {
    if (!a(l))
      return !1;
    var g = r(l);
    return g == o || g == c || g == n || g == s;
  }
  return Co = h, Co;
}
var xo, hf;
function nv() {
  if (hf) return xo;
  hf = 1;
  var r = Xe(), a = r["__core-js_shared__"];
  return xo = a, xo;
}
var Eo, lf;
function av() {
  if (lf) return Eo;
  lf = 1;
  var r = nv(), a = function() {
    var o = /[^.]+$/.exec(r && r.keys && r.keys.IE_PROTO || "");
    return o ? "Symbol(src)_1." + o : "";
  }();
  function n(o) {
    return !!a && a in o;
  }
  return Eo = n, Eo;
}
var Ao, uf;
function e1() {
  if (uf) return Ao;
  uf = 1;
  var r = Function.prototype, a = r.toString;
  function n(o) {
    if (o != null) {
      try {
        return a.call(o);
      } catch {
      }
      try {
        return o + "";
      } catch {
      }
    }
    return "";
  }
  return Ao = n, Ao;
}
var Ro, cf;
function sv() {
  if (cf) return Ro;
  cf = 1;
  var r = t1(), a = av(), n = yn(), o = e1(), c = /[\\^$.*+?()[\]{}|]/g, s = /^\[object .+?Constructor\]$/, h = Function.prototype, l = Object.prototype, g = h.toString, p = l.hasOwnProperty, b = RegExp(
    "^" + g.call(p).replace(c, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  );
  function w(x) {
    if (!n(x) || a(x))
      return !1;
    var v = r(x) ? b : s;
    return v.test(o(x));
  }
  return Ro = w, Ro;
}
var To, df;
function ov() {
  if (df) return To;
  df = 1;
  function r(a, n) {
    return a == null ? void 0 : a[n];
  }
  return To = r, To;
}
var Po, ff;
function ni() {
  if (ff) return Po;
  ff = 1;
  var r = sv(), a = ov();
  function n(o, c) {
    var s = a(o, c);
    return r(s) ? s : void 0;
  }
  return Po = n, Po;
}
var Oo, gf;
function Zh() {
  if (gf) return Oo;
  gf = 1;
  var r = ni(), a = Xe(), n = r(a, "Map");
  return Oo = n, Oo;
}
var Fo, pf;
function Ca() {
  if (pf) return Fo;
  pf = 1;
  var r = ni(), a = r(Object, "create");
  return Fo = a, Fo;
}
var ko, _f;
function hv() {
  if (_f) return ko;
  _f = 1;
  var r = Ca();
  function a() {
    this.__data__ = r ? r(null) : {}, this.size = 0;
  }
  return ko = a, ko;
}
var Io, vf;
function lv() {
  if (vf) return Io;
  vf = 1;
  function r(a) {
    var n = this.has(a) && delete this.__data__[a];
    return this.size -= n ? 1 : 0, n;
  }
  return Io = r, Io;
}
var Lo, yf;
function uv() {
  if (yf) return Lo;
  yf = 1;
  var r = Ca(), a = "__lodash_hash_undefined__", n = Object.prototype, o = n.hasOwnProperty;
  function c(s) {
    var h = this.__data__;
    if (r) {
      var l = h[s];
      return l === a ? void 0 : l;
    }
    return o.call(h, s) ? h[s] : void 0;
  }
  return Lo = c, Lo;
}
var Mo, mf;
function cv() {
  if (mf) return Mo;
  mf = 1;
  var r = Ca(), a = Object.prototype, n = a.hasOwnProperty;
  function o(c) {
    var s = this.__data__;
    return r ? s[c] !== void 0 : n.call(s, c);
  }
  return Mo = o, Mo;
}
var No, bf;
function dv() {
  if (bf) return No;
  bf = 1;
  var r = Ca(), a = "__lodash_hash_undefined__";
  function n(o, c) {
    var s = this.__data__;
    return this.size += this.has(o) ? 0 : 1, s[o] = r && c === void 0 ? a : c, this;
  }
  return No = n, No;
}
var Go, wf;
function fv() {
  if (wf) return Go;
  wf = 1;
  var r = hv(), a = lv(), n = uv(), o = cv(), c = dv();
  function s(h) {
    var l = -1, g = h == null ? 0 : h.length;
    for (this.clear(); ++l < g; ) {
      var p = h[l];
      this.set(p[0], p[1]);
    }
  }
  return s.prototype.clear = r, s.prototype.delete = a, s.prototype.get = n, s.prototype.has = o, s.prototype.set = c, Go = s, Go;
}
var Do, Sf;
function gv() {
  if (Sf) return Do;
  Sf = 1;
  var r = fv(), a = Sa(), n = Zh();
  function o() {
    this.size = 0, this.__data__ = {
      hash: new r(),
      map: new (n || a)(),
      string: new r()
    };
  }
  return Do = o, Do;
}
var Bo, Cf;
function pv() {
  if (Cf) return Bo;
  Cf = 1;
  function r(a) {
    var n = typeof a;
    return n == "string" || n == "number" || n == "symbol" || n == "boolean" ? a !== "__proto__" : a === null;
  }
  return Bo = r, Bo;
}
var Uo, xf;
function xa() {
  if (xf) return Uo;
  xf = 1;
  var r = pv();
  function a(n, o) {
    var c = n.__data__;
    return r(o) ? c[typeof o == "string" ? "string" : "hash"] : c.map;
  }
  return Uo = a, Uo;
}
var qo, Ef;
function _v() {
  if (Ef) return qo;
  Ef = 1;
  var r = xa();
  function a(n) {
    var o = r(this, n).delete(n);
    return this.size -= o ? 1 : 0, o;
  }
  return qo = a, qo;
}
var Ho, Af;
function vv() {
  if (Af) return Ho;
  Af = 1;
  var r = xa();
  function a(n) {
    return r(this, n).get(n);
  }
  return Ho = a, Ho;
}
var Vo, Rf;
function yv() {
  if (Rf) return Vo;
  Rf = 1;
  var r = xa();
  function a(n) {
    return r(this, n).has(n);
  }
  return Vo = a, Vo;
}
var Wo, Tf;
function mv() {
  if (Tf) return Wo;
  Tf = 1;
  var r = xa();
  function a(n, o) {
    var c = r(this, n), s = c.size;
    return c.set(n, o), this.size += c.size == s ? 0 : 1, this;
  }
  return Wo = a, Wo;
}
var zo, Pf;
function r1() {
  if (Pf) return zo;
  Pf = 1;
  var r = gv(), a = _v(), n = vv(), o = yv(), c = mv();
  function s(h) {
    var l = -1, g = h == null ? 0 : h.length;
    for (this.clear(); ++l < g; ) {
      var p = h[l];
      this.set(p[0], p[1]);
    }
  }
  return s.prototype.clear = r, s.prototype.delete = a, s.prototype.get = n, s.prototype.has = o, s.prototype.set = c, zo = s, zo;
}
var jo, Of;
function bv() {
  if (Of) return jo;
  Of = 1;
  var r = Sa(), a = Zh(), n = r1(), o = 200;
  function c(s, h) {
    var l = this.__data__;
    if (l instanceof r) {
      var g = l.__data__;
      if (!a || g.length < o - 1)
        return g.push([s, h]), this.size = ++l.size, this;
      l = this.__data__ = new n(g);
    }
    return l.set(s, h), this.size = l.size, this;
  }
  return jo = c, jo;
}
var Ko, Ff;
function wv() {
  if (Ff) return Ko;
  Ff = 1;
  var r = Sa(), a = tv(), n = ev(), o = rv(), c = iv(), s = bv();
  function h(l) {
    var g = this.__data__ = new r(l);
    this.size = g.size;
  }
  return h.prototype.clear = a, h.prototype.delete = n, h.prototype.get = o, h.prototype.has = c, h.prototype.set = s, Ko = h, Ko;
}
var Yo, kf;
function Sv() {
  if (kf) return Yo;
  kf = 1;
  var r = "__lodash_hash_undefined__";
  function a(n) {
    return this.__data__.set(n, r), this;
  }
  return Yo = a, Yo;
}
var Xo, If;
function Cv() {
  if (If) return Xo;
  If = 1;
  function r(a) {
    return this.__data__.has(a);
  }
  return Xo = r, Xo;
}
var $o, Lf;
function xv() {
  if (Lf) return $o;
  Lf = 1;
  var r = r1(), a = Sv(), n = Cv();
  function o(c) {
    var s = -1, h = c == null ? 0 : c.length;
    for (this.__data__ = new r(); ++s < h; )
      this.add(c[s]);
  }
  return o.prototype.add = o.prototype.push = a, o.prototype.has = n, $o = o, $o;
}
var Zo, Mf;
function Ev() {
  if (Mf) return Zo;
  Mf = 1;
  function r(a, n) {
    for (var o = -1, c = a == null ? 0 : a.length; ++o < c; )
      if (n(a[o], o, a))
        return !0;
    return !1;
  }
  return Zo = r, Zo;
}
var Jo, Nf;
function Av() {
  if (Nf) return Jo;
  Nf = 1;
  function r(a, n) {
    return a.has(n);
  }
  return Jo = r, Jo;
}
var Qo, Gf;
function i1() {
  if (Gf) return Qo;
  Gf = 1;
  var r = xv(), a = Ev(), n = Av(), o = 1, c = 2;
  function s(h, l, g, p, b, w) {
    var x = g & o, v = h.length, _ = l.length;
    if (v != _ && !(x && _ > v))
      return !1;
    var S = w.get(h), C = w.get(l);
    if (S && C)
      return S == l && C == h;
    var O = -1, d = !0, f = g & c ? new r() : void 0;
    for (w.set(h, l), w.set(l, h); ++O < v; ) {
      var m = h[O], E = l[O];
      if (p)
        var T = x ? p(E, m, O, l, h, w) : p(m, E, O, h, l, w);
      if (T !== void 0) {
        if (T)
          continue;
        d = !1;
        break;
      }
      if (f) {
        if (!a(l, function(D, I) {
          if (!n(f, I) && (m === D || b(m, D, g, p, w)))
            return f.push(I);
        })) {
          d = !1;
          break;
        }
      } else if (!(m === E || b(m, E, g, p, w))) {
        d = !1;
        break;
      }
    }
    return w.delete(h), w.delete(l), d;
  }
  return Qo = s, Qo;
}
var th, Df;
function Rv() {
  if (Df) return th;
  Df = 1;
  var r = Xe(), a = r.Uint8Array;
  return th = a, th;
}
var eh, Bf;
function Tv() {
  if (Bf) return eh;
  Bf = 1;
  function r(a) {
    var n = -1, o = Array(a.size);
    return a.forEach(function(c, s) {
      o[++n] = [s, c];
    }), o;
  }
  return eh = r, eh;
}
var rh, Uf;
function Pv() {
  if (Uf) return rh;
  Uf = 1;
  function r(a) {
    var n = -1, o = Array(a.size);
    return a.forEach(function(c) {
      o[++n] = c;
    }), o;
  }
  return rh = r, rh;
}
var ih, qf;
function Ov() {
  if (qf) return ih;
  qf = 1;
  var r = ya(), a = Rv(), n = Q0(), o = i1(), c = Tv(), s = Pv(), h = 1, l = 2, g = "[object Boolean]", p = "[object Date]", b = "[object Error]", w = "[object Map]", x = "[object Number]", v = "[object RegExp]", _ = "[object Set]", S = "[object String]", C = "[object Symbol]", O = "[object ArrayBuffer]", d = "[object DataView]", f = r ? r.prototype : void 0, m = f ? f.valueOf : void 0;
  function E(T, D, I, L, F, N, H) {
    switch (I) {
      case d:
        if (T.byteLength != D.byteLength || T.byteOffset != D.byteOffset)
          return !1;
        T = T.buffer, D = D.buffer;
      case O:
        return !(T.byteLength != D.byteLength || !N(new a(T), new a(D)));
      case g:
      case p:
      case x:
        return n(+T, +D);
      case b:
        return T.name == D.name && T.message == D.message;
      case v:
      case S:
        return T == D + "";
      case w:
        var y = c;
      case _:
        var P = L & h;
        if (y || (y = s), T.size != D.size && !P)
          return !1;
        var A = H.get(T);
        if (A)
          return A == D;
        L |= l, H.set(T, D);
        var G = o(y(T), y(D), L, F, N, H);
        return H.delete(T), G;
      case C:
        if (m)
          return m.call(T) == m.call(D);
    }
    return !1;
  }
  return ih = E, ih;
}
var nh, Hf;
function Fv() {
  if (Hf) return nh;
  Hf = 1;
  function r(a, n) {
    for (var o = -1, c = n.length, s = a.length; ++o < c; )
      a[s + o] = n[o];
    return a;
  }
  return nh = r, nh;
}
var ah, Vf;
function Ea() {
  if (Vf) return ah;
  Vf = 1;
  var r = Array.isArray;
  return ah = r, ah;
}
var sh, Wf;
function kv() {
  if (Wf) return sh;
  Wf = 1;
  var r = Fv(), a = Ea();
  function n(o, c, s) {
    var h = c(o);
    return a(o) ? h : r(h, s(o));
  }
  return sh = n, sh;
}
var oh, zf;
function Iv() {
  if (zf) return oh;
  zf = 1;
  function r(a, n) {
    for (var o = -1, c = a == null ? 0 : a.length, s = 0, h = []; ++o < c; ) {
      var l = a[o];
      n(l, o, a) && (h[s++] = l);
    }
    return h;
  }
  return oh = r, oh;
}
var hh, jf;
function Lv() {
  if (jf) return hh;
  jf = 1;
  function r() {
    return [];
  }
  return hh = r, hh;
}
var lh, Kf;
function Mv() {
  if (Kf) return lh;
  Kf = 1;
  var r = Iv(), a = Lv(), n = Object.prototype, o = n.propertyIsEnumerable, c = Object.getOwnPropertySymbols, s = c ? function(h) {
    return h == null ? [] : (h = Object(h), r(c(h), function(l) {
      return o.call(h, l);
    }));
  } : a;
  return lh = s, lh;
}
var uh, Yf;
function Nv() {
  if (Yf) return uh;
  Yf = 1;
  function r(a, n) {
    for (var o = -1, c = Array(a); ++o < a; )
      c[o] = n(o);
    return c;
  }
  return uh = r, uh;
}
var ch, Xf;
function Gv() {
  if (Xf) return ch;
  Xf = 1;
  var r = mn(), a = bn(), n = "[object Arguments]";
  function o(c) {
    return a(c) && r(c) == n;
  }
  return ch = o, ch;
}
var dh, $f;
function Dv() {
  if ($f) return dh;
  $f = 1;
  var r = Gv(), a = bn(), n = Object.prototype, o = n.hasOwnProperty, c = n.propertyIsEnumerable, s = r(/* @__PURE__ */ function() {
    return arguments;
  }()) ? r : function(h) {
    return a(h) && o.call(h, "callee") && !c.call(h, "callee");
  };
  return dh = s, dh;
}
var un = { exports: {} }, fh, Zf;
function Bv() {
  if (Zf) return fh;
  Zf = 1;
  function r() {
    return !1;
  }
  return fh = r, fh;
}
un.exports;
var Jf;
function n1() {
  return Jf || (Jf = 1, function(r, a) {
    var n = Xe(), o = Bv(), c = a && !a.nodeType && a, s = c && !0 && r && !r.nodeType && r, h = s && s.exports === c, l = h ? n.Buffer : void 0, g = l ? l.isBuffer : void 0, p = g || o;
    r.exports = p;
  }(un, un.exports)), un.exports;
}
var gh, Qf;
function Uv() {
  if (Qf) return gh;
  Qf = 1;
  var r = 9007199254740991, a = /^(?:0|[1-9]\d*)$/;
  function n(o, c) {
    var s = typeof o;
    return c = c == null ? r : c, !!c && (s == "number" || s != "symbol" && a.test(o)) && o > -1 && o % 1 == 0 && o < c;
  }
  return gh = n, gh;
}
var ph, t0;
function a1() {
  if (t0) return ph;
  t0 = 1;
  var r = 9007199254740991;
  function a(n) {
    return typeof n == "number" && n > -1 && n % 1 == 0 && n <= r;
  }
  return ph = a, ph;
}
var _h, e0;
function qv() {
  if (e0) return _h;
  e0 = 1;
  var r = mn(), a = a1(), n = bn(), o = "[object Arguments]", c = "[object Array]", s = "[object Boolean]", h = "[object Date]", l = "[object Error]", g = "[object Function]", p = "[object Map]", b = "[object Number]", w = "[object Object]", x = "[object RegExp]", v = "[object Set]", _ = "[object String]", S = "[object WeakMap]", C = "[object ArrayBuffer]", O = "[object DataView]", d = "[object Float32Array]", f = "[object Float64Array]", m = "[object Int8Array]", E = "[object Int16Array]", T = "[object Int32Array]", D = "[object Uint8Array]", I = "[object Uint8ClampedArray]", L = "[object Uint16Array]", F = "[object Uint32Array]", N = {};
  N[d] = N[f] = N[m] = N[E] = N[T] = N[D] = N[I] = N[L] = N[F] = !0, N[o] = N[c] = N[C] = N[s] = N[O] = N[h] = N[l] = N[g] = N[p] = N[b] = N[w] = N[x] = N[v] = N[_] = N[S] = !1;
  function H(y) {
    return n(y) && a(y.length) && !!N[r(y)];
  }
  return _h = H, _h;
}
var vh, r0;
function Hv() {
  if (r0) return vh;
  r0 = 1;
  function r(a) {
    return function(n) {
      return a(n);
    };
  }
  return vh = r, vh;
}
var cn = { exports: {} };
cn.exports;
var i0;
function Vv() {
  return i0 || (i0 = 1, function(r, a) {
    var n = V0(), o = a && !a.nodeType && a, c = o && !0 && r && !r.nodeType && r, s = c && c.exports === o, h = s && n.process, l = function() {
      try {
        var g = c && c.require && c.require("util").types;
        return g || h && h.binding && h.binding("util");
      } catch {
      }
    }();
    r.exports = l;
  }(cn, cn.exports)), cn.exports;
}
var yh, n0;
function s1() {
  if (n0) return yh;
  n0 = 1;
  var r = qv(), a = Hv(), n = Vv(), o = n && n.isTypedArray, c = o ? a(o) : r;
  return yh = c, yh;
}
var mh, a0;
function Wv() {
  if (a0) return mh;
  a0 = 1;
  var r = Nv(), a = Dv(), n = Ea(), o = n1(), c = Uv(), s = s1(), h = Object.prototype, l = h.hasOwnProperty;
  function g(p, b) {
    var w = n(p), x = !w && a(p), v = !w && !x && o(p), _ = !w && !x && !v && s(p), S = w || x || v || _, C = S ? r(p.length, String) : [], O = C.length;
    for (var d in p)
      (b || l.call(p, d)) && !(S && // Safari 9 has enumerable `arguments.length` in strict mode.
      (d == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      v && (d == "offset" || d == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      _ && (d == "buffer" || d == "byteLength" || d == "byteOffset") || // Skip index properties.
      c(d, O))) && C.push(d);
    return C;
  }
  return mh = g, mh;
}
var bh, s0;
function zv() {
  if (s0) return bh;
  s0 = 1;
  var r = Object.prototype;
  function a(n) {
    var o = n && n.constructor, c = typeof o == "function" && o.prototype || r;
    return n === c;
  }
  return bh = a, bh;
}
var wh, o0;
function jv() {
  if (o0) return wh;
  o0 = 1;
  function r(a, n) {
    return function(o) {
      return a(n(o));
    };
  }
  return wh = r, wh;
}
var Sh, h0;
function Kv() {
  if (h0) return Sh;
  h0 = 1;
  var r = jv(), a = r(Object.keys, Object);
  return Sh = a, Sh;
}
var Ch, l0;
function Yv() {
  if (l0) return Ch;
  l0 = 1;
  var r = zv(), a = Kv(), n = Object.prototype, o = n.hasOwnProperty;
  function c(s) {
    if (!r(s))
      return a(s);
    var h = [];
    for (var l in Object(s))
      o.call(s, l) && l != "constructor" && h.push(l);
    return h;
  }
  return Ch = c, Ch;
}
var xh, u0;
function Xv() {
  if (u0) return xh;
  u0 = 1;
  var r = t1(), a = a1();
  function n(o) {
    return o != null && a(o.length) && !r(o);
  }
  return xh = n, xh;
}
var Eh, c0;
function $v() {
  if (c0) return Eh;
  c0 = 1;
  var r = Wv(), a = Yv(), n = Xv();
  function o(c) {
    return n(c) ? r(c) : a(c);
  }
  return Eh = o, Eh;
}
var Ah, d0;
function Zv() {
  if (d0) return Ah;
  d0 = 1;
  var r = kv(), a = Mv(), n = $v();
  function o(c) {
    return r(c, n, a);
  }
  return Ah = o, Ah;
}
var Rh, f0;
function Jv() {
  if (f0) return Rh;
  f0 = 1;
  var r = Zv(), a = 1, n = Object.prototype, o = n.hasOwnProperty;
  function c(s, h, l, g, p, b) {
    var w = l & a, x = r(s), v = x.length, _ = r(h), S = _.length;
    if (v != S && !w)
      return !1;
    for (var C = v; C--; ) {
      var O = x[C];
      if (!(w ? O in h : o.call(h, O)))
        return !1;
    }
    var d = b.get(s), f = b.get(h);
    if (d && f)
      return d == h && f == s;
    var m = !0;
    b.set(s, h), b.set(h, s);
    for (var E = w; ++C < v; ) {
      O = x[C];
      var T = s[O], D = h[O];
      if (g)
        var I = w ? g(D, T, O, h, s, b) : g(T, D, O, s, h, b);
      if (!(I === void 0 ? T === D || p(T, D, l, g, b) : I)) {
        m = !1;
        break;
      }
      E || (E = O == "constructor");
    }
    if (m && !E) {
      var L = s.constructor, F = h.constructor;
      L != F && "constructor" in s && "constructor" in h && !(typeof L == "function" && L instanceof L && typeof F == "function" && F instanceof F) && (m = !1);
    }
    return b.delete(s), b.delete(h), m;
  }
  return Rh = c, Rh;
}
var Th, g0;
function Qv() {
  if (g0) return Th;
  g0 = 1;
  var r = ni(), a = Xe(), n = r(a, "DataView");
  return Th = n, Th;
}
var Ph, p0;
function t8() {
  if (p0) return Ph;
  p0 = 1;
  var r = ni(), a = Xe(), n = r(a, "Promise");
  return Ph = n, Ph;
}
var Oh, _0;
function e8() {
  if (_0) return Oh;
  _0 = 1;
  var r = ni(), a = Xe(), n = r(a, "Set");
  return Oh = n, Oh;
}
var Fh, v0;
function r8() {
  if (v0) return Fh;
  v0 = 1;
  var r = ni(), a = Xe(), n = r(a, "WeakMap");
  return Fh = n, Fh;
}
var kh, y0;
function i8() {
  if (y0) return kh;
  y0 = 1;
  var r = Qv(), a = Zh(), n = t8(), o = e8(), c = r8(), s = mn(), h = e1(), l = "[object Map]", g = "[object Object]", p = "[object Promise]", b = "[object Set]", w = "[object WeakMap]", x = "[object DataView]", v = h(r), _ = h(a), S = h(n), C = h(o), O = h(c), d = s;
  return (r && d(new r(new ArrayBuffer(1))) != x || a && d(new a()) != l || n && d(n.resolve()) != p || o && d(new o()) != b || c && d(new c()) != w) && (d = function(f) {
    var m = s(f), E = m == g ? f.constructor : void 0, T = E ? h(E) : "";
    if (T)
      switch (T) {
        case v:
          return x;
        case _:
          return l;
        case S:
          return p;
        case C:
          return b;
        case O:
          return w;
      }
    return m;
  }), kh = d, kh;
}
var Ih, m0;
function n8() {
  if (m0) return Ih;
  m0 = 1;
  var r = wv(), a = i1(), n = Ov(), o = Jv(), c = i8(), s = Ea(), h = n1(), l = s1(), g = 1, p = "[object Arguments]", b = "[object Array]", w = "[object Object]", x = Object.prototype, v = x.hasOwnProperty;
  function _(S, C, O, d, f, m) {
    var E = s(S), T = s(C), D = E ? b : c(S), I = T ? b : c(C);
    D = D == p ? w : D, I = I == p ? w : I;
    var L = D == w, F = I == w, N = D == I;
    if (N && h(S)) {
      if (!h(C))
        return !1;
      E = !0, L = !1;
    }
    if (N && !L)
      return m || (m = new r()), E || l(S) ? a(S, C, O, d, f, m) : n(S, C, D, O, d, f, m);
    if (!(O & g)) {
      var H = L && v.call(S, "__wrapped__"), y = F && v.call(C, "__wrapped__");
      if (H || y) {
        var P = H ? S.value() : S, A = y ? C.value() : C;
        return m || (m = new r()), f(P, A, O, d, m);
      }
    }
    return N ? (m || (m = new r()), o(S, C, O, d, f, m)) : !1;
  }
  return Ih = _, Ih;
}
var Lh, b0;
function a8() {
  if (b0) return Lh;
  b0 = 1;
  var r = n8(), a = bn();
  function n(o, c, s, h, l) {
    return o === c ? !0 : o == null || c == null || !a(o) && !a(c) ? o !== o && c !== c : r(o, c, s, h, n, l);
  }
  return Lh = n, Lh;
}
var Mh, w0;
function s8() {
  if (w0) return Mh;
  w0 = 1;
  var r = a8();
  function a(n, o) {
    return r(n, o);
  }
  return Mh = a, Mh;
}
var o8 = s8();
const S0 = /* @__PURE__ */ vn(o8);
var Nh, C0;
function h8() {
  if (C0) return Nh;
  C0 = 1;
  var r = jh(), a = 1 / 0, n = 17976931348623157e292;
  function o(c) {
    if (!c)
      return c === 0 ? c : 0;
    if (c = r(c), c === a || c === -1 / 0) {
      var s = c < 0 ? -1 : 1;
      return s * n;
    }
    return c === c ? c : 0;
  }
  return Nh = o, Nh;
}
var Gh, x0;
function l8() {
  if (x0) return Gh;
  x0 = 1;
  var r = h8();
  function a(n) {
    var o = r(n), c = o % 1;
    return o === o ? c ? o - c : o : 0;
  }
  return Gh = a, Gh;
}
var Dh, E0;
function u8() {
  if (E0) return Dh;
  E0 = 1;
  function r(a, n) {
    for (var o = -1, c = a == null ? 0 : a.length, s = Array(c); ++o < c; )
      s[o] = n(a[o], o, a);
    return s;
  }
  return Dh = r, Dh;
}
var Bh, A0;
function c8() {
  if (A0) return Bh;
  A0 = 1;
  var r = ya(), a = u8(), n = Ea(), o = W0(), c = r ? r.prototype : void 0, s = c ? c.toString : void 0;
  function h(l) {
    if (typeof l == "string")
      return l;
    if (n(l))
      return a(l, h) + "";
    if (o(l))
      return s ? s.call(l) : "";
    var g = l + "";
    return g == "0" && 1 / l == -1 / 0 ? "-0" : g;
  }
  return Bh = h, Bh;
}
var Uh, R0;
function d8() {
  if (R0) return Uh;
  R0 = 1;
  var r = c8();
  function a(n) {
    return n == null ? "" : r(n);
  }
  return Uh = a, Uh;
}
var qh, T0;
function f8() {
  if (T0) return qh;
  T0 = 1;
  var r = Xe(), a = l8(), n = jh(), o = d8(), c = r.isFinite, s = Math.min;
  function h(l) {
    var g = Math[l];
    return function(p, b) {
      if (p = n(p), b = b == null ? 0 : s(a(b), 292), b && c(p)) {
        var w = (o(p) + "e").split("e"), x = g(w[0] + "e" + (+w[1] + b));
        return w = (o(x) + "e").split("e"), +(w[0] + "e" + (+w[1] - b));
      }
      return g(p);
    };
  }
  return qh = h, qh;
}
var Hh, P0;
function g8() {
  if (P0) return Hh;
  P0 = 1;
  var r = f8(), a = r("round");
  return Hh = a, Hh;
}
var p8 = g8();
const dn = /* @__PURE__ */ vn(p8), ga = {
  getBackgroundColor(r) {
    switch (r) {
      case tt.GREY:
        return "rgb(103, 103, 103, 0.4)";
      case tt.BLUE:
        return "rgba(0, 176, 255, 0.4)";
      default:
        Dr(r);
    }
  },
  getBorderColor(r) {
    switch (r) {
      case tt.GREY:
        return "rgb(103, 103, 103)";
      case tt.BLUE:
        return "rgb(0, 176, 255)";
      default:
        Dr(r);
    }
  }
}, Ue = {
  loadImageFromUrl(r, a) {
    const { isPrintEnabled: n } = xt.getState();
    return new Promise((o, c) => {
      const s = document.createElement("img");
      n && (s.crossOrigin = "anonymous"), s.onload = function() {
        const h = new yt.Image({
          image: s,
          listening: !1,
          ...a
        });
        o(h);
      }, s.onerror = c, s.src = r;
    });
  }
};
function O0(r) {
  return typeof r == "string";
}
class Be extends yt.Group {
  constructor(n, o) {
    var c;
    super(n);
    Ye(this, "HIGHLIGHT_GROUP_NAME", "highlight");
    Ye(this, "IMAGE_NAME", "image");
    Ye(this, "SPOT_NAME", "spot");
    Ye(this, "GAP", 2);
    Ye(this, "ATTRIBUTE_ICON_WIDTH", 8);
    Ye(this, "highligthColor", null);
    this.spot = o, this.highligthColor = (c = o.highlightColor) != null ? c : null;
  }
  get backgroundBorderColor() {
    var n, o, c;
    return (c = (o = (n = this.spot.style) == null ? void 0 : n.css) == null ? void 0 : o.borderColor) != null ? c : "rgb(135, 135, 135)";
  }
  get hasAttributeIcon() {
    var n;
    return O0((n = this.spot.style) == null ? void 0 : n.attributeIcon);
  }
  get isPlayfield() {
    return this.spot.subType === Er.PLAYFIELD;
  }
  get strokeWidth() {
    var n, o, c;
    return (c = (o = (n = this.spot.style) == null ? void 0 : n.css) == null ? void 0 : o.borderWidth) != null ? c : 1;
  }
  get bgWidth() {
    return this.spot.width - this.strokeWidth;
  }
  addBackground() {
    var o, c, s, h, l;
    const n = new yt.Rect({
      width: this.bgWidth,
      height: this.spot.height - this.strokeWidth,
      fill: (s = (c = (o = this.spot.style) == null ? void 0 : o.css) == null ? void 0 : c.backgroundColor) != null ? s : "#FFF",
      cornerRadius: 4,
      stroke: this.backgroundBorderColor,
      strokeWidth: this.strokeWidth,
      ...((l = (h = this.spot.style) == null ? void 0 : h.css) == null ? void 0 : l.borderStyle) === "dashed" ? { dash: [5, 5] } : {}
    });
    this.add(n);
  }
  clearHighlight() {
    this.highligthColor = null, this.find(`.${this.HIGHLIGHT_GROUP_NAME}`).forEach((n) => n.destroy());
  }
  async highlight(n, o = !1) {
    try {
      if (this.highligthColor !== null && !o)
        return;
      this.highligthColor = n;
      const c = ga.getBackgroundColor(n), s = ga.getBorderColor(n), h = new yt.Rect({
        name: this.HIGHLIGHT_GROUP_NAME,
        width: this.width(),
        height: this.height(),
        fill: c,
        stroke: s,
        cornerRadius: 4,
        listening: !1
      });
      this.add(h), h.zIndex(1);
      const l = await Ue.loadImageFromUrl(
        `${xt.getState().assetsBaseUrl}/iconset/check.svg`
      ), g = new yt.Circle({
        name: this.HIGHLIGHT_GROUP_NAME,
        width: 16,
        height: 16,
        fill: s,
        x: this.width() / 2,
        y: this.height() / 2,
        listening: !1
      }), p = 10;
      l.name(this.HIGHLIGHT_GROUP_NAME), l.width(p), l.height(p), l.x(this.width() / 2 - p / 2), l.y(this.height() / 2 - p / 2), this.add(g, l);
    } catch (c) {
      console.error(c);
    }
  }
  getYFromImageSize() {
    const n = this.GAP, o = this.findOne(`.${this.IMAGE_NAME}`);
    return o ? o.y() + 1 + o.height() : n;
  }
  async addAttributeIcon() {
    var n;
    try {
      const o = (n = this.spot.style) == null ? void 0 : n.attributeIcon;
      if (!O0(o))
        return;
      const { assetsBaseUrl: c } = xt.getState(), s = await Ue.loadImageFromUrl(
        `${c}/iconset/${o}`
      ), h = this.ATTRIBUTE_ICON_WIDTH, l = new yt.Rect({
        width: h + this.GAP * 2,
        height: h + this.GAP * 2,
        fill: this.backgroundBorderColor,
        listening: !1
      });
      l.x(this.bgWidth - l.width()), s.width(h), s.height(h), s.x(this.bgWidth - h - this.GAP), s.y(this.GAP), s.listening(!1), this.add(l, s);
    } catch (o) {
      console.error(o);
    }
  }
}
const _8 = "background-sea", v8 = "background-sand", y8 = 100;
class m8 extends yt.Layer {
  constructor(n) {
    super({
      draggable: !1,
      listening: !1
    });
    Ye(this, "bgImage", null);
    Ye(this, "seaImage", null);
    Ye(this, "sandRect", null);
    typeof (n == null ? void 0 : n.visible) == "boolean" && this.visible(n.visible), this.init();
  }
  setVisibility(n) {
    this.visible(n);
  }
  toggleVisibility() {
    this.visible(!this.visible());
  }
  updateBgSize() {
    const { background: n, mapSize: o } = xt.getState();
    this.sandRect !== null && (this.sandRect.width(o.width), this.sandRect.height(o.height)), this.seaImage !== null && this.seaImage.width(o.width), this.bgImage !== null && (this.bgImage.width(n.width), this.bgImage.height(n.height));
  }
  init() {
    this.renderSand(), this.renderSea(() => this.renderCustomBackground());
  }
  renderSand() {
    const { mapSize: n } = xt.getState();
    this.sandRect = new yt.Rect({
      x: 0,
      y: 0,
      width: n.width,
      height: n.height,
      fill: "wheat",
      id: v8,
      listening: !1,
      draggable: !1
    }), this.add(this.sandRect);
  }
  renderSea(n) {
    const { assetsBaseUrl: o } = xt.getState();
    Ue.loadImageFromUrl(`${o}/images/sea.svg`).then((c) => {
      this.seaImage = c;
      const { mapSize: s } = xt.getState();
      c.setAttrs({
        x: 0,
        y: 0,
        fillPatternRepeat: "repeat-x",
        width: s.width,
        height: y8,
        id: _8
      }), c.listening(!1), c.draggable(!1), this.add(c), n();
    }).catch((c) => {
      console.error(c);
    });
  }
  renderCustomBackground() {
    const { background: n } = xt.getState(), o = n.url;
    o && Ue.loadImageFromUrl(o).then((c) => {
      this.bgImage = c, c.width(n.width), c.height(n.height), c.x(n.offset.x), c.y(n.offset.y), this.add(c);
    }).catch((c) => {
      console.error(c);
    });
  }
}
class er extends yt.Group {
  constructor(a, n, o) {
    super({
      x: n.x,
      y: n.y,
      ...o
    }), this.decoration = n, this.add(a), this.init(a);
  }
  getSubType() {
    return this.decoration.subType;
  }
  get isSquareCell() {
    return this.decoration.width === this.decoration.cellSize.width;
  }
  get isDebugEnabled() {
    return xt.getState().debug;
  }
  addDebugInfo() {
    if (!this.isDebugEnabled)
      return;
    const a = new yt.Rect({
      dash: [5, 5],
      height: this.height(),
      listening: !1,
      stroke: "rebeccapurple",
      strokeWidth: 1,
      width: this.width(),
      x: 0,
      y: 0
    });
    this.add(a);
  }
}
const fn = (r) => r * (Math.PI / 180), b8 = (r) => r * (180 / Math.PI);
function F0(r, a) {
  const n = Math.cos(a), o = Math.sin(a);
  return {
    x: r.x * n - r.y * o,
    y: r.y * n + r.x * o
  };
}
function Nr(r, a) {
  const n = { x: -r.width() / 2, y: -r.height() / 2 }, o = F0(n, 0), c = F0(n, fn(a)), s = c.x - o.x, h = c.y - o.y;
  r.rotation(a), r.x(r.x() + s), r.y(r.y() + h);
}
class o1 extends er {
  constructor(a, n) {
    const o = n.cellSize.width / n.width;
    super(a, n, {
      height: a.height(),
      width: a.width() * o
    }), this.add(a);
  }
  init(a) {
    this.addDebugInfo(), a.x(this.width() / 2 - a.width() / 2), this.decoration.rotation > 0 && Nr(a, this.decoration.rotation);
  }
  addDebugInfo() {
    if (!this.isDebugEnabled)
      return;
    const a = new yt.Rect({
      dash: [5, 5],
      height: this.height(),
      listening: !1,
      stroke: "yellow",
      strokeWidth: 1,
      width: this.width(),
      x: 0,
      y: 0
    });
    this.add(a);
  }
}
class w8 extends er {
  constructor(a, n) {
    super(a, n, {
      height: n.cellSize.height,
      width: n.cellSize.width
    }), this.add(a);
  }
  init(a) {
    this.adjustImageSize(a), this.adjustImagePosition(a), this.addDebugInfo();
  }
  getCustomDecorationImageSize(a, n, o) {
    const c = a.width / n, s = a.height / o;
    return c < s ? {
      width: a.width,
      height: Math.floor(o * c)
    } : {
      width: Math.floor(n * s),
      height: a.height
    };
  }
  adjustImageSize(a) {
    a.setAttrs({
      ...this.getCustomDecorationImageSize(
        this.decoration,
        a.width(),
        a.height()
      )
    });
  }
  adjustImagePosition(a) {
    a.x(this.width() / 2 - a.width() / 2), a.y(this.height() / 2 - a.height() / 2), this.decoration.rotation > 0 && Nr(a, this.decoration.rotation);
  }
}
class S8 extends er {
  constructor(a, n) {
    super(a, n, {
      height: n.cellSize.height,
      width: n.cellSize.width
    }), this.add(a);
  }
  init() {
  }
}
class C8 extends er {
  constructor(a, n) {
    super(a, n, {
      height: n.height,
      width: n.width
    }), this.add(a);
  }
  init(a) {
    this.adjustLineWidth(a), this.adjustRotation(a), this.addDebugInfo();
  }
  addDebugInfo() {
    if (!this.isDebugEnabled)
      return;
    const a = fn(this.decoration.rotation), n = Math.cos(a), o = Math.sin(a);
    if (Math.abs(n) === 1 || Math.abs(o) === 1)
      return;
    const c = n < 0, s = o < 0, h = Math.abs(this.decoration.width * n), l = Math.abs(this.decoration.width * o), g = new yt.Rect({
      x: c ? -h : 0,
      y: s ? -l : 0,
      width: h,
      height: l,
      stroke: "goldenrod",
      strokeWidth: 1,
      dash: [5, 5],
      listening: !1
    }), p = this.decoration.cellSize.width / this.decoration.width;
    if (p !== 1) {
      const b = h * p, w = new yt.Rect({
        x: c ? -b : 0,
        y: s ? -l : 0,
        width: b,
        height: l,
        stroke: "deepskyblue",
        strokeWidth: 1,
        dash: [5, 5],
        listening: !1
      });
      this.add(w);
    }
    this.add(g);
  }
  adjustLineWidth(a) {
    if (this.isSquareCell || !(a instanceof yt.Group) || a.children.length < 1)
      return;
    const n = a.children[0], o = fn(this.decoration.rotation), c = Math.cos(o), s = Math.sin(o);
    if (Math.abs(s) === 1)
      return;
    if (Math.abs(c) === 1) {
      n.width(this.decoration.cellSize.width);
      return;
    }
    const h = this.decoration.width * c, l = this.decoration.width * s, g = this.decoration.cellSize.width / this.decoration.width, p = h * g, b = Math.sqrt(Math.pow(p, 2) + Math.pow(l, 2));
    n.width(b);
  }
  adjustRotation(a) {
    if (this.decoration.rotation <= 0)
      return;
    const n = fn(this.decoration.rotation), o = Math.cos(n), c = Math.sin(n);
    if (this.isSquareCell || Math.abs(o) === 1 || Math.abs(c) === 1) {
      Nr(a, this.decoration.rotation);
      return;
    }
    const s = o < 0, h = c < 0, l = Math.abs(this.decoration.width * o), g = Math.abs(this.decoration.width * c), p = this.decoration.cellSize.width / this.decoration.width, b = l * p, w = Math.atan(g / b), x = b8(w);
    s && h ? Nr(a, x + 180) : s ? Nr(a, 180 - x) : Nr(a, x);
  }
}
function x8(r) {
  const a = fn(r), n = Math.cos(a), o = Math.sin(a);
  switch (!0) {
    case n === 1:
      return "horizontal";
    case n === -1:
      return "horizontal-flip";
    case o === 1:
      return "vertical";
    case o === -1:
      return "vertical-flip";
    default:
      return "diagonal";
  }
}
class E8 extends o1 {
  constructor(a, n) {
    super(a, n);
  }
  init(a) {
    const n = x8(this.decoration.rotation);
    if (this.isSquareCell || n === "diagonal") {
      super.init(a);
      return;
    }
    this.decoration.rotation > 0 && Nr(a, this.decoration.rotation), this.handleStretch(a, n), this.addDebugInfo();
  }
  addDebugInfo() {
    if (!this.isDebugEnabled)
      return;
    const a = this.children[0];
    if (!a)
      return;
    const n = new yt.Rect({
      dash: [5, 5],
      height: a.height(),
      listening: !1,
      stroke: "hotpink",
      strokeWidth: 1,
      width: a.width(),
      x: 0,
      y: 0
    });
    this.add(n);
  }
  handleStretch(a, n) {
    const o = this.decoration.cellSize.width / this.decoration.width;
    switch (n) {
      case "vertical": {
        const c = a.height() * o, s = c - a.height();
        a.height(c), a.offsetY(s);
        break;
      }
      case "vertical-flip": {
        a.height(a.height() * o);
        break;
      }
      case "horizontal": {
        a.width(a.width() * o), a.x(0);
        break;
      }
      case "horizontal-flip": {
        a.width(a.width() * o), a.x(this.width());
        break;
      }
      default:
        Dr(n);
    }
  }
}
const A8 = "black";
class R8 {
  async createDecoration(a) {
    switch (a.subType) {
      case ge.CUSTOM:
        return T8(a);
      case ge.LABEL:
        return P8(a);
      case ge.LINE:
        return F8(a);
      case ge.BASKET_FIELD:
      case ge.BEACH_VOLLEY:
      case ge.FOOTBOARD:
      case ge.POOL:
      case ge.POOL_ROUNDED:
      case ge.SOCCER_FIELD:
      case ge.TENT:
      case ge.TENT_BIG:
        return k0(a, !0);
      default:
        return k0(a);
    }
  }
}
async function T8(r) {
  if (!r.url)
    throw new Error("Decoration URL is required");
  try {
    const a = await Ue.loadImageFromUrl(r.url);
    return a.setAttrs({
      x: 0,
      y: 0
    }), new w8(a, r);
  } catch (a) {
    console.error(a);
  }
  return null;
}
async function k0(r, a = !1) {
  const n = `${xt.getState().assetsBaseUrl}/decorations/${r.subType}.svg`;
  try {
    const o = await Ue.loadImageFromUrl(n), c = k8(r), s = o.width(), h = o.height();
    if (s > h) {
      const l = c.width, g = h / s * c.height;
      o.setAttrs({
        height: g,
        width: l
      });
    } else if (s < h) {
      const l = c.height, g = s / h * c.width;
      o.setAttrs({
        height: l,
        width: g
      });
    } else {
      const l = c.height, g = c.width;
      o.setAttrs({
        height: l,
        width: g
      });
    }
    return a ? new E8(o, r) : new o1(o, r);
  } catch (o) {
    console.error(o);
  }
  return null;
}
function P8(r) {
  const a = new yt.Text({
    fill: "black",
    fontFamily: "Calibri",
    fontSize: 14,
    listening: !1,
    padding: 4,
    text: r.name,
    x: 0,
    y: 0
  });
  return new S8(a, r);
}
const O8 = (r) => r.trim().length === 0 ? A8 : r;
function F8(r) {
  const a = new yt.Group({
    listening: !1,
    x: 0,
    y: 0
  }), n = new yt.Rect({
    fill: O8(r.name),
    height: r.height,
    listening: !1,
    strokeEnabled: !1,
    width: r.width,
    x: 0,
    y: 0
  });
  return a.add(n), new C8(a, r);
}
function k8(r) {
  return r.width > r.height ? {
    width: r.height,
    height: r.height
  } : r.width < r.height ? {
    width: r.width,
    height: r.width
  } : {
    width: r.width,
    height: r.height
  };
}
function I8(r) {
  const a = r.split(" ");
  return {
    timeSlot: a[a.length - 1],
    name: a.slice(0, a.length - 1).join(" ")
  };
}
function Jh(r) {
  return r.subType === Er.PLAYFIELD ? I8(r.name).name : r.name;
}
const ti = 1, I0 = "image";
class h1 extends Be {
  constructor(a, n) {
    super(a, n);
  }
  get isAvailable() {
    var a;
    return ((a = this.spot.style) == null ? void 0 : a.iconColor) === tt.GREEN;
  }
  async init() {
    this.addBackground(), await this.addImage(), this.addSpotName();
  }
  clearHighlight() {
    this.highligthColor !== null && (this.highligthColor = null, this.redrawImage());
  }
  async highlight() {
    this.highligthColor === null && (this.highligthColor = tt.BLUE, await this.redrawImage());
  }
  async redrawImage() {
    var n;
    (n = this.findOne(`.${I0}`)) == null || n.destroy();
    const a = await this.addImage();
    a !== null && a.zIndex(1);
  }
  addBackground() {
    const a = new yt.Rect({
      width: this.spot.width,
      height: this.spot.height,
      fill: "#FFF",
      cornerRadius: 4
    });
    this.add(a);
  }
  getImageName() {
    return this.highligthColor ? "checked" : this.isAvailable ? "available" : "not-available";
  }
  getImageWidth() {
    return this.spot.subType === Er.CABIN ? 24 : this.spot.subType === Er.UMBRELLA && this.highligthColor ? 35 : 30;
  }
  async addImage() {
    try {
      const a = `${this.spot.subType}-${this.getImageName()}`, n = `${xt.getState().assetsBaseUrl}/spots/${a}.svg`, o = await Ue.loadImageFromUrl(n), c = this.getImageWidth(), s = c * o.height() / o.width();
      return o.width(c), o.height(s), o.x(this.width() / 2 - o.width() / 2), o.y(this.height() / 2 - o.height() / 2), o.name(I0), this.add(o), o;
    } catch (a) {
      console.error(a);
    }
    return null;
  }
  addSpotName() {
    if (!this.isAvailable)
      return;
    if (this.spot.subType === Er.PLAYFIELD)
      return this.addPlayfieldName();
    const a = new yt.Text({
      text: Jh(this.spot),
      fontSize: 12,
      fontStyle: "bold",
      fill: "black",
      wrap: "none",
      listening: !1,
      x: 0,
      y: 0
    });
    a.width() > this.width() ? (a.width(this.width() - ti * 2), a.x(this.width() - a.width() - ti)) : a.x(this.width() - a.width() - ti * 2), a.y(this.height() - a.height());
    const n = new yt.Rect({
      cornerRadius: 4,
      fill: "white",
      height: a.height(),
      listening: !1,
      width: a.width(),
      x: a.x(),
      y: a.y()
    });
    this.add(n, a);
  }
  addPlayfieldName() {
    const [a, n] = this.spot.name.split(" "), o = new yt.Text({
      text: a,
      fontSize: 10,
      fontStyle: "bold",
      fill: "black",
      wrap: "none",
      listening: !1,
      x: 0,
      y: 0
    });
    o.x(this.width() - o.width() - ti * 2), o.y(this.height() - o.height());
    const c = new yt.Rect({
      cornerRadius: 4,
      fill: "white",
      height: o.height() * 2,
      listening: !1,
      width: this.width(),
      x: 0,
      y: o.y()
    }), s = n.indexOf("-"), h = n.substring(0, s + 1), l = n.substring(s + 1), g = new yt.Text({
      text: h,
      fontSize: 10,
      fontStyle: "bold",
      fill: "black",
      wrap: "none",
      listening: !1,
      x: 0,
      y: 0
    });
    g.x(this.width() - g.width() - ti * 2), g.y(c.y() + 10);
    const p = new yt.Text({
      text: l,
      fontSize: 10,
      fontStyle: "bold",
      fill: "black",
      wrap: "none",
      listening: !1,
      x: 0,
      y: 0
    });
    p.x(this.width() - p.width() - ti * 2), p.y(g.y() + 10), this.add(c, o, g, p);
  }
}
const Qh = {
  getSpotIconByColor(r, a) {
    const n = `spots/${r}`;
    switch (a) {
      case tt.RED:
      case tt.BLUE:
      case tt.GREEN:
      case tt.YELLOW:
      case tt.ORANGE:
      case tt.WHITE:
      case tt.BLACK:
      case tt.PURPLE:
      case tt.BLACK_WHITE:
      case tt.BLACK_BLUE:
      case tt.BLACK_YELLOW:
      case tt.BLACK_GREY:
      case tt.BLACK_RED:
      case tt.BLACK_GREEN:
      case tt.BLACK_PURPLE:
      case tt.GREY:
      case tt.CYAN:
      case tt.BROWN:
      case tt.LIME:
      case tt.PINK:
        return `${n}/${a.toLowerCase()}.svg`;
      case tt.PINK_FLUO:
        return `${n}/pinkfluo.svg`;
      case tt.RED_FLUO:
        return `${n}/redfluo.svg`;
      case tt.BLUE_FLUO:
        return `${n}/bluefluo.svg`;
      case tt.GREEN_FLUO:
        return `${n}/greenfluo.svg`;
      case tt.YELLOW_FLUO:
        return `${n}/yellowfluo.svg`;
      case tt.WHITE_FLUO:
        return `${n}/whitefluo.svg`;
      case tt.PURPLE_FLUO:
        return `${n}/purplefluo.svg`;
    }
  }
};
class L8 extends Be {
  constructor(a, n) {
    super(a, n);
  }
  async init() {
    this.addBackground(), await this.addImage(), this.addSpotName(), this.addCustomLabel();
  }
  clearHighlight() {
  }
  async highlight() {
  }
  addBackground() {
    var n, o, c, s, h, l, g, p;
    const a = new yt.Circle({
      radius: this.width() / 2,
      fill: (c = (o = (n = this.spot.style) == null ? void 0 : n.css) == null ? void 0 : o.backgroundColor) != null ? c : "#FFF",
      stroke: "rgb(135, 135, 135)",
      strokeWidth: (l = (h = (s = this.spot.style) == null ? void 0 : s.css) == null ? void 0 : h.borderWidth) != null ? l : 1,
      x: this.width() / 2,
      y: this.height() / 2,
      ...((p = (g = this.spot.style) == null ? void 0 : g.css) == null ? void 0 : p.borderStyle) === "dashed" ? { dash: [5, 5] } : {}
    });
    this.add(a);
  }
  async addImage() {
    var a, n;
    try {
      const o = `${xt.getState().assetsBaseUrl}/${Qh.getSpotIconByColor(this.spot.subType, (n = (a = this.spot.style) == null ? void 0 : a.iconColor) != null ? n : tt.GREEN)}`, c = await Ue.loadImageFromUrl(o), s = 32, h = s * c.height() / c.width();
      c.width(s), c.height(h), c.x(this.width() / 2 - c.width() / 2), c.y(this.height() / 2 - c.height() / 2), this.add(c);
    } catch (o) {
      console.error(o);
    }
  }
  addSpotName() {
    const a = new yt.Text({
      text: this.spot.name,
      fontSize: 10,
      fontStyle: "bold",
      fill: "#242424",
      align: "center",
      wrap: "none",
      width: this.width(),
      y: 38,
      listening: !1
    });
    this.add(a);
  }
  addCustomLabel() {
    if (typeof this.spot.customLabel != "string")
      return;
    const a = new yt.Text({
      text: this.spot.customLabel,
      fontSize: 8,
      fill: "#242424",
      align: "center",
      width: this.width(),
      y: 8,
      listening: !1
    });
    this.add(a);
  }
}
const L0 = "SPOT_DATE", la = 10, M8 = 6.6, M0 = 13;
class N8 extends Be {
  constructor(a, n) {
    super(a, n);
  }
  async init() {
    this.addBackground(), this.addCustomerName(), this.addServiceIcons(), await this.addImage(), this.addDate(), this.addSpotName(), this.addStaging(), this.highligthColor && await this.highlight(this.highligthColor, !0), await this.addAttributeIcon();
  }
  async addImage() {
    var a, n;
    try {
      const o = `${xt.getState().assetsBaseUrl}/${Qh.getSpotIconByColor(this.spot.subType, (n = (a = this.spot.style) == null ? void 0 : a.iconColor) != null ? n : tt.GREEN)}`, c = await Ue.loadImageFromUrl(o, {
        name: this.IMAGE_NAME,
        y: 14
      }), s = 1 / (c.height() / M0);
      c.width(c.width() * s), c.height(M0), c.x(this.GAP), this.add(c);
    } catch (o) {
      console.error(o);
    }
  }
  getSpotNameWidth() {
    const a = this.findOne(`.${L0}`);
    return a ? this.bgWidth - a.width() : this.bgWidth;
  }
  addSpotName() {
    const a = this.getSpotNameWidth(), n = new yt.Text({
      fill: "black",
      fontSize: la,
      fontStyle: "bold",
      listening: !1,
      name: this.SPOT_NAME,
      text: Jh(this.spot),
      width: a,
      wrap: "none",
      x: this.GAP / 2,
      y: this.getYFromImageSize()
    });
    this.add(n);
  }
  addStaging() {
    if (this.spot.staging === null)
      return;
    const a = new yt.Text({
      text: this.spot.staging,
      fontSize: this.isPlayfield ? M8 : la,
      fill: "black",
      y: 20 - this.strokeWidth,
      listening: !1
    });
    a.x(
      this.width() - a.width() * 2 / this.GAP - this.strokeWidth
    ), this.add(a);
  }
  addDate() {
    var o, c, s;
    const a = (s = (o = this.spot.reservation) == null ? void 0 : o.endDate) != null ? s : (c = this.spot.reservation) == null ? void 0 : c.startDate;
    if (a === null)
      return;
    const n = new yt.Text({
      text: a,
      name: L0,
      fontSize: la,
      fill: "black",
      y: 30 - this.strokeWidth,
      listening: !1,
      wrap: "none"
    });
    n.x(this.width() - n.width() - this.strokeWidth), this.add(n);
  }
  addCustomerName() {
    var o;
    const a = (o = this.spot.reservation) == null ? void 0 : o.customerName;
    if (typeof a != "string")
      return;
    const n = new yt.Text({
      ellipsis: !0,
      fill: "black",
      fontSize: la,
      listening: !1,
      text: a,
      width: this.width() - 2 * this.GAP - (this.hasAttributeIcon ? this.ATTRIBUTE_ICON_WIDTH : 0),
      wrap: "none",
      x: this.GAP,
      y: this.GAP
    });
    this.add(n);
  }
  async addServiceIcons() {
    if (!Array.isArray(this.spot.serviceIcons) || this.spot.serviceIcons.length === 0)
      return;
    const { assetsBaseUrl: a } = xt.getState(), n = 7;
    let o = 0;
    for await (const c of this.spot.serviceIcons)
      try {
        const s = await Ue.loadImageFromUrl(
          `${a}/services/${c}`
        ), h = s.width() * n / s.height();
        s.width(h), s.height(n), s.y(12), s.x(this.width() - s.width() - o - this.strokeWidth), s.listening(!1), o += s.width(), this.add(s);
      } catch (s) {
        console.error(s);
      }
  }
}
const G8 = "SPOT_DATE", Vh = 10, D8 = 6.6, N0 = 13;
class B8 extends Be {
  constructor(a, n) {
    super(a, n);
  }
  async init() {
    this.addBackground(), await this.addImage(), this.addSpotName(), this.addDate(), this.addStaging(), this.highligthColor && await this.highlight(this.highligthColor, !0), await this.addAttributeIcon();
  }
  clearHighlight() {
    this.highligthColor = null, this.find(`.${this.HIGHLIGHT_GROUP_NAME}`).forEach((a) => a.destroy());
  }
  async highlight(a, n = !1) {
    try {
      if (this.highligthColor !== null && !n)
        return;
      this.highligthColor = a;
      const o = ga.getBackgroundColor(a), c = ga.getBorderColor(a), s = new yt.Rect({
        name: this.HIGHLIGHT_GROUP_NAME,
        width: this.width(),
        height: this.height(),
        fill: o,
        stroke: c,
        cornerRadius: 4,
        listening: !1
      });
      this.add(s), s.zIndex(1);
      const h = await Ue.loadImageFromUrl(
        `${xt.getState().assetsBaseUrl}/iconset/check.svg`
      ), l = new yt.Circle({
        name: this.HIGHLIGHT_GROUP_NAME,
        width: 16,
        height: 16,
        fill: c,
        x: this.width() / 2,
        y: this.height() / 2,
        listening: !1
      }), g = 10;
      h.name(this.HIGHLIGHT_GROUP_NAME), h.width(g), h.height(g), h.x(this.width() / 2 - g / 2), h.y(this.height() / 2 - g / 2), this.add(l, h);
    } catch (o) {
      console.error(o);
    }
  }
  getYFromSpotName() {
    const a = this.GAP, n = this.findOne(`.${this.SPOT_NAME}`);
    return n ? a + n.y() + n.height() : a;
  }
  async addImage() {
    var a, n;
    try {
      const o = `${xt.getState().assetsBaseUrl}/${Qh.getSpotIconByColor(this.spot.subType, (n = (a = this.spot.style) == null ? void 0 : a.iconColor) != null ? n : tt.GREEN)}`, c = await Ue.loadImageFromUrl(o, {
        name: this.IMAGE_NAME,
        y: this.GAP
      }), s = 1 / (c.height() / N0);
      c.width(c.width() * s), c.height(N0), c.x(this.spot.width / 2 - c.width() / 2), this.add(c);
    } catch (o) {
      console.error(o);
    }
  }
  getSpotNameWidth() {
    return this.spot.width;
  }
  addSpotName() {
    const a = this.getSpotNameWidth(), n = new yt.Text({
      align: "center",
      ellipsis: !0,
      fill: "black",
      fontSize: Vh,
      fontStyle: "bold",
      listening: !1,
      name: this.SPOT_NAME,
      text: Jh(this.spot),
      width: a,
      wrap: "none",
      y: this.getYFromImageSize()
    });
    this.add(n);
  }
  addStaging() {
    if (this.spot.layout !== Te.VIEWER_STAGING || this.spot.staging === null)
      return;
    const a = new yt.Text({
      align: "center",
      ellipsis: !0,
      fill: "black",
      fontSize: this.isPlayfield ? D8 : Vh,
      listening: !1,
      text: this.spot.staging,
      width: this.spot.width,
      wrap: "none",
      y: this.getYFromSpotName()
    });
    this.add(a);
  }
  addDate() {
    var o, c, s;
    const a = (s = (o = this.spot.reservation) == null ? void 0 : o.endDate) != null ? s : (c = this.spot.reservation) == null ? void 0 : c.startDate;
    if (this.spot.layout !== Te.VIEWER_DATE || a === null)
      return;
    const n = new yt.Text({
      align: "center",
      ellipsis: !0,
      fill: "black",
      fontSize: Vh,
      listening: !1,
      name: G8,
      text: a,
      width: this.spot.width,
      wrap: "none",
      y: this.getYFromSpotName()
    });
    this.add(n);
  }
}
class U8 {
  async createSpot(a) {
    const n = {
      id: a.id,
      x: a.x,
      y: a.y,
      width: a.width,
      height: a.height
    };
    let o;
    switch (a.layout) {
      case Te.BOOKING_NAME:
        o = new h1(n, a);
        break;
      case Te.VIEWER_DATE:
      case Te.VIEWER_FULL:
      case Te.VIEWER_NAME:
      case Te.VIEWER_STAGING:
        o = q8(n, a);
        break;
      default:
        Dr(a.layout);
    }
    return await o.init(), o;
  }
}
function q8(r, a) {
  if (a.subType === Er.BEDS)
    return new L8(
      {
        ...r,
        height: 52,
        width: 52
      },
      a
    );
  switch (a.layout) {
    case Te.BOOKING_NAME:
      throw new Error(`Invalid layout: ${a.layout}`);
    case Te.VIEWER_FULL:
      return new N8(r, a);
    case Te.VIEWER_DATE:
    case Te.VIEWER_NAME:
    case Te.VIEWER_STAGING:
      return new B8(r, a);
    default:
      Dr(a.layout);
  }
}
class H8 extends yt.Layer {
  constructor() {
    super();
  }
  addElements(a) {
    return this.renderElements({
      elements: a,
      destroyChildren: !1
    });
  }
  removeAllElements() {
    this.children.slice().forEach((a) => {
      a.destroy();
    });
  }
  removeElementsById(a) {
    a.forEach((n) => {
      const o = this.findOne(`#${n}`);
      o == null || o.destroy();
    });
  }
  async renderElements({
    elements: a,
    destroyChildren: n = !0,
    layerConfig: o
  }) {
    var w, x, v, _;
    n && this.destroyChildren();
    const c = new U8(), s = new R8(), h = (x = (w = o == null ? void 0 : o.spots) == null ? void 0 : w.visible) != null ? x : !0, l = (_ = (v = o == null ? void 0 : o.decorations) == null ? void 0 : v.visible) != null ? _ : !0, g = a.map(
      async (S) => {
        if (H0(S)) {
          const O = await c.createSpot(S);
          return h || O.visible(!1), O;
        }
        const C = await s.createDecoration(S);
        if (C === null)
          throw new Error(
            `Cannot create decoration element from: ${JSON.stringify(S)}`
          );
        return l || C.visible(!1), C;
      }
    ), b = (await Promise.allSettled(g)).reduce((S, C) => {
      switch (C.status) {
        case "rejected":
          console.error(C.reason);
          break;
        case "fulfilled":
          S.push(C.value);
      }
      return S;
    }, []).sort((S, C) => {
      if (S instanceof Be && C instanceof er)
        return 1;
      if (S instanceof er && C instanceof Be)
        return -1;
      if (S instanceof er && C instanceof er) {
        const O = S.getSubType() === ge.LABEL, d = C.getSubType() === ge.LABEL;
        if (O && !d)
          return 1;
        if (!O && d)
          return -1;
      }
      return 0;
    });
    this.add(...b), this.adjustLayerPosition();
  }
  updateOffset(a) {
    this.x(a), xt.setState({
      elementsLayerOffsetX: a
    });
  }
  adjustLayerPosition() {
    if (this.children.length === 0) {
      this.updateOffset(0);
      return;
    }
    const { mapSize: a, background: n, elementsMetaData: o } = xt.getState();
    if (!n.url && o !== null && o.maxX < a.width) {
      const c = a.width / 2 - o.maxX / 2;
      this.updateOffset(c);
    } else
      this.updateOffset(0);
  }
  setSpotsVisibility(a) {
    this.children.forEach((n) => {
      n instanceof Be && n.visible(a != null ? a : !n.visible());
    });
  }
  setDecorationsVisibility(a) {
    this.children.forEach((n) => {
      n instanceof er && n.visible(a != null ? a : !n.visible());
    });
  }
  setVisibility(a, n) {
    switch (a) {
      case fr.SPOT: {
        this.setSpotsVisibility(n);
        break;
      }
      case fr.DECORATION: {
        this.setDecorationsVisibility(n);
        break;
      }
      default:
        Dr(a);
    }
  }
  toggleVisibility(a) {
    switch (a) {
      case fr.SPOT: {
        this.setSpotsVisibility();
        break;
      }
      case fr.DECORATION: {
        this.setDecorationsVisibility();
        break;
      }
      default:
        Dr(a);
    }
  }
}
const G0 = 1754, ua = "black", ca = 0.5, gn = class gn extends yt.Layer {
  constructor(a) {
    super(), this.init(a);
  }
  init(a) {
    this.buildPrintPreview(a);
  }
  getPrintPreview() {
    return this.findOne(`#${gn.PRINT_PREVIEW_ID}`);
  }
  buildPrintPreview(a) {
    var v, _, S, C, O, d, f, m;
    const { mapSize: n } = xt.getState(), o = new yt.Rect({
      id: gn.PRINT_PREVIEW_ID,
      x: (_ = (v = a.initialPreview) == null ? void 0 : v.x) != null ? _ : 0,
      y: (C = (S = a.initialPreview) == null ? void 0 : S.y) != null ? C : 0,
      width: (d = (O = a.initialPreview) == null ? void 0 : O.width) != null ? d : 100,
      height: (m = (f = a.initialPreview) == null ? void 0 : f.height) != null ? m : 100,
      draggable: !0
    }), c = o.x(), s = o.y(), h = o.x() + o.width(), l = o.y() + o.height(), g = new yt.Rect({
      x: 0,
      y: 0,
      width: c,
      height: n.height,
      fill: ua,
      opacity: ca,
      listening: !1
    }), p = new yt.Rect({
      x: h - 0.5,
      y: 0,
      width: n.width - h,
      height: n.height,
      fill: ua,
      opacity: ca,
      listening: !1
    }), b = new yt.Rect({
      x: c,
      y: 0,
      width: o.width(),
      height: s,
      fill: ua,
      opacity: ca,
      listening: !1
    }), w = new yt.Rect({
      x: c,
      y: l,
      width: o.width(),
      height: n.height - l,
      fill: ua,
      opacity: ca,
      listening: !1
    }), x = new yt.Transformer({
      enabledAnchors: [
        "top-left",
        "top-right",
        "bottom-left",
        "bottom-right",
        "top-center",
        "middle-right",
        "middle-left",
        "bottom-center"
      ],
      rotateEnabled: !1,
      keepRatio: !1,
      anchorFill: "white",
      anchorStroke: "black",
      borderStroke: "black",
      borderStrokeWidth: 1,
      flipEnabled: !1
    });
    this.add(
      g,
      p,
      b,
      w,
      o,
      x
    ), x.nodes([o]), o.on("transform dragmove", () => {
      const E = this.getPrintPreview();
      if (!E) {
        console.error("printPreview is not initialized");
        return;
      }
      const T = E.width() * E.scaleX(), D = E.height() * E.scaleY(), I = E.x(), L = E.y(), F = E.x() + T, N = E.y() + D;
      g.width(I), p.setAttrs({
        x: F - 0.5,
        width: n.width - F
      }), b.setAttrs({
        x: I,
        y: 0,
        width: T,
        height: L
      }), w.setAttrs({
        x: I,
        y: N,
        width: T,
        height: n.height - N
      });
    }), o.on("transformend dragend", () => {
      a.cb && this.print(this.parent).then(a.cb);
    });
  }
  print(a) {
    return new Promise((n, o) => {
      const c = this.getPrintPreview();
      if (!c) {
        o("printPreview is not initialized");
        return;
      }
      const s = a.scaleX(), h = c.width() * c.scaleX(), l = c.height() * c.scaleY(), g = c.x(), p = c.y(), b = l > h ? G0 / (l * s) : G0 / (h * s);
      this.hide();
      try {
        a.toDataURL({
          x: g * s,
          y: p * s,
          // keep at least a 5x on the image
          pixelRatio: Math.max(b, 5),
          width: h * s,
          height: l * s,
          callback: (w) => {
            this.show(), n({
              data: w,
              x: g,
              y: p,
              width: h,
              height: l,
              pixelRatio: b
            });
          }
        });
      } catch (w) {
        this.show(), o(w);
      }
    });
  }
};
Ye(gn, "PRINT_PREVIEW_ID", "print-preview");
let pa = gn;
const D0 = {
  fit(r, a) {
    const n = r.width / r.height, o = a.width / a.height;
    return n > o ? {
      width: a.width,
      height: a.width / n
    } : {
      width: a.height * n,
      height: a.height
    };
  },
  cover(r, a) {
    const n = r.width / r.height, o = a.width / a.height;
    return n < o ? {
      width: a.width,
      height: a.width / n
    } : {
      width: a.height * n,
      height: a.height
    };
  }
};
function _a(r, a) {
  const { draggable: n, fit: o } = xt.getState();
  return o === _n.CONTAIN ? D0.fit(a, {
    width: r.clientWidth,
    height: r.clientHeight
  }) : n ? {
    width: r.clientWidth,
    height: r.clientHeight
  } : D0.cover(a, {
    width: r.clientWidth,
    height: r.clientHeight
  });
}
function V8(r) {
  const a = _a(r.container, r.mapSize), n = new yt.Stage({
    container: r.container.id,
    width: a.width,
    height: a.height,
    draggable: r.draggable
  });
  return n.on("click tap", function(o) {
    var s, h;
    const c = o.target.getParent();
    c instanceof Be && ((h = (s = r.events) == null ? void 0 : s.onMapElementClick) == null || h.call(s, c.id()));
  }), n.on("dragmove", function() {
    var o;
    if ((o = r.events) != null && o.onMapPanZoom) {
      const { x: c, y: s } = n.position(), h = n.scaleX();
      r.events.onMapPanZoom({
        position: {
          x: c / h,
          y: s / h
        },
        zoom: h
      });
    }
  }), n.on("mouseover", () => {
    var h, l, g, p;
    const o = n.getPointerPosition(), { isPrintEnabled: c } = xt.getState();
    if (o === null)
      return;
    let s = n.getIntersection(o);
    if (c) {
      if ((s == null ? void 0 : s.id()) === pa.PRINT_PREVIEW_ID) {
        n.container().style.cursor = "move";
        return;
      }
    } else {
      for (; s !== null; ) {
        if (s instanceof h1) {
          n.container().style.cursor = s.isAvailable ? "pointer" : "not-allowed";
          return;
        }
        if (s instanceof Be) {
          (l = (h = r.events) == null ? void 0 : h.onMapElementHover) == null || l.call(h, s.id()), n.container().style.cursor = "pointer";
          return;
        }
        if (s instanceof er) {
          (p = (g = r.events) == null ? void 0 : g.onMapElementHover) == null || p.call(g, s.id());
          return;
        }
        s = s.parent;
      }
      n.container().style.cursor = "move";
    }
  }), n.on("mouseout", () => {
    n.container().style.cursor = "default";
  }), n;
}
const pn = 2;
function Gr(r) {
  const { mapSize: a } = xt.getState(), n = a.width * r.scale, o = a.height * r.scale;
  return {
    x: Math.min(
      0,
      Math.max(r.stageSize.width - n, r.pos.x)
    ),
    y: Math.min(
      0,
      Math.max(r.stageSize.height - o, r.pos.y)
    )
  };
}
function zh(r) {
  const { minScale: a } = xt.getState();
  r.scale({ x: a, y: a }), r.position(
    Gr({
      scale: r.scaleX(),
      pos: r.position(),
      stageSize: { width: r.width(), height: r.height() }
    })
  );
}
function va(r, a) {
  return Math.min(Math.max(r, a), pn);
}
function B0(r) {
  const { minScale: a } = xt.getState();
  let n = r.scale;
  n < a && (n = a), n > pn && (n = pn);
  const o = {
    x: dn((r.point.x - r.stage.x()) / r.stage.scaleX(), 2),
    y: dn((r.point.y - r.stage.y()) / r.stage.scaleX(), 2)
  };
  r.stage.scale({
    x: n,
    y: n
  });
  const c = Gr({
    scale: n,
    pos: {
      x: dn(r.point.x - o.x * n, 2),
      y: dn(r.point.y - o.y * n, 2)
    },
    stageSize: { width: r.stage.width(), height: r.stage.height() }
  });
  return r.stage.position(c), {
    position: {
      x: o.x,
      y: o.y
    },
    scale: n
  };
}
function W8(r, a) {
  return Math.sqrt(Math.pow(a.x - r.x, 2) + Math.pow(a.y - r.y, 2));
}
function U0(r, a) {
  return {
    x: (r.x + a.x) / 2,
    y: (r.y + a.y) / 2
  };
}
const q0 = 0.2;
yt.hitOnDragEnabled = !0;
const ii = (r, a) => {
  const { fit: n } = xt.getState();
  return (n === _n.CONTAIN ? Math.min : Math.max)(a.width / r.width, a.height / r.height);
};
async function vy(r) {
  var w, x, v, _, S, C, O, d, f;
  const a = document.getElementById(r.opts.containerId);
  if (!a)
    throw new Error("Canvas container not found");
  const n = {
    width: Math.max(a.clientWidth, r.opts.size.width),
    height: Math.max(a.clientHeight, r.opts.size.height)
  }, o = (x = (w = r.opts.print) == null ? void 0 : w.enabled) != null ? x : !1, c = (v = r.opts.draggable) != null ? v : !0;
  xt.setState({
    assetsBaseUrl: r.opts.assetsBaseUrl,
    background: r.opts.background,
    debug: !!r.opts.debug,
    fit: (_ = r.opts.fit) != null ? _ : _n.COVER,
    draggable: c,
    mapSize: n,
    isPrintEnabled: o,
    ...r.opts.elementsMetaData ? { elementsMetaData: r.opts.elementsMetaData } : {}
  });
  const s = V8({
    container: a,
    draggable: c,
    events: r.events,
    mapSize: n
  }), h = ii(n, {
    width: s.width(),
    height: s.height()
  });
  xt.setState({
    minScale: h
  });
  const l = new m8(
    (S = r.opts.layersConfig) == null ? void 0 : S.background
  );
  s.add(l);
  const g = new H8();
  await g.renderElements({
    elements: r.opts.elements,
    layerConfig: (C = r.opts.layersConfig) == null ? void 0 : C.elements
  }), s.add(g);
  let p;
  if (o && (p = new pa({
    initialPreview: (O = r.opts.print) == null ? void 0 : O.initialPreview,
    cb: (d = r.events) == null ? void 0 : d.onPrintPreview
  }), s.add(p)), o)
    s.scale({ x: h, y: h });
  else {
    if (z8(s, (f = r.events) == null ? void 0 : f.onMapPanZoom), r.opts.initialZoom) {
      const m = va(h, r.opts.initialZoom);
      s.scale({ x: m, y: m });
    }
    r.opts.initialPosition && s.position(
      Gr({
        scale: s.scaleX(),
        pos: {
          x: r.opts.initialPosition.x * s.scaleX(),
          y: r.opts.initialPosition.y * s.scaleY()
        },
        stageSize: {
          height: s.height(),
          width: s.width()
        }
      })
    );
  }
  const b = Y6(j8(s, a), 250);
  return window.addEventListener("resize", b), {
    addElements(m) {
      return g.addElements(m);
    },
    destroy() {
      s.destroy();
    },
    getStageInfo() {
      const { fit: m } = xt.getState(), E = s.scaleX();
      return {
        fit: m,
        rect: {
          height: s.height() / E,
          width: s.width() / E,
          x: Math.abs(s.x()) / E,
          y: Math.abs(s.y()) / E
        },
        size: {
          height: s.height(),
          width: s.width()
        },
        zoom: E
      };
    },
    removeAllElements() {
      g.removeAllElements();
    },
    removeElementsById(m) {
      g.removeElementsById(m);
    },
    renderElements(m, E) {
      return g.renderElements({
        elements: m,
        layerConfig: E
      });
    },
    setBackgroundVisibility(m) {
      l.setVisibility(m);
    },
    setDecorationsVisibility(m) {
      g.setVisibility(fr.DECORATION, m);
    },
    setSpotsVisibility(m) {
      g.setVisibility(fr.SPOT, m);
    },
    toggleBackgroundVisibility() {
      l.toggleVisibility();
    },
    toggleDecorationsVisibility() {
      g.toggleVisibility(fr.DECORATION);
    },
    toggleSpotsVisibility() {
      g.toggleVisibility(fr.SPOT);
    },
    updateFit(m) {
      const { mapSize: E } = xt.getState();
      xt.setState({ fit: m });
      const T = _a(a, E);
      xt.setState({
        minScale: ii(E, T)
      }), s.size(T), zh(s);
    },
    zoomIn() {
      var D, I;
      const m = s.scaleX(), E = dn(
        Math.min(m + q0, pn),
        2
      ), T = B0({
        scale: E,
        point: {
          x: s.width() / 2,
          y: s.height() / 2
        },
        stage: s
      });
      (I = (D = r.events) == null ? void 0 : D.onMapPanZoom) == null || I.call(D, {
        position: T.position,
        zoom: T.scale
      });
    },
    zoomOut() {
      var I, L;
      const { minScale: m } = xt.getState(), E = s.scaleX(), T = Math.max(m, E - q0), D = B0({
        stage: s,
        scale: T,
        point: {
          x: s.width() / 2,
          y: s.height() / 2
        }
      });
      (L = (I = r.events) == null ? void 0 : I.onMapPanZoom) == null || L.call(I, {
        position: D.position,
        zoom: D.scale
      });
    },
    updateBgSize(m, E) {
      const T = {
        width: Math.max(a.clientWidth, m.width),
        height: Math.max(a.clientHeight, m.height)
      }, D = xt.getState();
      if (S0(T, D.mapSize) && S0(E, {
        width: D.background.width,
        height: D.background.height
      }))
        return;
      const I = _a(a, T);
      s.width(I.width), s.height(I.height), xt.setState((L) => ({
        ...L,
        mapSize: T,
        background: {
          ...L.background,
          width: E.width,
          height: E.height
        },
        minScale: ii(m, {
          width: I.width,
          height: I.height
        })
      })), l.updateBgSize(), zh(s);
    },
    highlightElement(m, E) {
      const T = s.findOne(`#${m}`);
      T instanceof Be && T.highlight(E);
    },
    clearHighlight(m) {
      Array.isArray(m) ? m.forEach((E) => {
        const T = s.findOne(`#${E}`);
        T instanceof Be && T.clearHighlight();
      }) : g.children.filter((E) => E instanceof Be).forEach((E) => {
        E.clearHighlight();
      });
    },
    goToPosition(m, E) {
      if (E) {
        const { minScale: T } = xt.getState(), D = va(T, E);
        s.scale({ x: D, y: D });
      }
      s.position(
        Gr({
          scale: s.scaleX(),
          pos: {
            x: m.x * s.scaleX(),
            y: m.y * s.scaleY()
          },
          stageSize: {
            height: s.height(),
            width: s.width()
          }
        })
      );
    },
    print() {
      if (!p)
        throw new Error("Print mode is not enabled");
      return p.print(s);
    },
    updatePrintPreview(m) {
      var E;
      if (!p)
        throw new Error("Print mode is not enabled");
      p.destroyChildren(), p.buildPrintPreview({
        initialPreview: m,
        cb: (E = r.events) == null ? void 0 : E.onPrintPreview
      });
    }
  };
}
function z8(r, a) {
  const { mapSize: n, minScale: o } = xt.getState(), c = 1.05;
  r.scale({ x: o, y: o }), r.on("wheel", (g) => {
    g.evt.preventDefault();
    const p = r.scaleX(), b = r.getPointerPosition();
    if (!b) return;
    const w = {
      x: (b.x - r.x()) / p,
      y: (b.y - r.y()) / p
    }, x = g.evt.deltaY > 0 ? -1 : 1, { mapSize: v } = xt.getState(), _ = x > 0 ? p * c : p / c, S = ii(v, {
      width: r.width(),
      height: r.height()
    }), C = va(S, _);
    if (_ > C || _ < S) return;
    r.scale({
      x: C,
      y: C
    });
    const O = b.x - w.x * _, d = b.y - w.y * _, f = {
      x: Math.min(0, O),
      // bound to the left of the bg
      y: Math.min(0, d)
      // bound to the top of the bg
    };
    r.position(
      Gr({
        scale: C,
        pos: f,
        stageSize: {
          height: r.height(),
          width: r.width()
        }
      })
    ), a && a({
      position: {
        x: f.x / C,
        y: f.y / C
      },
      zoom: C
    });
  }), r.dragBoundFunc(
    (g) => Gr({
      stageSize: { width: r.width(), height: r.height() },
      pos: g,
      scale: r.scaleX()
    })
  );
  let s = null, h = 0, l = !1;
  r.on("touchmove", function(g) {
    g.evt.preventDefault();
    const p = g.evt.touches[0], b = g.evt.touches[1];
    if (p && !b && !r.isDragging() && l && (r.startDrag(), l = !1), p && b) {
      r.isDragging() && (l = !0, r.stopDrag());
      const w = {
        x: p.clientX,
        y: p.clientY
      }, x = {
        x: b.clientX,
        y: b.clientY
      };
      if (!s) {
        s = U0(w, x);
        return;
      }
      const v = U0(w, x), _ = W8(w, x);
      h || (h = _);
      const S = r.scaleX() * (_ / h), C = {
        x: (v.x - r.x()) / r.scaleX(),
        y: (v.y - r.y()) / r.scaleX()
      }, O = ii(n, {
        width: r.width(),
        height: r.height()
      }), d = va(O, S);
      if (r.scale({
        x: d,
        y: d
      }), S >= pn || S <= O)
        return;
      const f = v.x - s.x, m = v.y - s.y, E = {
        x: v.x - C.x * S + f,
        y: v.y - C.y * S + m
      };
      r.position(
        Gr({
          scale: r.scaleX(),
          pos: E,
          stageSize: {
            height: r.height(),
            width: r.width()
          }
        })
      ), h = _, s = v;
    }
  }), r.on("touchend", function() {
    h = 0, s = null;
  });
}
const j8 = (r, a) => () => {
  const n = a.clientWidth, o = a.clientHeight, c = _a(a, xt.getState().mapSize);
  r.width(c.width), r.height(c.height), xt.setState((s) => ({
    ...s,
    minScale: ii(s.mapSize, {
      width: n,
      height: o
    })
  })), zh(r);
};
export {
  _n as Fit,
  Te as SpotLayout,
  n6 as addElementsToClusters,
  vy as init,
  Y8 as initializeClusters,
  a6 as updateClustersVisibility,
  X8 as updateRenderedElements
};
